;!function(){try{var e="undefined"!=typeof window?window:"undefined"!=typeof global?global:"undefined"!=typeof self?self:{},n=(new Error).stack;n&&(e._sentryDebugIds=e._sentryDebugIds||{},e._sentryDebugIds[n]="73c1a76c-b252-471e-93b7-fe9dd4e4a7ae",e._sentryDebugIdIdentifier="sentry-dbid-73c1a76c-b252-471e-93b7-fe9dd4e4a7ae")}catch(e){}}();
"use strict";
(self["webpackChunkretino"] = self["webpackChunkretino"] || []).push([[363],{

/***/ 75630:
/***/ ((__unused_webpack_module, __webpack_exports__, __webpack_require__) => {

/* harmony export */ __webpack_require__.d(__webpack_exports__, {
/* harmony export */   A: () => (__WEBPACK_DEFAULT_EXPORT__)
/* harmony export */ });
/* unused harmony export logError */
/* harmony import */ var react__WEBPACK_IMPORTED_MODULE_0__ = __webpack_require__(96540);
/* harmony import */ var mobx_react__WEBPACK_IMPORTED_MODULE_3__ = __webpack_require__(44015);
/* harmony import */ var helpers_utils__WEBPACK_IMPORTED_MODULE_1__ = __webpack_require__(36315);
/* harmony import */ var _DefaultFallback__WEBPACK_IMPORTED_MODULE_2__ = __webpack_require__(20927);
var _class;




const logError = (error, info) => {
  if (true) {
    window.Sentry.captureException(error, {
      extra: info
    });
  }
};
let ErrorBoundary = (0,mobx_react__WEBPACK_IMPORTED_MODULE_3__/* .observer */ .PA)(_class = class ErrorBoundary extends react__WEBPACK_IMPORTED_MODULE_0__.Component {
  constructor() {
    super(...arguments);
    this.state = {
      hasError: false
    };
  }
  static getDerivedStateFromError(error) {
    return {
      hasError: true
    };
  }
  componentDidCatch(error, info) {
    this.setState({
      hasError: true
    });
    logError(error, info);
  }
  render() {
    if (this.state.hasError) {
      return this.props.fallbackComponent && this.props.fallbackComponent({
        removeError: () => this.setState({
          hasError: false
        }),
        isOutdated: (0,helpers_utils__WEBPACK_IMPORTED_MODULE_1__/* .isFrontendOutdated */ .Rg)()
      });
    }
    return this.props.children;
  }
}) || _class;
ErrorBoundary.defaultProps = {
  fallbackComponent: _DefaultFallback__WEBPACK_IMPORTED_MODULE_2__/* ["default"] */ .A
};
/* harmony default export */ const __WEBPACK_DEFAULT_EXPORT__ = (ErrorBoundary);

/***/ }),

/***/ 15798:
/***/ ((__unused_webpack_module, __webpack_exports__, __webpack_require__) => {

/* harmony export */ __webpack_require__.d(__webpack_exports__, {
/* harmony export */   t: () => (/* reexport safe */ _ErrorBoundary__WEBPACK_IMPORTED_MODULE_0__.A)
/* harmony export */ });
/* harmony import */ var _ErrorBoundary__WEBPACK_IMPORTED_MODULE_0__ = __webpack_require__(75630);
/* harmony import */ var _withErrorBoundary__WEBPACK_IMPORTED_MODULE_1__ = __webpack_require__(87890);



/***/ }),

/***/ 87890:
/***/ ((__unused_webpack_module, __unused_webpack___webpack_exports__, __webpack_require__) => {

/* harmony import */ var react__WEBPACK_IMPORTED_MODULE_0__ = __webpack_require__(96540);
/* harmony import */ var _ErrorBoundary__WEBPACK_IMPORTED_MODULE_1__ = __webpack_require__(75630);


const withErrorBoundary = fallbackComponent => Component => function (props) {
  return /*#__PURE__*/React.createElement(ErrorBoundary, {
    fallbackComponent: fallbackComponent
  }, /*#__PURE__*/React.createElement(Component, props));
};
/* unused harmony default export */ var __WEBPACK_DEFAULT_EXPORT__ = ((/* unused pure expression or super */ null && (withErrorBoundary)));

/***/ }),

/***/ 73711:
/***/ ((__unused_webpack_module, __webpack_exports__, __webpack_require__) => {

/* unused harmony export useCurrentLanguage */
/* harmony import */ var react__WEBPACK_IMPORTED_MODULE_0__ = __webpack_require__(96540);
/* harmony import */ var helpers_utils__WEBPACK_IMPORTED_MODULE_1__ = __webpack_require__(36315);


const CurrentLanguageContext = /*#__PURE__*/(/* unused pure expression or super */ null && (createContext(undefined)));
const useCurrentLanguage = () => useContextSafe(CurrentLanguageContext);
/* unused harmony default export */ var __WEBPACK_DEFAULT_EXPORT__ = ((/* unused pure expression or super */ null && (CurrentLanguageContext)));

/***/ }),

/***/ 67211:
/***/ ((__unused_webpack_module, __webpack_exports__, __webpack_require__) => {

/* harmony export */ __webpack_require__.d(__webpack_exports__, {
/* harmony export */   Ay: () => (__WEBPACK_DEFAULT_EXPORT__),
/* harmony export */   Fm: () => (/* binding */ PublicApiProvider)
/* harmony export */ });
/* unused harmony export PublicApiContext */
/* harmony import */ var react__WEBPACK_IMPORTED_MODULE_0__ = __webpack_require__(96540);
/* harmony import */ var helpers_utils__WEBPACK_IMPORTED_MODULE_1__ = __webpack_require__(36315);
/* harmony import */ var _codegen_api__WEBPACK_IMPORTED_MODULE_2__ = __webpack_require__(4247);
/* harmony import */ var _middlewares__WEBPACK_IMPORTED_MODULE_3__ = __webpack_require__(22356);




const PublicApiContext = /*#__PURE__*/(0,react__WEBPACK_IMPORTED_MODULE_0__.createContext)(null);
const usePublicApi = () => (0,helpers_utils__WEBPACK_IMPORTED_MODULE_1__/* .useContextSafe */ .qr)(PublicApiContext);
function PublicApiProvider(_ref) {
  let {
    children
  } = _ref;
  const [api] = (0,react__WEBPACK_IMPORTED_MODULE_0__.useState)(() => new _codegen_api__WEBPACK_IMPORTED_MODULE_2__/* .ApiClient */ .OW({
    baseUrl: "".concat(window.location.origin, "/api/internal/public"),
    middlewares: [new _middlewares__WEBPACK_IMPORTED_MODULE_3__/* ["default"] */ .A.AddCsrfHeaderMiddleware(), new _middlewares__WEBPACK_IMPORTED_MODULE_3__/* ["default"] */ .A.HandleErrorsMiddleware()],
    getHeaders: () => ({
      'Accept-Language': window.appState.lang,
      'Content-Type': 'application/json',
      'X-Retino-Frontend': window.appState.bundleHash
    })
  }));
  return /*#__PURE__*/react__WEBPACK_IMPORTED_MODULE_0__.createElement(PublicApiContext.Provider, {
    value: api
  }, children);
}

/* harmony default export */ const __WEBPACK_DEFAULT_EXPORT__ = (usePublicApi);

/***/ }),

/***/ 92664:
/***/ ((__unused_webpack_module, __webpack_exports__, __webpack_require__) => {

/* harmony export */ __webpack_require__.d(__webpack_exports__, {
/* harmony export */   S: () => (/* binding */ isResponse),
/* harmony export */   Y: () => (/* binding */ getErrors)
/* harmony export */ });
/* harmony import */ var _codegen_base__WEBPACK_IMPORTED_MODULE_0__ = __webpack_require__(6270);

function isResponse(error) {
  return error instanceof _codegen_base__WEBPACK_IMPORTED_MODULE_0__/* .ResponseError */ .o3;
}
async function getErrors(error) {
  if (isResponse(error)) {
    return error.response.json();
  }
  return null;
}

/***/ }),

/***/ 64843:
/***/ ((__unused_webpack_module, __unused_webpack___webpack_exports__, __webpack_require__) => {

/* harmony import */ var react__WEBPACK_IMPORTED_MODULE_0__ = __webpack_require__(96540);
/* harmony import */ var ui_card_Card__WEBPACK_IMPORTED_MODULE_1__ = __webpack_require__(33314);


function ActionPanel(_ref) {
  let {
    title,
    description,
    action,
    actionPosition = 'right'
  } = _ref;
  return /*#__PURE__*/React.createElement(Card, null, /*#__PURE__*/React.createElement(Card.Content, null, /*#__PURE__*/React.createElement("h3", {
    className: "text-lg font-medium leading-6 text-gray-900"
  }, title), /*#__PURE__*/React.createElement("div", {
    className: "mt-2 sm:flex sm:items-start sm:justify-between"
  }, /*#__PURE__*/React.createElement("div", {
    className: "text-sm text-gray-500"
  }, /*#__PURE__*/React.createElement("p", null, description)), actionPosition === 'right' && /*#__PURE__*/React.createElement("div", {
    className: "mt-5 sm:mt-0 sm:ml-6 sm:flex sm:flex-shrink-0 sm:items-center"
  }, action)), actionPosition === 'bottom' && /*#__PURE__*/React.createElement("div", {
    className: "mt-5"
  }, action)));
}
/* unused harmony default export */ var __WEBPACK_DEFAULT_EXPORT__ = ((/* unused pure expression or super */ null && (ActionPanel)));

/***/ }),

/***/ 63064:
/***/ ((__unused_webpack_module, __unused_webpack___webpack_exports__, __webpack_require__) => {

/* harmony import */ var react__WEBPACK_IMPORTED_MODULE_0__ = __webpack_require__(96540);
/* harmony import */ var ui__WEBPACK_IMPORTED_MODULE_1__ = __webpack_require__(61715);



function Breadcrumbs(_ref) {
  let {
    items
  } = _ref;
  return /*#__PURE__*/React.createElement("nav", {
    className: "flex",
    "aria-label": "Breadcrumb"
  }, /*#__PURE__*/React.createElement("ol", {
    className: "flex items-center gap-4"
  }, items.map((item, index) => /*#__PURE__*/React.createElement("li", {
    key: item.title || item.url
  }, /*#__PURE__*/React.createElement("div", {
    className: "flex items-center"
  }, index > 0 && /*#__PURE__*/React.createElement(Icon, {
    name: "chevron-right",
    className: "h-5 w-5 flex-shrink-0 text-gray-400"
  }), item.external ? /*#__PURE__*/React.createElement("a", {
    href: item.url || '#',
    className: "".concat(index > 0 && 'ml-4', " text-sm font-medium text-gray-500 hover:text-gray-700")
  }, item.icon && /*#__PURE__*/React.createElement(Icon, {
    name: item.icon,
    className: "h-5 w-5 flex-shrink-0"
  }), item.title) : /*#__PURE__*/React.createElement(Link, {
    to: item.url || '.',
    className: "".concat(index > 0 && 'ml-4', " text-sm font-medium text-gray-500 hover:text-gray-700")
  }, item.icon && /*#__PURE__*/React.createElement(Icon, {
    name: item.icon,
    className: "h-5 w-5 flex-shrink-0"
  }), item.title))))));
}
/* unused harmony default export */ var __WEBPACK_DEFAULT_EXPORT__ = ((/* unused pure expression or super */ null && (Breadcrumbs)));

/***/ }),

/***/ 74306:
/***/ ((__unused_webpack_module, __webpack_exports__, __webpack_require__) => {

/* harmony export */ __webpack_require__.d(__webpack_exports__, {
/* harmony export */   A: () => (__WEBPACK_DEFAULT_EXPORT__)
/* harmony export */ });
/* harmony import */ var react__WEBPACK_IMPORTED_MODULE_0__ = __webpack_require__(96540);
/* harmony import */ var ui__WEBPACK_IMPORTED_MODULE_1__ = __webpack_require__(61715);


const Button = /*#__PURE__*/(0,react__WEBPACK_IMPORTED_MODULE_0__.forwardRef)((_ref, ref) => {
  let {
    form,
    size,
    primary,
    secondary,
    tertiary,
    negative,
    grayLink,
    link,
    icon,
    iconSolid,
    iconSize,
    iconPosition = 'left',
    loading,
    disabled,
    fluid,
    id,
    submit = false,
    title,
    attached,
    classNames = classes => classes,
    children,
    onClick,
    onMouseEnter,
    onMouseLeave,
    wrap = false
  } = _ref;
  if (!iconSize) {
    iconSize = size;
  }
  if (loading) disabled = true;
  const classArray = ['inline-flex', 'items-center', 'font-medium', 'focus:outline-none', 'focus:ring-2', 'focus:ring-offset-2', 'focus:ring-primary-500'];
  let iconClassName = '';
  if (!wrap) {
    classArray.push('whitespace-nowrap');
  }
  if (!link) {
    let roundingSize = '';
    switch (size) {
      case 'tiny':
        classArray.push('px-2.5', 'py-1.5', 'text-xs');
        if (children) {
          iconClassName = '-ml-0.5 mr-1 h-4 w-4';
        }
        break;
      case 'small':
        roundingSize = '-md';
        classArray.push('px-3', 'py-2', 'text-sm');
        if (children) {
          iconClassName = '-ml-0.5 mr-1.5 h-4 w-4';
        }
        break;
      default:
      case 'medium':
        roundingSize = '-md';
        if (attached) {
          classArray.push('px-4', 'py-2', 'text-base', 'sm:text-sm');
        } else {
          classArray.push('px-4', 'py-2', 'text-sm');
        }
        if (children) {
          iconClassName = '-ml-1 mr-2 h-5 w-5';
        }
        break;
      case 'large':
        roundingSize = '-md';
        classArray.push('px-4', 'py-2', 'text-base');
        if (children) {
          iconClassName = '-ml-1 mr-2 h-5 w-5';
        }
        break;
      case 'huge':
        roundingSize = '-md';
        classArray.push('px-6', 'py-3', 'text-base');
        if (children) {
          iconClassName = '-ml-1 mr-3 h-6 w-6';
        }
        break;
    }
    switch (attached) {
      case 'left':
        classArray.push("rounded-r".concat(roundingSize));
        break;
      case 'right':
        classArray.push("rounded-l".concat(roundingSize));
        break;
      case 'both':
        classArray.push('rounded-none');
        break;
      default:
        classArray.push("rounded".concat(roundingSize));
        break;
    }
  }
  if (primary) {
    classArray.push('text-white', 'bg-primary-600', 'hover:bg-primary-700', 'border', 'border-transparent', 'shadow-sm');
  } else if (secondary) {
    classArray.push('text-primary-700', 'bg-primary-100', 'hover:bg-primary-200', 'border', 'border-transparent');
  } else if (tertiary) {
    classArray.push('text-primary-600', 'hover:text-primary-800');
  } else if (link && negative) {
    classArray.push('text-red-600', 'hover:text-red-800', 'text-sm');
  } else if (grayLink) {
    classArray.push('text-gray-400', 'hover:text-gray-700', 'text-sm');
  } else if (link) {
    classArray.push('text-primary-600', 'hover:text-primary-800', 'text-sm');
  } else if (negative) {
    classArray.push('text-white', 'bg-red-600', 'hover:bg-red-700', 'border', 'border-transparent', 'shadow-sm');
  } else {
    classArray.push('text-gray-700', 'bg-white', 'hover:bg-gray-50', 'border', 'border-gray-300', 'shadow-sm');
  }
  if (loading) {
    classArray.push('cursor-wait');
  } else if (disabled) {
    classArray.push('cursor-not-allowed');
  }
  if (disabled) {
    classArray.push('opacity-50');
  }
  if (fluid) {
    classArray.push('w-full', 'justify-center');
  }
  return /*#__PURE__*/react__WEBPACK_IMPORTED_MODULE_0__.createElement("button", {
    form: form,
    id: id,
    ref: ref,
    type: submit ? 'submit' : 'button',
    title: title,
    disabled: disabled,
    className: classNames(classArray).join(' '),
    onClick: onClick,
    onMouseEnter: onMouseEnter,
    onMouseLeave: onMouseLeave
  }, !loading && icon && iconPosition === 'left' && /*#__PURE__*/react__WEBPACK_IMPORTED_MODULE_0__.createElement(ui__WEBPACK_IMPORTED_MODULE_1__/* .Icon */ .In, {
    solid: iconSolid,
    name: icon,
    size: iconSize,
    className: iconClassName,
    fitted: !react__WEBPACK_IMPORTED_MODULE_0__.Children.count(children)
  }), loading && /*#__PURE__*/react__WEBPACK_IMPORTED_MODULE_0__.createElement(ui__WEBPACK_IMPORTED_MODULE_1__/* .Loader */ .aH, null), /*#__PURE__*/react__WEBPACK_IMPORTED_MODULE_0__.createElement("div", {
    className: "contents"
  }, children), !loading && icon && iconPosition === 'right' && /*#__PURE__*/react__WEBPACK_IMPORTED_MODULE_0__.createElement("span", {
    className: "ml-3.5 -mr-4"
  }, /*#__PURE__*/react__WEBPACK_IMPORTED_MODULE_0__.createElement(ui__WEBPACK_IMPORTED_MODULE_1__/* .Icon */ .In, {
    solid: iconSolid,
    fitted: true,
    name: icon,
    size: iconSize,
    className: iconClassName
  })));
});
/* harmony default export */ const __WEBPACK_DEFAULT_EXPORT__ = (Button);

/***/ }),

/***/ 21862:
/***/ ((__unused_webpack_module, __webpack_exports__, __webpack_require__) => {

/* harmony export */ __webpack_require__.d(__webpack_exports__, {
/* harmony export */   A: () => (__WEBPACK_DEFAULT_EXPORT__)
/* harmony export */ });
/* harmony import */ var react__WEBPACK_IMPORTED_MODULE_0__ = __webpack_require__(96540);

function Dimmer(_ref) {
  let {
    color = 'white',
    open,
    children
  } = _ref;
  const classes = ['sm:rounded-md', 'absolute', 'inset-0', 'flex', 'justify-center', 'items-center', 'opacity-75', 'z-20'];
  if (color === 'white') {
    classes.push('bg-white');
  } else if (color === 'dark-gray') {
    classes.push('bg-gray-500');
  } else {
    classes.push('bg-gray-100');
  }
  return open ? /*#__PURE__*/react__WEBPACK_IMPORTED_MODULE_0__.createElement("div", null, /*#__PURE__*/react__WEBPACK_IMPORTED_MODULE_0__.createElement("div", {
    className: classes.join(' ')
  }), /*#__PURE__*/react__WEBPACK_IMPORTED_MODULE_0__.createElement("div", {
    className: "absolute inset-0 z-30 flex items-center justify-center"
  }, children)) : null;
}
/* harmony default export */ const __WEBPACK_DEFAULT_EXPORT__ = (Dimmer);

/***/ }),

/***/ 50320:
/***/ ((__unused_webpack_module, __webpack_exports__, __webpack_require__) => {

/* harmony export */ __webpack_require__.d(__webpack_exports__, {
/* harmony export */   A: () => (__WEBPACK_DEFAULT_EXPORT__)
/* harmony export */ });
/* harmony import */ var react__WEBPACK_IMPORTED_MODULE_0__ = __webpack_require__(96540);

function Divider(props) {
  return /*#__PURE__*/react__WEBPACK_IMPORTED_MODULE_0__.createElement("hr", {
    className: props.section ? 'my-8' : 'my-2'
  });
}
/* harmony default export */ const __WEBPACK_DEFAULT_EXPORT__ = (Divider);

/***/ }),

/***/ 91176:
/***/ ((__unused_webpack_module, __unused_webpack___webpack_exports__, __webpack_require__) => {

/* harmony import */ var react__WEBPACK_IMPORTED_MODULE_0__ = __webpack_require__(96540);
/* harmony import */ var _headlessui_react__WEBPACK_IMPORTED_MODULE_4__ = __webpack_require__(55360);
/* harmony import */ var ui__WEBPACK_IMPORTED_MODULE_1__ = __webpack_require__(61715);
/* harmony import */ var _DropdownGroup__WEBPACK_IMPORTED_MODULE_2__ = __webpack_require__(32715);
/* harmony import */ var _DropdownItem__WEBPACK_IMPORTED_MODULE_3__ = __webpack_require__(22889);





function Dropdown(_ref) {
  let {
    children,
    fluid = true,
    trigger,
    position = 'bottom right',
    onOpen
  } = _ref;
  return /*#__PURE__*/react__WEBPACK_IMPORTED_MODULE_0__.createElement(_headlessui_react__WEBPACK_IMPORTED_MODULE_4__/* .Menu */ .W, null, _ref2 => {
    let {
      open
    } = _ref2;
    return /*#__PURE__*/react__WEBPACK_IMPORTED_MODULE_0__.createElement(ui__WEBPACK_IMPORTED_MODULE_1__/* .Popup */ .zD, {
      fluid: fluid,
      className: "",
      open: open,
      on: "click",
      position: position,
      trigger: /*#__PURE__*/react__WEBPACK_IMPORTED_MODULE_0__.createElement(_headlessui_react__WEBPACK_IMPORTED_MODULE_4__/* .Menu */ .W.Button, {
        as: react__WEBPACK_IMPORTED_MODULE_0__.Fragment
      }, trigger),
      onOpen: onOpen
    }, /*#__PURE__*/react__WEBPACK_IMPORTED_MODULE_0__.createElement(_headlessui_react__WEBPACK_IMPORTED_MODULE_4__/* .Menu */ .W.Items, {
      static: true,
      className: "min-w-56 z-10 divide-y rounded-md bg-white shadow-lg outline-none ring-1 ring-black ring-opacity-5"
    }, children));
  });
}
/* unused harmony default export */ var __WEBPACK_DEFAULT_EXPORT__ = (Object.assign(Dropdown, {
  Item: _DropdownItem__WEBPACK_IMPORTED_MODULE_3__/* ["default"] */ .A,
  Group: _DropdownGroup__WEBPACK_IMPORTED_MODULE_2__/* ["default"] */ .A
}));

/***/ }),

/***/ 25190:
/***/ ((__unused_webpack_module, __webpack_exports__, __webpack_require__) => {

/* harmony export */ __webpack_require__.d(__webpack_exports__, {
/* harmony export */   A: () => (__WEBPACK_DEFAULT_EXPORT__)
/* harmony export */ });
/* harmony import */ var react__WEBPACK_IMPORTED_MODULE_0__ = __webpack_require__(96540);
/* harmony import */ var _formFields__WEBPACK_IMPORTED_MODULE_1__ = __webpack_require__(15511);
const _excluded = ["id", "onSubmit", "children"];
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }
function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }


function Fields(_ref) {
  let {
    title,
    subtitle,
    children
  } = _ref;
  const classNames = ['space-y-4'];
  if (title || subtitle) {
    classNames.push('mt-4');
  }
  return /*#__PURE__*/react__WEBPACK_IMPORTED_MODULE_0__.createElement("fieldset", {
    className: "min-w-0"
  }, title && /*#__PURE__*/react__WEBPACK_IMPORTED_MODULE_0__.createElement("legend", {
    className: "text-base font-medium text-gray-900"
  }, title), subtitle && /*#__PURE__*/react__WEBPACK_IMPORTED_MODULE_0__.createElement("p", {
    className: "text-sm text-gray-500"
  }, subtitle), /*#__PURE__*/react__WEBPACK_IMPORTED_MODULE_0__.createElement("div", {
    className: classNames.join(' ')
  }, children));
}
const Form = /*#__PURE__*/(0,react__WEBPACK_IMPORTED_MODULE_0__.forwardRef)((_ref2, ref) => {
  let {
      id,
      onSubmit,
      children
    } = _ref2,
    rest = _objectWithoutProperties(_ref2, _excluded);
  const classNames = ['relative'];
  const handleSubmit = e => {
    e.preventDefault();
    if (onSubmit) onSubmit(e);
  };
  return /*#__PURE__*/react__WEBPACK_IMPORTED_MODULE_0__.createElement("form", _extends({
    ref: ref,
    id: id,
    className: classNames.join(' '),
    onSubmit: handleSubmit
  }, rest), children);
});
/* harmony default export */ const __WEBPACK_DEFAULT_EXPORT__ = (Object.assign(Form, {
  Field: _formFields__WEBPACK_IMPORTED_MODULE_1__/* .Field */ .D0,
  Fields,
  Input: _formFields__WEBPACK_IMPORTED_MODULE_1__/* .FormInput */ .ZQ,
  Checkbox: _formFields__WEBPACK_IMPORTED_MODULE_1__/* .FormCheckbox */ .cG,
  Radio: _formFields__WEBPACK_IMPORTED_MODULE_1__/* .FormRadio */ .Mi,
  RadioPanel: _formFields__WEBPACK_IMPORTED_MODULE_1__/* .FormRadioPanel */ .wN,
  Textarea: _formFields__WEBPACK_IMPORTED_MODULE_1__/* .FormTextarea */ .hg,
  RichText: _formFields__WEBPACK_IMPORTED_MODULE_1__/* .FormRichText */ .sM,
  Select: _formFields__WEBPACK_IMPORTED_MODULE_1__/* .FormSelect */ .FX,
  Multiselect: _formFields__WEBPACK_IMPORTED_MODULE_1__/* .FormMultiselect */ .GC
}));

/***/ }),

/***/ 67791:
/***/ ((__unused_webpack_module, __webpack_exports__, __webpack_require__) => {

/* harmony export */ __webpack_require__.d(__webpack_exports__, {
/* harmony export */   A: () => (__WEBPACK_DEFAULT_EXPORT__)
/* harmony export */ });
/* harmony import */ var react__WEBPACK_IMPORTED_MODULE_0__ = __webpack_require__(96540);
/* harmony import */ var ui_utils__WEBPACK_IMPORTED_MODULE_1__ = __webpack_require__(48014);


function Checkbox(_ref) {
  let {
    name,
    id,
    label,
    helpText,
    required,
    disabled,
    value,
    onChange,
    error,
    stopOnClickPropagation
  } = _ref;
  const internalId = (0,ui_utils__WEBPACK_IMPORTED_MODULE_1__/* .useId */ .B)();
  if (!name) {
    name = "checkbox-".concat(internalId);
  }
  if (!id) {
    id = "".concat(name, "__id");
  }
  return /*#__PURE__*/react__WEBPACK_IMPORTED_MODULE_0__.createElement("div", {
    className: "relative flex items-start ".concat(disabled ? 'pointer-events-none opacity-50' : '')
  }, /*#__PURE__*/react__WEBPACK_IMPORTED_MODULE_0__.createElement("div", {
    className: "flex h-5 items-center"
  }, /*#__PURE__*/react__WEBPACK_IMPORTED_MODULE_0__.createElement("input", {
    id: id,
    name: name,
    value: value ? 'true' : undefined,
    checked: value,
    required: required,
    disabled: disabled,
    onChange: onChange ? () => onChange(!value) : undefined,
    type: "checkbox",
    className: "h-4 w-4 rounded border-gray-300 text-indigo-600 focus:ring-indigo-500",
    onClick: e => {
      if (stopOnClickPropagation) e.stopPropagation();
    }
  })), /*#__PURE__*/react__WEBPACK_IMPORTED_MODULE_0__.createElement("div", {
    className: "ml-3 text-sm"
  }, label && /*#__PURE__*/react__WEBPACK_IMPORTED_MODULE_0__.createElement("label", {
    htmlFor: id,
    className: "font-medium text-gray-700"
  }, label), (helpText || error) && /*#__PURE__*/react__WEBPACK_IMPORTED_MODULE_0__.createElement("div", {
    className: "mt-2"
  }, helpText && /*#__PURE__*/react__WEBPACK_IMPORTED_MODULE_0__.createElement("p", {
    className: "text-gray-500"
  }, helpText), error && /*#__PURE__*/react__WEBPACK_IMPORTED_MODULE_0__.createElement("p", {
    className: "text-red-600"
  }, error))));
}
/* harmony default export */ const __WEBPACK_DEFAULT_EXPORT__ = (Checkbox);

/***/ }),

/***/ 52551:
/***/ ((__unused_webpack_module, __webpack_exports__, __webpack_require__) => {

/* harmony export */ __webpack_require__.d(__webpack_exports__, {
/* harmony export */   A: () => (__WEBPACK_DEFAULT_EXPORT__)
/* harmony export */ });
/* harmony import */ var react__WEBPACK_IMPORTED_MODULE_0__ = __webpack_require__(96540);
/* harmony import */ var ui__WEBPACK_IMPORTED_MODULE_1__ = __webpack_require__(61715);
/* harmony import */ var ui_loader_Loader__WEBPACK_IMPORTED_MODULE_2__ = __webpack_require__(19320);
/* harmony import */ var ui_utils__WEBPACK_IMPORTED_MODULE_3__ = __webpack_require__(48014);




function Input(_ref) {
  let {
    id,
    name,
    autoFocus,
    autoComplete = 'on',
    icon,
    type = 'text',
    textAlign = 'left',
    required = false,
    attached,
    size = 'basic',
    value = '',
    placeholder,
    error,
    loading,
    readOnly,
    classNames = classes => classes,
    onChange,
    onClear,
    onFocus,
    onBlur,
    maxLength,
    min,
    max,
    onKeyPress,
    onKeyDown,
    roundedFull
  } = _ref;
  const internalId = (0,ui_utils__WEBPACK_IMPORTED_MODULE_3__/* .useId */ .B)();
  if (!name) {
    name = "input-".concat(internalId);
  }
  if (!id) {
    id = "".concat(name, "__id");
  }
  const helpTextId = "".concat(id, "__description");
  const inputClasses = ['text-gray-900', 'shadow-sm', 'block', 'w-full', 'placeholder-gray-300'];
  if (size === 'basic') {
    inputClasses.push('sm:text-sm');
  } else {
    inputClasses.push('text-basic px-4 py-3');
  }
  if (error) {
    inputClasses.push('border-red-300', 'text-red-900', 'placeholder-red-300', 'focus:outline-none', 'focus:ring-red-500', 'focus:border-red-500');
  } else {
    inputClasses.push('focus:ring-indigo-500', 'focus:border-indigo-500', 'border-gray-300');
  }

  // if (button) {
  //   inputClasses.push('rounded-l-md');
  // } else {
  //   inputClasses.push('rounded-md');
  // }

  switch (attached) {
    case 'left':
      if (roundedFull) {
        inputClasses.push('rounded-r-full border-l-0');
      } else inputClasses.push('rounded-r-md border-l-0');
      break;
    case 'right':
      if (roundedFull) {
        inputClasses.push('rounded-l-full border-r-0');
      } else inputClasses.push('rounded-l-md border-r-0');
      break;
    case 'both':
      inputClasses.push('rounded-none border-l-0 border-r-0');
      break;
    default:
      if (roundedFull) {
        inputClasses.push('rounded-full');
      } else inputClasses.push('rounded-md');
      break;
  }
  if (textAlign === 'right') {
    inputClasses.push('text-right');
  }
  const iconClasses = [];
  if (icon) {
    if (size === 'basic') {
      inputClasses.push('pl-10');
      iconClasses.push('h-5 w-5 text-gray-400');
    } else {
      inputClasses.push('pl-12');
      iconClasses.push('h-7 w-7 text-gray-400');
    }
  }
  if (onClear) {
    inputClasses.push('pr-10');
  }

  // types fetched from: https://developer.mozilla.org/en-US/docs/Web/HTML/Element/input
  const inputTypes = ['text', 'password', 'text', 'button', 'email', 'color', 'date', 'file', 'hidden', 'radio', 'range', 'tel', 'time', 'url', 'checkbox', 'datetime-local', 'image', 'month', 'number', 'reset', 'search', 'submit', 'week'];

  // we want the error exclamation icon to be on the other side of text
  const errorClasses = ['pointer-events-none', 'absolute', 'inset-y-0', 'flex', 'items-center', 'pr-3'];
  if (textAlign === 'left') {
    errorClasses.push('right-0');
  } else {
    errorClasses.push('left-2');
  }
  return /*#__PURE__*/react__WEBPACK_IMPORTED_MODULE_0__.createElement("div", {
    className: "relative flex flex-grow items-stretch focus-within:z-10"
  }, icon && /*#__PURE__*/react__WEBPACK_IMPORTED_MODULE_0__.createElement("div", {
    className: "pointer-events-none absolute inset-y-0 left-0 flex items-center pl-3"
  }, /*#__PURE__*/react__WEBPACK_IMPORTED_MODULE_0__.createElement(ui__WEBPACK_IMPORTED_MODULE_1__/* .Icon */ .In, {
    name: icon,
    className: iconClasses.join(' ')
  })), /*#__PURE__*/react__WEBPACK_IMPORTED_MODULE_0__.createElement("input", {
    autoFocus: autoFocus,
    autoComplete: autoComplete,
    type: inputTypes.includes(type) ? type : 'text',
    name: name,
    id: id,
    maxLength: maxLength,
    min: min,
    max: max,
    readOnly: readOnly,
    className: classNames(inputClasses.flatMap(cls => cls.split(' '))).join(' '),
    placeholder: placeholder,
    value: value,
    required: required,
    onChange: e => onChange && onChange(e.target.value),
    "aria-describedby": helpTextId,
    onFocus: onFocus,
    onBlur: onBlur,
    step: "any",
    onKeyPress: onKeyPress,
    onKeyDown: onKeyDown
  }), onClear && /*#__PURE__*/react__WEBPACK_IMPORTED_MODULE_0__.createElement("div", {
    className: "absolute inset-y-0 right-0 flex items-center pr-3",
    onClick: onClear,
    role: "button",
    tabIndex: 0
  }, /*#__PURE__*/react__WEBPACK_IMPORTED_MODULE_0__.createElement(ui__WEBPACK_IMPORTED_MODULE_1__/* .Icon */ .In, {
    name: "x",
    solid: true,
    className: "h-5 w-5 text-gray-400"
  })), error && /*#__PURE__*/react__WEBPACK_IMPORTED_MODULE_0__.createElement("div", {
    className: errorClasses.join(' ')
  }, /*#__PURE__*/react__WEBPACK_IMPORTED_MODULE_0__.createElement("svg", {
    className: "h-5 w-5 text-red-500",
    xmlns: "http://www.w3.org/2000/svg",
    viewBox: "0 0 20 20",
    fill: "currentColor",
    "aria-hidden": "true"
  }, /*#__PURE__*/react__WEBPACK_IMPORTED_MODULE_0__.createElement("path", {
    fillRule: "evenodd",
    d: "M18 10a8 8 0 11-16 0 8 8 0 0116 0zm-7 4a1 1 0 11-2 0 1 1 0 012 0zm-1-9a1 1 0 00-1 1v4a1 1 0 102 0V6a1 1 0 00-1-1z",
    clipRule: "evenodd"
  }))), loading && /*#__PURE__*/react__WEBPACK_IMPORTED_MODULE_0__.createElement("div", {
    className: "pointer-events-none absolute inset-y-0 right-0 flex items-center pr-3"
  }, /*#__PURE__*/react__WEBPACK_IMPORTED_MODULE_0__.createElement(ui_loader_Loader__WEBPACK_IMPORTED_MODULE_2__/* ["default"] */ .A, {
    size: "tiny"
  })));
}
/* harmony default export */ const __WEBPACK_DEFAULT_EXPORT__ = (Input);

/***/ }),

/***/ 89918:
/***/ ((__unused_webpack_module, __webpack_exports__, __webpack_require__) => {


// EXPORTS
__webpack_require__.d(__webpack_exports__, {
  Ay$: () => (/* binding */ icon_Icon)
});

// UNUSED EXPORTS: OutlineAcademicCap, OutlineAdjustments, OutlineAnnotation, OutlineArchive, OutlineArrowCircleDown, OutlineArrowCircleLeft, OutlineArrowCircleRight, OutlineArrowCircleUp, OutlineArrowDown, OutlineArrowLeft, OutlineArrowNarrowDown, OutlineArrowNarrowLeft, OutlineArrowNarrowRight, OutlineArrowNarrowUp, OutlineArrowRight, OutlineArrowUp, OutlineArrowsExpand, OutlineAtSymbol, OutlineBackspace, OutlineBadgeCheck, OutlineBan, OutlineBeaker, OutlineBell, OutlineBookOpen, OutlineBookmark, OutlineBookmarkAlt, OutlineBriefcase, OutlineCake, OutlineCalculator, OutlineCalendar, OutlineCamera, OutlineCash, OutlineChartBar, OutlineChartPie, OutlineChartSquareBar, OutlineChat, OutlineChatAlt, OutlineChatAlt2, OutlineCheck, OutlineCheckCircle, OutlineChevronDoubleDown, OutlineChevronDoubleLeft, OutlineChevronDoubleRight, OutlineChevronDoubleUp, OutlineChevronDown, OutlineChevronLeft, OutlineChevronRight, OutlineChevronUp, OutlineChip, OutlineClipboard, OutlineClipboardCheck, OutlineClipboardCopy, OutlineClipboardList, OutlineClock, OutlineCloud, OutlineCloudDownload, OutlineCloudUpload, OutlineCode, OutlineCog, OutlineCollection, OutlineColorSwatch, OutlineCreditCard, OutlineCube, OutlineCubeTransparent, OutlineCurrencyBangladeshi, OutlineCurrencyDollar, OutlineCurrencyEuro, OutlineCurrencyPound, OutlineCurrencyRupee, OutlineCurrencyYen, OutlineCursorClick, OutlineDatabase, OutlineDesktopComputer, OutlineDeviceMobile, OutlineDeviceTablet, OutlineDocument, OutlineDocumentAdd, OutlineDocumentDownload, OutlineDocumentDuplicate, OutlineDocumentRemove, OutlineDocumentReport, OutlineDocumentSearch, OutlineDocumentText, OutlineDotsCircleHorizontal, OutlineDotsHorizontal, OutlineDotsVertical, OutlineDownload, OutlineDuplicate, OutlineEmojiHappy, OutlineEmojiSad, OutlineExclamation, OutlineExclamationCircle, OutlineExternalLink, OutlineEye, OutlineEyeOff, OutlineFastForward, OutlineFilm, OutlineFilter, OutlineFingerPrint, OutlineFire, OutlineFlag, OutlineFolder, OutlineFolderAdd, OutlineFolderDownload, OutlineFolderOpen, OutlineFolderRemove, OutlineGift, OutlineGlobe, OutlineGlobeAlt, OutlineHand, OutlineHashtag, OutlineHeart, OutlineHome, OutlineIdentification, OutlineInbox, OutlineInboxIn, OutlineInformationCircle, OutlineKey, OutlineLibrary, OutlineLightBulb, OutlineLightningBolt, OutlineLink, OutlineLocationMarker, OutlineLockClosed, OutlineLockOpen, OutlineLogin, OutlineLogout, OutlineMail, OutlineMailOpen, OutlineMap, OutlineMenu, OutlineMenuAlt1, OutlineMenuAlt2, OutlineMenuAlt3, OutlineMenuAlt4, OutlineMicrophone, OutlineMinus, OutlineMinusCircle, OutlineMinusSm, OutlineMoon, OutlineMusicNote, OutlineNewspaper, OutlineOfficeBuilding, OutlinePaperAirplane, OutlinePaperClip, OutlinePause, OutlinePencil, OutlinePencilAlt, OutlinePhone, OutlinePhoneIncoming, OutlinePhoneMissedCall, OutlinePhoneOutgoing, OutlinePhotograph, OutlinePlay, OutlinePlus, OutlinePlusCircle, OutlinePlusSm, OutlinePresentationChartBar, OutlinePresentationChartLine, OutlinePrinter, OutlinePuzzle, OutlineQrcode, OutlineQuestionMarkCircle, OutlineReceiptRefund, OutlineReceiptTax, OutlineRefresh, OutlineReply, OutlineRewind, OutlineRss, OutlineSave, OutlineSaveAs, OutlineScale, OutlineScissors, OutlineSearch, OutlineSearchCircle, OutlineSelector, OutlineServer, OutlineShare, OutlineShieldCheck, OutlineShieldExclamation, OutlineShoppingBag, OutlineShoppingCart, OutlineSortAscending, OutlineSortDescending, OutlineSparkles, OutlineSpeakerphone, OutlineStar, OutlineStatusOffline, OutlineStatusOnline, OutlineStop, OutlineSun, OutlineSupport, OutlineSwitchHorizontal, OutlineSwitchVertical, OutlineTable, OutlineTag, OutlineTemplate, OutlineTerminal, OutlineThumbDown, OutlineThumbUp, OutlineTicket, OutlineTranslate, OutlineTrash, OutlineTrendingDown, OutlineTrendingUp, OutlineTruck, OutlineUpload, OutlineUser, OutlineUserAdd, OutlineUserCircle, OutlineUserGroup, OutlineUserRemove, OutlineUsers, OutlineVariable, OutlineVideoCamera, OutlineViewBoards, OutlineViewGrid, OutlineViewGridAdd, OutlineViewList, OutlineVolumeOff, OutlineVolumeUp, OutlineWifi, OutlineX, OutlineXCircle, OutlineZoomIn, OutlineZoomOut, SolidAcademicCap, SolidAdjustments, SolidAnnotation, SolidArchive, SolidArrowCircleDown, SolidArrowCircleLeft, SolidArrowCircleRight, SolidArrowCircleUp, SolidArrowDown, SolidArrowLeft, SolidArrowNarrowDown, SolidArrowNarrowLeft, SolidArrowNarrowRight, SolidArrowNarrowUp, SolidArrowRight, SolidArrowUp, SolidArrowsExpand, SolidAtSymbol, SolidBackspace, SolidBadgeCheck, SolidBan, SolidBeaker, SolidBell, SolidBookOpen, SolidBookmark, SolidBookmarkAlt, SolidBriefcase, SolidCake, SolidCalculator, SolidCalendar, SolidCamera, SolidCash, SolidChartBar, SolidChartPie, SolidChartSquareBar, SolidChat, SolidChatAlt, SolidChatAlt2, SolidCheck, SolidCheckCircle, SolidChevronDoubleDown, SolidChevronDoubleLeft, SolidChevronDoubleRight, SolidChevronDoubleUp, SolidChevronDown, SolidChevronLeft, SolidChevronRight, SolidChevronUp, SolidChip, SolidClipboard, SolidClipboardCheck, SolidClipboardCopy, SolidClipboardList, SolidClock, SolidCloud, SolidCloudDownload, SolidCloudUpload, SolidCode, SolidCog, SolidCollection, SolidColorSwatch, SolidCreditCard, SolidCube, SolidCubeTransparent, SolidCurrencyBangladeshi, SolidCurrencyDollar, SolidCurrencyEuro, SolidCurrencyPound, SolidCurrencyRupee, SolidCurrencyYen, SolidCursorClick, SolidDatabase, SolidDesktopComputer, SolidDeviceMobile, SolidDeviceTablet, SolidDocument, SolidDocumentAdd, SolidDocumentDownload, SolidDocumentDuplicate, SolidDocumentRemove, SolidDocumentReport, SolidDocumentSearch, SolidDocumentText, SolidDotsCircleHorizontal, SolidDotsHorizontal, SolidDotsVertical, SolidDownload, SolidDuplicate, SolidEmojiHappy, SolidEmojiSad, SolidExclamation, SolidExclamationCircle, SolidExternalLink, SolidEye, SolidEyeOff, SolidFastForward, SolidFilm, SolidFilter, SolidFingerPrint, SolidFire, SolidFlag, SolidFolder, SolidFolderAdd, SolidFolderDownload, SolidFolderOpen, SolidFolderRemove, SolidGift, SolidGlobe, SolidGlobeAlt, SolidHand, SolidHashtag, SolidHeart, SolidHome, SolidIdentification, SolidInbox, SolidInboxIn, SolidInformationCircle, SolidKey, SolidLibrary, SolidLightBulb, SolidLightningBolt, SolidLink, SolidLocationMarker, SolidLockClosed, SolidLockOpen, SolidLogin, SolidLogout, SolidMail, SolidMailOpen, SolidMap, SolidMenu, SolidMenuAlt1, SolidMenuAlt2, SolidMenuAlt3, SolidMenuAlt4, SolidMicrophone, SolidMinus, SolidMinusCircle, SolidMinusSm, SolidMoon, SolidMusicNote, SolidNewspaper, SolidOfficeBuilding, SolidPaperAirplane, SolidPaperClip, SolidPause, SolidPencil, SolidPencilAlt, SolidPhone, SolidPhoneIncoming, SolidPhoneMissedCall, SolidPhoneOutgoing, SolidPhotograph, SolidPlay, SolidPlus, SolidPlusCircle, SolidPlusSm, SolidPresentationChartBar, SolidPresentationChartLine, SolidPrinter, SolidPuzzle, SolidQrcode, SolidQuestionMarkCircle, SolidReceiptRefund, SolidReceiptTax, SolidRefresh, SolidReply, SolidRewind, SolidRss, SolidSave, SolidSaveAs, SolidScale, SolidScissors, SolidSearch, SolidSearchCircle, SolidSelector, SolidServer, SolidShare, SolidShieldCheck, SolidShieldExclamation, SolidShoppingBag, SolidShoppingCart, SolidSortAscending, SolidSortDescending, SolidSparkles, SolidSpeakerphone, SolidStar, SolidStatusOffline, SolidStatusOnline, SolidStop, SolidSun, SolidSupport, SolidSwitchHorizontal, SolidSwitchVertical, SolidTable, SolidTag, SolidTemplate, SolidTerminal, SolidThumbDown, SolidThumbUp, SolidTicket, SolidTranslate, SolidTrash, SolidTrendingDown, SolidTrendingUp, SolidTruck, SolidUpload, SolidUser, SolidUserAdd, SolidUserCircle, SolidUserGroup, SolidUserRemove, SolidUsers, SolidVariable, SolidVideoCamera, SolidViewBoards, SolidViewGrid, SolidViewGridAdd, SolidViewList, SolidVolumeOff, SolidVolumeUp, SolidWifi, SolidX, SolidXCircle, SolidZoomIn, SolidZoomOut

// EXTERNAL MODULE: ./node_modules/react/index.js
var react = __webpack_require__(96540);
;// ./react/ui/icon/icons/outline/academic-cap.svg
var _path, _path2, _path3;
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }

var SvgAcademicCap = function SvgAcademicCap(props) {
  return /*#__PURE__*/react.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    fill: "none",
    stroke: "currentColor",
    viewBox: "0 0 24 24"
  }, props), _path || (_path = /*#__PURE__*/react.createElement("path", {
    fill: "#fff",
    d: "m12 14 9-5-9-5-9 5z"
  })), _path2 || (_path2 = /*#__PURE__*/react.createElement("path", {
    fill: "#fff",
    d: "m12 14 6.16-3.422a12.1 12.1 0 0 1 .665 6.479A11.95 11.95 0 0 0 12 20.055a11.95 11.95 0 0 0-6.824-2.998 12.1 12.1 0 0 1 .665-6.479z"
  })), _path3 || (_path3 = /*#__PURE__*/react.createElement("path", {
    strokeLinecap: "round",
    strokeLinejoin: "round",
    strokeWidth: 2,
    d: "m12 14 9-5-9-5-9 5zm0 0 6.16-3.422a12.1 12.1 0 0 1 .665 6.479A11.95 11.95 0 0 0 12 20.055a11.95 11.95 0 0 0-6.824-2.998 12.1 12.1 0 0 1 .665-6.479zm-4 6v-7.5l4-2.222"
  })));
};
/* harmony default export */ const academic_cap = (SvgAcademicCap);
;// ./react/ui/icon/icons/outline/adjustments.svg
var adjustments_path;
function adjustments_extends() { adjustments_extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return adjustments_extends.apply(this, arguments); }

var SvgAdjustments = function SvgAdjustments(props) {
  return /*#__PURE__*/react.createElement("svg", adjustments_extends({
    xmlns: "http://www.w3.org/2000/svg",
    fill: "none",
    stroke: "currentColor",
    viewBox: "0 0 24 24"
  }, props), adjustments_path || (adjustments_path = /*#__PURE__*/react.createElement("path", {
    strokeLinecap: "round",
    strokeLinejoin: "round",
    strokeWidth: 2,
    d: "M12 6V4m0 2a2 2 0 1 0 0 4m0-4a2 2 0 1 1 0 4m-6 8a2 2 0 1 0 0-4m0 4a2 2 0 1 1 0-4m0 4v2m0-6V4m6 6v10m6-2a2 2 0 1 0 0-4m0 4a2 2 0 1 1 0-4m0 4v2m0-6V4"
  })));
};
/* harmony default export */ const adjustments = (SvgAdjustments);
;// ./react/ui/icon/icons/outline/annotation.svg
var annotation_path;
function annotation_extends() { annotation_extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return annotation_extends.apply(this, arguments); }

var SvgAnnotation = function SvgAnnotation(props) {
  return /*#__PURE__*/react.createElement("svg", annotation_extends({
    xmlns: "http://www.w3.org/2000/svg",
    fill: "none",
    stroke: "currentColor",
    viewBox: "0 0 24 24"
  }, props), annotation_path || (annotation_path = /*#__PURE__*/react.createElement("path", {
    strokeLinecap: "round",
    strokeLinejoin: "round",
    strokeWidth: 2,
    d: "M7 8h10M7 12h4m1 8-4-4H5a2 2 0 0 1-2-2V6a2 2 0 0 1 2-2h14a2 2 0 0 1 2 2v8a2 2 0 0 1-2 2h-3z"
  })));
};
/* harmony default export */ const annotation = (SvgAnnotation);
;// ./react/ui/icon/icons/outline/archive.svg
var archive_path;
function archive_extends() { archive_extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return archive_extends.apply(this, arguments); }

var SvgArchive = function SvgArchive(props) {
  return /*#__PURE__*/react.createElement("svg", archive_extends({
    xmlns: "http://www.w3.org/2000/svg",
    fill: "none",
    stroke: "currentColor",
    viewBox: "0 0 24 24"
  }, props), archive_path || (archive_path = /*#__PURE__*/react.createElement("path", {
    strokeLinecap: "round",
    strokeLinejoin: "round",
    strokeWidth: 2,
    d: "M5 8h14M5 8a2 2 0 1 1 0-4h14a2 2 0 1 1 0 4M5 8v10a2 2 0 0 0 2 2h10a2 2 0 0 0 2-2V8m-9 4h4"
  })));
};
/* harmony default export */ const archive = (SvgArchive);
;// ./react/ui/icon/icons/outline/arrow-circle-down.svg
var arrow_circle_down_path;
function arrow_circle_down_extends() { arrow_circle_down_extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return arrow_circle_down_extends.apply(this, arguments); }

var SvgArrowCircleDown = function SvgArrowCircleDown(props) {
  return /*#__PURE__*/react.createElement("svg", arrow_circle_down_extends({
    xmlns: "http://www.w3.org/2000/svg",
    fill: "none",
    stroke: "currentColor",
    viewBox: "0 0 24 24"
  }, props), arrow_circle_down_path || (arrow_circle_down_path = /*#__PURE__*/react.createElement("path", {
    strokeLinecap: "round",
    strokeLinejoin: "round",
    strokeWidth: 2,
    d: "m15 13-3 3m0 0-3-3m3 3V8m0 13a9 9 0 1 1 0-18 9 9 0 0 1 0 18"
  })));
};
/* harmony default export */ const arrow_circle_down = (SvgArrowCircleDown);
;// ./react/ui/icon/icons/outline/arrow-circle-left.svg
var arrow_circle_left_path;
function arrow_circle_left_extends() { arrow_circle_left_extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return arrow_circle_left_extends.apply(this, arguments); }

var SvgArrowCircleLeft = function SvgArrowCircleLeft(props) {
  return /*#__PURE__*/react.createElement("svg", arrow_circle_left_extends({
    xmlns: "http://www.w3.org/2000/svg",
    fill: "none",
    stroke: "currentColor",
    viewBox: "0 0 24 24"
  }, props), arrow_circle_left_path || (arrow_circle_left_path = /*#__PURE__*/react.createElement("path", {
    strokeLinecap: "round",
    strokeLinejoin: "round",
    strokeWidth: 2,
    d: "m11 15-3-3m0 0 3-3m-3 3h8M3 12a9 9 0 1 1 18 0 9 9 0 0 1-18 0"
  })));
};
/* harmony default export */ const arrow_circle_left = (SvgArrowCircleLeft);
;// ./react/ui/icon/icons/outline/arrow-circle-right.svg
var arrow_circle_right_path;
function arrow_circle_right_extends() { arrow_circle_right_extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return arrow_circle_right_extends.apply(this, arguments); }

var SvgArrowCircleRight = function SvgArrowCircleRight(props) {
  return /*#__PURE__*/react.createElement("svg", arrow_circle_right_extends({
    xmlns: "http://www.w3.org/2000/svg",
    fill: "none",
    stroke: "currentColor",
    viewBox: "0 0 24 24"
  }, props), arrow_circle_right_path || (arrow_circle_right_path = /*#__PURE__*/react.createElement("path", {
    strokeLinecap: "round",
    strokeLinejoin: "round",
    strokeWidth: 2,
    d: "m13 9 3 3m0 0-3 3m3-3H8m13 0a9 9 0 1 1-18 0 9 9 0 0 1 18 0"
  })));
};
/* harmony default export */ const arrow_circle_right = (SvgArrowCircleRight);
;// ./react/ui/icon/icons/outline/arrow-circle-up.svg
var arrow_circle_up_path;
function arrow_circle_up_extends() { arrow_circle_up_extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return arrow_circle_up_extends.apply(this, arguments); }

var SvgArrowCircleUp = function SvgArrowCircleUp(props) {
  return /*#__PURE__*/react.createElement("svg", arrow_circle_up_extends({
    xmlns: "http://www.w3.org/2000/svg",
    fill: "none",
    stroke: "currentColor",
    viewBox: "0 0 24 24"
  }, props), arrow_circle_up_path || (arrow_circle_up_path = /*#__PURE__*/react.createElement("path", {
    strokeLinecap: "round",
    strokeLinejoin: "round",
    strokeWidth: 2,
    d: "m9 11 3-3m0 0 3 3m-3-3v8m0-13a9 9 0 1 1 0 18 9 9 0 0 1 0-18"
  })));
};
/* harmony default export */ const arrow_circle_up = (SvgArrowCircleUp);
;// ./react/ui/icon/icons/outline/arrow-down.svg
var arrow_down_path;
function arrow_down_extends() { arrow_down_extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return arrow_down_extends.apply(this, arguments); }

var SvgArrowDown = function SvgArrowDown(props) {
  return /*#__PURE__*/react.createElement("svg", arrow_down_extends({
    xmlns: "http://www.w3.org/2000/svg",
    fill: "none",
    stroke: "currentColor",
    viewBox: "0 0 24 24"
  }, props), arrow_down_path || (arrow_down_path = /*#__PURE__*/react.createElement("path", {
    strokeLinecap: "round",
    strokeLinejoin: "round",
    strokeWidth: 2,
    d: "m19 14-7 7m0 0-7-7m7 7V3"
  })));
};
/* harmony default export */ const arrow_down = (SvgArrowDown);
;// ./react/ui/icon/icons/outline/arrow-left.svg
var arrow_left_path;
function arrow_left_extends() { arrow_left_extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return arrow_left_extends.apply(this, arguments); }

var SvgArrowLeft = function SvgArrowLeft(props) {
  return /*#__PURE__*/react.createElement("svg", arrow_left_extends({
    xmlns: "http://www.w3.org/2000/svg",
    fill: "none",
    stroke: "currentColor",
    viewBox: "0 0 24 24"
  }, props), arrow_left_path || (arrow_left_path = /*#__PURE__*/react.createElement("path", {
    strokeLinecap: "round",
    strokeLinejoin: "round",
    strokeWidth: 2,
    d: "m10 19-7-7m0 0 7-7m-7 7h18"
  })));
};
/* harmony default export */ const arrow_left = (SvgArrowLeft);
;// ./react/ui/icon/icons/outline/arrow-narrow-down.svg
var arrow_narrow_down_path;
function arrow_narrow_down_extends() { arrow_narrow_down_extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return arrow_narrow_down_extends.apply(this, arguments); }

var SvgArrowNarrowDown = function SvgArrowNarrowDown(props) {
  return /*#__PURE__*/react.createElement("svg", arrow_narrow_down_extends({
    xmlns: "http://www.w3.org/2000/svg",
    fill: "none",
    stroke: "currentColor",
    viewBox: "0 0 24 24"
  }, props), arrow_narrow_down_path || (arrow_narrow_down_path = /*#__PURE__*/react.createElement("path", {
    strokeLinecap: "round",
    strokeLinejoin: "round",
    strokeWidth: 2,
    d: "m16 17-4 4m0 0-4-4m4 4V3"
  })));
};
/* harmony default export */ const arrow_narrow_down = (SvgArrowNarrowDown);
;// ./react/ui/icon/icons/outline/arrow-narrow-left.svg
var arrow_narrow_left_path;
function arrow_narrow_left_extends() { arrow_narrow_left_extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return arrow_narrow_left_extends.apply(this, arguments); }

var SvgArrowNarrowLeft = function SvgArrowNarrowLeft(props) {
  return /*#__PURE__*/react.createElement("svg", arrow_narrow_left_extends({
    xmlns: "http://www.w3.org/2000/svg",
    fill: "none",
    stroke: "currentColor",
    viewBox: "0 0 24 24"
  }, props), arrow_narrow_left_path || (arrow_narrow_left_path = /*#__PURE__*/react.createElement("path", {
    strokeLinecap: "round",
    strokeLinejoin: "round",
    strokeWidth: 2,
    d: "m7 16-4-4m0 0 4-4m-4 4h18"
  })));
};
/* harmony default export */ const arrow_narrow_left = (SvgArrowNarrowLeft);
;// ./react/ui/icon/icons/outline/arrow-narrow-right.svg
var arrow_narrow_right_path;
function arrow_narrow_right_extends() { arrow_narrow_right_extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return arrow_narrow_right_extends.apply(this, arguments); }

var SvgArrowNarrowRight = function SvgArrowNarrowRight(props) {
  return /*#__PURE__*/react.createElement("svg", arrow_narrow_right_extends({
    xmlns: "http://www.w3.org/2000/svg",
    fill: "none",
    stroke: "currentColor",
    viewBox: "0 0 24 24"
  }, props), arrow_narrow_right_path || (arrow_narrow_right_path = /*#__PURE__*/react.createElement("path", {
    strokeLinecap: "round",
    strokeLinejoin: "round",
    strokeWidth: 2,
    d: "m17 8 4 4m0 0-4 4m4-4H3"
  })));
};
/* harmony default export */ const arrow_narrow_right = (SvgArrowNarrowRight);
;// ./react/ui/icon/icons/outline/arrow-narrow-up.svg
var arrow_narrow_up_path;
function arrow_narrow_up_extends() { arrow_narrow_up_extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return arrow_narrow_up_extends.apply(this, arguments); }

var SvgArrowNarrowUp = function SvgArrowNarrowUp(props) {
  return /*#__PURE__*/react.createElement("svg", arrow_narrow_up_extends({
    xmlns: "http://www.w3.org/2000/svg",
    fill: "none",
    stroke: "currentColor",
    viewBox: "0 0 24 24"
  }, props), arrow_narrow_up_path || (arrow_narrow_up_path = /*#__PURE__*/react.createElement("path", {
    strokeLinecap: "round",
    strokeLinejoin: "round",
    strokeWidth: 2,
    d: "m8 7 4-4m0 0 4 4m-4-4v18"
  })));
};
/* harmony default export */ const arrow_narrow_up = (SvgArrowNarrowUp);
;// ./react/ui/icon/icons/outline/arrow-right.svg
var arrow_right_path;
function arrow_right_extends() { arrow_right_extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return arrow_right_extends.apply(this, arguments); }

var SvgArrowRight = function SvgArrowRight(props) {
  return /*#__PURE__*/react.createElement("svg", arrow_right_extends({
    xmlns: "http://www.w3.org/2000/svg",
    fill: "none",
    stroke: "currentColor",
    viewBox: "0 0 24 24"
  }, props), arrow_right_path || (arrow_right_path = /*#__PURE__*/react.createElement("path", {
    strokeLinecap: "round",
    strokeLinejoin: "round",
    strokeWidth: 2,
    d: "m14 5 7 7m0 0-7 7m7-7H3"
  })));
};
/* harmony default export */ const arrow_right = (SvgArrowRight);
;// ./react/ui/icon/icons/outline/arrow-up.svg
var arrow_up_path;
function arrow_up_extends() { arrow_up_extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return arrow_up_extends.apply(this, arguments); }

var SvgArrowUp = function SvgArrowUp(props) {
  return /*#__PURE__*/react.createElement("svg", arrow_up_extends({
    xmlns: "http://www.w3.org/2000/svg",
    fill: "none",
    stroke: "currentColor",
    viewBox: "0 0 24 24"
  }, props), arrow_up_path || (arrow_up_path = /*#__PURE__*/react.createElement("path", {
    strokeLinecap: "round",
    strokeLinejoin: "round",
    strokeWidth: 2,
    d: "m5 10 7-7m0 0 7 7m-7-7v18"
  })));
};
/* harmony default export */ const arrow_up = (SvgArrowUp);
;// ./react/ui/icon/icons/outline/arrows-expand.svg
var arrows_expand_path;
function arrows_expand_extends() { arrows_expand_extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return arrows_expand_extends.apply(this, arguments); }

var SvgArrowsExpand = function SvgArrowsExpand(props) {
  return /*#__PURE__*/react.createElement("svg", arrows_expand_extends({
    xmlns: "http://www.w3.org/2000/svg",
    fill: "none",
    stroke: "currentColor",
    viewBox: "0 0 24 24"
  }, props), arrows_expand_path || (arrows_expand_path = /*#__PURE__*/react.createElement("path", {
    strokeLinecap: "round",
    strokeLinejoin: "round",
    strokeWidth: 2,
    d: "M4 8V4m0 0h4M4 4l5 5m11-1V4m0 0h-4m4 0-5 5M4 16v4m0 0h4m-4 0 5-5m11 5-5-5m5 5v-4m0 4h-4"
  })));
};
/* harmony default export */ const arrows_expand = (SvgArrowsExpand);
;// ./react/ui/icon/icons/outline/at-symbol.svg
var at_symbol_path;
function at_symbol_extends() { at_symbol_extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return at_symbol_extends.apply(this, arguments); }

var SvgAtSymbol = function SvgAtSymbol(props) {
  return /*#__PURE__*/react.createElement("svg", at_symbol_extends({
    xmlns: "http://www.w3.org/2000/svg",
    fill: "none",
    stroke: "currentColor",
    viewBox: "0 0 24 24"
  }, props), at_symbol_path || (at_symbol_path = /*#__PURE__*/react.createElement("path", {
    strokeLinecap: "round",
    strokeLinejoin: "round",
    strokeWidth: 2,
    d: "M16 12a4 4 0 1 0-8 0 4 4 0 0 0 8 0m0 0v1.5a2.5 2.5 0 0 0 5 0V12a9 9 0 1 0-9 9m4.5-1.206a8.96 8.96 0 0 1-4.5 1.207"
  })));
};
/* harmony default export */ const at_symbol = (SvgAtSymbol);
;// ./react/ui/icon/icons/outline/backspace.svg
var backspace_path;
function backspace_extends() { backspace_extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return backspace_extends.apply(this, arguments); }

var SvgBackspace = function SvgBackspace(props) {
  return /*#__PURE__*/react.createElement("svg", backspace_extends({
    xmlns: "http://www.w3.org/2000/svg",
    fill: "none",
    stroke: "currentColor",
    viewBox: "0 0 24 24"
  }, props), backspace_path || (backspace_path = /*#__PURE__*/react.createElement("path", {
    strokeLinecap: "round",
    strokeLinejoin: "round",
    strokeWidth: 2,
    d: "m12 14 2-2m0 0 2-2m-2 2-2-2m2 2 2 2M3 12l6.414 6.414a2 2 0 0 0 1.414.586H19a2 2 0 0 0 2-2V7a2 2 0 0 0-2-2h-8.172a2 2 0 0 0-1.414.586z"
  })));
};
/* harmony default export */ const backspace = (SvgBackspace);
;// ./react/ui/icon/icons/outline/badge-check.svg
var badge_check_path;
function badge_check_extends() { badge_check_extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return badge_check_extends.apply(this, arguments); }

var SvgBadgeCheck = function SvgBadgeCheck(props) {
  return /*#__PURE__*/react.createElement("svg", badge_check_extends({
    xmlns: "http://www.w3.org/2000/svg",
    fill: "none",
    stroke: "currentColor",
    viewBox: "0 0 24 24"
  }, props), badge_check_path || (badge_check_path = /*#__PURE__*/react.createElement("path", {
    strokeLinecap: "round",
    strokeLinejoin: "round",
    strokeWidth: 2,
    d: "m9 12 2 2 4-4M7.835 4.697a3.42 3.42 0 0 0 1.946-.806 3.42 3.42 0 0 1 4.438 0 3.42 3.42 0 0 0 1.946.806 3.42 3.42 0 0 1 3.138 3.138 3.42 3.42 0 0 0 .806 1.946 3.42 3.42 0 0 1 0 4.438 3.42 3.42 0 0 0-.806 1.946 3.42 3.42 0 0 1-3.138 3.138 3.42 3.42 0 0 0-1.946.806 3.42 3.42 0 0 1-4.438 0 3.42 3.42 0 0 0-1.946-.806 3.42 3.42 0 0 1-3.138-3.138 3.42 3.42 0 0 0-.806-1.946 3.42 3.42 0 0 1 0-4.438 3.42 3.42 0 0 0 .806-1.946 3.42 3.42 0 0 1 3.138-3.138"
  })));
};
/* harmony default export */ const badge_check = (SvgBadgeCheck);
;// ./react/ui/icon/icons/outline/ban.svg
var ban_path;
function ban_extends() { ban_extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return ban_extends.apply(this, arguments); }

var SvgBan = function SvgBan(props) {
  return /*#__PURE__*/react.createElement("svg", ban_extends({
    xmlns: "http://www.w3.org/2000/svg",
    fill: "none",
    stroke: "currentColor",
    viewBox: "0 0 24 24"
  }, props), ban_path || (ban_path = /*#__PURE__*/react.createElement("path", {
    strokeLinecap: "round",
    strokeLinejoin: "round",
    strokeWidth: 2,
    d: "M18.364 18.364A9 9 0 0 0 5.636 5.636m12.728 12.728A9 9 0 0 1 5.636 5.636m12.728 12.728L5.636 5.636"
  })));
};
/* harmony default export */ const ban = (SvgBan);
;// ./react/ui/icon/icons/outline/beaker.svg
var beaker_path;
function beaker_extends() { beaker_extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return beaker_extends.apply(this, arguments); }

var SvgBeaker = function SvgBeaker(props) {
  return /*#__PURE__*/react.createElement("svg", beaker_extends({
    xmlns: "http://www.w3.org/2000/svg",
    fill: "none",
    stroke: "currentColor",
    viewBox: "0 0 24 24"
  }, props), beaker_path || (beaker_path = /*#__PURE__*/react.createElement("path", {
    strokeLinecap: "round",
    strokeLinejoin: "round",
    strokeWidth: 2,
    d: "M19.428 15.428a2 2 0 0 0-1.022-.547l-2.387-.477a6 6 0 0 0-3.86.517l-.318.158a6 6 0 0 1-3.86.517L6.05 15.21a2 2 0 0 0-1.806.547M8 4h8l-1 1v5.172a2 2 0 0 0 .586 1.414l5 5c1.26 1.26.367 3.414-1.415 3.414H4.828c-1.782 0-2.674-2.154-1.414-3.414l5-5A2 2 0 0 0 9 10.172V5z"
  })));
};
/* harmony default export */ const beaker = (SvgBeaker);
;// ./react/ui/icon/icons/outline/bell.svg
var bell_path;
function bell_extends() { bell_extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return bell_extends.apply(this, arguments); }

var SvgBell = function SvgBell(props) {
  return /*#__PURE__*/react.createElement("svg", bell_extends({
    xmlns: "http://www.w3.org/2000/svg",
    fill: "none",
    stroke: "currentColor",
    viewBox: "0 0 24 24"
  }, props), bell_path || (bell_path = /*#__PURE__*/react.createElement("path", {
    strokeLinecap: "round",
    strokeLinejoin: "round",
    strokeWidth: 2,
    d: "M14.857 17.082a23.9 23.9 0 0 0 5.454-1.31A8.97 8.97 0 0 1 18 9.75V9A6 6 0 0 0 6 9v.75a8.97 8.97 0 0 1-2.312 6.022c1.733.64 3.56 1.085 5.455 1.31m5.714 0a24.3 24.3 0 0 1-5.714 0m5.714 0a3 3 0 1 1-5.714 0"
  })));
};
/* harmony default export */ const bell = (SvgBell);
;// ./react/ui/icon/icons/outline/book-open.svg
var book_open_path;
function book_open_extends() { book_open_extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return book_open_extends.apply(this, arguments); }

var SvgBookOpen = function SvgBookOpen(props) {
  return /*#__PURE__*/react.createElement("svg", book_open_extends({
    xmlns: "http://www.w3.org/2000/svg",
    fill: "none",
    stroke: "currentColor",
    viewBox: "0 0 24 24"
  }, props), book_open_path || (book_open_path = /*#__PURE__*/react.createElement("path", {
    strokeLinecap: "round",
    strokeLinejoin: "round",
    strokeWidth: 2,
    d: "M12 6.253v13m0-13C10.832 5.477 9.246 5 7.5 5S4.168 5.477 3 6.253v13C4.168 18.477 5.754 18 7.5 18s3.332.477 4.5 1.253m0-13C13.168 5.477 14.754 5 16.5 5c1.747 0 3.332.477 4.5 1.253v13C19.832 18.477 18.247 18 16.5 18s-3.332.477-4.5 1.253"
  })));
};
/* harmony default export */ const book_open = (SvgBookOpen);
;// ./react/ui/icon/icons/outline/bookmark-alt.svg
var bookmark_alt_path;
function bookmark_alt_extends() { bookmark_alt_extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return bookmark_alt_extends.apply(this, arguments); }

var SvgBookmarkAlt = function SvgBookmarkAlt(props) {
  return /*#__PURE__*/react.createElement("svg", bookmark_alt_extends({
    xmlns: "http://www.w3.org/2000/svg",
    fill: "none",
    stroke: "currentColor",
    viewBox: "0 0 24 24"
  }, props), bookmark_alt_path || (bookmark_alt_path = /*#__PURE__*/react.createElement("path", {
    strokeLinecap: "round",
    strokeLinejoin: "round",
    strokeWidth: 2,
    d: "M16 4v12l-4-2-4 2V4M6 20h12a2 2 0 0 0 2-2V6a2 2 0 0 0-2-2H6a2 2 0 0 0-2 2v12a2 2 0 0 0 2 2"
  })));
};
/* harmony default export */ const bookmark_alt = (SvgBookmarkAlt);
;// ./react/ui/icon/icons/outline/bookmark.svg
var bookmark_path;
function bookmark_extends() { bookmark_extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return bookmark_extends.apply(this, arguments); }

var SvgBookmark = function SvgBookmark(props) {
  return /*#__PURE__*/react.createElement("svg", bookmark_extends({
    xmlns: "http://www.w3.org/2000/svg",
    fill: "none",
    stroke: "currentColor",
    viewBox: "0 0 24 24"
  }, props), bookmark_path || (bookmark_path = /*#__PURE__*/react.createElement("path", {
    strokeLinecap: "round",
    strokeLinejoin: "round",
    strokeWidth: 2,
    d: "M5 5a2 2 0 0 1 2-2h10a2 2 0 0 1 2 2v16l-7-3.5L5 21z"
  })));
};
/* harmony default export */ const bookmark = (SvgBookmark);
;// ./react/ui/icon/icons/outline/briefcase.svg
var briefcase_path;
function briefcase_extends() { briefcase_extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return briefcase_extends.apply(this, arguments); }

var SvgBriefcase = function SvgBriefcase(props) {
  return /*#__PURE__*/react.createElement("svg", briefcase_extends({
    xmlns: "http://www.w3.org/2000/svg",
    fill: "none",
    stroke: "currentColor",
    viewBox: "0 0 24 24"
  }, props), briefcase_path || (briefcase_path = /*#__PURE__*/react.createElement("path", {
    strokeLinecap: "round",
    strokeLinejoin: "round",
    strokeWidth: 2,
    d: "M21 13.255A23.9 23.9 0 0 1 12 15c-3.183 0-6.22-.62-9-1.745M16 6V4a2 2 0 0 0-2-2h-4a2 2 0 0 0-2 2v2m4 6h.01M5 20h14a2 2 0 0 0 2-2V8a2 2 0 0 0-2-2H5a2 2 0 0 0-2 2v10a2 2 0 0 0 2 2"
  })));
};
/* harmony default export */ const briefcase = (SvgBriefcase);
;// ./react/ui/icon/icons/outline/cake.svg
var cake_path;
function cake_extends() { cake_extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return cake_extends.apply(this, arguments); }

var SvgCake = function SvgCake(props) {
  return /*#__PURE__*/react.createElement("svg", cake_extends({
    xmlns: "http://www.w3.org/2000/svg",
    fill: "none",
    stroke: "currentColor",
    viewBox: "0 0 24 24"
  }, props), cake_path || (cake_path = /*#__PURE__*/react.createElement("path", {
    strokeLinecap: "round",
    strokeLinejoin: "round",
    strokeWidth: 2,
    d: "M21 15.546c-.523 0-1.046.151-1.5.454a2.7 2.7 0 0 1-3 0 2.7 2.7 0 0 0-3 0 2.7 2.7 0 0 1-3 0 2.7 2.7 0 0 0-3 0 2.7 2.7 0 0 1-3 0 2.7 2.7 0 0 0-1.5-.454M9 6v2m3-2v2m3-2v2M9 3h.01M12 3h.01M15 3h.01M21 21v-7a2 2 0 0 0-2-2H5a2 2 0 0 0-2 2v7zm-3-9v-2a2 2 0 0 0-2-2H8a2 2 0 0 0-2 2v2z"
  })));
};
/* harmony default export */ const cake = (SvgCake);
;// ./react/ui/icon/icons/outline/calculator.svg
var calculator_path;
function calculator_extends() { calculator_extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return calculator_extends.apply(this, arguments); }

var SvgCalculator = function SvgCalculator(props) {
  return /*#__PURE__*/react.createElement("svg", calculator_extends({
    xmlns: "http://www.w3.org/2000/svg",
    fill: "none",
    stroke: "currentColor",
    viewBox: "0 0 24 24"
  }, props), calculator_path || (calculator_path = /*#__PURE__*/react.createElement("path", {
    strokeLinecap: "round",
    strokeLinejoin: "round",
    strokeWidth: 2,
    d: "M9 7h6m0 10v-3m-3 3h.01M9 17h.01M9 14h.01M12 14h.01M15 11h.01M12 11h.01M9 11h.01M7 21h10a2 2 0 0 0 2-2V5a2 2 0 0 0-2-2H7a2 2 0 0 0-2 2v14a2 2 0 0 0 2 2"
  })));
};
/* harmony default export */ const calculator = (SvgCalculator);
;// ./react/ui/icon/icons/outline/calendar.svg
var calendar_path;
function calendar_extends() { calendar_extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return calendar_extends.apply(this, arguments); }

var SvgCalendar = function SvgCalendar(props) {
  return /*#__PURE__*/react.createElement("svg", calendar_extends({
    xmlns: "http://www.w3.org/2000/svg",
    fill: "none",
    stroke: "currentColor",
    viewBox: "0 0 24 24"
  }, props), calendar_path || (calendar_path = /*#__PURE__*/react.createElement("path", {
    strokeLinecap: "round",
    strokeLinejoin: "round",
    strokeWidth: 2,
    d: "M8 7V3m8 4V3m-9 8h10M5 21h14a2 2 0 0 0 2-2V7a2 2 0 0 0-2-2H5a2 2 0 0 0-2 2v12a2 2 0 0 0 2 2"
  })));
};
/* harmony default export */ const calendar = (SvgCalendar);
;// ./react/ui/icon/icons/outline/camera.svg
var camera_path, camera_path2;
function camera_extends() { camera_extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return camera_extends.apply(this, arguments); }

var SvgCamera = function SvgCamera(props) {
  return /*#__PURE__*/react.createElement("svg", camera_extends({
    xmlns: "http://www.w3.org/2000/svg",
    fill: "none",
    stroke: "currentColor",
    viewBox: "0 0 24 24"
  }, props), camera_path || (camera_path = /*#__PURE__*/react.createElement("path", {
    strokeLinecap: "round",
    strokeLinejoin: "round",
    strokeWidth: 2,
    d: "M3 9a2 2 0 0 1 2-2h.93a2 2 0 0 0 1.664-.89l.812-1.22A2 2 0 0 1 10.07 4h3.86a2 2 0 0 1 1.664.89l.812 1.22A2 2 0 0 0 18.07 7H19a2 2 0 0 1 2 2v9a2 2 0 0 1-2 2H5a2 2 0 0 1-2-2z"
  })), camera_path2 || (camera_path2 = /*#__PURE__*/react.createElement("path", {
    strokeLinecap: "round",
    strokeLinejoin: "round",
    strokeWidth: 2,
    d: "M15 13a3 3 0 1 1-6 0 3 3 0 0 1 6 0"
  })));
};
/* harmony default export */ const camera = (SvgCamera);
;// ./react/ui/icon/icons/outline/cash.svg
var cash_path;
function cash_extends() { cash_extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return cash_extends.apply(this, arguments); }

var SvgCash = function SvgCash(props) {
  return /*#__PURE__*/react.createElement("svg", cash_extends({
    xmlns: "http://www.w3.org/2000/svg",
    fill: "none",
    stroke: "currentColor",
    viewBox: "0 0 24 24"
  }, props), cash_path || (cash_path = /*#__PURE__*/react.createElement("path", {
    strokeLinecap: "round",
    strokeLinejoin: "round",
    strokeWidth: 2,
    d: "M17 9V7a2 2 0 0 0-2-2H5a2 2 0 0 0-2 2v6a2 2 0 0 0 2 2h2m2 4h10a2 2 0 0 0 2-2v-6a2 2 0 0 0-2-2H9a2 2 0 0 0-2 2v6a2 2 0 0 0 2 2m7-5a2 2 0 1 1-4 0 2 2 0 0 1 4 0"
  })));
};
/* harmony default export */ const cash = (SvgCash);
;// ./react/ui/icon/icons/outline/chart-bar.svg
var chart_bar_path;
function chart_bar_extends() { chart_bar_extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return chart_bar_extends.apply(this, arguments); }

var SvgChartBar = function SvgChartBar(props) {
  return /*#__PURE__*/react.createElement("svg", chart_bar_extends({
    xmlns: "http://www.w3.org/2000/svg",
    fill: "none",
    stroke: "currentColor",
    viewBox: "0 0 24 24"
  }, props), chart_bar_path || (chart_bar_path = /*#__PURE__*/react.createElement("path", {
    strokeLinecap: "round",
    strokeLinejoin: "round",
    strokeWidth: 2,
    d: "M3 13.125C3 12.504 3.504 12 4.125 12h2.25c.621 0 1.125.504 1.125 1.125v6.75C7.5 20.496 6.996 21 6.375 21h-2.25A1.125 1.125 0 0 1 3 19.875zm6.75-4.5c0-.621.504-1.125 1.125-1.125h2.25c.621 0 1.125.504 1.125 1.125v11.25c0 .621-.504 1.125-1.125 1.125h-2.25a1.125 1.125 0 0 1-1.125-1.125zm6.75-4.5c0-.621.504-1.125 1.125-1.125h2.25C20.496 3 21 3.504 21 4.125v15.75c0 .621-.504 1.125-1.125 1.125h-2.25a1.125 1.125 0 0 1-1.125-1.125z"
  })));
};
/* harmony default export */ const chart_bar = (SvgChartBar);
;// ./react/ui/icon/icons/outline/chart-pie.svg
var chart_pie_path, chart_pie_path2;
function chart_pie_extends() { chart_pie_extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return chart_pie_extends.apply(this, arguments); }

var SvgChartPie = function SvgChartPie(props) {
  return /*#__PURE__*/react.createElement("svg", chart_pie_extends({
    xmlns: "http://www.w3.org/2000/svg",
    fill: "none",
    stroke: "currentColor",
    strokeWidth: 2,
    viewBox: "0 0 24 24"
  }, props), chart_pie_path || (chart_pie_path = /*#__PURE__*/react.createElement("path", {
    strokeLinecap: "round",
    strokeLinejoin: "round",
    d: "M10.5 6a7.5 7.5 0 1 0 7.5 7.5h-7.5z"
  })), chart_pie_path2 || (chart_pie_path2 = /*#__PURE__*/react.createElement("path", {
    strokeLinecap: "round",
    strokeLinejoin: "round",
    d: "M13.5 10.5H21A7.5 7.5 0 0 0 13.5 3z"
  })));
};
/* harmony default export */ const chart_pie = (SvgChartPie);
;// ./react/ui/icon/icons/outline/chart-square-bar.svg
var chart_square_bar_path;
function chart_square_bar_extends() { chart_square_bar_extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return chart_square_bar_extends.apply(this, arguments); }

var SvgChartSquareBar = function SvgChartSquareBar(props) {
  return /*#__PURE__*/react.createElement("svg", chart_square_bar_extends({
    xmlns: "http://www.w3.org/2000/svg",
    fill: "none",
    stroke: "currentColor",
    viewBox: "0 0 24 24"
  }, props), chart_square_bar_path || (chart_square_bar_path = /*#__PURE__*/react.createElement("path", {
    strokeLinecap: "round",
    strokeLinejoin: "round",
    strokeWidth: 2,
    d: "M16 8v8m-4-5v5m-4-2v2m-2 4h12a2 2 0 0 0 2-2V6a2 2 0 0 0-2-2H6a2 2 0 0 0-2 2v12a2 2 0 0 0 2 2"
  })));
};
/* harmony default export */ const chart_square_bar = (SvgChartSquareBar);
;// ./react/ui/icon/icons/outline/chat-alt-2.svg
var chat_alt_2_path;
function chat_alt_2_extends() { chat_alt_2_extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return chat_alt_2_extends.apply(this, arguments); }

var SvgChatAlt2 = function SvgChatAlt2(props) {
  return /*#__PURE__*/react.createElement("svg", chat_alt_2_extends({
    xmlns: "http://www.w3.org/2000/svg",
    fill: "none",
    stroke: "currentColor",
    viewBox: "0 0 24 24"
  }, props), chat_alt_2_path || (chat_alt_2_path = /*#__PURE__*/react.createElement("path", {
    strokeLinecap: "round",
    strokeLinejoin: "round",
    strokeWidth: 2,
    d: "M17 8h2a2 2 0 0 1 2 2v6a2 2 0 0 1-2 2h-2v4l-4-4H9a2 2 0 0 1-1.414-.586m0 0L11 14h4a2 2 0 0 0 2-2V6a2 2 0 0 0-2-2H5a2 2 0 0 0-2 2v6a2 2 0 0 0 2 2h2v4z"
  })));
};
/* harmony default export */ const chat_alt_2 = (SvgChatAlt2);
;// ./react/ui/icon/icons/outline/chat-alt.svg
var chat_alt_path;
function chat_alt_extends() { chat_alt_extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return chat_alt_extends.apply(this, arguments); }

var SvgChatAlt = function SvgChatAlt(props) {
  return /*#__PURE__*/react.createElement("svg", chat_alt_extends({
    xmlns: "http://www.w3.org/2000/svg",
    fill: "none",
    stroke: "currentColor",
    viewBox: "0 0 24 24"
  }, props), chat_alt_path || (chat_alt_path = /*#__PURE__*/react.createElement("path", {
    strokeLinecap: "round",
    strokeLinejoin: "round",
    strokeWidth: 2,
    d: "M8 10h.01M12 10h.01M16 10h.01M9 16H5a2 2 0 0 1-2-2V6a2 2 0 0 1 2-2h14a2 2 0 0 1 2 2v8a2 2 0 0 1-2 2h-5l-5 5z"
  })));
};
/* harmony default export */ const chat_alt = (SvgChatAlt);
;// ./react/ui/icon/icons/outline/chat.svg
var chat_path;
function chat_extends() { chat_extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return chat_extends.apply(this, arguments); }

var SvgChat = function SvgChat(props) {
  return /*#__PURE__*/react.createElement("svg", chat_extends({
    xmlns: "http://www.w3.org/2000/svg",
    fill: "none",
    stroke: "currentColor",
    viewBox: "0 0 24 24"
  }, props), chat_path || (chat_path = /*#__PURE__*/react.createElement("path", {
    strokeLinecap: "round",
    strokeLinejoin: "round",
    strokeWidth: 2,
    d: "M8 12h.01M12 12h.01M16 12h.01M21 12c0 4.418-4.03 8-9 8a9.9 9.9 0 0 1-4.255-.949L3 20l1.395-3.72C3.512 15.042 3 13.574 3 12c0-4.418 4.03-8 9-8s9 3.582 9 8"
  })));
};
/* harmony default export */ const chat = (SvgChat);
;// ./react/ui/icon/icons/outline/check-circle.svg
var check_circle_path;
function check_circle_extends() { check_circle_extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return check_circle_extends.apply(this, arguments); }

var SvgCheckCircle = function SvgCheckCircle(props) {
  return /*#__PURE__*/react.createElement("svg", check_circle_extends({
    xmlns: "http://www.w3.org/2000/svg",
    fill: "none",
    stroke: "currentColor",
    viewBox: "0 0 24 24"
  }, props), check_circle_path || (check_circle_path = /*#__PURE__*/react.createElement("path", {
    strokeLinecap: "round",
    strokeLinejoin: "round",
    strokeWidth: 2,
    d: "m9 12 2 2 4-4m6 2a9 9 0 1 1-18 0 9 9 0 0 1 18 0"
  })));
};
/* harmony default export */ const check_circle = (SvgCheckCircle);
;// ./react/ui/icon/icons/outline/check.svg
var check_path;
function check_extends() { check_extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return check_extends.apply(this, arguments); }

var SvgCheck = function SvgCheck(props) {
  return /*#__PURE__*/react.createElement("svg", check_extends({
    xmlns: "http://www.w3.org/2000/svg",
    fill: "none",
    stroke: "currentColor",
    viewBox: "0 0 24 24"
  }, props), check_path || (check_path = /*#__PURE__*/react.createElement("path", {
    strokeLinecap: "round",
    strokeLinejoin: "round",
    strokeWidth: 2,
    d: "m5 13 4 4L19 7"
  })));
};
/* harmony default export */ const check = (SvgCheck);
;// ./react/ui/icon/icons/outline/chevron-double-down.svg
var chevron_double_down_path;
function chevron_double_down_extends() { chevron_double_down_extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return chevron_double_down_extends.apply(this, arguments); }

var SvgChevronDoubleDown = function SvgChevronDoubleDown(props) {
  return /*#__PURE__*/react.createElement("svg", chevron_double_down_extends({
    xmlns: "http://www.w3.org/2000/svg",
    fill: "none",
    stroke: "currentColor",
    viewBox: "0 0 24 24"
  }, props), chevron_double_down_path || (chevron_double_down_path = /*#__PURE__*/react.createElement("path", {
    strokeLinecap: "round",
    strokeLinejoin: "round",
    strokeWidth: 2,
    d: "m19 13-7 7-7-7m14-8-7 7-7-7"
  })));
};
/* harmony default export */ const chevron_double_down = (SvgChevronDoubleDown);
;// ./react/ui/icon/icons/outline/chevron-double-left.svg
var chevron_double_left_path;
function chevron_double_left_extends() { chevron_double_left_extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return chevron_double_left_extends.apply(this, arguments); }

var SvgChevronDoubleLeft = function SvgChevronDoubleLeft(props) {
  return /*#__PURE__*/react.createElement("svg", chevron_double_left_extends({
    xmlns: "http://www.w3.org/2000/svg",
    fill: "none",
    stroke: "currentColor",
    viewBox: "0 0 24 24"
  }, props), chevron_double_left_path || (chevron_double_left_path = /*#__PURE__*/react.createElement("path", {
    strokeLinecap: "round",
    strokeLinejoin: "round",
    strokeWidth: 2,
    d: "m11 19-7-7 7-7m8 14-7-7 7-7"
  })));
};
/* harmony default export */ const chevron_double_left = (SvgChevronDoubleLeft);
;// ./react/ui/icon/icons/outline/chevron-double-right.svg
var chevron_double_right_path;
function chevron_double_right_extends() { chevron_double_right_extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return chevron_double_right_extends.apply(this, arguments); }

var SvgChevronDoubleRight = function SvgChevronDoubleRight(props) {
  return /*#__PURE__*/react.createElement("svg", chevron_double_right_extends({
    xmlns: "http://www.w3.org/2000/svg",
    fill: "none",
    stroke: "currentColor",
    viewBox: "0 0 24 24"
  }, props), chevron_double_right_path || (chevron_double_right_path = /*#__PURE__*/react.createElement("path", {
    strokeLinecap: "round",
    strokeLinejoin: "round",
    strokeWidth: 2,
    d: "m13 5 7 7-7 7M5 5l7 7-7 7"
  })));
};
/* harmony default export */ const chevron_double_right = (SvgChevronDoubleRight);
;// ./react/ui/icon/icons/outline/chevron-double-up.svg
var chevron_double_up_path;
function chevron_double_up_extends() { chevron_double_up_extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return chevron_double_up_extends.apply(this, arguments); }

var SvgChevronDoubleUp = function SvgChevronDoubleUp(props) {
  return /*#__PURE__*/react.createElement("svg", chevron_double_up_extends({
    xmlns: "http://www.w3.org/2000/svg",
    fill: "none",
    stroke: "currentColor",
    viewBox: "0 0 24 24"
  }, props), chevron_double_up_path || (chevron_double_up_path = /*#__PURE__*/react.createElement("path", {
    strokeLinecap: "round",
    strokeLinejoin: "round",
    strokeWidth: 2,
    d: "m5 11 7-7 7 7M5 19l7-7 7 7"
  })));
};
/* harmony default export */ const chevron_double_up = (SvgChevronDoubleUp);
;// ./react/ui/icon/icons/outline/chevron-down.svg
var chevron_down_path;
function chevron_down_extends() { chevron_down_extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return chevron_down_extends.apply(this, arguments); }

var SvgChevronDown = function SvgChevronDown(props) {
  return /*#__PURE__*/react.createElement("svg", chevron_down_extends({
    xmlns: "http://www.w3.org/2000/svg",
    fill: "none",
    stroke: "currentColor",
    viewBox: "0 0 24 24"
  }, props), chevron_down_path || (chevron_down_path = /*#__PURE__*/react.createElement("path", {
    strokeLinecap: "round",
    strokeLinejoin: "round",
    strokeWidth: 2,
    d: "m19 9-7 7-7-7"
  })));
};
/* harmony default export */ const chevron_down = (SvgChevronDown);
;// ./react/ui/icon/icons/outline/chevron-left.svg
var chevron_left_path;
function chevron_left_extends() { chevron_left_extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return chevron_left_extends.apply(this, arguments); }

var SvgChevronLeft = function SvgChevronLeft(props) {
  return /*#__PURE__*/react.createElement("svg", chevron_left_extends({
    xmlns: "http://www.w3.org/2000/svg",
    fill: "none",
    stroke: "currentColor",
    viewBox: "0 0 24 24"
  }, props), chevron_left_path || (chevron_left_path = /*#__PURE__*/react.createElement("path", {
    strokeLinecap: "round",
    strokeLinejoin: "round",
    strokeWidth: 2,
    d: "m15 19-7-7 7-7"
  })));
};
/* harmony default export */ const chevron_left = (SvgChevronLeft);
;// ./react/ui/icon/icons/outline/chevron-right.svg
var chevron_right_path;
function chevron_right_extends() { chevron_right_extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return chevron_right_extends.apply(this, arguments); }

var SvgChevronRight = function SvgChevronRight(props) {
  return /*#__PURE__*/react.createElement("svg", chevron_right_extends({
    xmlns: "http://www.w3.org/2000/svg",
    fill: "none",
    stroke: "currentColor",
    viewBox: "0 0 24 24"
  }, props), chevron_right_path || (chevron_right_path = /*#__PURE__*/react.createElement("path", {
    strokeLinecap: "round",
    strokeLinejoin: "round",
    strokeWidth: 2,
    d: "m9 5 7 7-7 7"
  })));
};
/* harmony default export */ const chevron_right = (SvgChevronRight);
;// ./react/ui/icon/icons/outline/chevron-up.svg
var chevron_up_path;
function chevron_up_extends() { chevron_up_extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return chevron_up_extends.apply(this, arguments); }

var SvgChevronUp = function SvgChevronUp(props) {
  return /*#__PURE__*/react.createElement("svg", chevron_up_extends({
    xmlns: "http://www.w3.org/2000/svg",
    fill: "none",
    stroke: "currentColor",
    viewBox: "0 0 24 24"
  }, props), chevron_up_path || (chevron_up_path = /*#__PURE__*/react.createElement("path", {
    strokeLinecap: "round",
    strokeLinejoin: "round",
    strokeWidth: 2,
    d: "m5 15 7-7 7 7"
  })));
};
/* harmony default export */ const chevron_up = (SvgChevronUp);
;// ./react/ui/icon/icons/outline/chip.svg
var chip_path;
function chip_extends() { chip_extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return chip_extends.apply(this, arguments); }

var SvgChip = function SvgChip(props) {
  return /*#__PURE__*/react.createElement("svg", chip_extends({
    xmlns: "http://www.w3.org/2000/svg",
    fill: "none",
    stroke: "currentColor",
    viewBox: "0 0 24 24"
  }, props), chip_path || (chip_path = /*#__PURE__*/react.createElement("path", {
    strokeLinecap: "round",
    strokeLinejoin: "round",
    strokeWidth: 2,
    d: "M9 3v2m6-2v2M9 19v2m6-2v2M5 9H3m2 6H3m18-6h-2m2 6h-2M7 19h10a2 2 0 0 0 2-2V7a2 2 0 0 0-2-2H7a2 2 0 0 0-2 2v10a2 2 0 0 0 2 2M9 9h6v6H9z"
  })));
};
/* harmony default export */ const chip = (SvgChip);
;// ./react/ui/icon/icons/outline/clipboard-check.svg
var clipboard_check_path;
function clipboard_check_extends() { clipboard_check_extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return clipboard_check_extends.apply(this, arguments); }

var SvgClipboardCheck = function SvgClipboardCheck(props) {
  return /*#__PURE__*/react.createElement("svg", clipboard_check_extends({
    xmlns: "http://www.w3.org/2000/svg",
    fill: "none",
    stroke: "currentColor",
    viewBox: "0 0 24 24"
  }, props), clipboard_check_path || (clipboard_check_path = /*#__PURE__*/react.createElement("path", {
    strokeLinecap: "round",
    strokeLinejoin: "round",
    strokeWidth: 2,
    d: "M9 5H7a2 2 0 0 0-2 2v12a2 2 0 0 0 2 2h10a2 2 0 0 0 2-2V7a2 2 0 0 0-2-2h-2M9 5a2 2 0 0 0 2 2h2a2 2 0 0 0 2-2M9 5a2 2 0 0 1 2-2h2a2 2 0 0 1 2 2m-6 9 2 2 4-4"
  })));
};
/* harmony default export */ const clipboard_check = (SvgClipboardCheck);
;// ./react/ui/icon/icons/outline/clipboard-copy.svg
var clipboard_copy_path;
function clipboard_copy_extends() { clipboard_copy_extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return clipboard_copy_extends.apply(this, arguments); }

var SvgClipboardCopy = function SvgClipboardCopy(props) {
  return /*#__PURE__*/react.createElement("svg", clipboard_copy_extends({
    xmlns: "http://www.w3.org/2000/svg",
    fill: "none",
    stroke: "currentColor",
    viewBox: "0 0 24 24"
  }, props), clipboard_copy_path || (clipboard_copy_path = /*#__PURE__*/react.createElement("path", {
    strokeLinecap: "round",
    strokeLinejoin: "round",
    strokeWidth: 2,
    d: "M8 5H6a2 2 0 0 0-2 2v12a2 2 0 0 0 2 2h10a2 2 0 0 0 2-2v-1M8 5a2 2 0 0 0 2 2h2a2 2 0 0 0 2-2M8 5a2 2 0 0 1 2-2h2a2 2 0 0 1 2 2m0 0h2a2 2 0 0 1 2 2v3m2 4H10m0 0 3-3m-3 3 3 3"
  })));
};
/* harmony default export */ const clipboard_copy = (SvgClipboardCopy);
;// ./react/ui/icon/icons/outline/clipboard-list.svg
var clipboard_list_path;
function clipboard_list_extends() { clipboard_list_extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return clipboard_list_extends.apply(this, arguments); }

var SvgClipboardList = function SvgClipboardList(props) {
  return /*#__PURE__*/react.createElement("svg", clipboard_list_extends({
    xmlns: "http://www.w3.org/2000/svg",
    fill: "none",
    stroke: "currentColor",
    viewBox: "0 0 24 24"
  }, props), clipboard_list_path || (clipboard_list_path = /*#__PURE__*/react.createElement("path", {
    strokeLinecap: "round",
    strokeLinejoin: "round",
    strokeWidth: 2,
    d: "M9 5H7a2 2 0 0 0-2 2v12a2 2 0 0 0 2 2h10a2 2 0 0 0 2-2V7a2 2 0 0 0-2-2h-2M9 5a2 2 0 0 0 2 2h2a2 2 0 0 0 2-2M9 5a2 2 0 0 1 2-2h2a2 2 0 0 1 2 2m-3 7h3m-3 4h3m-6-4h.01M9 16h.01"
  })));
};
/* harmony default export */ const clipboard_list = (SvgClipboardList);
;// ./react/ui/icon/icons/outline/clipboard.svg
var clipboard_path;
function clipboard_extends() { clipboard_extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return clipboard_extends.apply(this, arguments); }

var SvgClipboard = function SvgClipboard(props) {
  return /*#__PURE__*/react.createElement("svg", clipboard_extends({
    xmlns: "http://www.w3.org/2000/svg",
    fill: "none",
    stroke: "currentColor",
    viewBox: "0 0 24 24"
  }, props), clipboard_path || (clipboard_path = /*#__PURE__*/react.createElement("path", {
    strokeLinecap: "round",
    strokeLinejoin: "round",
    strokeWidth: 2,
    d: "M9 5H7a2 2 0 0 0-2 2v12a2 2 0 0 0 2 2h10a2 2 0 0 0 2-2V7a2 2 0 0 0-2-2h-2M9 5a2 2 0 0 0 2 2h2a2 2 0 0 0 2-2M9 5a2 2 0 0 1 2-2h2a2 2 0 0 1 2 2"
  })));
};
/* harmony default export */ const clipboard = (SvgClipboard);
;// ./react/ui/icon/icons/outline/clock.svg
var clock_path;
function clock_extends() { clock_extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return clock_extends.apply(this, arguments); }

var SvgClock = function SvgClock(props) {
  return /*#__PURE__*/react.createElement("svg", clock_extends({
    xmlns: "http://www.w3.org/2000/svg",
    fill: "none",
    stroke: "currentColor",
    viewBox: "0 0 24 24"
  }, props), clock_path || (clock_path = /*#__PURE__*/react.createElement("path", {
    strokeLinecap: "round",
    strokeLinejoin: "round",
    strokeWidth: 2,
    d: "M12 8v4l3 3m6-3a9 9 0 1 1-18 0 9 9 0 0 1 18 0"
  })));
};
/* harmony default export */ const clock = (SvgClock);
;// ./react/ui/icon/icons/outline/cloud-download.svg
var cloud_download_path;
function cloud_download_extends() { cloud_download_extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return cloud_download_extends.apply(this, arguments); }

var SvgCloudDownload = function SvgCloudDownload(props) {
  return /*#__PURE__*/react.createElement("svg", cloud_download_extends({
    xmlns: "http://www.w3.org/2000/svg",
    fill: "none",
    stroke: "currentColor",
    viewBox: "0 0 24 24"
  }, props), cloud_download_path || (cloud_download_path = /*#__PURE__*/react.createElement("path", {
    strokeLinecap: "round",
    strokeLinejoin: "round",
    strokeWidth: 2,
    d: "M7 16a4 4 0 0 1-.88-7.903A5 5 0 1 1 15.9 6h.1a5 5 0 0 1 1 9.9M9 19l3 3m0 0 3-3m-3 3V10"
  })));
};
/* harmony default export */ const cloud_download = (SvgCloudDownload);
;// ./react/ui/icon/icons/outline/cloud-upload.svg
var cloud_upload_path;
function cloud_upload_extends() { cloud_upload_extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return cloud_upload_extends.apply(this, arguments); }

var SvgCloudUpload = function SvgCloudUpload(props) {
  return /*#__PURE__*/react.createElement("svg", cloud_upload_extends({
    xmlns: "http://www.w3.org/2000/svg",
    fill: "none",
    stroke: "currentColor",
    viewBox: "0 0 24 24"
  }, props), cloud_upload_path || (cloud_upload_path = /*#__PURE__*/react.createElement("path", {
    strokeLinecap: "round",
    strokeLinejoin: "round",
    strokeWidth: 2,
    d: "M7 16a4 4 0 0 1-.88-7.903A5 5 0 1 1 15.9 6h.1a5 5 0 0 1 1 9.9M15 13l-3-3m0 0-3 3m3-3v12"
  })));
};
/* harmony default export */ const cloud_upload = (SvgCloudUpload);
;// ./react/ui/icon/icons/outline/cloud.svg
var cloud_path;
function cloud_extends() { cloud_extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return cloud_extends.apply(this, arguments); }

var SvgCloud = function SvgCloud(props) {
  return /*#__PURE__*/react.createElement("svg", cloud_extends({
    xmlns: "http://www.w3.org/2000/svg",
    fill: "none",
    stroke: "currentColor",
    viewBox: "0 0 24 24"
  }, props), cloud_path || (cloud_path = /*#__PURE__*/react.createElement("path", {
    strokeLinecap: "round",
    strokeLinejoin: "round",
    strokeWidth: 2,
    d: "M3 15a4 4 0 0 0 4 4h9a5 5 0 1 0-.1-9.999 5.002 5.002 0 1 0-9.78 2.096A4 4 0 0 0 3 15"
  })));
};
/* harmony default export */ const cloud = (SvgCloud);
;// ./react/ui/icon/icons/outline/code.svg
var code_path;
function code_extends() { code_extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return code_extends.apply(this, arguments); }

var SvgCode = function SvgCode(props) {
  return /*#__PURE__*/react.createElement("svg", code_extends({
    xmlns: "http://www.w3.org/2000/svg",
    fill: "none",
    stroke: "currentColor",
    viewBox: "0 0 24 24"
  }, props), code_path || (code_path = /*#__PURE__*/react.createElement("path", {
    strokeLinecap: "round",
    strokeLinejoin: "round",
    strokeWidth: 2,
    d: "m10 20 4-16m4 4 4 4-4 4M6 16l-4-4 4-4"
  })));
};
/* harmony default export */ const code = (SvgCode);
;// ./react/ui/icon/icons/outline/cog.svg
var cog_path, cog_path2;
function cog_extends() { cog_extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return cog_extends.apply(this, arguments); }

var SvgCog = function SvgCog(props) {
  return /*#__PURE__*/react.createElement("svg", cog_extends({
    xmlns: "http://www.w3.org/2000/svg",
    fill: "none",
    stroke: "currentColor",
    viewBox: "0 0 24 24"
  }, props), cog_path || (cog_path = /*#__PURE__*/react.createElement("path", {
    strokeLinecap: "round",
    strokeLinejoin: "round",
    strokeWidth: 2,
    d: "M9.594 3.94c.09-.542.56-.94 1.11-.94h2.593c.55 0 1.02.398 1.11.94l.213 1.281c.063.374.313.686.645.87q.11.06.22.127c.325.196.72.257 1.075.124l1.217-.456a1.125 1.125 0 0 1 1.37.49l1.296 2.247a1.125 1.125 0 0 1-.26 1.431l-1.003.827c-.293.241-.438.613-.43.992a8 8 0 0 1 0 .255c-.008.378.137.75.43.991l1.004.827c.424.35.534.955.26 1.43l-1.298 2.247a1.125 1.125 0 0 1-1.369.491l-1.217-.456c-.355-.133-.75-.072-1.076.124a7 7 0 0 1-.22.128c-.331.183-.581.495-.644.869l-.213 1.281c-.09.543-.56.94-1.11.94h-2.594c-.55 0-1.019-.398-1.11-.94l-.213-1.281c-.062-.374-.312-.686-.644-.87a7 7 0 0 1-.22-.127c-.325-.196-.72-.257-1.076-.124l-1.217.456a1.125 1.125 0 0 1-1.369-.49l-1.297-2.247a1.125 1.125 0 0 1 .26-1.431l1.004-.827c.292-.24.437-.613.43-.991a7 7 0 0 1 0-.255c.007-.38-.138-.751-.43-.992l-1.004-.827a1.125 1.125 0 0 1-.26-1.43l1.297-2.247a1.125 1.125 0 0 1 1.37-.491l1.216.456c.356.133.751.072 1.076-.124q.108-.066.22-.128c.332-.183.582-.495.644-.869z"
  })), cog_path2 || (cog_path2 = /*#__PURE__*/react.createElement("path", {
    strokeLinecap: "round",
    strokeLinejoin: "round",
    strokeWidth: 2,
    d: "M15 12a3 3 0 1 1-6 0 3 3 0 0 1 6 0"
  })));
};
/* harmony default export */ const cog = (SvgCog);
;// ./react/ui/icon/icons/outline/collection.svg
var collection_path;
function collection_extends() { collection_extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return collection_extends.apply(this, arguments); }

var SvgCollection = function SvgCollection(props) {
  return /*#__PURE__*/react.createElement("svg", collection_extends({
    xmlns: "http://www.w3.org/2000/svg",
    fill: "none",
    stroke: "currentColor",
    viewBox: "0 0 24 24"
  }, props), collection_path || (collection_path = /*#__PURE__*/react.createElement("path", {
    strokeLinecap: "round",
    strokeLinejoin: "round",
    strokeWidth: 2,
    d: "M19 11H5m14 0a2 2 0 0 1 2 2v6a2 2 0 0 1-2 2H5a2 2 0 0 1-2-2v-6a2 2 0 0 1 2-2m14 0V9a2 2 0 0 0-2-2M5 11V9a2 2 0 0 1 2-2m0 0V5a2 2 0 0 1 2-2h6a2 2 0 0 1 2 2v2M7 7h10"
  })));
};
/* harmony default export */ const collection = (SvgCollection);
;// ./react/ui/icon/icons/outline/color-swatch.svg
var color_swatch_path;
function color_swatch_extends() { color_swatch_extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return color_swatch_extends.apply(this, arguments); }

var SvgColorSwatch = function SvgColorSwatch(props) {
  return /*#__PURE__*/react.createElement("svg", color_swatch_extends({
    xmlns: "http://www.w3.org/2000/svg",
    fill: "none",
    stroke: "currentColor",
    viewBox: "0 0 24 24"
  }, props), color_swatch_path || (color_swatch_path = /*#__PURE__*/react.createElement("path", {
    strokeLinecap: "round",
    strokeLinejoin: "round",
    strokeWidth: 2,
    d: "M7 21a4 4 0 0 1-4-4V5a2 2 0 0 1 2-2h4a2 2 0 0 1 2 2v12a4 4 0 0 1-4 4m0 0h12a2 2 0 0 0 2-2v-4a2 2 0 0 0-2-2h-2.343M11 7.343l1.657-1.657a2 2 0 0 1 2.828 0l2.829 2.829a2 2 0 0 1 0 2.828l-8.486 8.485M7 17h.01"
  })));
};
/* harmony default export */ const color_swatch = (SvgColorSwatch);
;// ./react/ui/icon/icons/outline/credit-card.svg
var credit_card_path;
function credit_card_extends() { credit_card_extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return credit_card_extends.apply(this, arguments); }

var SvgCreditCard = function SvgCreditCard(props) {
  return /*#__PURE__*/react.createElement("svg", credit_card_extends({
    xmlns: "http://www.w3.org/2000/svg",
    fill: "none",
    stroke: "currentColor",
    viewBox: "0 0 24 24"
  }, props), credit_card_path || (credit_card_path = /*#__PURE__*/react.createElement("path", {
    strokeLinecap: "round",
    strokeLinejoin: "round",
    strokeWidth: 2,
    d: "M3 10h18M7 15h1m4 0h1m-7 4h12a3 3 0 0 0 3-3V8a3 3 0 0 0-3-3H6a3 3 0 0 0-3 3v8a3 3 0 0 0 3 3"
  })));
};
/* harmony default export */ const credit_card = (SvgCreditCard);
;// ./react/ui/icon/icons/outline/cube-transparent.svg
var cube_transparent_path;
function cube_transparent_extends() { cube_transparent_extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return cube_transparent_extends.apply(this, arguments); }

var SvgCubeTransparent = function SvgCubeTransparent(props) {
  return /*#__PURE__*/react.createElement("svg", cube_transparent_extends({
    xmlns: "http://www.w3.org/2000/svg",
    fill: "none",
    stroke: "currentColor",
    viewBox: "0 0 24 24"
  }, props), cube_transparent_path || (cube_transparent_path = /*#__PURE__*/react.createElement("path", {
    strokeLinecap: "round",
    strokeLinejoin: "round",
    strokeWidth: 2,
    d: "m14 10-2 1m0 0-2-1m2 1v2.5M20 7l-2 1m2-1-2-1m2 1v2.5M14 4l-2-1-2 1M4 7l2-1M4 7l2 1M4 7v2.5M12 21l-2-1m2 1 2-1m-2 1v-2.5M6 18l-2-1v-2.5M18 18l2-1v-2.5"
  })));
};
/* harmony default export */ const cube_transparent = (SvgCubeTransparent);
;// ./react/ui/icon/icons/outline/cube.svg
var cube_path;
function cube_extends() { cube_extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return cube_extends.apply(this, arguments); }

var SvgCube = function SvgCube(props) {
  return /*#__PURE__*/react.createElement("svg", cube_extends({
    xmlns: "http://www.w3.org/2000/svg",
    fill: "none",
    stroke: "currentColor",
    viewBox: "0 0 24 24"
  }, props), cube_path || (cube_path = /*#__PURE__*/react.createElement("path", {
    strokeLinecap: "round",
    strokeLinejoin: "round",
    strokeWidth: 2,
    d: "m20 7-8-4-8 4m16 0-8 4m8-4v10l-8 4m0-10L4 7m8 4v10M4 7v10l8 4"
  })));
};
/* harmony default export */ const cube = (SvgCube);
;// ./react/ui/icon/icons/outline/currency-bangladeshi.svg
var currency_bangladeshi_path;
function currency_bangladeshi_extends() { currency_bangladeshi_extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return currency_bangladeshi_extends.apply(this, arguments); }

var SvgCurrencyBangladeshi = function SvgCurrencyBangladeshi(props) {
  return /*#__PURE__*/react.createElement("svg", currency_bangladeshi_extends({
    xmlns: "http://www.w3.org/2000/svg",
    fill: "none",
    stroke: "currentColor",
    viewBox: "0 0 24 24"
  }, props), currency_bangladeshi_path || (currency_bangladeshi_path = /*#__PURE__*/react.createElement("path", {
    strokeLinecap: "round",
    strokeLinejoin: "round",
    strokeWidth: 2,
    d: "M11 11V9a2 2 0 0 0-2-2m2 4v4a2 2 0 1 0 4 0v-1m-4-3H9m2 0h4m6 1a9 9 0 1 1-18 0 9 9 0 0 1 18 0"
  })));
};
/* harmony default export */ const currency_bangladeshi = (SvgCurrencyBangladeshi);
;// ./react/ui/icon/icons/outline/currency-dollar.svg
var currency_dollar_path;
function currency_dollar_extends() { currency_dollar_extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return currency_dollar_extends.apply(this, arguments); }

var SvgCurrencyDollar = function SvgCurrencyDollar(props) {
  return /*#__PURE__*/react.createElement("svg", currency_dollar_extends({
    xmlns: "http://www.w3.org/2000/svg",
    fill: "none",
    stroke: "currentColor",
    viewBox: "0 0 24 24"
  }, props), currency_dollar_path || (currency_dollar_path = /*#__PURE__*/react.createElement("path", {
    strokeLinecap: "round",
    strokeLinejoin: "round",
    strokeWidth: 2,
    d: "M12 8c-1.657 0-3 .895-3 2s1.343 2 3 2 3 .895 3 2-1.343 2-3 2m0-8c1.11 0 2.08.402 2.599 1M12 8V7m0 1v8m0 0v1m0-1c-1.11 0-2.08-.402-2.599-1M21 12a9 9 0 1 1-18 0 9 9 0 0 1 18 0"
  })));
};
/* harmony default export */ const currency_dollar = (SvgCurrencyDollar);
;// ./react/ui/icon/icons/outline/currency-euro.svg
var currency_euro_path;
function currency_euro_extends() { currency_euro_extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return currency_euro_extends.apply(this, arguments); }

var SvgCurrencyEuro = function SvgCurrencyEuro(props) {
  return /*#__PURE__*/react.createElement("svg", currency_euro_extends({
    xmlns: "http://www.w3.org/2000/svg",
    fill: "none",
    stroke: "currentColor",
    viewBox: "0 0 24 24"
  }, props), currency_euro_path || (currency_euro_path = /*#__PURE__*/react.createElement("path", {
    strokeLinecap: "round",
    strokeLinejoin: "round",
    strokeWidth: 2,
    d: "M14.121 15.536c-1.171 1.952-3.07 1.952-4.242 0-1.172-1.953-1.172-5.119 0-7.072 1.171-1.952 3.07-1.952 4.242 0M8 10.5h4m-4 3h4m9-1.5a9 9 0 1 1-18 0 9 9 0 0 1 18 0"
  })));
};
/* harmony default export */ const currency_euro = (SvgCurrencyEuro);
;// ./react/ui/icon/icons/outline/currency-pound.svg
var currency_pound_path;
function currency_pound_extends() { currency_pound_extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return currency_pound_extends.apply(this, arguments); }

var SvgCurrencyPound = function SvgCurrencyPound(props) {
  return /*#__PURE__*/react.createElement("svg", currency_pound_extends({
    xmlns: "http://www.w3.org/2000/svg",
    fill: "none",
    stroke: "currentColor",
    viewBox: "0 0 24 24"
  }, props), currency_pound_path || (currency_pound_path = /*#__PURE__*/react.createElement("path", {
    strokeLinecap: "round",
    strokeLinejoin: "round",
    strokeWidth: 2,
    d: "M15 9a2 2 0 1 0-4 0v5a2 2 0 0 1-2 2h6m-6-4h4m8 0a9 9 0 1 1-18 0 9 9 0 0 1 18 0"
  })));
};
/* harmony default export */ const currency_pound = (SvgCurrencyPound);
;// ./react/ui/icon/icons/outline/currency-rupee.svg
var currency_rupee_path;
function currency_rupee_extends() { currency_rupee_extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return currency_rupee_extends.apply(this, arguments); }

var SvgCurrencyRupee = function SvgCurrencyRupee(props) {
  return /*#__PURE__*/react.createElement("svg", currency_rupee_extends({
    xmlns: "http://www.w3.org/2000/svg",
    fill: "none",
    stroke: "currentColor",
    viewBox: "0 0 24 24"
  }, props), currency_rupee_path || (currency_rupee_path = /*#__PURE__*/react.createElement("path", {
    strokeLinecap: "round",
    strokeLinejoin: "round",
    strokeWidth: 2,
    d: "M9 8h6m-5 0a3 3 0 1 1 0 6H9l3 3m-3-6h6m6 1a9 9 0 1 1-18 0 9 9 0 0 1 18 0"
  })));
};
/* harmony default export */ const currency_rupee = (SvgCurrencyRupee);
;// ./react/ui/icon/icons/outline/currency-yen.svg
var currency_yen_path;
function currency_yen_extends() { currency_yen_extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return currency_yen_extends.apply(this, arguments); }

var SvgCurrencyYen = function SvgCurrencyYen(props) {
  return /*#__PURE__*/react.createElement("svg", currency_yen_extends({
    xmlns: "http://www.w3.org/2000/svg",
    fill: "none",
    stroke: "currentColor",
    viewBox: "0 0 24 24"
  }, props), currency_yen_path || (currency_yen_path = /*#__PURE__*/react.createElement("path", {
    strokeLinecap: "round",
    strokeLinejoin: "round",
    strokeWidth: 2,
    d: "m9 8 3 5m0 0 3-5m-3 5v4m-3-5h6m-6 3h6m6-3a9 9 0 1 1-18 0 9 9 0 0 1 18 0"
  })));
};
/* harmony default export */ const currency_yen = (SvgCurrencyYen);
;// ./react/ui/icon/icons/outline/cursor-click.svg
var cursor_click_path;
function cursor_click_extends() { cursor_click_extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return cursor_click_extends.apply(this, arguments); }

var SvgCursorClick = function SvgCursorClick(props) {
  return /*#__PURE__*/react.createElement("svg", cursor_click_extends({
    xmlns: "http://www.w3.org/2000/svg",
    fill: "none",
    stroke: "currentColor",
    viewBox: "0 0 24 24"
  }, props), cursor_click_path || (cursor_click_path = /*#__PURE__*/react.createElement("path", {
    strokeLinecap: "round",
    strokeLinejoin: "round",
    strokeWidth: 2,
    d: "m15 15-2 5L9 9l11 4zm0 0 5 5M7.188 2.239l.777 2.897M5.136 7.965l-2.898-.777M13.95 4.05l-2.122 2.122m-5.657 5.656-2.12 2.122"
  })));
};
/* harmony default export */ const cursor_click = (SvgCursorClick);
;// ./react/ui/icon/icons/outline/database.svg
var database_path;
function database_extends() { database_extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return database_extends.apply(this, arguments); }

var SvgDatabase = function SvgDatabase(props) {
  return /*#__PURE__*/react.createElement("svg", database_extends({
    xmlns: "http://www.w3.org/2000/svg",
    fill: "none",
    stroke: "currentColor",
    viewBox: "0 0 24 24"
  }, props), database_path || (database_path = /*#__PURE__*/react.createElement("path", {
    strokeLinecap: "round",
    strokeLinejoin: "round",
    strokeWidth: 2,
    d: "M4 7v10c0 2.21 3.582 4 8 4s8-1.79 8-4V7M4 7c0 2.21 3.582 4 8 4s8-1.79 8-4M4 7c0-2.21 3.582-4 8-4s8 1.79 8 4m0 5c0 2.21-3.582 4-8 4s-8-1.79-8-4"
  })));
};
/* harmony default export */ const database = (SvgDatabase);
;// ./react/ui/icon/icons/outline/desktop-computer.svg
var desktop_computer_path;
function desktop_computer_extends() { desktop_computer_extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return desktop_computer_extends.apply(this, arguments); }

var SvgDesktopComputer = function SvgDesktopComputer(props) {
  return /*#__PURE__*/react.createElement("svg", desktop_computer_extends({
    xmlns: "http://www.w3.org/2000/svg",
    fill: "none",
    stroke: "currentColor",
    viewBox: "0 0 24 24"
  }, props), desktop_computer_path || (desktop_computer_path = /*#__PURE__*/react.createElement("path", {
    strokeLinecap: "round",
    strokeLinejoin: "round",
    strokeWidth: 2,
    d: "M9.75 17 9 20l-1 1h8l-1-1-.75-3M3 13h18M5 17h14a2 2 0 0 0 2-2V5a2 2 0 0 0-2-2H5a2 2 0 0 0-2 2v10a2 2 0 0 0 2 2"
  })));
};
/* harmony default export */ const desktop_computer = (SvgDesktopComputer);
;// ./react/ui/icon/icons/outline/device-mobile.svg
var device_mobile_path;
function device_mobile_extends() { device_mobile_extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return device_mobile_extends.apply(this, arguments); }

var SvgDeviceMobile = function SvgDeviceMobile(props) {
  return /*#__PURE__*/react.createElement("svg", device_mobile_extends({
    xmlns: "http://www.w3.org/2000/svg",
    fill: "none",
    stroke: "currentColor",
    viewBox: "0 0 24 24"
  }, props), device_mobile_path || (device_mobile_path = /*#__PURE__*/react.createElement("path", {
    strokeLinecap: "round",
    strokeLinejoin: "round",
    strokeWidth: 2,
    d: "M12 18h.01M8 21h8a2 2 0 0 0 2-2V5a2 2 0 0 0-2-2H8a2 2 0 0 0-2 2v14a2 2 0 0 0 2 2"
  })));
};
/* harmony default export */ const device_mobile = (SvgDeviceMobile);
;// ./react/ui/icon/icons/outline/device-tablet.svg
var device_tablet_path;
function device_tablet_extends() { device_tablet_extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return device_tablet_extends.apply(this, arguments); }

var SvgDeviceTablet = function SvgDeviceTablet(props) {
  return /*#__PURE__*/react.createElement("svg", device_tablet_extends({
    xmlns: "http://www.w3.org/2000/svg",
    fill: "none",
    stroke: "currentColor",
    viewBox: "0 0 24 24"
  }, props), device_tablet_path || (device_tablet_path = /*#__PURE__*/react.createElement("path", {
    strokeLinecap: "round",
    strokeLinejoin: "round",
    strokeWidth: 2,
    d: "M12 18h.01M7 21h10a2 2 0 0 0 2-2V5a2 2 0 0 0-2-2H7a2 2 0 0 0-2 2v14a2 2 0 0 0 2 2"
  })));
};
/* harmony default export */ const device_tablet = (SvgDeviceTablet);
;// ./react/ui/icon/icons/outline/document-add.svg
var document_add_path;
function document_add_extends() { document_add_extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return document_add_extends.apply(this, arguments); }

var SvgDocumentAdd = function SvgDocumentAdd(props) {
  return /*#__PURE__*/react.createElement("svg", document_add_extends({
    xmlns: "http://www.w3.org/2000/svg",
    fill: "none",
    stroke: "currentColor",
    viewBox: "0 0 24 24"
  }, props), document_add_path || (document_add_path = /*#__PURE__*/react.createElement("path", {
    strokeLinecap: "round",
    strokeLinejoin: "round",
    strokeWidth: 2,
    d: "M9 13h6m-3-3v6m5 5H7a2 2 0 0 1-2-2V5a2 2 0 0 1 2-2h5.586a1 1 0 0 1 .707.293l5.414 5.414a1 1 0 0 1 .293.707V19a2 2 0 0 1-2 2"
  })));
};
/* harmony default export */ const document_add = (SvgDocumentAdd);
;// ./react/ui/icon/icons/outline/document-download.svg
var document_download_path;
function document_download_extends() { document_download_extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return document_download_extends.apply(this, arguments); }

var SvgDocumentDownload = function SvgDocumentDownload(props) {
  return /*#__PURE__*/react.createElement("svg", document_download_extends({
    xmlns: "http://www.w3.org/2000/svg",
    fill: "none",
    stroke: "currentColor",
    viewBox: "0 0 24 24"
  }, props), document_download_path || (document_download_path = /*#__PURE__*/react.createElement("path", {
    strokeLinecap: "round",
    strokeLinejoin: "round",
    strokeWidth: 2,
    d: "M12 10v6m0 0-3-3m3 3 3-3m2 8H7a2 2 0 0 1-2-2V5a2 2 0 0 1 2-2h5.586a1 1 0 0 1 .707.293l5.414 5.414a1 1 0 0 1 .293.707V19a2 2 0 0 1-2 2"
  })));
};
/* harmony default export */ const document_download = (SvgDocumentDownload);
;// ./react/ui/icon/icons/outline/document-duplicate.svg
var document_duplicate_path;
function document_duplicate_extends() { document_duplicate_extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return document_duplicate_extends.apply(this, arguments); }

var SvgDocumentDuplicate = function SvgDocumentDuplicate(props) {
  return /*#__PURE__*/react.createElement("svg", document_duplicate_extends({
    xmlns: "http://www.w3.org/2000/svg",
    fill: "none",
    stroke: "currentColor",
    viewBox: "0 0 24 24"
  }, props), document_duplicate_path || (document_duplicate_path = /*#__PURE__*/react.createElement("path", {
    strokeLinecap: "round",
    strokeLinejoin: "round",
    strokeWidth: 2,
    d: "M8 7v8a2 2 0 0 0 2 2h6M8 7V5a2 2 0 0 1 2-2h4.586a1 1 0 0 1 .707.293l4.414 4.414a1 1 0 0 1 .293.707V15a2 2 0 0 1-2 2h-2M8 7H6a2 2 0 0 0-2 2v10a2 2 0 0 0 2 2h8a2 2 0 0 0 2-2v-2"
  })));
};
/* harmony default export */ const document_duplicate = (SvgDocumentDuplicate);
;// ./react/ui/icon/icons/outline/document-remove.svg
var document_remove_path;
function document_remove_extends() { document_remove_extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return document_remove_extends.apply(this, arguments); }

var SvgDocumentRemove = function SvgDocumentRemove(props) {
  return /*#__PURE__*/react.createElement("svg", document_remove_extends({
    xmlns: "http://www.w3.org/2000/svg",
    fill: "none",
    stroke: "currentColor",
    viewBox: "0 0 24 24"
  }, props), document_remove_path || (document_remove_path = /*#__PURE__*/react.createElement("path", {
    strokeLinecap: "round",
    strokeLinejoin: "round",
    strokeWidth: 2,
    d: "M9 13h6m2 8H7a2 2 0 0 1-2-2V5a2 2 0 0 1 2-2h5.586a1 1 0 0 1 .707.293l5.414 5.414a1 1 0 0 1 .293.707V19a2 2 0 0 1-2 2"
  })));
};
/* harmony default export */ const document_remove = (SvgDocumentRemove);
;// ./react/ui/icon/icons/outline/document-report.svg
var document_report_path;
function document_report_extends() { document_report_extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return document_report_extends.apply(this, arguments); }

var SvgDocumentReport = function SvgDocumentReport(props) {
  return /*#__PURE__*/react.createElement("svg", document_report_extends({
    xmlns: "http://www.w3.org/2000/svg",
    fill: "none",
    stroke: "currentColor",
    viewBox: "0 0 24 24"
  }, props), document_report_path || (document_report_path = /*#__PURE__*/react.createElement("path", {
    strokeLinecap: "round",
    strokeLinejoin: "round",
    strokeWidth: 2,
    d: "M9 17v-2m3 2v-4m3 4v-6m2 10H7a2 2 0 0 1-2-2V5a2 2 0 0 1 2-2h5.586a1 1 0 0 1 .707.293l5.414 5.414a1 1 0 0 1 .293.707V19a2 2 0 0 1-2 2"
  })));
};
/* harmony default export */ const document_report = (SvgDocumentReport);
;// ./react/ui/icon/icons/outline/document-search.svg
var document_search_path;
function document_search_extends() { document_search_extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return document_search_extends.apply(this, arguments); }

var SvgDocumentSearch = function SvgDocumentSearch(props) {
  return /*#__PURE__*/react.createElement("svg", document_search_extends({
    xmlns: "http://www.w3.org/2000/svg",
    fill: "none",
    stroke: "currentColor",
    viewBox: "0 0 24 24"
  }, props), document_search_path || (document_search_path = /*#__PURE__*/react.createElement("path", {
    strokeLinecap: "round",
    strokeLinejoin: "round",
    strokeWidth: 2,
    d: "M10 21h7a2 2 0 0 0 2-2V9.414a1 1 0 0 0-.293-.707l-5.414-5.414A1 1 0 0 0 12.586 3H7a2 2 0 0 0-2 2v11m0 5 4.879-4.879m0 0a3 3 0 1 0 4.243-4.242 3 3 0 0 0-4.243 4.242"
  })));
};
/* harmony default export */ const document_search = (SvgDocumentSearch);
;// ./react/ui/icon/icons/outline/document-text.svg
var document_text_path;
function document_text_extends() { document_text_extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return document_text_extends.apply(this, arguments); }

var SvgDocumentText = function SvgDocumentText(props) {
  return /*#__PURE__*/react.createElement("svg", document_text_extends({
    xmlns: "http://www.w3.org/2000/svg",
    fill: "none",
    stroke: "currentColor",
    viewBox: "0 0 24 24"
  }, props), document_text_path || (document_text_path = /*#__PURE__*/react.createElement("path", {
    strokeLinecap: "round",
    strokeLinejoin: "round",
    strokeWidth: 2,
    d: "M9 12h6m-6 4h6m2 5H7a2 2 0 0 1-2-2V5a2 2 0 0 1 2-2h5.586a1 1 0 0 1 .707.293l5.414 5.414a1 1 0 0 1 .293.707V19a2 2 0 0 1-2 2"
  })));
};
/* harmony default export */ const document_text = (SvgDocumentText);
;// ./react/ui/icon/icons/outline/document.svg
var document_path;
function document_extends() { document_extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return document_extends.apply(this, arguments); }

var SvgDocument = function SvgDocument(props) {
  return /*#__PURE__*/react.createElement("svg", document_extends({
    xmlns: "http://www.w3.org/2000/svg",
    fill: "none",
    stroke: "currentColor",
    viewBox: "0 0 24 24"
  }, props), document_path || (document_path = /*#__PURE__*/react.createElement("path", {
    strokeLinecap: "round",
    strokeLinejoin: "round",
    strokeWidth: 2,
    d: "M7 21h10a2 2 0 0 0 2-2V9.414a1 1 0 0 0-.293-.707l-5.414-5.414A1 1 0 0 0 12.586 3H7a2 2 0 0 0-2 2v14a2 2 0 0 0 2 2"
  })));
};
/* harmony default export */ const outline_document = (SvgDocument);
;// ./react/ui/icon/icons/outline/dots-circle-horizontal.svg
var dots_circle_horizontal_path;
function dots_circle_horizontal_extends() { dots_circle_horizontal_extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return dots_circle_horizontal_extends.apply(this, arguments); }

var SvgDotsCircleHorizontal = function SvgDotsCircleHorizontal(props) {
  return /*#__PURE__*/react.createElement("svg", dots_circle_horizontal_extends({
    xmlns: "http://www.w3.org/2000/svg",
    fill: "none",
    stroke: "currentColor",
    viewBox: "0 0 24 24"
  }, props), dots_circle_horizontal_path || (dots_circle_horizontal_path = /*#__PURE__*/react.createElement("path", {
    strokeLinecap: "round",
    strokeLinejoin: "round",
    strokeWidth: 2,
    d: "M8 12h.01M12 12h.01M16 12h.01M21 12a9 9 0 1 1-18 0 9 9 0 0 1 18 0"
  })));
};
/* harmony default export */ const dots_circle_horizontal = (SvgDotsCircleHorizontal);
;// ./react/ui/icon/icons/outline/dots-horizontal.svg
var dots_horizontal_path;
function dots_horizontal_extends() { dots_horizontal_extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return dots_horizontal_extends.apply(this, arguments); }

var SvgDotsHorizontal = function SvgDotsHorizontal(props) {
  return /*#__PURE__*/react.createElement("svg", dots_horizontal_extends({
    xmlns: "http://www.w3.org/2000/svg",
    fill: "none",
    stroke: "currentColor",
    viewBox: "0 0 24 24"
  }, props), dots_horizontal_path || (dots_horizontal_path = /*#__PURE__*/react.createElement("path", {
    strokeLinecap: "round",
    strokeLinejoin: "round",
    strokeWidth: 2,
    d: "M5 12h.01M12 12h.01M19 12h.01M6 12a1 1 0 1 1-2 0 1 1 0 0 1 2 0m7 0a1 1 0 1 1-2 0 1 1 0 0 1 2 0m7 0a1 1 0 1 1-2 0 1 1 0 0 1 2 0"
  })));
};
/* harmony default export */ const dots_horizontal = (SvgDotsHorizontal);
;// ./react/ui/icon/icons/outline/dots-vertical.svg
var dots_vertical_path;
function dots_vertical_extends() { dots_vertical_extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return dots_vertical_extends.apply(this, arguments); }

var SvgDotsVertical = function SvgDotsVertical(props) {
  return /*#__PURE__*/react.createElement("svg", dots_vertical_extends({
    xmlns: "http://www.w3.org/2000/svg",
    fill: "none",
    stroke: "currentColor",
    viewBox: "0 0 24 24"
  }, props), dots_vertical_path || (dots_vertical_path = /*#__PURE__*/react.createElement("path", {
    strokeLinecap: "round",
    strokeLinejoin: "round",
    strokeWidth: 2,
    d: "M12 5v.01M12 12v.01M12 19v.01M12 6a1 1 0 1 1 0-2 1 1 0 0 1 0 2m0 7a1 1 0 1 1 0-2 1 1 0 0 1 0 2m0 7a1 1 0 1 1 0-2 1 1 0 0 1 0 2"
  })));
};
/* harmony default export */ const dots_vertical = (SvgDotsVertical);
;// ./react/ui/icon/icons/outline/download.svg
var download_path;
function download_extends() { download_extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return download_extends.apply(this, arguments); }

var SvgDownload = function SvgDownload(props) {
  return /*#__PURE__*/react.createElement("svg", download_extends({
    xmlns: "http://www.w3.org/2000/svg",
    fill: "none",
    stroke: "currentColor",
    viewBox: "0 0 24 24"
  }, props), download_path || (download_path = /*#__PURE__*/react.createElement("path", {
    strokeLinecap: "round",
    strokeLinejoin: "round",
    strokeWidth: 2,
    d: "M4 16v1a3 3 0 0 0 3 3h10a3 3 0 0 0 3-3v-1m-4-4-4 4m0 0-4-4m4 4V4"
  })));
};
/* harmony default export */ const download = (SvgDownload);
;// ./react/ui/icon/icons/outline/duplicate.svg
var duplicate_path;
function duplicate_extends() { duplicate_extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return duplicate_extends.apply(this, arguments); }

var SvgDuplicate = function SvgDuplicate(props) {
  return /*#__PURE__*/react.createElement("svg", duplicate_extends({
    xmlns: "http://www.w3.org/2000/svg",
    fill: "none",
    stroke: "currentColor",
    viewBox: "0 0 24 24"
  }, props), duplicate_path || (duplicate_path = /*#__PURE__*/react.createElement("path", {
    strokeLinecap: "round",
    strokeLinejoin: "round",
    strokeWidth: 2,
    d: "M8 16H6a2 2 0 0 1-2-2V6a2 2 0 0 1 2-2h8a2 2 0 0 1 2 2v2m-6 12h8a2 2 0 0 0 2-2v-8a2 2 0 0 0-2-2h-8a2 2 0 0 0-2 2v8a2 2 0 0 0 2 2"
  })));
};
/* harmony default export */ const duplicate = (SvgDuplicate);
;// ./react/ui/icon/icons/outline/emoji-happy.svg
var emoji_happy_path;
function emoji_happy_extends() { emoji_happy_extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return emoji_happy_extends.apply(this, arguments); }

var SvgEmojiHappy = function SvgEmojiHappy(props) {
  return /*#__PURE__*/react.createElement("svg", emoji_happy_extends({
    xmlns: "http://www.w3.org/2000/svg",
    fill: "none",
    stroke: "currentColor",
    viewBox: "0 0 24 24"
  }, props), emoji_happy_path || (emoji_happy_path = /*#__PURE__*/react.createElement("path", {
    strokeLinecap: "round",
    strokeLinejoin: "round",
    strokeWidth: 2,
    d: "M14.828 14.828a4 4 0 0 1-5.656 0M9 10h.01M15 10h.01M21 12a9 9 0 1 1-18 0 9 9 0 0 1 18 0"
  })));
};
/* harmony default export */ const emoji_happy = (SvgEmojiHappy);
;// ./react/ui/icon/icons/outline/emoji-sad.svg
var emoji_sad_path;
function emoji_sad_extends() { emoji_sad_extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return emoji_sad_extends.apply(this, arguments); }

var SvgEmojiSad = function SvgEmojiSad(props) {
  return /*#__PURE__*/react.createElement("svg", emoji_sad_extends({
    xmlns: "http://www.w3.org/2000/svg",
    fill: "none",
    stroke: "currentColor",
    viewBox: "0 0 24 24"
  }, props), emoji_sad_path || (emoji_sad_path = /*#__PURE__*/react.createElement("path", {
    strokeLinecap: "round",
    strokeLinejoin: "round",
    strokeWidth: 2,
    d: "M9.172 16.172a4 4 0 0 1 5.656 0M9 10h.01M15 10h.01M21 12a9 9 0 1 1-18 0 9 9 0 0 1 18 0"
  })));
};
/* harmony default export */ const emoji_sad = (SvgEmojiSad);
;// ./react/ui/icon/icons/outline/exclamation-circle.svg
var exclamation_circle_path;
function exclamation_circle_extends() { exclamation_circle_extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return exclamation_circle_extends.apply(this, arguments); }

var SvgExclamationCircle = function SvgExclamationCircle(props) {
  return /*#__PURE__*/react.createElement("svg", exclamation_circle_extends({
    xmlns: "http://www.w3.org/2000/svg",
    fill: "none",
    stroke: "currentColor",
    viewBox: "0 0 24 24"
  }, props), exclamation_circle_path || (exclamation_circle_path = /*#__PURE__*/react.createElement("path", {
    strokeLinecap: "round",
    strokeLinejoin: "round",
    strokeWidth: 2,
    d: "M12 8v4m0 4h.01M21 12a9 9 0 1 1-18 0 9 9 0 0 1 18 0"
  })));
};
/* harmony default export */ const exclamation_circle = (SvgExclamationCircle);
;// ./react/ui/icon/icons/outline/exclamation.svg
var exclamation_path;
function exclamation_extends() { exclamation_extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return exclamation_extends.apply(this, arguments); }

var SvgExclamation = function SvgExclamation(props) {
  return /*#__PURE__*/react.createElement("svg", exclamation_extends({
    xmlns: "http://www.w3.org/2000/svg",
    fill: "none",
    stroke: "currentColor",
    viewBox: "0 0 24 24"
  }, props), exclamation_path || (exclamation_path = /*#__PURE__*/react.createElement("path", {
    strokeLinecap: "round",
    strokeLinejoin: "round",
    strokeWidth: 2,
    d: "M12 9v3.75m-9.303 3.376c-.866 1.5.217 3.374 1.948 3.374h14.71c1.73 0 2.813-1.874 1.948-3.374L13.949 3.378c-.866-1.5-3.032-1.5-3.898 0zM12 15.75h.007v.008H12z"
  })));
};
/* harmony default export */ const exclamation = (SvgExclamation);
;// ./react/ui/icon/icons/outline/external-link.svg
var external_link_path;
function external_link_extends() { external_link_extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return external_link_extends.apply(this, arguments); }

var SvgExternalLink = function SvgExternalLink(props) {
  return /*#__PURE__*/react.createElement("svg", external_link_extends({
    xmlns: "http://www.w3.org/2000/svg",
    fill: "none",
    stroke: "currentColor",
    viewBox: "0 0 24 24"
  }, props), external_link_path || (external_link_path = /*#__PURE__*/react.createElement("path", {
    strokeLinecap: "round",
    strokeLinejoin: "round",
    strokeWidth: 2,
    d: "M10 6H6a2 2 0 0 0-2 2v10a2 2 0 0 0 2 2h10a2 2 0 0 0 2-2v-4M14 4h6m0 0v6m0-6L10 14"
  })));
};
/* harmony default export */ const external_link = (SvgExternalLink);
;// ./react/ui/icon/icons/outline/eye-off.svg
var eye_off_path;
function eye_off_extends() { eye_off_extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return eye_off_extends.apply(this, arguments); }

var SvgEyeOff = function SvgEyeOff(props) {
  return /*#__PURE__*/react.createElement("svg", eye_off_extends({
    xmlns: "http://www.w3.org/2000/svg",
    fill: "none",
    stroke: "currentColor",
    viewBox: "0 0 24 24"
  }, props), eye_off_path || (eye_off_path = /*#__PURE__*/react.createElement("path", {
    strokeLinecap: "round",
    strokeLinejoin: "round",
    strokeWidth: 2,
    d: "M13.875 18.825A10 10 0 0 1 12 19c-4.478 0-8.268-2.943-9.543-7A10 10 0 0 1 4.02 8.971m5.858.908a3 3 0 1 1 4.243 4.243M9.878 9.878l4.242 4.242M9.88 9.88 6.59 6.59m7.532 7.532 3.29 3.29M3 3l3.59 3.59m0 0A9.95 9.95 0 0 1 12 5c4.478 0 8.268 2.943 9.543 7a10.03 10.03 0 0 1-4.132 5.411m0 0L21 21"
  })));
};
/* harmony default export */ const eye_off = (SvgEyeOff);
;// ./react/ui/icon/icons/outline/eye.svg
var eye_path, eye_path2;
function eye_extends() { eye_extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return eye_extends.apply(this, arguments); }

var SvgEye = function SvgEye(props) {
  return /*#__PURE__*/react.createElement("svg", eye_extends({
    xmlns: "http://www.w3.org/2000/svg",
    fill: "none",
    stroke: "currentColor",
    viewBox: "0 0 24 24"
  }, props), eye_path || (eye_path = /*#__PURE__*/react.createElement("path", {
    strokeLinecap: "round",
    strokeLinejoin: "round",
    strokeWidth: 2,
    d: "M15 12a3 3 0 1 1-6 0 3 3 0 0 1 6 0"
  })), eye_path2 || (eye_path2 = /*#__PURE__*/react.createElement("path", {
    strokeLinecap: "round",
    strokeLinejoin: "round",
    strokeWidth: 2,
    d: "M2.458 12C3.732 7.943 7.523 5 12 5c4.478 0 8.268 2.943 9.542 7-1.274 4.057-5.064 7-9.542 7s-8.268-2.943-9.542-7"
  })));
};
/* harmony default export */ const eye = (SvgEye);
;// ./react/ui/icon/icons/outline/fast-forward.svg
var fast_forward_path;
function fast_forward_extends() { fast_forward_extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return fast_forward_extends.apply(this, arguments); }

var SvgFastForward = function SvgFastForward(props) {
  return /*#__PURE__*/react.createElement("svg", fast_forward_extends({
    xmlns: "http://www.w3.org/2000/svg",
    fill: "none",
    stroke: "currentColor",
    viewBox: "0 0 24 24"
  }, props), fast_forward_path || (fast_forward_path = /*#__PURE__*/react.createElement("path", {
    strokeLinecap: "round",
    strokeLinejoin: "round",
    strokeWidth: 2,
    d: "M11.933 12.8a1 1 0 0 0 0-1.6L6.6 7.2A1 1 0 0 0 5 8v8a1 1 0 0 0 1.6.8zm8 0a1 1 0 0 0 0-1.6l-5.333-4A1 1 0 0 0 13 8v8a1 1 0 0 0 1.6.8z"
  })));
};
/* harmony default export */ const fast_forward = (SvgFastForward);
;// ./react/ui/icon/icons/outline/film.svg
var film_path;
function film_extends() { film_extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return film_extends.apply(this, arguments); }

var SvgFilm = function SvgFilm(props) {
  return /*#__PURE__*/react.createElement("svg", film_extends({
    xmlns: "http://www.w3.org/2000/svg",
    fill: "none",
    stroke: "currentColor",
    viewBox: "0 0 24 24"
  }, props), film_path || (film_path = /*#__PURE__*/react.createElement("path", {
    strokeLinecap: "round",
    strokeLinejoin: "round",
    strokeWidth: 2,
    d: "M7 4v16M17 4v16M3 8h4m10 0h4M3 12h18M3 16h4m10 0h4M4 20h16a1 1 0 0 0 1-1V5a1 1 0 0 0-1-1H4a1 1 0 0 0-1 1v14a1 1 0 0 0 1 1"
  })));
};
/* harmony default export */ const film = (SvgFilm);
;// ./react/ui/icon/icons/outline/filter.svg
var filter_path;
function filter_extends() { filter_extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return filter_extends.apply(this, arguments); }

var SvgFilter = function SvgFilter(props) {
  return /*#__PURE__*/react.createElement("svg", filter_extends({
    xmlns: "http://www.w3.org/2000/svg",
    fill: "none",
    stroke: "currentColor",
    viewBox: "0 0 24 24"
  }, props), filter_path || (filter_path = /*#__PURE__*/react.createElement("path", {
    strokeLinecap: "round",
    strokeLinejoin: "round",
    strokeWidth: 2,
    d: "M3 4a1 1 0 0 1 1-1h16a1 1 0 0 1 1 1v2.586a1 1 0 0 1-.293.707l-6.414 6.414a1 1 0 0 0-.293.707V17l-4 4v-6.586a1 1 0 0 0-.293-.707L3.293 7.293A1 1 0 0 1 3 6.586z"
  })));
};
/* harmony default export */ const filter = (SvgFilter);
;// ./react/ui/icon/icons/outline/finger-print.svg
var finger_print_path;
function finger_print_extends() { finger_print_extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return finger_print_extends.apply(this, arguments); }

var SvgFingerPrint = function SvgFingerPrint(props) {
  return /*#__PURE__*/react.createElement("svg", finger_print_extends({
    xmlns: "http://www.w3.org/2000/svg",
    fill: "none",
    stroke: "currentColor",
    viewBox: "0 0 24 24"
  }, props), finger_print_path || (finger_print_path = /*#__PURE__*/react.createElement("path", {
    strokeLinecap: "round",
    strokeLinejoin: "round",
    strokeWidth: 2,
    d: "M12 11c0 3.517-1.009 6.799-2.753 9.571m-3.44-2.04.054-.09A13.9 13.9 0 0 0 8 11a4 4 0 1 1 8 0q-.002 1.527-.203 3m-2.118 6.844A22 22 0 0 0 15.171 17m3.839 1.132c.645-2.266.99-4.659.99-7.132A8 8 0 0 0 8 4.07M3 15.364c.64-1.319 1-2.8 1-4.364 0-1.457.39-2.823 1.07-4"
  })));
};
/* harmony default export */ const finger_print = (SvgFingerPrint);
;// ./react/ui/icon/icons/outline/fire.svg
var fire_path, fire_path2;
function fire_extends() { fire_extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return fire_extends.apply(this, arguments); }

var SvgFire = function SvgFire(props) {
  return /*#__PURE__*/react.createElement("svg", fire_extends({
    xmlns: "http://www.w3.org/2000/svg",
    fill: "none",
    stroke: "currentColor",
    viewBox: "0 0 24 24"
  }, props), fire_path || (fire_path = /*#__PURE__*/react.createElement("path", {
    strokeLinecap: "round",
    strokeLinejoin: "round",
    strokeWidth: 2,
    d: "M17.657 18.657A8 8 0 0 1 6.343 7.343S7 9 9 10c0-2 .5-5 2.986-7C14 5 16.09 5.777 17.656 7.343A7.98 7.98 0 0 1 20 13a7.98 7.98 0 0 1-2.343 5.657"
  })), fire_path2 || (fire_path2 = /*#__PURE__*/react.createElement("path", {
    strokeLinecap: "round",
    strokeLinejoin: "round",
    strokeWidth: 2,
    d: "M9.879 16.121A3 3 0 1 0 12.015 11L11 14H9c0 .768.293 1.536.879 2.121"
  })));
};
/* harmony default export */ const fire = (SvgFire);
;// ./react/ui/icon/icons/outline/flag.svg
var flag_path;
function flag_extends() { flag_extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return flag_extends.apply(this, arguments); }

var SvgFlag = function SvgFlag(props) {
  return /*#__PURE__*/react.createElement("svg", flag_extends({
    xmlns: "http://www.w3.org/2000/svg",
    fill: "none",
    stroke: "currentColor",
    viewBox: "0 0 24 24"
  }, props), flag_path || (flag_path = /*#__PURE__*/react.createElement("path", {
    strokeLinecap: "round",
    strokeLinejoin: "round",
    strokeWidth: 2,
    d: "M3 21v-4m0 0V5a2 2 0 0 1 2-2h6.5l1 1H21l-3 6 3 6h-8.5l-1-1H5a2 2 0 0 0-2 2m9-13.5V9"
  })));
};
/* harmony default export */ const flag = (SvgFlag);
;// ./react/ui/icon/icons/outline/folder-add.svg
var folder_add_path;
function folder_add_extends() { folder_add_extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return folder_add_extends.apply(this, arguments); }

var SvgFolderAdd = function SvgFolderAdd(props) {
  return /*#__PURE__*/react.createElement("svg", folder_add_extends({
    xmlns: "http://www.w3.org/2000/svg",
    fill: "none",
    stroke: "currentColor",
    viewBox: "0 0 24 24"
  }, props), folder_add_path || (folder_add_path = /*#__PURE__*/react.createElement("path", {
    strokeLinecap: "round",
    strokeLinejoin: "round",
    strokeWidth: 2,
    d: "M9 13h6m-3-3v6m-9 1V7a2 2 0 0 1 2-2h6l2 2h6a2 2 0 0 1 2 2v8a2 2 0 0 1-2 2H5a2 2 0 0 1-2-2"
  })));
};
/* harmony default export */ const folder_add = (SvgFolderAdd);
;// ./react/ui/icon/icons/outline/folder-download.svg
var folder_download_path;
function folder_download_extends() { folder_download_extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return folder_download_extends.apply(this, arguments); }

var SvgFolderDownload = function SvgFolderDownload(props) {
  return /*#__PURE__*/react.createElement("svg", folder_download_extends({
    xmlns: "http://www.w3.org/2000/svg",
    fill: "none",
    stroke: "currentColor",
    viewBox: "0 0 24 24"
  }, props), folder_download_path || (folder_download_path = /*#__PURE__*/react.createElement("path", {
    strokeLinecap: "round",
    strokeLinejoin: "round",
    strokeWidth: 2,
    d: "M12 10v6m0 0-3-3m3 3 3-3M3 17V7a2 2 0 0 1 2-2h6l2 2h6a2 2 0 0 1 2 2v8a2 2 0 0 1-2 2H5a2 2 0 0 1-2-2"
  })));
};
/* harmony default export */ const folder_download = (SvgFolderDownload);
;// ./react/ui/icon/icons/outline/folder-open.svg
var folder_open_path;
function folder_open_extends() { folder_open_extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return folder_open_extends.apply(this, arguments); }

var SvgFolderOpen = function SvgFolderOpen(props) {
  return /*#__PURE__*/react.createElement("svg", folder_open_extends({
    xmlns: "http://www.w3.org/2000/svg",
    fill: "none",
    stroke: "currentColor",
    viewBox: "0 0 24 24"
  }, props), folder_open_path || (folder_open_path = /*#__PURE__*/react.createElement("path", {
    strokeLinecap: "round",
    strokeLinejoin: "round",
    strokeWidth: 2,
    d: "M5 19a2 2 0 0 1-2-2V7a2 2 0 0 1 2-2h4l2 2h4a2 2 0 0 1 2 2v1M5 19h14a2 2 0 0 0 2-2v-5a2 2 0 0 0-2-2H9a2 2 0 0 0-2 2v5a2 2 0 0 1-2 2"
  })));
};
/* harmony default export */ const folder_open = (SvgFolderOpen);
;// ./react/ui/icon/icons/outline/folder-remove.svg
var folder_remove_path;
function folder_remove_extends() { folder_remove_extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return folder_remove_extends.apply(this, arguments); }

var SvgFolderRemove = function SvgFolderRemove(props) {
  return /*#__PURE__*/react.createElement("svg", folder_remove_extends({
    xmlns: "http://www.w3.org/2000/svg",
    fill: "none",
    stroke: "currentColor",
    viewBox: "0 0 24 24"
  }, props), folder_remove_path || (folder_remove_path = /*#__PURE__*/react.createElement("path", {
    strokeLinecap: "round",
    strokeLinejoin: "round",
    strokeWidth: 2,
    d: "M9 13h6M3 17V7a2 2 0 0 1 2-2h6l2 2h6a2 2 0 0 1 2 2v8a2 2 0 0 1-2 2H5a2 2 0 0 1-2-2"
  })));
};
/* harmony default export */ const folder_remove = (SvgFolderRemove);
;// ./react/ui/icon/icons/outline/folder.svg
var folder_path;
function folder_extends() { folder_extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return folder_extends.apply(this, arguments); }

var SvgFolder = function SvgFolder(props) {
  return /*#__PURE__*/react.createElement("svg", folder_extends({
    xmlns: "http://www.w3.org/2000/svg",
    fill: "none",
    stroke: "currentColor",
    viewBox: "0 0 24 24"
  }, props), folder_path || (folder_path = /*#__PURE__*/react.createElement("path", {
    strokeLinecap: "round",
    strokeLinejoin: "round",
    strokeWidth: 2,
    d: "M3 7v10a2 2 0 0 0 2 2h14a2 2 0 0 0 2-2V9a2 2 0 0 0-2-2h-6l-2-2H5a2 2 0 0 0-2 2"
  })));
};
/* harmony default export */ const folder = (SvgFolder);
;// ./react/ui/icon/icons/outline/gift.svg
var gift_path;
function gift_extends() { gift_extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return gift_extends.apply(this, arguments); }

var SvgGift = function SvgGift(props) {
  return /*#__PURE__*/react.createElement("svg", gift_extends({
    xmlns: "http://www.w3.org/2000/svg",
    fill: "none",
    stroke: "currentColor",
    viewBox: "0 0 24 24"
  }, props), gift_path || (gift_path = /*#__PURE__*/react.createElement("path", {
    strokeLinecap: "round",
    strokeLinejoin: "round",
    strokeWidth: 2,
    d: "M12 8v13m0-13V6a2 2 0 1 1 2 2zm0 0V5.5A2.5 2.5 0 1 0 9.5 8zm-7 4h14M5 12a2 2 0 1 1 0-4h14a2 2 0 1 1 0 4M5 12v7a2 2 0 0 0 2 2h10a2 2 0 0 0 2-2v-7"
  })));
};
/* harmony default export */ const gift = (SvgGift);
;// ./react/ui/icon/icons/outline/globe-alt.svg
var globe_alt_path;
function globe_alt_extends() { globe_alt_extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return globe_alt_extends.apply(this, arguments); }

var SvgGlobeAlt = function SvgGlobeAlt(props) {
  return /*#__PURE__*/react.createElement("svg", globe_alt_extends({
    xmlns: "http://www.w3.org/2000/svg",
    fill: "none",
    stroke: "currentColor",
    viewBox: "0 0 24 24"
  }, props), globe_alt_path || (globe_alt_path = /*#__PURE__*/react.createElement("path", {
    strokeLinecap: "round",
    strokeLinejoin: "round",
    strokeWidth: 2,
    d: "M21 12a9 9 0 0 1-9 9m9-9a9 9 0 0 0-9-9m9 9H3m9 9a9 9 0 0 1-9-9m9 9c1.657 0 3-4.03 3-9s-1.343-9-3-9m0 18c-1.657 0-3-4.03-3-9s1.343-9 3-9m-9 9a9 9 0 0 1 9-9"
  })));
};
/* harmony default export */ const globe_alt = (SvgGlobeAlt);
;// ./react/ui/icon/icons/outline/globe.svg
var globe_path;
function globe_extends() { globe_extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return globe_extends.apply(this, arguments); }

var SvgGlobe = function SvgGlobe(props) {
  return /*#__PURE__*/react.createElement("svg", globe_extends({
    xmlns: "http://www.w3.org/2000/svg",
    fill: "none",
    stroke: "currentColor",
    viewBox: "0 0 24 24"
  }, props), globe_path || (globe_path = /*#__PURE__*/react.createElement("path", {
    strokeLinecap: "round",
    strokeLinejoin: "round",
    strokeWidth: 2,
    d: "M3.055 11H5a2 2 0 0 1 2 2v1a2 2 0 0 0 2 2 2 2 0 0 1 2 2v2.945M8 3.935V5.5A2.5 2.5 0 0 0 10.5 8h.5a2 2 0 0 1 2 2 2 2 0 1 0 4 0 2 2 0 0 1 2-2h1.064M15 20.488V18a2 2 0 0 1 2-2h3.064M21 12a9 9 0 1 1-18 0 9 9 0 0 1 18 0"
  })));
};
/* harmony default export */ const globe = (SvgGlobe);
;// ./react/ui/icon/icons/outline/hand.svg
var hand_path;
function hand_extends() { hand_extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return hand_extends.apply(this, arguments); }

var SvgHand = function SvgHand(props) {
  return /*#__PURE__*/react.createElement("svg", hand_extends({
    xmlns: "http://www.w3.org/2000/svg",
    fill: "none",
    stroke: "currentColor",
    viewBox: "0 0 24 24"
  }, props), hand_path || (hand_path = /*#__PURE__*/react.createElement("path", {
    strokeLinecap: "round",
    strokeLinejoin: "round",
    strokeWidth: 2,
    d: "M7 11.5V14m0-2.5v-6a1.5 1.5 0 1 1 3 0m-3 6a1.5 1.5 0 0 0-3 0v2a7.5 7.5 0 0 0 15 0v-5a1.5 1.5 0 0 0-3 0m-6-3V11m0-5.5v-1a1.5 1.5 0 0 1 3 0v1m0 0V11m0-5.5a1.5 1.5 0 0 1 3 0v3m0 0V11"
  })));
};
/* harmony default export */ const hand = (SvgHand);
;// ./react/ui/icon/icons/outline/hashtag.svg
var hashtag_path;
function hashtag_extends() { hashtag_extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return hashtag_extends.apply(this, arguments); }

var SvgHashtag = function SvgHashtag(props) {
  return /*#__PURE__*/react.createElement("svg", hashtag_extends({
    xmlns: "http://www.w3.org/2000/svg",
    fill: "none",
    stroke: "currentColor",
    viewBox: "0 0 24 24"
  }, props), hashtag_path || (hashtag_path = /*#__PURE__*/react.createElement("path", {
    strokeLinecap: "round",
    strokeLinejoin: "round",
    strokeWidth: 2,
    d: "m7 20 4-16m2 16 4-16M6 9h14M4 15h14"
  })));
};
/* harmony default export */ const hashtag = (SvgHashtag);
;// ./react/ui/icon/icons/outline/heart.svg
var heart_path;
function heart_extends() { heart_extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return heart_extends.apply(this, arguments); }

var SvgHeart = function SvgHeart(props) {
  return /*#__PURE__*/react.createElement("svg", heart_extends({
    xmlns: "http://www.w3.org/2000/svg",
    fill: "none",
    stroke: "currentColor",
    viewBox: "0 0 24 24"
  }, props), heart_path || (heart_path = /*#__PURE__*/react.createElement("path", {
    strokeLinecap: "round",
    strokeLinejoin: "round",
    strokeWidth: 2,
    d: "M4.318 6.318a4.5 4.5 0 0 0 0 6.364L12 20.364l7.682-7.682a4.5 4.5 0 0 0-6.364-6.364L12 7.636l-1.318-1.318a4.5 4.5 0 0 0-6.364 0"
  })));
};
/* harmony default export */ const heart = (SvgHeart);
;// ./react/ui/icon/icons/outline/home.svg
var home_path;
function home_extends() { home_extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return home_extends.apply(this, arguments); }

var SvgHome = function SvgHome(props) {
  return /*#__PURE__*/react.createElement("svg", home_extends({
    xmlns: "http://www.w3.org/2000/svg",
    fill: "none",
    stroke: "currentColor",
    viewBox: "0 0 24 24"
  }, props), home_path || (home_path = /*#__PURE__*/react.createElement("path", {
    strokeLinecap: "round",
    strokeLinejoin: "round",
    strokeWidth: 2,
    d: "m3 12 2-2m0 0 7-7 7 7M5 10v10a1 1 0 0 0 1 1h3m10-11 2 2m-2-2v10a1 1 0 0 1-1 1h-3m-6 0a1 1 0 0 0 1-1v-4a1 1 0 0 1 1-1h2a1 1 0 0 1 1 1v4a1 1 0 0 0 1 1m-6 0h6"
  })));
};
/* harmony default export */ const home = (SvgHome);
;// ./react/ui/icon/icons/outline/identification.svg
var identification_path;
function identification_extends() { identification_extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return identification_extends.apply(this, arguments); }

var SvgIdentification = function SvgIdentification(props) {
  return /*#__PURE__*/react.createElement("svg", identification_extends({
    xmlns: "http://www.w3.org/2000/svg",
    fill: "none",
    stroke: "currentColor",
    viewBox: "0 0 24 24"
  }, props), identification_path || (identification_path = /*#__PURE__*/react.createElement("path", {
    strokeLinecap: "round",
    strokeLinejoin: "round",
    strokeWidth: 2,
    d: "M10 6H5a2 2 0 0 0-2 2v9a2 2 0 0 0 2 2h14a2 2 0 0 0 2-2V8a2 2 0 0 0-2-2h-5m-4 0V5a2 2 0 1 1 4 0v1m-4 0a2 2 0 1 0 4 0m-5 8a2 2 0 1 0 0-4 2 2 0 0 0 0 4m0 0c1.306 0 2.417.835 2.83 2M9 14a3 3 0 0 0-2.83 2M15 11h3m-3 4h2"
  })));
};
/* harmony default export */ const identification = (SvgIdentification);
;// ./react/ui/icon/icons/outline/inbox-in.svg
var inbox_in_path;
function inbox_in_extends() { inbox_in_extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return inbox_in_extends.apply(this, arguments); }

var SvgInboxIn = function SvgInboxIn(props) {
  return /*#__PURE__*/react.createElement("svg", inbox_in_extends({
    xmlns: "http://www.w3.org/2000/svg",
    fill: "none",
    stroke: "currentColor",
    viewBox: "0 0 24 24"
  }, props), inbox_in_path || (inbox_in_path = /*#__PURE__*/react.createElement("path", {
    strokeLinecap: "round",
    strokeLinejoin: "round",
    strokeWidth: 2,
    d: "M8 4H6a2 2 0 0 0-2 2v12a2 2 0 0 0 2 2h12a2 2 0 0 0 2-2V6a2 2 0 0 0-2-2h-2m-4-1v8m0 0 3-3m-3 3L9 8m-5 5h2.586a1 1 0 0 1 .707.293l2.414 2.414a1 1 0 0 0 .707.293h3.172a1 1 0 0 0 .707-.293l2.414-2.414a1 1 0 0 1 .707-.293H20"
  })));
};
/* harmony default export */ const inbox_in = (SvgInboxIn);
;// ./react/ui/icon/icons/outline/inbox.svg
var inbox_path;
function inbox_extends() { inbox_extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return inbox_extends.apply(this, arguments); }

var SvgInbox = function SvgInbox(props) {
  return /*#__PURE__*/react.createElement("svg", inbox_extends({
    xmlns: "http://www.w3.org/2000/svg",
    fill: "none",
    stroke: "currentColor",
    viewBox: "0 0 24 24"
  }, props), inbox_path || (inbox_path = /*#__PURE__*/react.createElement("path", {
    strokeLinecap: "round",
    strokeLinejoin: "round",
    strokeWidth: 2,
    d: "M20 13V6a2 2 0 0 0-2-2H6a2 2 0 0 0-2 2v7m16 0v5a2 2 0 0 1-2 2H6a2 2 0 0 1-2-2v-5m16 0h-2.586a1 1 0 0 0-.707.293l-2.414 2.414a1 1 0 0 1-.707.293h-3.172a1 1 0 0 1-.707-.293l-2.414-2.414A1 1 0 0 0 6.586 13H4"
  })));
};
/* harmony default export */ const inbox = (SvgInbox);
;// ./react/ui/icon/icons/outline/information-circle.svg
var information_circle_path;
function information_circle_extends() { information_circle_extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return information_circle_extends.apply(this, arguments); }

var SvgInformationCircle = function SvgInformationCircle(props) {
  return /*#__PURE__*/react.createElement("svg", information_circle_extends({
    xmlns: "http://www.w3.org/2000/svg",
    fill: "none",
    stroke: "currentColor",
    viewBox: "0 0 24 24"
  }, props), information_circle_path || (information_circle_path = /*#__PURE__*/react.createElement("path", {
    strokeLinecap: "round",
    strokeLinejoin: "round",
    strokeWidth: 2,
    d: "M13 16h-1v-4h-1m1-4h.01M21 12a9 9 0 1 1-18 0 9 9 0 0 1 18 0"
  })));
};
/* harmony default export */ const information_circle = (SvgInformationCircle);
;// ./react/ui/icon/icons/outline/key.svg
var key_path;
function key_extends() { key_extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return key_extends.apply(this, arguments); }

var SvgKey = function SvgKey(props) {
  return /*#__PURE__*/react.createElement("svg", key_extends({
    xmlns: "http://www.w3.org/2000/svg",
    fill: "none",
    stroke: "currentColor",
    viewBox: "0 0 24 24"
  }, props), key_path || (key_path = /*#__PURE__*/react.createElement("path", {
    strokeLinecap: "round",
    strokeLinejoin: "round",
    strokeWidth: 2,
    d: "M15 7a2 2 0 0 1 2 2m4 0a6 6 0 0 1-7.743 5.743L11 17H9v2H7v2H4a1 1 0 0 1-1-1v-2.586a1 1 0 0 1 .293-.707l5.964-5.964A6 6 0 1 1 21 9"
  })));
};
/* harmony default export */ const key = (SvgKey);
;// ./react/ui/icon/icons/outline/library.svg
var library_path;
function library_extends() { library_extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return library_extends.apply(this, arguments); }

var SvgLibrary = function SvgLibrary(props) {
  return /*#__PURE__*/react.createElement("svg", library_extends({
    xmlns: "http://www.w3.org/2000/svg",
    fill: "none",
    stroke: "currentColor",
    viewBox: "0 0 24 24"
  }, props), library_path || (library_path = /*#__PURE__*/react.createElement("path", {
    strokeLinecap: "round",
    strokeLinejoin: "round",
    strokeWidth: 2,
    d: "M8 14v3m4-3v3m4-3v3M3 21h18M3 10h18M3 7l9-4 9 4M4 10h16v11H4z"
  })));
};
/* harmony default export */ const library = (SvgLibrary);
;// ./react/ui/icon/icons/outline/light-bulb.svg
var light_bulb_path;
function light_bulb_extends() { light_bulb_extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return light_bulb_extends.apply(this, arguments); }

var SvgLightBulb = function SvgLightBulb(props) {
  return /*#__PURE__*/react.createElement("svg", light_bulb_extends({
    xmlns: "http://www.w3.org/2000/svg",
    fill: "none",
    stroke: "currentColor",
    viewBox: "0 0 24 24"
  }, props), light_bulb_path || (light_bulb_path = /*#__PURE__*/react.createElement("path", {
    strokeLinecap: "round",
    strokeLinejoin: "round",
    strokeWidth: 2,
    d: "M9.663 17h4.673M12 3v1m6.364 1.636-.707.707M21 12h-1M4 12H3m3.343-5.657-.707-.707m2.828 9.9a5 5 0 1 1 7.072 0l-.548.547A3.37 3.37 0 0 0 14 18.469V19a2 2 0 1 1-4 0v-.531c0-.895-.356-1.754-.988-2.386z"
  })));
};
/* harmony default export */ const light_bulb = (SvgLightBulb);
;// ./react/ui/icon/icons/outline/lightning-bolt.svg
var lightning_bolt_path;
function lightning_bolt_extends() { lightning_bolt_extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return lightning_bolt_extends.apply(this, arguments); }

var SvgLightningBolt = function SvgLightningBolt(props) {
  return /*#__PURE__*/react.createElement("svg", lightning_bolt_extends({
    xmlns: "http://www.w3.org/2000/svg",
    fill: "none",
    stroke: "currentColor",
    viewBox: "0 0 24 24"
  }, props), lightning_bolt_path || (lightning_bolt_path = /*#__PURE__*/react.createElement("path", {
    strokeLinecap: "round",
    strokeLinejoin: "round",
    strokeWidth: 2,
    d: "M13 10V3L4 14h7v7l9-11z"
  })));
};
/* harmony default export */ const lightning_bolt = (SvgLightningBolt);
;// ./react/ui/icon/icons/outline/link.svg
var link_path;
function link_extends() { link_extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return link_extends.apply(this, arguments); }

var SvgLink = function SvgLink(props) {
  return /*#__PURE__*/react.createElement("svg", link_extends({
    xmlns: "http://www.w3.org/2000/svg",
    fill: "none",
    stroke: "currentColor",
    viewBox: "0 0 24 24"
  }, props), link_path || (link_path = /*#__PURE__*/react.createElement("path", {
    strokeLinecap: "round",
    strokeLinejoin: "round",
    strokeWidth: 2,
    d: "M13.828 10.172a4 4 0 0 0-5.656 0l-4 4a4 4 0 1 0 5.656 5.656l1.102-1.101m-.758-4.899a4 4 0 0 0 5.656 0l4-4a4 4 0 0 0-5.656-5.656l-1.1 1.1"
  })));
};
/* harmony default export */ const outline_link = (SvgLink);
;// ./react/ui/icon/icons/outline/location-marker.svg
var location_marker_path, location_marker_path2;
function location_marker_extends() { location_marker_extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return location_marker_extends.apply(this, arguments); }

var SvgLocationMarker = function SvgLocationMarker(props) {
  return /*#__PURE__*/react.createElement("svg", location_marker_extends({
    xmlns: "http://www.w3.org/2000/svg",
    fill: "none",
    stroke: "currentColor",
    viewBox: "0 0 24 24"
  }, props), location_marker_path || (location_marker_path = /*#__PURE__*/react.createElement("path", {
    strokeLinecap: "round",
    strokeLinejoin: "round",
    strokeWidth: 2,
    d: "M17.657 16.657 13.414 20.9a2 2 0 0 1-2.827 0l-4.244-4.243a8 8 0 1 1 11.314 0"
  })), location_marker_path2 || (location_marker_path2 = /*#__PURE__*/react.createElement("path", {
    strokeLinecap: "round",
    strokeLinejoin: "round",
    strokeWidth: 2,
    d: "M15 11a3 3 0 1 1-6 0 3 3 0 0 1 6 0"
  })));
};
/* harmony default export */ const location_marker = (SvgLocationMarker);
;// ./react/ui/icon/icons/outline/lock-closed.svg
var lock_closed_path;
function lock_closed_extends() { lock_closed_extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return lock_closed_extends.apply(this, arguments); }

var SvgLockClosed = function SvgLockClosed(props) {
  return /*#__PURE__*/react.createElement("svg", lock_closed_extends({
    xmlns: "http://www.w3.org/2000/svg",
    fill: "none",
    stroke: "currentColor",
    viewBox: "0 0 24 24"
  }, props), lock_closed_path || (lock_closed_path = /*#__PURE__*/react.createElement("path", {
    strokeLinecap: "round",
    strokeLinejoin: "round",
    strokeWidth: 2,
    d: "M12 15v2m-6 4h12a2 2 0 0 0 2-2v-6a2 2 0 0 0-2-2H6a2 2 0 0 0-2 2v6a2 2 0 0 0 2 2m10-10V7a4 4 0 0 0-8 0v4z"
  })));
};
/* harmony default export */ const lock_closed = (SvgLockClosed);
;// ./react/ui/icon/icons/outline/lock-open.svg
var lock_open_path;
function lock_open_extends() { lock_open_extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return lock_open_extends.apply(this, arguments); }

var SvgLockOpen = function SvgLockOpen(props) {
  return /*#__PURE__*/react.createElement("svg", lock_open_extends({
    xmlns: "http://www.w3.org/2000/svg",
    fill: "none",
    stroke: "currentColor",
    viewBox: "0 0 24 24"
  }, props), lock_open_path || (lock_open_path = /*#__PURE__*/react.createElement("path", {
    strokeLinecap: "round",
    strokeLinejoin: "round",
    strokeWidth: 2,
    d: "M8 11V7a4 4 0 1 1 8 0m-4 8v2m-6 4h12a2 2 0 0 0 2-2v-6a2 2 0 0 0-2-2H6a2 2 0 0 0-2 2v6a2 2 0 0 0 2 2"
  })));
};
/* harmony default export */ const lock_open = (SvgLockOpen);
;// ./react/ui/icon/icons/outline/login.svg
var login_path;
function login_extends() { login_extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return login_extends.apply(this, arguments); }

var SvgLogin = function SvgLogin(props) {
  return /*#__PURE__*/react.createElement("svg", login_extends({
    xmlns: "http://www.w3.org/2000/svg",
    fill: "none",
    stroke: "currentColor",
    viewBox: "0 0 24 24"
  }, props), login_path || (login_path = /*#__PURE__*/react.createElement("path", {
    strokeLinecap: "round",
    strokeLinejoin: "round",
    strokeWidth: 2,
    d: "m11 16-4-4m0 0 4-4m-4 4h14m-5 4v1a3 3 0 0 1-3 3H6a3 3 0 0 1-3-3V7a3 3 0 0 1 3-3h7a3 3 0 0 1 3 3v1"
  })));
};
/* harmony default export */ const login = (SvgLogin);
;// ./react/ui/icon/icons/outline/logout.svg
var logout_path;
function logout_extends() { logout_extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return logout_extends.apply(this, arguments); }

var SvgLogout = function SvgLogout(props) {
  return /*#__PURE__*/react.createElement("svg", logout_extends({
    xmlns: "http://www.w3.org/2000/svg",
    fill: "none",
    stroke: "currentColor",
    viewBox: "0 0 24 24"
  }, props), logout_path || (logout_path = /*#__PURE__*/react.createElement("path", {
    strokeLinecap: "round",
    strokeLinejoin: "round",
    strokeWidth: 2,
    d: "m17 16 4-4m0 0-4-4m4 4H7m6 4v1a3 3 0 0 1-3 3H6a3 3 0 0 1-3-3V7a3 3 0 0 1 3-3h4a3 3 0 0 1 3 3v1"
  })));
};
/* harmony default export */ const logout = (SvgLogout);
;// ./react/ui/icon/icons/outline/mail-open.svg
var mail_open_path;
function mail_open_extends() { mail_open_extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return mail_open_extends.apply(this, arguments); }

var SvgMailOpen = function SvgMailOpen(props) {
  return /*#__PURE__*/react.createElement("svg", mail_open_extends({
    xmlns: "http://www.w3.org/2000/svg",
    fill: "none",
    stroke: "currentColor",
    viewBox: "0 0 24 24"
  }, props), mail_open_path || (mail_open_path = /*#__PURE__*/react.createElement("path", {
    strokeLinecap: "round",
    strokeLinejoin: "round",
    strokeWidth: 2,
    d: "M3 19v-8.93a2 2 0 0 1 .89-1.664l7-4.666a2 2 0 0 1 2.22 0l7 4.666A2 2 0 0 1 21 10.07V19M3 19a2 2 0 0 0 2 2h14a2 2 0 0 0 2-2M3 19l6.75-4.5M21 19l-6.75-4.5M3 10l6.75 4.5M21 10l-6.75 4.5m0 0-1.14.76a2 2 0 0 1-2.22 0l-1.14-.76"
  })));
};
/* harmony default export */ const mail_open = (SvgMailOpen);
;// ./react/ui/icon/icons/outline/mail.svg
var mail_path;
function mail_extends() { mail_extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return mail_extends.apply(this, arguments); }

var SvgMail = function SvgMail(props) {
  return /*#__PURE__*/react.createElement("svg", mail_extends({
    xmlns: "http://www.w3.org/2000/svg",
    fill: "none",
    stroke: "currentColor",
    viewBox: "0 0 24 24"
  }, props), mail_path || (mail_path = /*#__PURE__*/react.createElement("path", {
    strokeLinecap: "round",
    strokeLinejoin: "round",
    strokeWidth: 2,
    d: "m3 8 7.89 5.26a2 2 0 0 0 2.22 0L21 8M5 19h14a2 2 0 0 0 2-2V7a2 2 0 0 0-2-2H5a2 2 0 0 0-2 2v10a2 2 0 0 0 2 2"
  })));
};
/* harmony default export */ const mail = (SvgMail);
;// ./react/ui/icon/icons/outline/map.svg
var map_path;
function map_extends() { map_extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return map_extends.apply(this, arguments); }

var SvgMap = function SvgMap(props) {
  return /*#__PURE__*/react.createElement("svg", map_extends({
    xmlns: "http://www.w3.org/2000/svg",
    fill: "none",
    stroke: "currentColor",
    viewBox: "0 0 24 24"
  }, props), map_path || (map_path = /*#__PURE__*/react.createElement("path", {
    strokeLinecap: "round",
    strokeLinejoin: "round",
    strokeWidth: 2,
    d: "m9 20-5.447-2.724A1 1 0 0 1 3 16.382V5.618a1 1 0 0 1 1.447-.894L9 7m0 13 6-3m-6 3V7m6 10 4.553 2.276A1 1 0 0 0 21 18.382V7.618a1 1 0 0 0-.553-.894L15 4m0 13V4m0 0L9 7"
  })));
};
/* harmony default export */ const map = (SvgMap);
;// ./react/ui/icon/icons/outline/menu-alt-1.svg
var menu_alt_1_path;
function menu_alt_1_extends() { menu_alt_1_extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return menu_alt_1_extends.apply(this, arguments); }

var SvgMenuAlt1 = function SvgMenuAlt1(props) {
  return /*#__PURE__*/react.createElement("svg", menu_alt_1_extends({
    xmlns: "http://www.w3.org/2000/svg",
    fill: "none",
    stroke: "currentColor",
    viewBox: "0 0 24 24"
  }, props), menu_alt_1_path || (menu_alt_1_path = /*#__PURE__*/react.createElement("path", {
    strokeLinecap: "round",
    strokeLinejoin: "round",
    strokeWidth: 2,
    d: "M4 6h16M4 12h8m-8 6h16"
  })));
};
/* harmony default export */ const menu_alt_1 = (SvgMenuAlt1);
;// ./react/ui/icon/icons/outline/menu-alt-2.svg
var menu_alt_2_path;
function menu_alt_2_extends() { menu_alt_2_extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return menu_alt_2_extends.apply(this, arguments); }

var SvgMenuAlt2 = function SvgMenuAlt2(props) {
  return /*#__PURE__*/react.createElement("svg", menu_alt_2_extends({
    xmlns: "http://www.w3.org/2000/svg",
    fill: "none",
    stroke: "currentColor",
    viewBox: "0 0 24 24"
  }, props), menu_alt_2_path || (menu_alt_2_path = /*#__PURE__*/react.createElement("path", {
    strokeLinecap: "round",
    strokeLinejoin: "round",
    strokeWidth: 2,
    d: "M4 6h16M4 12h16M4 18h7"
  })));
};
/* harmony default export */ const menu_alt_2 = (SvgMenuAlt2);
;// ./react/ui/icon/icons/outline/menu-alt-3.svg
var menu_alt_3_path;
function menu_alt_3_extends() { menu_alt_3_extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return menu_alt_3_extends.apply(this, arguments); }

var SvgMenuAlt3 = function SvgMenuAlt3(props) {
  return /*#__PURE__*/react.createElement("svg", menu_alt_3_extends({
    xmlns: "http://www.w3.org/2000/svg",
    fill: "none",
    stroke: "currentColor",
    viewBox: "0 0 24 24"
  }, props), menu_alt_3_path || (menu_alt_3_path = /*#__PURE__*/react.createElement("path", {
    strokeLinecap: "round",
    strokeLinejoin: "round",
    strokeWidth: 2,
    d: "M4 6h16M4 12h16m-7 6h7"
  })));
};
/* harmony default export */ const menu_alt_3 = (SvgMenuAlt3);
;// ./react/ui/icon/icons/outline/menu-alt-4.svg
var menu_alt_4_path;
function menu_alt_4_extends() { menu_alt_4_extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return menu_alt_4_extends.apply(this, arguments); }

var SvgMenuAlt4 = function SvgMenuAlt4(props) {
  return /*#__PURE__*/react.createElement("svg", menu_alt_4_extends({
    xmlns: "http://www.w3.org/2000/svg",
    fill: "none",
    stroke: "currentColor",
    viewBox: "0 0 24 24"
  }, props), menu_alt_4_path || (menu_alt_4_path = /*#__PURE__*/react.createElement("path", {
    strokeLinecap: "round",
    strokeLinejoin: "round",
    strokeWidth: 2,
    d: "M4 8h16M4 16h16"
  })));
};
/* harmony default export */ const menu_alt_4 = (SvgMenuAlt4);
;// ./react/ui/icon/icons/outline/menu.svg
var menu_path;
function menu_extends() { menu_extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return menu_extends.apply(this, arguments); }

var SvgMenu = function SvgMenu(props) {
  return /*#__PURE__*/react.createElement("svg", menu_extends({
    xmlns: "http://www.w3.org/2000/svg",
    fill: "none",
    stroke: "currentColor",
    viewBox: "0 0 24 24"
  }, props), menu_path || (menu_path = /*#__PURE__*/react.createElement("path", {
    strokeLinecap: "round",
    strokeLinejoin: "round",
    strokeWidth: 2,
    d: "M4 6h16M4 12h16M4 18h16"
  })));
};
/* harmony default export */ const menu = (SvgMenu);
;// ./react/ui/icon/icons/outline/microphone.svg
var microphone_path;
function microphone_extends() { microphone_extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return microphone_extends.apply(this, arguments); }

var SvgMicrophone = function SvgMicrophone(props) {
  return /*#__PURE__*/react.createElement("svg", microphone_extends({
    xmlns: "http://www.w3.org/2000/svg",
    fill: "none",
    stroke: "currentColor",
    viewBox: "0 0 24 24"
  }, props), microphone_path || (microphone_path = /*#__PURE__*/react.createElement("path", {
    strokeLinecap: "round",
    strokeLinejoin: "round",
    strokeWidth: 2,
    d: "M19 11a7 7 0 0 1-7 7m0 0a7 7 0 0 1-7-7m7 7v4m0 0H8m4 0h4m-4-8a3 3 0 0 1-3-3V5a3 3 0 1 1 6 0v6a3 3 0 0 1-3 3"
  })));
};
/* harmony default export */ const microphone = (SvgMicrophone);
;// ./react/ui/icon/icons/outline/minus-circle.svg
var minus_circle_path;
function minus_circle_extends() { minus_circle_extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return minus_circle_extends.apply(this, arguments); }

var SvgMinusCircle = function SvgMinusCircle(props) {
  return /*#__PURE__*/react.createElement("svg", minus_circle_extends({
    xmlns: "http://www.w3.org/2000/svg",
    fill: "none",
    stroke: "currentColor",
    viewBox: "0 0 24 24"
  }, props), minus_circle_path || (minus_circle_path = /*#__PURE__*/react.createElement("path", {
    strokeLinecap: "round",
    strokeLinejoin: "round",
    strokeWidth: 2,
    d: "M15 12H9m12 0a9 9 0 1 1-18 0 9 9 0 0 1 18 0"
  })));
};
/* harmony default export */ const minus_circle = (SvgMinusCircle);
;// ./react/ui/icon/icons/outline/minus-sm.svg
var minus_sm_path;
function minus_sm_extends() { minus_sm_extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return minus_sm_extends.apply(this, arguments); }

var SvgMinusSm = function SvgMinusSm(props) {
  return /*#__PURE__*/react.createElement("svg", minus_sm_extends({
    xmlns: "http://www.w3.org/2000/svg",
    fill: "none",
    stroke: "currentColor",
    viewBox: "0 0 24 24"
  }, props), minus_sm_path || (minus_sm_path = /*#__PURE__*/react.createElement("path", {
    strokeLinecap: "round",
    strokeLinejoin: "round",
    strokeWidth: 2,
    d: "M18 12H6"
  })));
};
/* harmony default export */ const minus_sm = (SvgMinusSm);
;// ./react/ui/icon/icons/outline/minus.svg
var minus_path;
function minus_extends() { minus_extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return minus_extends.apply(this, arguments); }

var SvgMinus = function SvgMinus(props) {
  return /*#__PURE__*/react.createElement("svg", minus_extends({
    xmlns: "http://www.w3.org/2000/svg",
    fill: "none",
    stroke: "currentColor",
    viewBox: "0 0 24 24"
  }, props), minus_path || (minus_path = /*#__PURE__*/react.createElement("path", {
    strokeLinecap: "round",
    strokeLinejoin: "round",
    strokeWidth: 2,
    d: "M20 12H4"
  })));
};
/* harmony default export */ const minus = (SvgMinus);
;// ./react/ui/icon/icons/outline/moon.svg
var moon_path;
function moon_extends() { moon_extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return moon_extends.apply(this, arguments); }

var SvgMoon = function SvgMoon(props) {
  return /*#__PURE__*/react.createElement("svg", moon_extends({
    xmlns: "http://www.w3.org/2000/svg",
    fill: "none",
    stroke: "currentColor",
    viewBox: "0 0 24 24"
  }, props), moon_path || (moon_path = /*#__PURE__*/react.createElement("path", {
    strokeLinecap: "round",
    strokeLinejoin: "round",
    strokeWidth: 2,
    d: "M20.354 15.354A9 9 0 0 1 8.646 3.646 9.003 9.003 0 0 0 12 21a9 9 0 0 0 8.354-5.646"
  })));
};
/* harmony default export */ const moon = (SvgMoon);
;// ./react/ui/icon/icons/outline/music-note.svg
var music_note_path;
function music_note_extends() { music_note_extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return music_note_extends.apply(this, arguments); }

var SvgMusicNote = function SvgMusicNote(props) {
  return /*#__PURE__*/react.createElement("svg", music_note_extends({
    xmlns: "http://www.w3.org/2000/svg",
    fill: "none",
    stroke: "currentColor",
    viewBox: "0 0 24 24"
  }, props), music_note_path || (music_note_path = /*#__PURE__*/react.createElement("path", {
    strokeLinecap: "round",
    strokeLinejoin: "round",
    strokeWidth: 2,
    d: "M9 19V6l12-3v13M9 19c0 1.105-1.343 2-3 2s-3-.895-3-2 1.343-2 3-2 3 .895 3 2m12-3c0 1.105-1.343 2-3 2s-3-.895-3-2 1.343-2 3-2 3 .895 3 2M9 10l12-3"
  })));
};
/* harmony default export */ const music_note = (SvgMusicNote);
;// ./react/ui/icon/icons/outline/newspaper.svg
var newspaper_path;
function newspaper_extends() { newspaper_extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return newspaper_extends.apply(this, arguments); }

var SvgNewspaper = function SvgNewspaper(props) {
  return /*#__PURE__*/react.createElement("svg", newspaper_extends({
    xmlns: "http://www.w3.org/2000/svg",
    fill: "none",
    stroke: "currentColor",
    viewBox: "0 0 24 24"
  }, props), newspaper_path || (newspaper_path = /*#__PURE__*/react.createElement("path", {
    strokeLinecap: "round",
    strokeLinejoin: "round",
    strokeWidth: 2,
    d: "M19 20H5a2 2 0 0 1-2-2V6a2 2 0 0 1 2-2h10a2 2 0 0 1 2 2v1m2 13a2 2 0 0 1-2-2V7m2 13a2 2 0 0 0 2-2V9a2 2 0 0 0-2-2h-2m-4-3H9M7 16h6M7 8h6v4H7z"
  })));
};
/* harmony default export */ const newspaper = (SvgNewspaper);
;// ./react/ui/icon/icons/outline/no-symbol.svg
var no_symbol_path;
function no_symbol_extends() { no_symbol_extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return no_symbol_extends.apply(this, arguments); }

var SvgNoSymbol = function SvgNoSymbol(props) {
  return /*#__PURE__*/react.createElement("svg", no_symbol_extends({
    xmlns: "http://www.w3.org/2000/svg",
    fill: "none",
    stroke: "currentColor",
    strokeWidth: 1.5,
    className: "no-symbol_svg__size-6",
    viewBox: "0 0 24 24"
  }, props), no_symbol_path || (no_symbol_path = /*#__PURE__*/react.createElement("path", {
    strokeLinecap: "round",
    strokeLinejoin: "round",
    d: "M18.364 18.364A9 9 0 0 0 5.636 5.636m12.728 12.728A9 9 0 0 1 5.636 5.636m12.728 12.728L5.636 5.636"
  })));
};
/* harmony default export */ const no_symbol = (SvgNoSymbol);
;// ./react/ui/icon/icons/outline/office-building.svg
var office_building_path;
function office_building_extends() { office_building_extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return office_building_extends.apply(this, arguments); }

var SvgOfficeBuilding = function SvgOfficeBuilding(props) {
  return /*#__PURE__*/react.createElement("svg", office_building_extends({
    xmlns: "http://www.w3.org/2000/svg",
    fill: "none",
    stroke: "currentColor",
    viewBox: "0 0 24 24"
  }, props), office_building_path || (office_building_path = /*#__PURE__*/react.createElement("path", {
    strokeLinecap: "round",
    strokeLinejoin: "round",
    strokeWidth: 2,
    d: "M19 21V5a2 2 0 0 0-2-2H7a2 2 0 0 0-2 2v16m14 0h2m-2 0h-5m-9 0H3m2 0h5M9 7h1m-1 4h1m4-4h1m-1 4h1m-5 10v-5a1 1 0 0 1 1-1h2a1 1 0 0 1 1 1v5m-4 0h4"
  })));
};
/* harmony default export */ const office_building = (SvgOfficeBuilding);
;// ./react/ui/icon/icons/outline/paper-airplane.svg
var paper_airplane_path;
function paper_airplane_extends() { paper_airplane_extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return paper_airplane_extends.apply(this, arguments); }

var SvgPaperAirplane = function SvgPaperAirplane(props) {
  return /*#__PURE__*/react.createElement("svg", paper_airplane_extends({
    xmlns: "http://www.w3.org/2000/svg",
    fill: "none",
    stroke: "currentColor",
    viewBox: "0 0 24 24"
  }, props), paper_airplane_path || (paper_airplane_path = /*#__PURE__*/react.createElement("path", {
    strokeLinecap: "round",
    strokeLinejoin: "round",
    strokeWidth: 2,
    d: "m12 19 9 2-9-18-9 18zm0 0v-8"
  })));
};
/* harmony default export */ const paper_airplane = (SvgPaperAirplane);
;// ./react/ui/icon/icons/outline/paper-clip.svg
var paper_clip_path;
function paper_clip_extends() { paper_clip_extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return paper_clip_extends.apply(this, arguments); }

var SvgPaperClip = function SvgPaperClip(props) {
  return /*#__PURE__*/react.createElement("svg", paper_clip_extends({
    xmlns: "http://www.w3.org/2000/svg",
    fill: "none",
    stroke: "currentColor",
    viewBox: "0 0 24 24"
  }, props), paper_clip_path || (paper_clip_path = /*#__PURE__*/react.createElement("path", {
    strokeLinecap: "round",
    strokeLinejoin: "round",
    strokeWidth: 2,
    d: "m15.172 7-6.586 6.586a2 2 0 1 0 2.828 2.828l6.414-6.586a4 4 0 0 0-5.656-5.656l-6.415 6.585a6 6 0 1 0 8.486 8.486L20.5 13"
  })));
};
/* harmony default export */ const paper_clip = (SvgPaperClip);
;// ./react/ui/icon/icons/outline/pause.svg
var pause_path;
function pause_extends() { pause_extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return pause_extends.apply(this, arguments); }

var SvgPause = function SvgPause(props) {
  return /*#__PURE__*/react.createElement("svg", pause_extends({
    xmlns: "http://www.w3.org/2000/svg",
    fill: "none",
    stroke: "currentColor",
    viewBox: "0 0 24 24"
  }, props), pause_path || (pause_path = /*#__PURE__*/react.createElement("path", {
    strokeLinecap: "round",
    strokeLinejoin: "round",
    strokeWidth: 2,
    d: "M10 9v6m4-6v6m7-3a9 9 0 1 1-18 0 9 9 0 0 1 18 0"
  })));
};
/* harmony default export */ const pause = (SvgPause);
;// ./react/ui/icon/icons/outline/pencil-alt.svg
var pencil_alt_path;
function pencil_alt_extends() { pencil_alt_extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return pencil_alt_extends.apply(this, arguments); }

var SvgPencilAlt = function SvgPencilAlt(props) {
  return /*#__PURE__*/react.createElement("svg", pencil_alt_extends({
    xmlns: "http://www.w3.org/2000/svg",
    fill: "none",
    stroke: "currentColor",
    viewBox: "0 0 24 24"
  }, props), pencil_alt_path || (pencil_alt_path = /*#__PURE__*/react.createElement("path", {
    strokeLinecap: "round",
    strokeLinejoin: "round",
    strokeWidth: 2,
    d: "M11 5H6a2 2 0 0 0-2 2v11a2 2 0 0 0 2 2h11a2 2 0 0 0 2-2v-5m-1.414-9.414a2 2 0 1 1 2.828 2.828L11.828 15H9v-2.828z"
  })));
};
/* harmony default export */ const pencil_alt = (SvgPencilAlt);
;// ./react/ui/icon/icons/outline/pencil.svg
var pencil_path;
function pencil_extends() { pencil_extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return pencil_extends.apply(this, arguments); }

var SvgPencil = function SvgPencil(props) {
  return /*#__PURE__*/react.createElement("svg", pencil_extends({
    xmlns: "http://www.w3.org/2000/svg",
    fill: "none",
    stroke: "currentColor",
    viewBox: "0 0 24 24"
  }, props), pencil_path || (pencil_path = /*#__PURE__*/react.createElement("path", {
    strokeLinecap: "round",
    strokeLinejoin: "round",
    strokeWidth: 2,
    d: "m15.232 5.232 3.536 3.536m-2.036-5.036a2.5 2.5 0 1 1 3.536 3.536L6.5 21.036H3v-3.572z"
  })));
};
/* harmony default export */ const pencil = (SvgPencil);
;// ./react/ui/icon/icons/outline/phone-incoming.svg
var phone_incoming_path;
function phone_incoming_extends() { phone_incoming_extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return phone_incoming_extends.apply(this, arguments); }

var SvgPhoneIncoming = function SvgPhoneIncoming(props) {
  return /*#__PURE__*/react.createElement("svg", phone_incoming_extends({
    xmlns: "http://www.w3.org/2000/svg",
    fill: "none",
    stroke: "currentColor",
    viewBox: "0 0 24 24"
  }, props), phone_incoming_path || (phone_incoming_path = /*#__PURE__*/react.createElement("path", {
    strokeLinecap: "round",
    strokeLinejoin: "round",
    strokeWidth: 2,
    d: "m21 3-6 6m0 0V4m0 5h5M5 3a2 2 0 0 0-2 2v1c0 8.284 6.716 15 15 15h1a2 2 0 0 0 2-2v-3.28a1 1 0 0 0-.684-.948l-4.493-1.498a1 1 0 0 0-1.21.502l-1.13 2.257a11.04 11.04 0 0 1-5.516-5.517l2.257-1.128a1 1 0 0 0 .502-1.21L9.228 3.683A1 1 0 0 0 8.279 3z"
  })));
};
/* harmony default export */ const phone_incoming = (SvgPhoneIncoming);
;// ./react/ui/icon/icons/outline/phone-missed-call.svg
var phone_missed_call_path;
function phone_missed_call_extends() { phone_missed_call_extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return phone_missed_call_extends.apply(this, arguments); }

var SvgPhoneMissedCall = function SvgPhoneMissedCall(props) {
  return /*#__PURE__*/react.createElement("svg", phone_missed_call_extends({
    xmlns: "http://www.w3.org/2000/svg",
    fill: "none",
    stroke: "currentColor",
    viewBox: "0 0 24 24"
  }, props), phone_missed_call_path || (phone_missed_call_path = /*#__PURE__*/react.createElement("path", {
    strokeLinecap: "round",
    strokeLinejoin: "round",
    strokeWidth: 2,
    d: "m16 8 2-2m0 0 2-2m-2 2-2-2m2 2 2 2M5 3a2 2 0 0 0-2 2v1c0 8.284 6.716 15 15 15h1a2 2 0 0 0 2-2v-3.28a1 1 0 0 0-.684-.948l-4.493-1.498a1 1 0 0 0-1.21.502l-1.13 2.257a11.04 11.04 0 0 1-5.516-5.517l2.257-1.128a1 1 0 0 0 .502-1.21L9.228 3.683A1 1 0 0 0 8.279 3z"
  })));
};
/* harmony default export */ const phone_missed_call = (SvgPhoneMissedCall);
;// ./react/ui/icon/icons/outline/phone-outgoing.svg
var phone_outgoing_path;
function phone_outgoing_extends() { phone_outgoing_extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return phone_outgoing_extends.apply(this, arguments); }

var SvgPhoneOutgoing = function SvgPhoneOutgoing(props) {
  return /*#__PURE__*/react.createElement("svg", phone_outgoing_extends({
    xmlns: "http://www.w3.org/2000/svg",
    fill: "none",
    stroke: "currentColor",
    viewBox: "0 0 24 24"
  }, props), phone_outgoing_path || (phone_outgoing_path = /*#__PURE__*/react.createElement("path", {
    strokeLinecap: "round",
    strokeLinejoin: "round",
    strokeWidth: 2,
    d: "M16 3h5m0 0v5m0-5-6 6M5 3a2 2 0 0 0-2 2v1c0 8.284 6.716 15 15 15h1a2 2 0 0 0 2-2v-3.28a1 1 0 0 0-.684-.948l-4.493-1.498a1 1 0 0 0-1.21.502l-1.13 2.257a11.04 11.04 0 0 1-5.516-5.517l2.257-1.128a1 1 0 0 0 .502-1.21L9.228 3.683A1 1 0 0 0 8.279 3z"
  })));
};
/* harmony default export */ const phone_outgoing = (SvgPhoneOutgoing);
;// ./react/ui/icon/icons/outline/phone.svg
var phone_path;
function phone_extends() { phone_extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return phone_extends.apply(this, arguments); }

var SvgPhone = function SvgPhone(props) {
  return /*#__PURE__*/react.createElement("svg", phone_extends({
    xmlns: "http://www.w3.org/2000/svg",
    fill: "none",
    stroke: "currentColor",
    viewBox: "0 0 24 24"
  }, props), phone_path || (phone_path = /*#__PURE__*/react.createElement("path", {
    strokeLinecap: "round",
    strokeLinejoin: "round",
    strokeWidth: 2,
    d: "M3 5a2 2 0 0 1 2-2h3.28a1 1 0 0 1 .948.684l1.498 4.493a1 1 0 0 1-.502 1.21l-2.257 1.13a11.04 11.04 0 0 0 5.516 5.516l1.13-2.257a1 1 0 0 1 1.21-.502l4.493 1.498a1 1 0 0 1 .684.949V19a2 2 0 0 1-2 2h-1C9.716 21 3 14.284 3 6z"
  })));
};
/* harmony default export */ const phone = (SvgPhone);
;// ./react/ui/icon/icons/outline/photograph.svg
var photograph_path;
function photograph_extends() { photograph_extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return photograph_extends.apply(this, arguments); }

var SvgPhotograph = function SvgPhotograph(props) {
  return /*#__PURE__*/react.createElement("svg", photograph_extends({
    xmlns: "http://www.w3.org/2000/svg",
    fill: "none",
    stroke: "currentColor",
    viewBox: "0 0 24 24"
  }, props), photograph_path || (photograph_path = /*#__PURE__*/react.createElement("path", {
    strokeLinecap: "round",
    strokeLinejoin: "round",
    strokeWidth: 2,
    d: "m4 16 4.586-4.586a2 2 0 0 1 2.828 0L16 16m-2-2 1.586-1.586a2 2 0 0 1 2.828 0L20 14m-6-6h.01M6 20h12a2 2 0 0 0 2-2V6a2 2 0 0 0-2-2H6a2 2 0 0 0-2 2v12a2 2 0 0 0 2 2"
  })));
};
/* harmony default export */ const photograph = (SvgPhotograph);
;// ./react/ui/icon/icons/outline/play.svg
var play_path, play_path2;
function play_extends() { play_extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return play_extends.apply(this, arguments); }

var SvgPlay = function SvgPlay(props) {
  return /*#__PURE__*/react.createElement("svg", play_extends({
    xmlns: "http://www.w3.org/2000/svg",
    fill: "none",
    stroke: "currentColor",
    viewBox: "0 0 24 24"
  }, props), play_path || (play_path = /*#__PURE__*/react.createElement("path", {
    strokeLinecap: "round",
    strokeLinejoin: "round",
    strokeWidth: 2,
    d: "m14.752 11.168-3.197-2.132A1 1 0 0 0 10 9.87v4.263a1 1 0 0 0 1.555.832l3.197-2.132a1 1 0 0 0 0-1.664z"
  })), play_path2 || (play_path2 = /*#__PURE__*/react.createElement("path", {
    strokeLinecap: "round",
    strokeLinejoin: "round",
    strokeWidth: 2,
    d: "M21 12a9 9 0 1 1-18 0 9 9 0 0 1 18 0"
  })));
};
/* harmony default export */ const play = (SvgPlay);
;// ./react/ui/icon/icons/outline/plus-circle.svg
var plus_circle_path;
function plus_circle_extends() { plus_circle_extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return plus_circle_extends.apply(this, arguments); }

var SvgPlusCircle = function SvgPlusCircle(props) {
  return /*#__PURE__*/react.createElement("svg", plus_circle_extends({
    xmlns: "http://www.w3.org/2000/svg",
    fill: "none",
    stroke: "currentColor",
    viewBox: "0 0 24 24"
  }, props), plus_circle_path || (plus_circle_path = /*#__PURE__*/react.createElement("path", {
    strokeLinecap: "round",
    strokeLinejoin: "round",
    strokeWidth: 2,
    d: "M12 9v3m0 0v3m0-3h3m-3 0H9m12 0a9 9 0 1 1-18 0 9 9 0 0 1 18 0"
  })));
};
/* harmony default export */ const plus_circle = (SvgPlusCircle);
;// ./react/ui/icon/icons/outline/plus-sm.svg
var plus_sm_path;
function plus_sm_extends() { plus_sm_extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return plus_sm_extends.apply(this, arguments); }

var SvgPlusSm = function SvgPlusSm(props) {
  return /*#__PURE__*/react.createElement("svg", plus_sm_extends({
    xmlns: "http://www.w3.org/2000/svg",
    fill: "none",
    stroke: "currentColor",
    viewBox: "0 0 24 24"
  }, props), plus_sm_path || (plus_sm_path = /*#__PURE__*/react.createElement("path", {
    strokeLinecap: "round",
    strokeLinejoin: "round",
    strokeWidth: 2,
    d: "M12 6v6m0 0v6m0-6h6m-6 0H6"
  })));
};
/* harmony default export */ const plus_sm = (SvgPlusSm);
;// ./react/ui/icon/icons/outline/plus.svg
var plus_path;
function plus_extends() { plus_extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return plus_extends.apply(this, arguments); }

var SvgPlus = function SvgPlus(props) {
  return /*#__PURE__*/react.createElement("svg", plus_extends({
    xmlns: "http://www.w3.org/2000/svg",
    fill: "none",
    stroke: "currentColor",
    viewBox: "0 0 24 24"
  }, props), plus_path || (plus_path = /*#__PURE__*/react.createElement("path", {
    strokeLinecap: "round",
    strokeLinejoin: "round",
    strokeWidth: 2,
    d: "M12 6v6m0 0v6m0-6h6m-6 0H6"
  })));
};
/* harmony default export */ const plus = (SvgPlus);
;// ./react/ui/icon/icons/outline/presentation-chart-bar.svg
var presentation_chart_bar_path;
function presentation_chart_bar_extends() { presentation_chart_bar_extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return presentation_chart_bar_extends.apply(this, arguments); }

var SvgPresentationChartBar = function SvgPresentationChartBar(props) {
  return /*#__PURE__*/react.createElement("svg", presentation_chart_bar_extends({
    xmlns: "http://www.w3.org/2000/svg",
    fill: "none",
    stroke: "currentColor",
    viewBox: "0 0 24 24"
  }, props), presentation_chart_bar_path || (presentation_chart_bar_path = /*#__PURE__*/react.createElement("path", {
    strokeLinecap: "round",
    strokeLinejoin: "round",
    strokeWidth: 2,
    d: "M8 13v-1m4 1v-3m4 3V8M8 21l4-4 4 4M3 4h18M4 4h16v12a1 1 0 0 1-1 1H5a1 1 0 0 1-1-1z"
  })));
};
/* harmony default export */ const presentation_chart_bar = (SvgPresentationChartBar);
;// ./react/ui/icon/icons/outline/presentation-chart-line.svg
var presentation_chart_line_path;
function presentation_chart_line_extends() { presentation_chart_line_extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return presentation_chart_line_extends.apply(this, arguments); }

var SvgPresentationChartLine = function SvgPresentationChartLine(props) {
  return /*#__PURE__*/react.createElement("svg", presentation_chart_line_extends({
    xmlns: "http://www.w3.org/2000/svg",
    fill: "none",
    stroke: "currentColor",
    viewBox: "0 0 24 24"
  }, props), presentation_chart_line_path || (presentation_chart_line_path = /*#__PURE__*/react.createElement("path", {
    strokeLinecap: "round",
    strokeLinejoin: "round",
    strokeWidth: 2,
    d: "m7 12 3-3 3 3 4-4M8 21l4-4 4 4M3 4h18M4 4h16v12a1 1 0 0 1-1 1H5a1 1 0 0 1-1-1z"
  })));
};
/* harmony default export */ const presentation_chart_line = (SvgPresentationChartLine);
;// ./react/ui/icon/icons/outline/printer.svg
var printer_path;
function printer_extends() { printer_extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return printer_extends.apply(this, arguments); }

var SvgPrinter = function SvgPrinter(props) {
  return /*#__PURE__*/react.createElement("svg", printer_extends({
    xmlns: "http://www.w3.org/2000/svg",
    fill: "none",
    stroke: "currentColor",
    viewBox: "0 0 24 24"
  }, props), printer_path || (printer_path = /*#__PURE__*/react.createElement("path", {
    strokeLinecap: "round",
    strokeLinejoin: "round",
    strokeWidth: 2,
    d: "M17 17h2a2 2 0 0 0 2-2v-4a2 2 0 0 0-2-2H5a2 2 0 0 0-2 2v4a2 2 0 0 0 2 2h2m2 4h6a2 2 0 0 0 2-2v-4a2 2 0 0 0-2-2H9a2 2 0 0 0-2 2v4a2 2 0 0 0 2 2m8-12V5a2 2 0 0 0-2-2H9a2 2 0 0 0-2 2v4z"
  })));
};
/* harmony default export */ const printer = (SvgPrinter);
;// ./react/ui/icon/icons/outline/puzzle.svg
var puzzle_path;
function puzzle_extends() { puzzle_extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return puzzle_extends.apply(this, arguments); }

var SvgPuzzle = function SvgPuzzle(props) {
  return /*#__PURE__*/react.createElement("svg", puzzle_extends({
    xmlns: "http://www.w3.org/2000/svg",
    fill: "none",
    stroke: "currentColor",
    viewBox: "0 0 24 24"
  }, props), puzzle_path || (puzzle_path = /*#__PURE__*/react.createElement("path", {
    strokeLinecap: "round",
    strokeLinejoin: "round",
    strokeWidth: 2,
    d: "M11 4a2 2 0 1 1 4 0v1a1 1 0 0 0 1 1h3a1 1 0 0 1 1 1v3a1 1 0 0 1-1 1h-1a2 2 0 1 0 0 4h1a1 1 0 0 1 1 1v3a1 1 0 0 1-1 1h-3a1 1 0 0 1-1-1v-1a2 2 0 1 0-4 0v1a1 1 0 0 1-1 1H7a1 1 0 0 1-1-1v-3a1 1 0 0 0-1-1H4a2 2 0 1 1 0-4h1a1 1 0 0 0 1-1V7a1 1 0 0 1 1-1h3a1 1 0 0 0 1-1z"
  })));
};
/* harmony default export */ const puzzle = (SvgPuzzle);
;// ./react/ui/icon/icons/outline/qrcode.svg
var qrcode_path;
function qrcode_extends() { qrcode_extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return qrcode_extends.apply(this, arguments); }

var SvgQrcode = function SvgQrcode(props) {
  return /*#__PURE__*/react.createElement("svg", qrcode_extends({
    xmlns: "http://www.w3.org/2000/svg",
    fill: "none",
    stroke: "currentColor",
    viewBox: "0 0 24 24"
  }, props), qrcode_path || (qrcode_path = /*#__PURE__*/react.createElement("path", {
    strokeLinecap: "round",
    strokeLinejoin: "round",
    strokeWidth: 2,
    d: "M12 4v1m6 11h2m-6 0h-2v4m0-11v3m0 0h.01M12 12h4.01M16 20h4M4 12h4m12 0h.01M5 8h2a1 1 0 0 0 1-1V5a1 1 0 0 0-1-1H5a1 1 0 0 0-1 1v2a1 1 0 0 0 1 1m12 0h2a1 1 0 0 0 1-1V5a1 1 0 0 0-1-1h-2a1 1 0 0 0-1 1v2a1 1 0 0 0 1 1M5 20h2a1 1 0 0 0 1-1v-2a1 1 0 0 0-1-1H5a1 1 0 0 0-1 1v2a1 1 0 0 0 1 1"
  })));
};
/* harmony default export */ const qrcode = (SvgQrcode);
;// ./react/ui/icon/icons/outline/question-mark-circle.svg
var question_mark_circle_path;
function question_mark_circle_extends() { question_mark_circle_extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return question_mark_circle_extends.apply(this, arguments); }

var SvgQuestionMarkCircle = function SvgQuestionMarkCircle(props) {
  return /*#__PURE__*/react.createElement("svg", question_mark_circle_extends({
    xmlns: "http://www.w3.org/2000/svg",
    fill: "none",
    stroke: "currentColor",
    viewBox: "0 0 24 24"
  }, props), question_mark_circle_path || (question_mark_circle_path = /*#__PURE__*/react.createElement("path", {
    strokeLinecap: "round",
    strokeLinejoin: "round",
    strokeWidth: 2,
    d: "M8.228 9c.549-1.165 2.03-2 3.772-2 2.21 0 4 1.343 4 3 0 1.4-1.278 2.575-3.006 2.907-.542.104-.994.54-.994 1.093m0 3h.01M21 12a9 9 0 1 1-18 0 9 9 0 0 1 18 0"
  })));
};
/* harmony default export */ const question_mark_circle = (SvgQuestionMarkCircle);
;// ./react/ui/icon/icons/outline/receipt-refund.svg
var receipt_refund_path;
function receipt_refund_extends() { receipt_refund_extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return receipt_refund_extends.apply(this, arguments); }

var SvgReceiptRefund = function SvgReceiptRefund(props) {
  return /*#__PURE__*/react.createElement("svg", receipt_refund_extends({
    xmlns: "http://www.w3.org/2000/svg",
    fill: "none",
    stroke: "currentColor",
    viewBox: "0 0 24 24"
  }, props), receipt_refund_path || (receipt_refund_path = /*#__PURE__*/react.createElement("path", {
    strokeLinecap: "round",
    strokeLinejoin: "round",
    strokeWidth: 2,
    d: "M16 15v-1a4 4 0 0 0-4-4H8m0 0 3 3m-3-3 3-3m9 14V5a2 2 0 0 0-2-2H6a2 2 0 0 0-2 2v16l4-2 4 2 4-2z"
  })));
};
/* harmony default export */ const receipt_refund = (SvgReceiptRefund);
;// ./react/ui/icon/icons/outline/receipt-tax.svg
var receipt_tax_path;
function receipt_tax_extends() { receipt_tax_extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return receipt_tax_extends.apply(this, arguments); }

var SvgReceiptTax = function SvgReceiptTax(props) {
  return /*#__PURE__*/react.createElement("svg", receipt_tax_extends({
    xmlns: "http://www.w3.org/2000/svg",
    fill: "none",
    stroke: "currentColor",
    viewBox: "0 0 24 24"
  }, props), receipt_tax_path || (receipt_tax_path = /*#__PURE__*/react.createElement("path", {
    strokeLinecap: "round",
    strokeLinejoin: "round",
    strokeWidth: 2,
    d: "m9 14 6-6m-5.5.5h.01m4.99 5h.01M19 21V5a2 2 0 0 0-2-2H7a2 2 0 0 0-2 2v16l3.5-2 3.5 2 3.5-2zM10 8.5a.5.5 0 1 1-1 0 .5.5 0 0 1 1 0m5 5a.5.5 0 1 1-1 0 .5.5 0 0 1 1 0"
  })));
};
/* harmony default export */ const receipt_tax = (SvgReceiptTax);
;// ./react/ui/icon/icons/outline/refresh.svg
var refresh_path;
function refresh_extends() { refresh_extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return refresh_extends.apply(this, arguments); }

var SvgRefresh = function SvgRefresh(props) {
  return /*#__PURE__*/react.createElement("svg", refresh_extends({
    xmlns: "http://www.w3.org/2000/svg",
    fill: "none",
    stroke: "currentColor",
    viewBox: "0 0 24 24"
  }, props), refresh_path || (refresh_path = /*#__PURE__*/react.createElement("path", {
    strokeLinecap: "round",
    strokeLinejoin: "round",
    strokeWidth: 2,
    d: "M4 4v5h.582m15.356 2A8.001 8.001 0 0 0 4.582 9m0 0H9m11 11v-5h-.581m0 0a8.003 8.003 0 0 1-15.357-2m15.357 2H15"
  })));
};
/* harmony default export */ const refresh = (SvgRefresh);
;// ./react/ui/icon/icons/outline/reply.svg
var reply_path;
function reply_extends() { reply_extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return reply_extends.apply(this, arguments); }

var SvgReply = function SvgReply(props) {
  return /*#__PURE__*/react.createElement("svg", reply_extends({
    xmlns: "http://www.w3.org/2000/svg",
    fill: "none",
    stroke: "currentColor",
    viewBox: "0 0 24 24"
  }, props), reply_path || (reply_path = /*#__PURE__*/react.createElement("path", {
    strokeLinecap: "round",
    strokeLinejoin: "round",
    strokeWidth: 2,
    d: "M3 10h10a8 8 0 0 1 8 8v2M3 10l6 6m-6-6 6-6"
  })));
};
/* harmony default export */ const reply = (SvgReply);
;// ./react/ui/icon/icons/outline/rewind.svg
var rewind_path;
function rewind_extends() { rewind_extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return rewind_extends.apply(this, arguments); }

var SvgRewind = function SvgRewind(props) {
  return /*#__PURE__*/react.createElement("svg", rewind_extends({
    xmlns: "http://www.w3.org/2000/svg",
    fill: "none",
    stroke: "currentColor",
    viewBox: "0 0 24 24"
  }, props), rewind_path || (rewind_path = /*#__PURE__*/react.createElement("path", {
    strokeLinecap: "round",
    strokeLinejoin: "round",
    strokeWidth: 2,
    d: "M12.066 11.2a1 1 0 0 0 0 1.6l5.334 4A1 1 0 0 0 19 16V8a1 1 0 0 0-1.6-.8zm-8 0a1 1 0 0 0 0 1.6l5.334 4A1 1 0 0 0 11 16V8a1 1 0 0 0-1.6-.8z"
  })));
};
/* harmony default export */ const rewind = (SvgRewind);
;// ./react/ui/icon/icons/outline/rss.svg
var rss_path;
function rss_extends() { rss_extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return rss_extends.apply(this, arguments); }

var SvgRss = function SvgRss(props) {
  return /*#__PURE__*/react.createElement("svg", rss_extends({
    xmlns: "http://www.w3.org/2000/svg",
    fill: "none",
    stroke: "currentColor",
    viewBox: "0 0 24 24"
  }, props), rss_path || (rss_path = /*#__PURE__*/react.createElement("path", {
    strokeLinecap: "round",
    strokeLinejoin: "round",
    strokeWidth: 2,
    d: "M6 5c7.18 0 13 5.82 13 13M6 11a7 7 0 0 1 7 7m-6 0a1 1 0 1 1-2 0 1 1 0 0 1 2 0"
  })));
};
/* harmony default export */ const rss = (SvgRss);
;// ./react/ui/icon/icons/outline/save-as.svg
var save_as_path;
function save_as_extends() { save_as_extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return save_as_extends.apply(this, arguments); }

var SvgSaveAs = function SvgSaveAs(props) {
  return /*#__PURE__*/react.createElement("svg", save_as_extends({
    xmlns: "http://www.w3.org/2000/svg",
    fill: "none",
    stroke: "currentColor",
    viewBox: "0 0 24 24"
  }, props), save_as_path || (save_as_path = /*#__PURE__*/react.createElement("path", {
    strokeLinecap: "round",
    strokeLinejoin: "round",
    strokeWidth: 2,
    d: "M17 16v2a2 2 0 0 1-2 2H5a2 2 0 0 1-2-2v-7a2 2 0 0 1 2-2h2m3-4H9a2 2 0 0 0-2 2v7a2 2 0 0 0 2 2h10a2 2 0 0 0 2-2V7a2 2 0 0 0-2-2h-1m-1 4-3 3m0 0-3-3m3 3V3"
  })));
};
/* harmony default export */ const save_as = (SvgSaveAs);
;// ./react/ui/icon/icons/outline/save.svg
var save_path;
function save_extends() { save_extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return save_extends.apply(this, arguments); }

var SvgSave = function SvgSave(props) {
  return /*#__PURE__*/react.createElement("svg", save_extends({
    xmlns: "http://www.w3.org/2000/svg",
    fill: "none",
    stroke: "currentColor",
    viewBox: "0 0 24 24"
  }, props), save_path || (save_path = /*#__PURE__*/react.createElement("path", {
    strokeLinecap: "round",
    strokeLinejoin: "round",
    strokeWidth: 2,
    d: "M8 7H5a2 2 0 0 0-2 2v9a2 2 0 0 0 2 2h14a2 2 0 0 0 2-2V9a2 2 0 0 0-2-2h-3m-1 4-3 3m0 0-3-3m3 3V4"
  })));
};
/* harmony default export */ const save = (SvgSave);
;// ./react/ui/icon/icons/outline/scale.svg
var scale_path;
function scale_extends() { scale_extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return scale_extends.apply(this, arguments); }

var SvgScale = function SvgScale(props) {
  return /*#__PURE__*/react.createElement("svg", scale_extends({
    xmlns: "http://www.w3.org/2000/svg",
    fill: "none",
    stroke: "currentColor",
    viewBox: "0 0 24 24"
  }, props), scale_path || (scale_path = /*#__PURE__*/react.createElement("path", {
    strokeLinecap: "round",
    strokeLinejoin: "round",
    strokeWidth: 2,
    d: "m3 6 3 1m0 0-3 9a5 5 0 0 0 6.001 0M6 7l3 9M6 7l6-2m6 2 3-1m-3 1-3 9a5 5 0 0 0 6.001 0M18 7l3 9m-3-9-6-2m0-2v2m0 16V5m0 16H9m3 0h3"
  })));
};
/* harmony default export */ const scale = (SvgScale);
;// ./react/ui/icon/icons/outline/scissors.svg
var scissors_path;
function scissors_extends() { scissors_extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return scissors_extends.apply(this, arguments); }

var SvgScissors = function SvgScissors(props) {
  return /*#__PURE__*/react.createElement("svg", scissors_extends({
    xmlns: "http://www.w3.org/2000/svg",
    fill: "none",
    stroke: "currentColor",
    viewBox: "0 0 24 24"
  }, props), scissors_path || (scissors_path = /*#__PURE__*/react.createElement("path", {
    strokeLinecap: "round",
    strokeLinejoin: "round",
    strokeWidth: 2,
    d: "M14.121 14.121 19 19m-7-7 7-7m-7 7-2.879 2.879M12 12 9.121 9.121m0 5.758a3 3 0 1 0-4.243 4.243 3 3 0 0 0 4.243-4.243m0-5.758a3 3 0 1 0-4.243-4.243 3 3 0 0 0 4.243 4.243"
  })));
};
/* harmony default export */ const scissors = (SvgScissors);
;// ./react/ui/icon/icons/outline/search-circle.svg
var search_circle_path;
function search_circle_extends() { search_circle_extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return search_circle_extends.apply(this, arguments); }

var SvgSearchCircle = function SvgSearchCircle(props) {
  return /*#__PURE__*/react.createElement("svg", search_circle_extends({
    xmlns: "http://www.w3.org/2000/svg",
    fill: "none",
    stroke: "currentColor",
    viewBox: "0 0 24 24"
  }, props), search_circle_path || (search_circle_path = /*#__PURE__*/react.createElement("path", {
    strokeLinecap: "round",
    strokeLinejoin: "round",
    strokeWidth: 2,
    d: "m8 16 2.879-2.879m0 0a3 3 0 1 0 4.243-4.242 3 3 0 0 0-4.243 4.242M21 12a9 9 0 1 1-18 0 9 9 0 0 1 18 0"
  })));
};
/* harmony default export */ const search_circle = (SvgSearchCircle);
;// ./react/ui/icon/icons/outline/search.svg
var search_path;
function search_extends() { search_extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return search_extends.apply(this, arguments); }

var SvgSearch = function SvgSearch(props) {
  return /*#__PURE__*/react.createElement("svg", search_extends({
    xmlns: "http://www.w3.org/2000/svg",
    fill: "none",
    stroke: "currentColor",
    viewBox: "0 0 24 24"
  }, props), search_path || (search_path = /*#__PURE__*/react.createElement("path", {
    strokeLinecap: "round",
    strokeLinejoin: "round",
    strokeWidth: 2,
    d: "m21 21-6-6m2-5a7 7 0 1 1-14 0 7 7 0 0 1 14 0"
  })));
};
/* harmony default export */ const search = (SvgSearch);
;// ./react/ui/icon/icons/outline/selector.svg
var selector_path;
function selector_extends() { selector_extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return selector_extends.apply(this, arguments); }

var SvgSelector = function SvgSelector(props) {
  return /*#__PURE__*/react.createElement("svg", selector_extends({
    xmlns: "http://www.w3.org/2000/svg",
    fill: "none",
    stroke: "currentColor",
    viewBox: "0 0 24 24"
  }, props), selector_path || (selector_path = /*#__PURE__*/react.createElement("path", {
    strokeLinecap: "round",
    strokeLinejoin: "round",
    strokeWidth: 2,
    d: "m8 9 4-4 4 4m0 6-4 4-4-4"
  })));
};
/* harmony default export */ const selector = (SvgSelector);
;// ./react/ui/icon/icons/outline/server.svg
var server_path;
function server_extends() { server_extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return server_extends.apply(this, arguments); }

var SvgServer = function SvgServer(props) {
  return /*#__PURE__*/react.createElement("svg", server_extends({
    xmlns: "http://www.w3.org/2000/svg",
    fill: "none",
    stroke: "currentColor",
    viewBox: "0 0 24 24"
  }, props), server_path || (server_path = /*#__PURE__*/react.createElement("path", {
    strokeLinecap: "round",
    strokeLinejoin: "round",
    strokeWidth: 2,
    d: "M5 12h14M5 12a2 2 0 0 1-2-2V6a2 2 0 0 1 2-2h14a2 2 0 0 1 2 2v4a2 2 0 0 1-2 2M5 12a2 2 0 0 0-2 2v4a2 2 0 0 0 2 2h14a2 2 0 0 0 2-2v-4a2 2 0 0 0-2-2m-2-4h.01M17 16h.01"
  })));
};
/* harmony default export */ const server = (SvgServer);
;// ./react/ui/icon/icons/outline/share.svg
var share_path;
function share_extends() { share_extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return share_extends.apply(this, arguments); }

var SvgShare = function SvgShare(props) {
  return /*#__PURE__*/react.createElement("svg", share_extends({
    xmlns: "http://www.w3.org/2000/svg",
    fill: "none",
    stroke: "currentColor",
    viewBox: "0 0 24 24"
  }, props), share_path || (share_path = /*#__PURE__*/react.createElement("path", {
    strokeLinecap: "round",
    strokeLinejoin: "round",
    strokeWidth: 2,
    d: "M8.684 13.342C8.886 12.938 9 12.482 9 12s-.114-.938-.316-1.342m0 2.684a3 3 0 1 1 0-2.684m0 2.684 6.632 3.316m-6.632-6 6.632-3.316m0 0a3 3 0 1 0 5.367-2.684 3 3 0 0 0-5.367 2.684m0 9.316a3 3 0 1 0 5.368 2.684 3 3 0 0 0-5.368-2.684"
  })));
};
/* harmony default export */ const share = (SvgShare);
;// ./react/ui/icon/icons/outline/shield-check.svg
var shield_check_path;
function shield_check_extends() { shield_check_extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return shield_check_extends.apply(this, arguments); }

var SvgShieldCheck = function SvgShieldCheck(props) {
  return /*#__PURE__*/react.createElement("svg", shield_check_extends({
    xmlns: "http://www.w3.org/2000/svg",
    fill: "none",
    stroke: "currentColor",
    viewBox: "0 0 24 24"
  }, props), shield_check_path || (shield_check_path = /*#__PURE__*/react.createElement("path", {
    strokeLinecap: "round",
    strokeLinejoin: "round",
    strokeWidth: 2,
    d: "m9 12 2 2 4-4m5.618-4.016A11.96 11.96 0 0 1 12 2.944a11.96 11.96 0 0 1-8.618 3.04A12 12 0 0 0 3 9c0 5.591 3.824 10.29 9 11.622 5.176-1.332 9-6.03 9-11.622 0-1.042-.133-2.052-.382-3.016"
  })));
};
/* harmony default export */ const shield_check = (SvgShieldCheck);
;// ./react/ui/icon/icons/outline/shield-exclamation.svg
var shield_exclamation_path;
function shield_exclamation_extends() { shield_exclamation_extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return shield_exclamation_extends.apply(this, arguments); }

var SvgShieldExclamation = function SvgShieldExclamation(props) {
  return /*#__PURE__*/react.createElement("svg", shield_exclamation_extends({
    xmlns: "http://www.w3.org/2000/svg",
    fill: "none",
    stroke: "currentColor",
    viewBox: "0 0 24 24"
  }, props), shield_exclamation_path || (shield_exclamation_path = /*#__PURE__*/react.createElement("path", {
    strokeLinecap: "round",
    strokeLinejoin: "round",
    strokeWidth: 2,
    d: "M20.618 5.984A11.96 11.96 0 0 1 12 2.944a11.96 11.96 0 0 1-8.618 3.04A12 12 0 0 0 3 9c0 5.591 3.824 10.29 9 11.622 5.176-1.332 9-6.03 9-11.622 0-1.042-.133-2.052-.382-3.016M12 9v2m0 4h.01"
  })));
};
/* harmony default export */ const shield_exclamation = (SvgShieldExclamation);
;// ./react/ui/icon/icons/outline/shopping-bag.svg
var shopping_bag_path;
function shopping_bag_extends() { shopping_bag_extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return shopping_bag_extends.apply(this, arguments); }

var SvgShoppingBag = function SvgShoppingBag(props) {
  return /*#__PURE__*/react.createElement("svg", shopping_bag_extends({
    xmlns: "http://www.w3.org/2000/svg",
    fill: "none",
    stroke: "currentColor",
    viewBox: "0 0 24 24"
  }, props), shopping_bag_path || (shopping_bag_path = /*#__PURE__*/react.createElement("path", {
    strokeLinecap: "round",
    strokeLinejoin: "round",
    strokeWidth: 2,
    d: "M16 11V7a4 4 0 0 0-8 0v4M5 9h14l1 12H4z"
  })));
};
/* harmony default export */ const shopping_bag = (SvgShoppingBag);
;// ./react/ui/icon/icons/outline/shopping-cart.svg
var shopping_cart_path;
function shopping_cart_extends() { shopping_cart_extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return shopping_cart_extends.apply(this, arguments); }

var SvgShoppingCart = function SvgShoppingCart(props) {
  return /*#__PURE__*/react.createElement("svg", shopping_cart_extends({
    xmlns: "http://www.w3.org/2000/svg",
    fill: "none",
    stroke: "currentColor",
    viewBox: "0 0 24 24"
  }, props), shopping_cart_path || (shopping_cart_path = /*#__PURE__*/react.createElement("path", {
    strokeLinecap: "round",
    strokeLinejoin: "round",
    strokeWidth: 2,
    d: "M3 3h2l.4 2M7 13h10l4-8H5.4M7 13 5.4 5M7 13l-2.293 2.293c-.63.63-.184 1.707.707 1.707H17m0 0a2 2 0 1 0 0 4 2 2 0 0 0 0-4m-8 2a2 2 0 1 1-4 0 2 2 0 0 1 4 0"
  })));
};
/* harmony default export */ const shopping_cart = (SvgShoppingCart);
;// ./react/ui/icon/icons/outline/sort-ascending.svg
var sort_ascending_path;
function sort_ascending_extends() { sort_ascending_extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return sort_ascending_extends.apply(this, arguments); }

var SvgSortAscending = function SvgSortAscending(props) {
  return /*#__PURE__*/react.createElement("svg", sort_ascending_extends({
    xmlns: "http://www.w3.org/2000/svg",
    fill: "none",
    stroke: "currentColor",
    viewBox: "0 0 24 24"
  }, props), sort_ascending_path || (sort_ascending_path = /*#__PURE__*/react.createElement("path", {
    strokeLinecap: "round",
    strokeLinejoin: "round",
    strokeWidth: 2,
    d: "M3 4h13M3 8h9m-9 4h6m4 0 4-4m0 0 4 4m-4-4v12"
  })));
};
/* harmony default export */ const sort_ascending = (SvgSortAscending);
;// ./react/ui/icon/icons/outline/sort-descending.svg
var sort_descending_path;
function sort_descending_extends() { sort_descending_extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return sort_descending_extends.apply(this, arguments); }

var SvgSortDescending = function SvgSortDescending(props) {
  return /*#__PURE__*/react.createElement("svg", sort_descending_extends({
    xmlns: "http://www.w3.org/2000/svg",
    fill: "none",
    stroke: "currentColor",
    viewBox: "0 0 24 24"
  }, props), sort_descending_path || (sort_descending_path = /*#__PURE__*/react.createElement("path", {
    strokeLinecap: "round",
    strokeLinejoin: "round",
    strokeWidth: 2,
    d: "M3 4h13M3 8h9m-9 4h9m5-4v12m0 0-4-4m4 4 4-4"
  })));
};
/* harmony default export */ const sort_descending = (SvgSortDescending);
;// ./react/ui/icon/icons/outline/sparkles.svg
var sparkles_path;
function sparkles_extends() { sparkles_extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return sparkles_extends.apply(this, arguments); }

var SvgSparkles = function SvgSparkles(props) {
  return /*#__PURE__*/react.createElement("svg", sparkles_extends({
    xmlns: "http://www.w3.org/2000/svg",
    fill: "none",
    stroke: "currentColor",
    viewBox: "0 0 24 24"
  }, props), sparkles_path || (sparkles_path = /*#__PURE__*/react.createElement("path", {
    strokeLinecap: "round",
    strokeLinejoin: "round",
    strokeWidth: 2,
    d: "M5 3v4M3 5h4M6 17v4m-2-2h4m5-16 2.286 6.857L21 12l-5.714 2.143L13 21l-2.286-6.857L5 12l5.714-2.143z"
  })));
};
/* harmony default export */ const sparkles = (SvgSparkles);
;// ./react/ui/icon/icons/outline/speakerphone.svg
var speakerphone_path;
function speakerphone_extends() { speakerphone_extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return speakerphone_extends.apply(this, arguments); }

var SvgSpeakerphone = function SvgSpeakerphone(props) {
  return /*#__PURE__*/react.createElement("svg", speakerphone_extends({
    xmlns: "http://www.w3.org/2000/svg",
    fill: "none",
    stroke: "currentColor",
    viewBox: "0 0 24 24"
  }, props), speakerphone_path || (speakerphone_path = /*#__PURE__*/react.createElement("path", {
    strokeLinecap: "round",
    strokeLinejoin: "round",
    strokeWidth: 2,
    d: "M11 5.882V19.24a1.76 1.76 0 0 1-3.417.592l-2.147-6.15M18 13a3 3 0 1 0 0-6M5.436 13.683A4.001 4.001 0 0 1 7 6h1.832c4.1 0 7.625-1.234 9.168-3v14c-1.543-1.766-5.067-3-9.168-3H7a4 4 0 0 1-1.564-.317"
  })));
};
/* harmony default export */ const speakerphone = (SvgSpeakerphone);
;// ./react/ui/icon/icons/outline/star.svg
var star_path;
function star_extends() { star_extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return star_extends.apply(this, arguments); }

var SvgStar = function SvgStar(props) {
  return /*#__PURE__*/react.createElement("svg", star_extends({
    xmlns: "http://www.w3.org/2000/svg",
    fill: "none",
    stroke: "currentColor",
    viewBox: "0 0 24 24"
  }, props), star_path || (star_path = /*#__PURE__*/react.createElement("path", {
    strokeLinecap: "round",
    strokeLinejoin: "round",
    strokeWidth: 2,
    d: "M11.049 2.927c.3-.921 1.603-.921 1.902 0l1.519 4.674a1 1 0 0 0 .95.69h4.915c.969 0 1.371 1.24.588 1.81l-3.976 2.888a1 1 0 0 0-.363 1.118l1.518 4.674c.3.922-.755 1.688-1.538 1.118l-3.976-2.888a1 1 0 0 0-1.176 0l-3.976 2.888c-.783.57-1.838-.197-1.538-1.118l1.518-4.674a1 1 0 0 0-.363-1.118l-3.976-2.888c-.784-.57-.38-1.81.588-1.81h4.914a1 1 0 0 0 .951-.69z"
  })));
};
/* harmony default export */ const star = (SvgStar);
;// ./react/ui/icon/icons/outline/status-offline.svg
var status_offline_path;
function status_offline_extends() { status_offline_extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return status_offline_extends.apply(this, arguments); }

var SvgStatusOffline = function SvgStatusOffline(props) {
  return /*#__PURE__*/react.createElement("svg", status_offline_extends({
    xmlns: "http://www.w3.org/2000/svg",
    fill: "none",
    stroke: "currentColor",
    viewBox: "0 0 24 24"
  }, props), status_offline_path || (status_offline_path = /*#__PURE__*/react.createElement("path", {
    strokeLinecap: "round",
    strokeLinejoin: "round",
    strokeWidth: 2,
    d: "M18.364 5.636a9 9 0 0 1 0 12.728m0 0-2.829-2.829m2.829 2.829L21 21M15.536 8.464a5 5 0 0 1 0 7.072m0 0-2.829-2.829m-4.243 2.829a4.98 4.98 0 0 1-1.414-2.83m-1.414 5.658a9 9 0 0 1-2.167-9.238m7.824 2.167a1 1 0 1 1 1.414 1.414m-1.414-1.414L3 3m8.293 8.293 1.414 1.414"
  })));
};
/* harmony default export */ const status_offline = (SvgStatusOffline);
;// ./react/ui/icon/icons/outline/status-online.svg
var status_online_path;
function status_online_extends() { status_online_extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return status_online_extends.apply(this, arguments); }

var SvgStatusOnline = function SvgStatusOnline(props) {
  return /*#__PURE__*/react.createElement("svg", status_online_extends({
    xmlns: "http://www.w3.org/2000/svg",
    fill: "none",
    stroke: "currentColor",
    viewBox: "0 0 24 24"
  }, props), status_online_path || (status_online_path = /*#__PURE__*/react.createElement("path", {
    strokeLinecap: "round",
    strokeLinejoin: "round",
    strokeWidth: 2,
    d: "M5.636 18.364a9 9 0 0 1 0-12.728m12.728 0a9 9 0 0 1 0 12.728m-9.9-2.829a5 5 0 0 1 0-7.07m7.072 0a5 5 0 0 1 0 7.07M13 12a1 1 0 1 1-2 0 1 1 0 0 1 2 0"
  })));
};
/* harmony default export */ const status_online = (SvgStatusOnline);
;// ./react/ui/icon/icons/outline/stop.svg
var stop_path, stop_path2;
function stop_extends() { stop_extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return stop_extends.apply(this, arguments); }

var SvgStop = function SvgStop(props) {
  return /*#__PURE__*/react.createElement("svg", stop_extends({
    xmlns: "http://www.w3.org/2000/svg",
    fill: "none",
    stroke: "currentColor",
    viewBox: "0 0 24 24"
  }, props), stop_path || (stop_path = /*#__PURE__*/react.createElement("path", {
    strokeLinecap: "round",
    strokeLinejoin: "round",
    strokeWidth: 2,
    d: "M21 12a9 9 0 1 1-18 0 9 9 0 0 1 18 0"
  })), stop_path2 || (stop_path2 = /*#__PURE__*/react.createElement("path", {
    strokeLinecap: "round",
    strokeLinejoin: "round",
    strokeWidth: 2,
    d: "M9 10a1 1 0 0 1 1-1h4a1 1 0 0 1 1 1v4a1 1 0 0 1-1 1h-4a1 1 0 0 1-1-1z"
  })));
};
/* harmony default export */ const stop = (SvgStop);
;// ./react/ui/icon/icons/outline/sun.svg
var sun_path;
function sun_extends() { sun_extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return sun_extends.apply(this, arguments); }

var SvgSun = function SvgSun(props) {
  return /*#__PURE__*/react.createElement("svg", sun_extends({
    xmlns: "http://www.w3.org/2000/svg",
    fill: "none",
    stroke: "currentColor",
    viewBox: "0 0 24 24"
  }, props), sun_path || (sun_path = /*#__PURE__*/react.createElement("path", {
    strokeLinecap: "round",
    strokeLinejoin: "round",
    strokeWidth: 2,
    d: "M12 3v1m0 16v1m9-9h-1M4 12H3m15.364 6.364-.707-.707M6.343 6.343l-.707-.707m12.728 0-.707.707M6.343 17.657l-.707.707M16 12a4 4 0 1 1-8 0 4 4 0 0 1 8 0"
  })));
};
/* harmony default export */ const sun = (SvgSun);
;// ./react/ui/icon/icons/outline/support.svg
var support_path;
function support_extends() { support_extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return support_extends.apply(this, arguments); }

var SvgSupport = function SvgSupport(props) {
  return /*#__PURE__*/react.createElement("svg", support_extends({
    xmlns: "http://www.w3.org/2000/svg",
    fill: "none",
    stroke: "currentColor",
    viewBox: "0 0 24 24"
  }, props), support_path || (support_path = /*#__PURE__*/react.createElement("path", {
    strokeLinecap: "round",
    strokeLinejoin: "round",
    strokeWidth: 2,
    d: "m18.364 5.636-3.536 3.536m0 5.656 3.536 3.536M9.172 9.172 5.636 5.636m3.536 9.192-3.536 3.536M21 12a9 9 0 1 1-18 0 9 9 0 0 1 18 0m-5 0a4 4 0 1 1-8 0 4 4 0 0 1 8 0"
  })));
};
/* harmony default export */ const support = (SvgSupport);
;// ./react/ui/icon/icons/outline/switch-horizontal.svg
var switch_horizontal_path;
function switch_horizontal_extends() { switch_horizontal_extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return switch_horizontal_extends.apply(this, arguments); }

var SvgSwitchHorizontal = function SvgSwitchHorizontal(props) {
  return /*#__PURE__*/react.createElement("svg", switch_horizontal_extends({
    xmlns: "http://www.w3.org/2000/svg",
    fill: "none",
    stroke: "currentColor",
    viewBox: "0 0 24 24"
  }, props), switch_horizontal_path || (switch_horizontal_path = /*#__PURE__*/react.createElement("path", {
    strokeLinecap: "round",
    strokeLinejoin: "round",
    strokeWidth: 2,
    d: "M8 7h12m0 0-4-4m4 4-4 4m0 6H4m0 0 4 4m-4-4 4-4"
  })));
};
/* harmony default export */ const switch_horizontal = (SvgSwitchHorizontal);
;// ./react/ui/icon/icons/outline/switch-vertical.svg
var switch_vertical_path;
function switch_vertical_extends() { switch_vertical_extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return switch_vertical_extends.apply(this, arguments); }

var SvgSwitchVertical = function SvgSwitchVertical(props) {
  return /*#__PURE__*/react.createElement("svg", switch_vertical_extends({
    xmlns: "http://www.w3.org/2000/svg",
    fill: "none",
    stroke: "currentColor",
    viewBox: "0 0 24 24"
  }, props), switch_vertical_path || (switch_vertical_path = /*#__PURE__*/react.createElement("path", {
    strokeLinecap: "round",
    strokeLinejoin: "round",
    strokeWidth: 2,
    d: "M7 16V4m0 0L3 8m4-4 4 4m6 0v12m0 0 4-4m-4 4-4-4"
  })));
};
/* harmony default export */ const switch_vertical = (SvgSwitchVertical);
;// ./react/ui/icon/icons/outline/table.svg
var table_path;
function table_extends() { table_extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return table_extends.apply(this, arguments); }

var SvgTable = function SvgTable(props) {
  return /*#__PURE__*/react.createElement("svg", table_extends({
    xmlns: "http://www.w3.org/2000/svg",
    fill: "none",
    stroke: "currentColor",
    viewBox: "0 0 24 24"
  }, props), table_path || (table_path = /*#__PURE__*/react.createElement("path", {
    strokeLinecap: "round",
    strokeLinejoin: "round",
    strokeWidth: 2,
    d: "M3 10h18M3 14h18m-9-4v8m-7 0h14a2 2 0 0 0 2-2V8a2 2 0 0 0-2-2H5a2 2 0 0 0-2 2v8a2 2 0 0 0 2 2"
  })));
};
/* harmony default export */ const table = (SvgTable);
;// ./react/ui/icon/icons/outline/tag.svg
var tag_path;
function tag_extends() { tag_extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return tag_extends.apply(this, arguments); }

var SvgTag = function SvgTag(props) {
  return /*#__PURE__*/react.createElement("svg", tag_extends({
    xmlns: "http://www.w3.org/2000/svg",
    fill: "none",
    stroke: "currentColor",
    viewBox: "0 0 24 24"
  }, props), tag_path || (tag_path = /*#__PURE__*/react.createElement("path", {
    strokeLinecap: "round",
    strokeLinejoin: "round",
    strokeWidth: 2,
    d: "M7 7h.01M7 3h5a2 2 0 0 1 1.414.586l7 7a2 2 0 0 1 0 2.828l-7 7a2 2 0 0 1-2.828 0l-7-7A2 2 0 0 1 3 12V7a4 4 0 0 1 4-4"
  })));
};
/* harmony default export */ const tag = (SvgTag);
;// ./react/ui/icon/icons/outline/template.svg
var template_path;
function template_extends() { template_extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return template_extends.apply(this, arguments); }

var SvgTemplate = function SvgTemplate(props) {
  return /*#__PURE__*/react.createElement("svg", template_extends({
    xmlns: "http://www.w3.org/2000/svg",
    fill: "none",
    stroke: "currentColor",
    viewBox: "0 0 24 24"
  }, props), template_path || (template_path = /*#__PURE__*/react.createElement("path", {
    strokeLinecap: "round",
    strokeLinejoin: "round",
    strokeWidth: 2,
    d: "M4 5a1 1 0 0 1 1-1h14a1 1 0 0 1 1 1v2a1 1 0 0 1-1 1H5a1 1 0 0 1-1-1zm0 8a1 1 0 0 1 1-1h6a1 1 0 0 1 1 1v6a1 1 0 0 1-1 1H5a1 1 0 0 1-1-1zm12 0a1 1 0 0 1 1-1h2a1 1 0 0 1 1 1v6a1 1 0 0 1-1 1h-2a1 1 0 0 1-1-1z"
  })));
};
/* harmony default export */ const template = (SvgTemplate);
;// ./react/ui/icon/icons/outline/terminal.svg
var terminal_path;
function terminal_extends() { terminal_extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return terminal_extends.apply(this, arguments); }

var SvgTerminal = function SvgTerminal(props) {
  return /*#__PURE__*/react.createElement("svg", terminal_extends({
    xmlns: "http://www.w3.org/2000/svg",
    fill: "none",
    stroke: "currentColor",
    viewBox: "0 0 24 24"
  }, props), terminal_path || (terminal_path = /*#__PURE__*/react.createElement("path", {
    strokeLinecap: "round",
    strokeLinejoin: "round",
    strokeWidth: 2,
    d: "m8 9 3 3-3 3m5 0h3M5 20h14a2 2 0 0 0 2-2V6a2 2 0 0 0-2-2H5a2 2 0 0 0-2 2v12a2 2 0 0 0 2 2"
  })));
};
/* harmony default export */ const terminal = (SvgTerminal);
;// ./react/ui/icon/icons/outline/thumb-down.svg
var thumb_down_path;
function thumb_down_extends() { thumb_down_extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return thumb_down_extends.apply(this, arguments); }

var SvgThumbDown = function SvgThumbDown(props) {
  return /*#__PURE__*/react.createElement("svg", thumb_down_extends({
    xmlns: "http://www.w3.org/2000/svg",
    fill: "none",
    stroke: "currentColor",
    viewBox: "0 0 24 24"
  }, props), thumb_down_path || (thumb_down_path = /*#__PURE__*/react.createElement("path", {
    strokeLinecap: "round",
    strokeLinejoin: "round",
    strokeWidth: 2,
    d: "M10 14H5.236a2 2 0 0 1-1.789-2.894l3.5-7A2 2 0 0 1 8.736 3h4.018a2 2 0 0 1 .485.06l3.76.94m-7 10v5a2 2 0 0 0 2 2h.096c.5 0 .905-.405.905-.904 0-.715.211-1.413.608-2.008L17 13V4m-7 10h2m5-10h2a2 2 0 0 1 2 2v6a2 2 0 0 1-2 2h-2.5"
  })));
};
/* harmony default export */ const thumb_down = (SvgThumbDown);
;// ./react/ui/icon/icons/outline/thumb-up.svg
var thumb_up_path;
function thumb_up_extends() { thumb_up_extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return thumb_up_extends.apply(this, arguments); }

var SvgThumbUp = function SvgThumbUp(props) {
  return /*#__PURE__*/react.createElement("svg", thumb_up_extends({
    xmlns: "http://www.w3.org/2000/svg",
    fill: "none",
    stroke: "currentColor",
    viewBox: "0 0 24 24"
  }, props), thumb_up_path || (thumb_up_path = /*#__PURE__*/react.createElement("path", {
    strokeLinecap: "round",
    strokeLinejoin: "round",
    strokeWidth: 2,
    d: "M14 10h4.764a2 2 0 0 1 1.789 2.894l-3.5 7A2 2 0 0 1 15.263 21h-4.017q-.246 0-.485-.06L7 20m7-10V5a2 2 0 0 0-2-2h-.095c-.5 0-.905.405-.905.905a3.6 3.6 0 0 1-.608 2.006L7 11v9m7-10h-2M7 20H5a2 2 0 0 1-2-2v-6a2 2 0 0 1 2-2h2.5"
  })));
};
/* harmony default export */ const thumb_up = (SvgThumbUp);
;// ./react/ui/icon/icons/outline/ticket.svg
var ticket_path;
function ticket_extends() { ticket_extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return ticket_extends.apply(this, arguments); }

var SvgTicket = function SvgTicket(props) {
  return /*#__PURE__*/react.createElement("svg", ticket_extends({
    xmlns: "http://www.w3.org/2000/svg",
    fill: "none",
    stroke: "currentColor",
    viewBox: "0 0 24 24"
  }, props), ticket_path || (ticket_path = /*#__PURE__*/react.createElement("path", {
    strokeLinecap: "round",
    strokeLinejoin: "round",
    strokeWidth: 2,
    d: "M15 5v2m0 4v2m0 4v2M5 5a2 2 0 0 0-2 2v3a2 2 0 1 1 0 4v3a2 2 0 0 0 2 2h14a2 2 0 0 0 2-2v-3a2 2 0 1 1 0-4V7a2 2 0 0 0-2-2z"
  })));
};
/* harmony default export */ const ticket = (SvgTicket);
;// ./react/ui/icon/icons/outline/translate.svg
var translate_path;
function translate_extends() { translate_extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return translate_extends.apply(this, arguments); }

var SvgTranslate = function SvgTranslate(props) {
  return /*#__PURE__*/react.createElement("svg", translate_extends({
    xmlns: "http://www.w3.org/2000/svg",
    fill: "none",
    stroke: "currentColor",
    viewBox: "0 0 24 24"
  }, props), translate_path || (translate_path = /*#__PURE__*/react.createElement("path", {
    strokeLinecap: "round",
    strokeLinejoin: "round",
    strokeWidth: 2,
    d: "M3 5h12M9 3v2m1.048 9.5A18 18 0 0 1 6.412 9m6.088 9h7M11 21l5-10 5 10M12.751 5C11.783 10.77 8.07 15.61 3 18.129"
  })));
};
/* harmony default export */ const translate = (SvgTranslate);
;// ./react/ui/icon/icons/outline/trash.svg
var trash_path;
function trash_extends() { trash_extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return trash_extends.apply(this, arguments); }

var SvgTrash = function SvgTrash(props) {
  return /*#__PURE__*/react.createElement("svg", trash_extends({
    xmlns: "http://www.w3.org/2000/svg",
    fill: "none",
    stroke: "currentColor",
    viewBox: "0 0 24 24"
  }, props), trash_path || (trash_path = /*#__PURE__*/react.createElement("path", {
    strokeLinecap: "round",
    strokeLinejoin: "round",
    strokeWidth: 2,
    d: "m19 7-.867 12.142A2 2 0 0 1 16.138 21H7.862a2 2 0 0 1-1.995-1.858L5 7m5 4v6m4-6v6m1-10V4a1 1 0 0 0-1-1h-4a1 1 0 0 0-1 1v3M4 7h16"
  })));
};
/* harmony default export */ const trash = (SvgTrash);
;// ./react/ui/icon/icons/outline/trending-down.svg
var trending_down_path;
function trending_down_extends() { trending_down_extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return trending_down_extends.apply(this, arguments); }

var SvgTrendingDown = function SvgTrendingDown(props) {
  return /*#__PURE__*/react.createElement("svg", trending_down_extends({
    xmlns: "http://www.w3.org/2000/svg",
    fill: "none",
    stroke: "currentColor",
    viewBox: "0 0 24 24"
  }, props), trending_down_path || (trending_down_path = /*#__PURE__*/react.createElement("path", {
    strokeLinecap: "round",
    strokeLinejoin: "round",
    strokeWidth: 2,
    d: "M13 17h8m0 0V9m0 8-8-8-4 4-6-6"
  })));
};
/* harmony default export */ const trending_down = (SvgTrendingDown);
;// ./react/ui/icon/icons/outline/trending-up.svg
var trending_up_path;
function trending_up_extends() { trending_up_extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return trending_up_extends.apply(this, arguments); }

var SvgTrendingUp = function SvgTrendingUp(props) {
  return /*#__PURE__*/react.createElement("svg", trending_up_extends({
    xmlns: "http://www.w3.org/2000/svg",
    fill: "none",
    stroke: "currentColor",
    viewBox: "0 0 24 24"
  }, props), trending_up_path || (trending_up_path = /*#__PURE__*/react.createElement("path", {
    strokeLinecap: "round",
    strokeLinejoin: "round",
    strokeWidth: 2,
    d: "M13 7h8m0 0v8m0-8-8 8-4-4-6 6"
  })));
};
/* harmony default export */ const trending_up = (SvgTrendingUp);
;// ./react/ui/icon/icons/outline/truck.svg
var truck_path;
function truck_extends() { truck_extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return truck_extends.apply(this, arguments); }

var SvgTruck = function SvgTruck(props) {
  return /*#__PURE__*/react.createElement("svg", truck_extends({
    xmlns: "http://www.w3.org/2000/svg",
    fill: "none",
    stroke: "currentColor",
    viewBox: "0 0 24 24"
  }, props), truck_path || (truck_path = /*#__PURE__*/react.createElement("path", {
    strokeLinecap: "round",
    strokeLinejoin: "round",
    strokeWidth: 2,
    d: "M8.25 18.75a1.5 1.5 0 0 1-3 0m3 0a1.5 1.5 0 0 0-3 0m3 0h6m-9 0H3.375a1.125 1.125 0 0 1-1.125-1.125V14.25m17.25 4.5a1.5 1.5 0 0 1-3 0m3 0a1.5 1.5 0 0 0-3 0m3 0h1.125c.621 0 1.129-.504 1.09-1.124a17.9 17.9 0 0 0-3.213-9.193 2.06 2.06 0 0 0-1.58-.86H14.25M16.5 18.75h-2.25m0-11.177v-.958c0-.568-.422-1.048-.987-1.106a48.6 48.6 0 0 0-10.026 0 1.106 1.106 0 0 0-.987 1.106v7.635m12-6.677v6.677m0 4.5v-4.5m0 0h-12"
  })));
};
/* harmony default export */ const truck = (SvgTruck);
;// ./react/ui/icon/icons/outline/upload.svg
var upload_path;
function upload_extends() { upload_extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return upload_extends.apply(this, arguments); }

var SvgUpload = function SvgUpload(props) {
  return /*#__PURE__*/react.createElement("svg", upload_extends({
    xmlns: "http://www.w3.org/2000/svg",
    fill: "none",
    stroke: "currentColor",
    viewBox: "0 0 24 24"
  }, props), upload_path || (upload_path = /*#__PURE__*/react.createElement("path", {
    strokeLinecap: "round",
    strokeLinejoin: "round",
    strokeWidth: 2,
    d: "M4 16v1a3 3 0 0 0 3 3h10a3 3 0 0 0 3-3v-1m-4-8-4-4m0 0L8 8m4-4v12"
  })));
};
/* harmony default export */ const upload = (SvgUpload);
;// ./react/ui/icon/icons/outline/user-add.svg
var user_add_path;
function user_add_extends() { user_add_extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return user_add_extends.apply(this, arguments); }

var SvgUserAdd = function SvgUserAdd(props) {
  return /*#__PURE__*/react.createElement("svg", user_add_extends({
    xmlns: "http://www.w3.org/2000/svg",
    fill: "none",
    stroke: "currentColor",
    viewBox: "0 0 24 24"
  }, props), user_add_path || (user_add_path = /*#__PURE__*/react.createElement("path", {
    strokeLinecap: "round",
    strokeLinejoin: "round",
    strokeWidth: 2,
    d: "M18 9v3m0 0v3m0-3h3m-3 0h-3m-2-5a4 4 0 1 1-8 0 4 4 0 0 1 8 0M3 20a6 6 0 0 1 12 0v1H3z"
  })));
};
/* harmony default export */ const user_add = (SvgUserAdd);
;// ./react/ui/icon/icons/outline/user-circle.svg
var user_circle_path;
function user_circle_extends() { user_circle_extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return user_circle_extends.apply(this, arguments); }

var SvgUserCircle = function SvgUserCircle(props) {
  return /*#__PURE__*/react.createElement("svg", user_circle_extends({
    xmlns: "http://www.w3.org/2000/svg",
    fill: "none",
    stroke: "currentColor",
    viewBox: "0 0 24 24"
  }, props), user_circle_path || (user_circle_path = /*#__PURE__*/react.createElement("path", {
    strokeLinecap: "round",
    strokeLinejoin: "round",
    strokeWidth: 2,
    d: "M5.121 17.804A13.94 13.94 0 0 1 12 16c2.5 0 4.847.655 6.879 1.804M15 10a3 3 0 1 1-6 0 3 3 0 0 1 6 0m6 2a9 9 0 1 1-18 0 9 9 0 0 1 18 0"
  })));
};
/* harmony default export */ const user_circle = (SvgUserCircle);
;// ./react/ui/icon/icons/outline/user-group.svg
var user_group_path;
function user_group_extends() { user_group_extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return user_group_extends.apply(this, arguments); }

var SvgUserGroup = function SvgUserGroup(props) {
  return /*#__PURE__*/react.createElement("svg", user_group_extends({
    xmlns: "http://www.w3.org/2000/svg",
    fill: "none",
    stroke: "currentColor",
    viewBox: "0 0 24 24"
  }, props), user_group_path || (user_group_path = /*#__PURE__*/react.createElement("path", {
    strokeLinecap: "round",
    strokeLinejoin: "round",
    strokeWidth: 2,
    d: "M17 20h5v-2a3 3 0 0 0-5.356-1.857M17 20H7m10 0v-2c0-.656-.126-1.283-.356-1.857M7 20H2v-2a3 3 0 0 1 5.356-1.857M7 20v-2c0-.656.126-1.283.356-1.857m0 0a5.002 5.002 0 0 1 9.288 0M15 7a3 3 0 1 1-6 0 3 3 0 0 1 6 0m6 3a2 2 0 1 1-4 0 2 2 0 0 1 4 0M7 10a2 2 0 1 1-4 0 2 2 0 0 1 4 0"
  })));
};
/* harmony default export */ const user_group = (SvgUserGroup);
;// ./react/ui/icon/icons/outline/user-remove.svg
var user_remove_path;
function user_remove_extends() { user_remove_extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return user_remove_extends.apply(this, arguments); }

var SvgUserRemove = function SvgUserRemove(props) {
  return /*#__PURE__*/react.createElement("svg", user_remove_extends({
    xmlns: "http://www.w3.org/2000/svg",
    fill: "none",
    stroke: "currentColor",
    viewBox: "0 0 24 24"
  }, props), user_remove_path || (user_remove_path = /*#__PURE__*/react.createElement("path", {
    strokeLinecap: "round",
    strokeLinejoin: "round",
    strokeWidth: 2,
    d: "M13 7a4 4 0 1 1-8 0 4 4 0 0 1 8 0m-4 7a6 6 0 0 0-6 6v1h12v-1a6 6 0 0 0-6-6m12-2h-6"
  })));
};
/* harmony default export */ const user_remove = (SvgUserRemove);
;// ./react/ui/icon/icons/outline/user.svg
var user_path;
function user_extends() { user_extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return user_extends.apply(this, arguments); }

var SvgUser = function SvgUser(props) {
  return /*#__PURE__*/react.createElement("svg", user_extends({
    xmlns: "http://www.w3.org/2000/svg",
    fill: "none",
    stroke: "currentColor",
    viewBox: "0 0 24 24"
  }, props), user_path || (user_path = /*#__PURE__*/react.createElement("path", {
    strokeLinecap: "round",
    strokeLinejoin: "round",
    strokeWidth: 2,
    d: "M16 7a4 4 0 1 1-8 0 4 4 0 0 1 8 0m-4 7a7 7 0 0 0-7 7h14a7 7 0 0 0-7-7"
  })));
};
/* harmony default export */ const user = (SvgUser);
;// ./react/ui/icon/icons/outline/users.svg
var users_path;
function users_extends() { users_extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return users_extends.apply(this, arguments); }

var SvgUsers = function SvgUsers(props) {
  return /*#__PURE__*/react.createElement("svg", users_extends({
    xmlns: "http://www.w3.org/2000/svg",
    fill: "none",
    stroke: "currentColor",
    viewBox: "0 0 24 24"
  }, props), users_path || (users_path = /*#__PURE__*/react.createElement("path", {
    strokeLinecap: "round",
    strokeLinejoin: "round",
    strokeWidth: 2,
    d: "M12 4.354a4 4 0 1 1 0 5.292M15 21H3v-1a6 6 0 0 1 12 0zm0 0h6v-1a6 6 0 0 0-9-5.197M13 7a4 4 0 1 1-8 0 4 4 0 0 1 8 0"
  })));
};
/* harmony default export */ const users = (SvgUsers);
;// ./react/ui/icon/icons/outline/variable.svg
var variable_path;
function variable_extends() { variable_extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return variable_extends.apply(this, arguments); }

var SvgVariable = function SvgVariable(props) {
  return /*#__PURE__*/react.createElement("svg", variable_extends({
    xmlns: "http://www.w3.org/2000/svg",
    fill: "none",
    stroke: "currentColor",
    viewBox: "0 0 24 24"
  }, props), variable_path || (variable_path = /*#__PURE__*/react.createElement("path", {
    strokeLinecap: "round",
    strokeLinejoin: "round",
    strokeWidth: 2,
    d: "M4.871 4A17.9 17.9 0 0 0 3 12c0 2.874.673 5.59 1.871 8m14.13 0a17.9 17.9 0 0 0 1.87-8c0-2.874-.673-5.59-1.87-8M9 9h1.246a1 1 0 0 1 .961.725l1.586 5.55a1 1 0 0 0 .961.725H15m1-7h-.08a2 2 0 0 0-1.519.698L9.6 15.302A2 2 0 0 1 8.08 16H8"
  })));
};
/* harmony default export */ const variable = (SvgVariable);
;// ./react/ui/icon/icons/outline/video-camera.svg
var video_camera_path;
function video_camera_extends() { video_camera_extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return video_camera_extends.apply(this, arguments); }

var SvgVideoCamera = function SvgVideoCamera(props) {
  return /*#__PURE__*/react.createElement("svg", video_camera_extends({
    xmlns: "http://www.w3.org/2000/svg",
    fill: "none",
    stroke: "currentColor",
    viewBox: "0 0 24 24"
  }, props), video_camera_path || (video_camera_path = /*#__PURE__*/react.createElement("path", {
    strokeLinecap: "round",
    strokeLinejoin: "round",
    strokeWidth: 2,
    d: "m15 10 4.553-2.276A1 1 0 0 1 21 8.618v6.764a1 1 0 0 1-1.447.894L15 14M5 18h8a2 2 0 0 0 2-2V8a2 2 0 0 0-2-2H5a2 2 0 0 0-2 2v8a2 2 0 0 0 2 2"
  })));
};
/* harmony default export */ const video_camera = (SvgVideoCamera);
;// ./react/ui/icon/icons/outline/view-boards.svg
var view_boards_path;
function view_boards_extends() { view_boards_extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return view_boards_extends.apply(this, arguments); }

var SvgViewBoards = function SvgViewBoards(props) {
  return /*#__PURE__*/react.createElement("svg", view_boards_extends({
    xmlns: "http://www.w3.org/2000/svg",
    fill: "none",
    stroke: "currentColor",
    viewBox: "0 0 24 24"
  }, props), view_boards_path || (view_boards_path = /*#__PURE__*/react.createElement("path", {
    strokeLinecap: "round",
    strokeLinejoin: "round",
    strokeWidth: 2,
    d: "M9 17V7m0 10a2 2 0 0 1-2 2H5a2 2 0 0 1-2-2V7a2 2 0 0 1 2-2h2a2 2 0 0 1 2 2m0 10a2 2 0 0 0 2 2h2a2 2 0 0 0 2-2M9 7a2 2 0 0 1 2-2h2a2 2 0 0 1 2 2m0 10V7m0 10a2 2 0 0 0 2 2h2a2 2 0 0 0 2-2V7a2 2 0 0 0-2-2h-2a2 2 0 0 0-2 2"
  })));
};
/* harmony default export */ const view_boards = (SvgViewBoards);
;// ./react/ui/icon/icons/outline/view-grid-add.svg
var view_grid_add_path;
function view_grid_add_extends() { view_grid_add_extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return view_grid_add_extends.apply(this, arguments); }

var SvgViewGridAdd = function SvgViewGridAdd(props) {
  return /*#__PURE__*/react.createElement("svg", view_grid_add_extends({
    xmlns: "http://www.w3.org/2000/svg",
    fill: "none",
    stroke: "currentColor",
    viewBox: "0 0 24 24"
  }, props), view_grid_add_path || (view_grid_add_path = /*#__PURE__*/react.createElement("path", {
    strokeLinecap: "round",
    strokeLinejoin: "round",
    strokeWidth: 2,
    d: "M17 14v6m-3-3h6M6 10h2a2 2 0 0 0 2-2V6a2 2 0 0 0-2-2H6a2 2 0 0 0-2 2v2a2 2 0 0 0 2 2m10 0h2a2 2 0 0 0 2-2V6a2 2 0 0 0-2-2h-2a2 2 0 0 0-2 2v2a2 2 0 0 0 2 2M6 20h2a2 2 0 0 0 2-2v-2a2 2 0 0 0-2-2H6a2 2 0 0 0-2 2v2a2 2 0 0 0 2 2"
  })));
};
/* harmony default export */ const view_grid_add = (SvgViewGridAdd);
;// ./react/ui/icon/icons/outline/view-grid.svg
var view_grid_path;
function view_grid_extends() { view_grid_extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return view_grid_extends.apply(this, arguments); }

var SvgViewGrid = function SvgViewGrid(props) {
  return /*#__PURE__*/react.createElement("svg", view_grid_extends({
    xmlns: "http://www.w3.org/2000/svg",
    fill: "none",
    stroke: "currentColor",
    viewBox: "0 0 24 24"
  }, props), view_grid_path || (view_grid_path = /*#__PURE__*/react.createElement("path", {
    strokeLinecap: "round",
    strokeLinejoin: "round",
    strokeWidth: 2,
    d: "M4 6a2 2 0 0 1 2-2h2a2 2 0 0 1 2 2v2a2 2 0 0 1-2 2H6a2 2 0 0 1-2-2zm10 0a2 2 0 0 1 2-2h2a2 2 0 0 1 2 2v2a2 2 0 0 1-2 2h-2a2 2 0 0 1-2-2zM4 16a2 2 0 0 1 2-2h2a2 2 0 0 1 2 2v2a2 2 0 0 1-2 2H6a2 2 0 0 1-2-2zm10 0a2 2 0 0 1 2-2h2a2 2 0 0 1 2 2v2a2 2 0 0 1-2 2h-2a2 2 0 0 1-2-2z"
  })));
};
/* harmony default export */ const view_grid = (SvgViewGrid);
;// ./react/ui/icon/icons/outline/view-list.svg
var view_list_path;
function view_list_extends() { view_list_extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return view_list_extends.apply(this, arguments); }

var SvgViewList = function SvgViewList(props) {
  return /*#__PURE__*/react.createElement("svg", view_list_extends({
    xmlns: "http://www.w3.org/2000/svg",
    fill: "none",
    stroke: "currentColor",
    viewBox: "0 0 24 24"
  }, props), view_list_path || (view_list_path = /*#__PURE__*/react.createElement("path", {
    strokeLinecap: "round",
    strokeLinejoin: "round",
    strokeWidth: 2,
    d: "M4 6h16M4 10h16M4 14h16M4 18h16"
  })));
};
/* harmony default export */ const view_list = (SvgViewList);
;// ./react/ui/icon/icons/outline/volume-off.svg
var volume_off_path, volume_off_path2;
function volume_off_extends() { volume_off_extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return volume_off_extends.apply(this, arguments); }

var SvgVolumeOff = function SvgVolumeOff(props) {
  return /*#__PURE__*/react.createElement("svg", volume_off_extends({
    xmlns: "http://www.w3.org/2000/svg",
    fill: "none",
    stroke: "currentColor",
    viewBox: "0 0 24 24"
  }, props), volume_off_path || (volume_off_path = /*#__PURE__*/react.createElement("path", {
    strokeLinecap: "round",
    strokeLinejoin: "round",
    strokeWidth: 2,
    d: "M5.586 15H4a1 1 0 0 1-1-1v-4a1 1 0 0 1 1-1h1.586l4.707-4.707C10.923 3.663 12 4.109 12 5v14c0 .891-1.077 1.337-1.707.707z",
    clipRule: "evenodd"
  })), volume_off_path2 || (volume_off_path2 = /*#__PURE__*/react.createElement("path", {
    strokeLinecap: "round",
    strokeLinejoin: "round",
    strokeWidth: 2,
    d: "m17 14 2-2m0 0 2-2m-2 2-2-2m2 2 2 2"
  })));
};
/* harmony default export */ const volume_off = (SvgVolumeOff);
;// ./react/ui/icon/icons/outline/volume-up.svg
var volume_up_path;
function volume_up_extends() { volume_up_extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return volume_up_extends.apply(this, arguments); }

var SvgVolumeUp = function SvgVolumeUp(props) {
  return /*#__PURE__*/react.createElement("svg", volume_up_extends({
    xmlns: "http://www.w3.org/2000/svg",
    fill: "none",
    stroke: "currentColor",
    viewBox: "0 0 24 24"
  }, props), volume_up_path || (volume_up_path = /*#__PURE__*/react.createElement("path", {
    strokeLinecap: "round",
    strokeLinejoin: "round",
    strokeWidth: 2,
    d: "M15.536 8.464a5 5 0 0 1 0 7.072m2.828-9.9a9 9 0 0 1 0 12.728M5.586 15H4a1 1 0 0 1-1-1v-4a1 1 0 0 1 1-1h1.586l4.707-4.707C10.923 3.663 12 4.109 12 5v14c0 .891-1.077 1.337-1.707.707z"
  })));
};
/* harmony default export */ const volume_up = (SvgVolumeUp);
;// ./react/ui/icon/icons/outline/wifi.svg
var wifi_path;
function wifi_extends() { wifi_extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return wifi_extends.apply(this, arguments); }

var SvgWifi = function SvgWifi(props) {
  return /*#__PURE__*/react.createElement("svg", wifi_extends({
    xmlns: "http://www.w3.org/2000/svg",
    fill: "none",
    stroke: "currentColor",
    viewBox: "0 0 24 24"
  }, props), wifi_path || (wifi_path = /*#__PURE__*/react.createElement("path", {
    strokeLinecap: "round",
    strokeLinejoin: "round",
    strokeWidth: 2,
    d: "M8.111 16.404a5.5 5.5 0 0 1 7.778 0M12 20h.01m-7.08-7.071c3.904-3.905 10.236-3.905 14.141 0M1.394 9.393c5.857-5.857 15.355-5.857 21.213 0"
  })));
};
/* harmony default export */ const wifi = (SvgWifi);
;// ./react/ui/icon/icons/outline/x-circle.svg
var x_circle_path;
function x_circle_extends() { x_circle_extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return x_circle_extends.apply(this, arguments); }

var SvgXCircle = function SvgXCircle(props) {
  return /*#__PURE__*/react.createElement("svg", x_circle_extends({
    xmlns: "http://www.w3.org/2000/svg",
    fill: "none",
    stroke: "currentColor",
    viewBox: "0 0 24 24"
  }, props), x_circle_path || (x_circle_path = /*#__PURE__*/react.createElement("path", {
    strokeLinecap: "round",
    strokeLinejoin: "round",
    strokeWidth: 2,
    d: "m10 14 2-2m0 0 2-2m-2 2-2-2m2 2 2 2m7-2a9 9 0 1 1-18 0 9 9 0 0 1 18 0"
  })));
};
/* harmony default export */ const x_circle = (SvgXCircle);
;// ./react/ui/icon/icons/outline/x.svg
var x_path;
function x_extends() { x_extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return x_extends.apply(this, arguments); }

var SvgX = function SvgX(props) {
  return /*#__PURE__*/react.createElement("svg", x_extends({
    xmlns: "http://www.w3.org/2000/svg",
    fill: "none",
    stroke: "currentColor",
    viewBox: "0 0 24 24"
  }, props), x_path || (x_path = /*#__PURE__*/react.createElement("path", {
    strokeLinecap: "round",
    strokeLinejoin: "round",
    strokeWidth: 2,
    d: "M6 18 18 6M6 6l12 12"
  })));
};
/* harmony default export */ const x = (SvgX);
;// ./react/ui/icon/icons/outline/zoom-in.svg
var zoom_in_path;
function zoom_in_extends() { zoom_in_extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return zoom_in_extends.apply(this, arguments); }

var SvgZoomIn = function SvgZoomIn(props) {
  return /*#__PURE__*/react.createElement("svg", zoom_in_extends({
    xmlns: "http://www.w3.org/2000/svg",
    fill: "none",
    stroke: "currentColor",
    viewBox: "0 0 24 24"
  }, props), zoom_in_path || (zoom_in_path = /*#__PURE__*/react.createElement("path", {
    strokeLinecap: "round",
    strokeLinejoin: "round",
    strokeWidth: 2,
    d: "m21 21-6-6m2-5a7 7 0 1 1-14 0 7 7 0 0 1 14 0m-7-3v3m0 0v3m0-3h3m-3 0H7"
  })));
};
/* harmony default export */ const zoom_in = (SvgZoomIn);
;// ./react/ui/icon/icons/outline/zoom-out.svg
var zoom_out_path;
function zoom_out_extends() { zoom_out_extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return zoom_out_extends.apply(this, arguments); }

var SvgZoomOut = function SvgZoomOut(props) {
  return /*#__PURE__*/react.createElement("svg", zoom_out_extends({
    xmlns: "http://www.w3.org/2000/svg",
    fill: "none",
    stroke: "currentColor",
    viewBox: "0 0 24 24"
  }, props), zoom_out_path || (zoom_out_path = /*#__PURE__*/react.createElement("path", {
    strokeLinecap: "round",
    strokeLinejoin: "round",
    strokeWidth: 2,
    d: "m21 21-6-6m2-5a7 7 0 1 1-14 0 7 7 0 0 1 14 0m-4 0H7"
  })));
};
/* harmony default export */ const zoom_out = (SvgZoomOut);
;// ./react/ui/icon/icons/solid/academic-cap.svg
var academic_cap_path;
function academic_cap_extends() { academic_cap_extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return academic_cap_extends.apply(this, arguments); }

var academic_cap_SvgAcademicCap = function SvgAcademicCap(props) {
  return /*#__PURE__*/react.createElement("svg", academic_cap_extends({
    xmlns: "http://www.w3.org/2000/svg",
    fill: "currentColor",
    viewBox: "0 0 20 20"
  }, props), academic_cap_path || (academic_cap_path = /*#__PURE__*/react.createElement("path", {
    d: "M10.394 2.08a1 1 0 0 0-.788 0l-7 3a1 1 0 0 0 0 1.84L5.25 8.051a1 1 0 0 1 .356-.257l4-1.714a1 1 0 1 1 .788 1.838l-2.727 1.17 1.94.831a1 1 0 0 0 .787 0l7-3a1 1 0 0 0 0-1.838zM3.31 9.397 5 10.12v4.102a9 9 0 0 0-1.05-.174 1 1 0 0 1-.89-.89 11.1 11.1 0 0 1 .25-3.762zm5.99 7.176A9 9 0 0 0 7 14.935v-3.957l1.818.78a3 3 0 0 0 2.364 0l5.508-2.361a11 11 0 0 1 .25 3.762 1 1 0 0 1-.89.89 8.97 8.97 0 0 0-5.35 2.524 1 1 0 0 1-1.4 0M6 18a1 1 0 0 0 1-1v-2.065a9 9 0 0 0-2-.712V17a1 1 0 0 0 1 1"
  })));
};
/* harmony default export */ const solid_academic_cap = (academic_cap_SvgAcademicCap);
;// ./react/ui/icon/icons/solid/adjustments.svg
var solid_adjustments_path;
function solid_adjustments_extends() { solid_adjustments_extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return solid_adjustments_extends.apply(this, arguments); }

var adjustments_SvgAdjustments = function SvgAdjustments(props) {
  return /*#__PURE__*/react.createElement("svg", solid_adjustments_extends({
    xmlns: "http://www.w3.org/2000/svg",
    fill: "currentColor",
    viewBox: "0 0 20 20"
  }, props), solid_adjustments_path || (solid_adjustments_path = /*#__PURE__*/react.createElement("path", {
    d: "M5 4a1 1 0 0 0-2 0v7.268a2 2 0 0 0 0 3.464V16a1 1 0 1 0 2 0v-1.268a2 2 0 0 0 0-3.464zm6 0a1 1 0 1 0-2 0v1.268a2 2 0 0 0 0 3.464V16a1 1 0 1 0 2 0V8.732a2 2 0 0 0 0-3.464zm5-1a1 1 0 0 1 1 1v7.268a2 2 0 0 1 0 3.464V16a1 1 0 1 1-2 0v-1.268a2 2 0 0 1 0-3.464V4a1 1 0 0 1 1-1"
  })));
};
/* harmony default export */ const solid_adjustments = (adjustments_SvgAdjustments);
;// ./react/ui/icon/icons/solid/annotation.svg
var solid_annotation_path;
function solid_annotation_extends() { solid_annotation_extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return solid_annotation_extends.apply(this, arguments); }

var annotation_SvgAnnotation = function SvgAnnotation(props) {
  return /*#__PURE__*/react.createElement("svg", solid_annotation_extends({
    xmlns: "http://www.w3.org/2000/svg",
    fill: "currentColor",
    viewBox: "0 0 20 20"
  }, props), solid_annotation_path || (solid_annotation_path = /*#__PURE__*/react.createElement("path", {
    fillRule: "evenodd",
    d: "M18 13V5a2 2 0 0 0-2-2H4a2 2 0 0 0-2 2v8a2 2 0 0 0 2 2h3l3 3 3-3h3a2 2 0 0 0 2-2M5 7a1 1 0 0 1 1-1h8a1 1 0 1 1 0 2H6a1 1 0 0 1-1-1m1 3a1 1 0 1 0 0 2h3a1 1 0 1 0 0-2z",
    clipRule: "evenodd"
  })));
};
/* harmony default export */ const solid_annotation = (annotation_SvgAnnotation);
;// ./react/ui/icon/icons/solid/archive.svg
var solid_archive_path, archive_path2;
function solid_archive_extends() { solid_archive_extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return solid_archive_extends.apply(this, arguments); }

var archive_SvgArchive = function SvgArchive(props) {
  return /*#__PURE__*/react.createElement("svg", solid_archive_extends({
    xmlns: "http://www.w3.org/2000/svg",
    fill: "currentColor",
    viewBox: "0 0 20 20"
  }, props), solid_archive_path || (solid_archive_path = /*#__PURE__*/react.createElement("path", {
    d: "M4 3a2 2 0 1 0 0 4h12a2 2 0 1 0 0-4z"
  })), archive_path2 || (archive_path2 = /*#__PURE__*/react.createElement("path", {
    fillRule: "evenodd",
    d: "M3 8h14v7a2 2 0 0 1-2 2H5a2 2 0 0 1-2-2zm5 3a1 1 0 0 1 1-1h2a1 1 0 1 1 0 2H9a1 1 0 0 1-1-1",
    clipRule: "evenodd"
  })));
};
/* harmony default export */ const solid_archive = (archive_SvgArchive);
;// ./react/ui/icon/icons/solid/arrow-circle-down.svg
var solid_arrow_circle_down_path;
function solid_arrow_circle_down_extends() { solid_arrow_circle_down_extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return solid_arrow_circle_down_extends.apply(this, arguments); }

var arrow_circle_down_SvgArrowCircleDown = function SvgArrowCircleDown(props) {
  return /*#__PURE__*/react.createElement("svg", solid_arrow_circle_down_extends({
    xmlns: "http://www.w3.org/2000/svg",
    fill: "currentColor",
    viewBox: "0 0 20 20"
  }, props), solid_arrow_circle_down_path || (solid_arrow_circle_down_path = /*#__PURE__*/react.createElement("path", {
    fillRule: "evenodd",
    d: "M10 18a8 8 0 1 0 0-16 8 8 0 0 0 0 16m1-11a1 1 0 1 0-2 0v3.586L7.707 9.293a1 1 0 0 0-1.414 1.414l3 3a1 1 0 0 0 1.414 0l3-3a1 1 0 0 0-1.414-1.414L11 10.586z",
    clipRule: "evenodd"
  })));
};
/* harmony default export */ const solid_arrow_circle_down = (arrow_circle_down_SvgArrowCircleDown);
;// ./react/ui/icon/icons/solid/arrow-circle-left.svg
var solid_arrow_circle_left_path;
function solid_arrow_circle_left_extends() { solid_arrow_circle_left_extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return solid_arrow_circle_left_extends.apply(this, arguments); }

var arrow_circle_left_SvgArrowCircleLeft = function SvgArrowCircleLeft(props) {
  return /*#__PURE__*/react.createElement("svg", solid_arrow_circle_left_extends({
    xmlns: "http://www.w3.org/2000/svg",
    fill: "currentColor",
    viewBox: "0 0 20 20"
  }, props), solid_arrow_circle_left_path || (solid_arrow_circle_left_path = /*#__PURE__*/react.createElement("path", {
    fillRule: "evenodd",
    d: "M10 18a8 8 0 1 0 0-16 8 8 0 0 0 0 16m.707-10.293a1 1 0 0 0-1.414-1.414l-3 3a1 1 0 0 0 0 1.414l3 3a1 1 0 0 0 1.414-1.414L9.414 11H13a1 1 0 1 0 0-2H9.414z",
    clipRule: "evenodd"
  })));
};
/* harmony default export */ const solid_arrow_circle_left = (arrow_circle_left_SvgArrowCircleLeft);
;// ./react/ui/icon/icons/solid/arrow-circle-right.svg
var solid_arrow_circle_right_path;
function solid_arrow_circle_right_extends() { solid_arrow_circle_right_extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return solid_arrow_circle_right_extends.apply(this, arguments); }

var arrow_circle_right_SvgArrowCircleRight = function SvgArrowCircleRight(props) {
  return /*#__PURE__*/react.createElement("svg", solid_arrow_circle_right_extends({
    xmlns: "http://www.w3.org/2000/svg",
    fill: "currentColor",
    viewBox: "0 0 20 20"
  }, props), solid_arrow_circle_right_path || (solid_arrow_circle_right_path = /*#__PURE__*/react.createElement("path", {
    fillRule: "evenodd",
    d: "M10 18a8 8 0 1 0 0-16 8 8 0 0 0 0 16m3.707-8.707-3-3a1 1 0 0 0-1.414 1.414L10.586 9H7a1 1 0 1 0 0 2h3.586l-1.293 1.293a1 1 0 1 0 1.414 1.414l3-3a1 1 0 0 0 0-1.414",
    clipRule: "evenodd"
  })));
};
/* harmony default export */ const solid_arrow_circle_right = (arrow_circle_right_SvgArrowCircleRight);
;// ./react/ui/icon/icons/solid/arrow-circle-up.svg
var solid_arrow_circle_up_path;
function solid_arrow_circle_up_extends() { solid_arrow_circle_up_extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return solid_arrow_circle_up_extends.apply(this, arguments); }

var arrow_circle_up_SvgArrowCircleUp = function SvgArrowCircleUp(props) {
  return /*#__PURE__*/react.createElement("svg", solid_arrow_circle_up_extends({
    xmlns: "http://www.w3.org/2000/svg",
    fill: "currentColor",
    viewBox: "0 0 20 20"
  }, props), solid_arrow_circle_up_path || (solid_arrow_circle_up_path = /*#__PURE__*/react.createElement("path", {
    fillRule: "evenodd",
    d: "M10 18a8 8 0 1 0 0-16 8 8 0 0 0 0 16m3.707-8.707-3-3a1 1 0 0 0-1.414 0l-3 3a1 1 0 0 0 1.414 1.414L9 9.414V13a1 1 0 1 0 2 0V9.414l1.293 1.293a1 1 0 0 0 1.414-1.414",
    clipRule: "evenodd"
  })));
};
/* harmony default export */ const solid_arrow_circle_up = (arrow_circle_up_SvgArrowCircleUp);
;// ./react/ui/icon/icons/solid/arrow-down.svg
var solid_arrow_down_path;
function solid_arrow_down_extends() { solid_arrow_down_extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return solid_arrow_down_extends.apply(this, arguments); }

var arrow_down_SvgArrowDown = function SvgArrowDown(props) {
  return /*#__PURE__*/react.createElement("svg", solid_arrow_down_extends({
    xmlns: "http://www.w3.org/2000/svg",
    fill: "currentColor",
    viewBox: "0 0 20 20"
  }, props), solid_arrow_down_path || (solid_arrow_down_path = /*#__PURE__*/react.createElement("path", {
    fillRule: "evenodd",
    d: "M16.707 10.293a1 1 0 0 1 0 1.414l-6 6a1 1 0 0 1-1.414 0l-6-6a1 1 0 1 1 1.414-1.414L9 14.586V3a1 1 0 0 1 2 0v11.586l4.293-4.293a1 1 0 0 1 1.414 0",
    clipRule: "evenodd"
  })));
};
/* harmony default export */ const solid_arrow_down = (arrow_down_SvgArrowDown);
;// ./react/ui/icon/icons/solid/arrow-left.svg
var solid_arrow_left_path;
function solid_arrow_left_extends() { solid_arrow_left_extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return solid_arrow_left_extends.apply(this, arguments); }

var arrow_left_SvgArrowLeft = function SvgArrowLeft(props) {
  return /*#__PURE__*/react.createElement("svg", solid_arrow_left_extends({
    xmlns: "http://www.w3.org/2000/svg",
    fill: "currentColor",
    viewBox: "0 0 20 20"
  }, props), solid_arrow_left_path || (solid_arrow_left_path = /*#__PURE__*/react.createElement("path", {
    fillRule: "evenodd",
    d: "M9.707 16.707a1 1 0 0 1-1.414 0l-6-6a1 1 0 0 1 0-1.414l6-6a1 1 0 0 1 1.414 1.414L5.414 9H17a1 1 0 1 1 0 2H5.414l4.293 4.293a1 1 0 0 1 0 1.414",
    clipRule: "evenodd"
  })));
};
/* harmony default export */ const solid_arrow_left = (arrow_left_SvgArrowLeft);
;// ./react/ui/icon/icons/solid/arrow-narrow-down.svg
var solid_arrow_narrow_down_path;
function solid_arrow_narrow_down_extends() { solid_arrow_narrow_down_extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return solid_arrow_narrow_down_extends.apply(this, arguments); }

var arrow_narrow_down_SvgArrowNarrowDown = function SvgArrowNarrowDown(props) {
  return /*#__PURE__*/react.createElement("svg", solid_arrow_narrow_down_extends({
    xmlns: "http://www.w3.org/2000/svg",
    fill: "currentColor",
    viewBox: "0 0 20 20"
  }, props), solid_arrow_narrow_down_path || (solid_arrow_narrow_down_path = /*#__PURE__*/react.createElement("path", {
    fillRule: "evenodd",
    d: "M14.707 12.293a1 1 0 0 1 0 1.414l-4 4a1 1 0 0 1-1.414 0l-4-4a1 1 0 1 1 1.414-1.414L9 14.586V3a1 1 0 0 1 2 0v11.586l2.293-2.293a1 1 0 0 1 1.414 0",
    clipRule: "evenodd"
  })));
};
/* harmony default export */ const solid_arrow_narrow_down = (arrow_narrow_down_SvgArrowNarrowDown);
;// ./react/ui/icon/icons/solid/arrow-narrow-left.svg
var solid_arrow_narrow_left_path;
function solid_arrow_narrow_left_extends() { solid_arrow_narrow_left_extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return solid_arrow_narrow_left_extends.apply(this, arguments); }

var arrow_narrow_left_SvgArrowNarrowLeft = function SvgArrowNarrowLeft(props) {
  return /*#__PURE__*/react.createElement("svg", solid_arrow_narrow_left_extends({
    xmlns: "http://www.w3.org/2000/svg",
    fill: "currentColor",
    viewBox: "0 0 20 20"
  }, props), solid_arrow_narrow_left_path || (solid_arrow_narrow_left_path = /*#__PURE__*/react.createElement("path", {
    fillRule: "evenodd",
    d: "M7.707 14.707a1 1 0 0 1-1.414 0l-4-4a1 1 0 0 1 0-1.414l4-4a1 1 0 0 1 1.414 1.414L5.414 9H17a1 1 0 1 1 0 2H5.414l2.293 2.293a1 1 0 0 1 0 1.414",
    clipRule: "evenodd"
  })));
};
/* harmony default export */ const solid_arrow_narrow_left = (arrow_narrow_left_SvgArrowNarrowLeft);
;// ./react/ui/icon/icons/solid/arrow-narrow-right.svg
var solid_arrow_narrow_right_path;
function solid_arrow_narrow_right_extends() { solid_arrow_narrow_right_extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return solid_arrow_narrow_right_extends.apply(this, arguments); }

var arrow_narrow_right_SvgArrowNarrowRight = function SvgArrowNarrowRight(props) {
  return /*#__PURE__*/react.createElement("svg", solid_arrow_narrow_right_extends({
    xmlns: "http://www.w3.org/2000/svg",
    fill: "currentColor",
    viewBox: "0 0 20 20"
  }, props), solid_arrow_narrow_right_path || (solid_arrow_narrow_right_path = /*#__PURE__*/react.createElement("path", {
    fillRule: "evenodd",
    d: "M12.293 5.293a1 1 0 0 1 1.414 0l4 4a1 1 0 0 1 0 1.414l-4 4a1 1 0 0 1-1.414-1.414L14.586 11H3a1 1 0 1 1 0-2h11.586l-2.293-2.293a1 1 0 0 1 0-1.414",
    clipRule: "evenodd"
  })));
};
/* harmony default export */ const solid_arrow_narrow_right = (arrow_narrow_right_SvgArrowNarrowRight);
;// ./react/ui/icon/icons/solid/arrow-narrow-up.svg
var solid_arrow_narrow_up_path;
function solid_arrow_narrow_up_extends() { solid_arrow_narrow_up_extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return solid_arrow_narrow_up_extends.apply(this, arguments); }

var arrow_narrow_up_SvgArrowNarrowUp = function SvgArrowNarrowUp(props) {
  return /*#__PURE__*/react.createElement("svg", solid_arrow_narrow_up_extends({
    xmlns: "http://www.w3.org/2000/svg",
    fill: "currentColor",
    viewBox: "0 0 20 20"
  }, props), solid_arrow_narrow_up_path || (solid_arrow_narrow_up_path = /*#__PURE__*/react.createElement("path", {
    fillRule: "evenodd",
    d: "M5.293 7.707a1 1 0 0 1 0-1.414l4-4a1 1 0 0 1 1.414 0l4 4a1 1 0 0 1-1.414 1.414L11 5.414V17a1 1 0 1 1-2 0V5.414L6.707 7.707a1 1 0 0 1-1.414 0",
    clipRule: "evenodd"
  })));
};
/* harmony default export */ const solid_arrow_narrow_up = (arrow_narrow_up_SvgArrowNarrowUp);
;// ./react/ui/icon/icons/solid/arrow-right.svg
var solid_arrow_right_path;
function solid_arrow_right_extends() { solid_arrow_right_extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return solid_arrow_right_extends.apply(this, arguments); }

var arrow_right_SvgArrowRight = function SvgArrowRight(props) {
  return /*#__PURE__*/react.createElement("svg", solid_arrow_right_extends({
    xmlns: "http://www.w3.org/2000/svg",
    fill: "currentColor",
    viewBox: "0 0 20 20"
  }, props), solid_arrow_right_path || (solid_arrow_right_path = /*#__PURE__*/react.createElement("path", {
    fillRule: "evenodd",
    d: "M10.293 3.293a1 1 0 0 1 1.414 0l6 6a1 1 0 0 1 0 1.414l-6 6a1 1 0 0 1-1.414-1.414L14.586 11H3a1 1 0 1 1 0-2h11.586l-4.293-4.293a1 1 0 0 1 0-1.414",
    clipRule: "evenodd"
  })));
};
/* harmony default export */ const solid_arrow_right = (arrow_right_SvgArrowRight);
;// ./react/ui/icon/icons/solid/arrow-up.svg
var solid_arrow_up_path;
function solid_arrow_up_extends() { solid_arrow_up_extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return solid_arrow_up_extends.apply(this, arguments); }

var arrow_up_SvgArrowUp = function SvgArrowUp(props) {
  return /*#__PURE__*/react.createElement("svg", solid_arrow_up_extends({
    xmlns: "http://www.w3.org/2000/svg",
    fill: "currentColor",
    viewBox: "0 0 20 20"
  }, props), solid_arrow_up_path || (solid_arrow_up_path = /*#__PURE__*/react.createElement("path", {
    fillRule: "evenodd",
    d: "M3.293 9.707a1 1 0 0 1 0-1.414l6-6a1 1 0 0 1 1.414 0l6 6a1 1 0 0 1-1.414 1.414L11 5.414V17a1 1 0 1 1-2 0V5.414L4.707 9.707a1 1 0 0 1-1.414 0",
    clipRule: "evenodd"
  })));
};
/* harmony default export */ const solid_arrow_up = (arrow_up_SvgArrowUp);
;// ./react/ui/icon/icons/solid/arrows-expand.svg
var solid_arrows_expand_path;
function solid_arrows_expand_extends() { solid_arrows_expand_extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return solid_arrows_expand_extends.apply(this, arguments); }

var arrows_expand_SvgArrowsExpand = function SvgArrowsExpand(props) {
  return /*#__PURE__*/react.createElement("svg", solid_arrows_expand_extends({
    xmlns: "http://www.w3.org/2000/svg",
    fill: "currentColor",
    viewBox: "0 0 19 20"
  }, props), solid_arrows_expand_path || (solid_arrows_expand_path = /*#__PURE__*/react.createElement("path", {
    stroke: "#374151",
    strokeLinecap: "round",
    strokeLinejoin: "round",
    strokeWidth: 2,
    d: "M3 8V4m0 0h4M3 4l4 4m8 0V4m0 0h-4m4 0-4 4m-8 4v4m0 0h4m-4 0 4-4m8 4-4-4m4 4v-4m0 4h-4"
  })));
};
/* harmony default export */ const solid_arrows_expand = (arrows_expand_SvgArrowsExpand);
;// ./react/ui/icon/icons/solid/at-symbol.svg
var solid_at_symbol_path;
function solid_at_symbol_extends() { solid_at_symbol_extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return solid_at_symbol_extends.apply(this, arguments); }

var at_symbol_SvgAtSymbol = function SvgAtSymbol(props) {
  return /*#__PURE__*/react.createElement("svg", solid_at_symbol_extends({
    xmlns: "http://www.w3.org/2000/svg",
    fill: "currentColor",
    viewBox: "0 0 20 20"
  }, props), solid_at_symbol_path || (solid_at_symbol_path = /*#__PURE__*/react.createElement("path", {
    fillRule: "evenodd",
    d: "M14.243 5.757a6 6 0 1 0-.986 9.284 1 1 0 1 1 1.087 1.678A8 8 0 1 1 18 10a3 3 0 0 1-4.8 2.401A4 4 0 1 1 14 10a1 1 0 1 0 2 0c0-1.537-.586-3.07-1.757-4.243M12 10a2 2 0 1 0-4 0 2 2 0 0 0 4 0",
    clipRule: "evenodd"
  })));
};
/* harmony default export */ const solid_at_symbol = (at_symbol_SvgAtSymbol);
;// ./react/ui/icon/icons/solid/backspace.svg
var solid_backspace_path;
function solid_backspace_extends() { solid_backspace_extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return solid_backspace_extends.apply(this, arguments); }

var backspace_SvgBackspace = function SvgBackspace(props) {
  return /*#__PURE__*/react.createElement("svg", solid_backspace_extends({
    xmlns: "http://www.w3.org/2000/svg",
    fill: "currentColor",
    viewBox: "0 0 20 20"
  }, props), solid_backspace_path || (solid_backspace_path = /*#__PURE__*/react.createElement("path", {
    fillRule: "evenodd",
    d: "M6.707 4.879A3 3 0 0 1 8.828 4H15a3 3 0 0 1 3 3v6a3 3 0 0 1-3 3H8.828a3 3 0 0 1-2.12-.879l-4.415-4.414a1 1 0 0 1 0-1.414zm4 2.414a1 1 0 0 0-1.414 1.414L10.586 10l-1.293 1.293a1 1 0 1 0 1.414 1.414L12 11.414l1.293 1.293a1 1 0 0 0 1.414-1.414L13.414 10l1.293-1.293a1 1 0 0 0-1.414-1.414L12 8.586z",
    clipRule: "evenodd"
  })));
};
/* harmony default export */ const solid_backspace = (backspace_SvgBackspace);
;// ./react/ui/icon/icons/solid/badge-check.svg
var solid_badge_check_path;
function solid_badge_check_extends() { solid_badge_check_extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return solid_badge_check_extends.apply(this, arguments); }

var badge_check_SvgBadgeCheck = function SvgBadgeCheck(props) {
  return /*#__PURE__*/react.createElement("svg", solid_badge_check_extends({
    xmlns: "http://www.w3.org/2000/svg",
    fill: "currentColor",
    viewBox: "0 0 20 20"
  }, props), solid_badge_check_path || (solid_badge_check_path = /*#__PURE__*/react.createElement("path", {
    fillRule: "evenodd",
    d: "M6.267 3.455a3.07 3.07 0 0 0 1.745-.723 3.066 3.066 0 0 1 3.976 0 3.07 3.07 0 0 0 1.745.723 3.066 3.066 0 0 1 2.812 2.812c.051.643.304 1.254.723 1.745a3.066 3.066 0 0 1 0 3.976 3.07 3.07 0 0 0-.723 1.745 3.066 3.066 0 0 1-2.812 2.812 3.07 3.07 0 0 0-1.745.723 3.066 3.066 0 0 1-3.976 0 3.07 3.07 0 0 0-1.745-.723 3.066 3.066 0 0 1-2.812-2.812 3.07 3.07 0 0 0-.723-1.745 3.066 3.066 0 0 1 0-3.976 3.07 3.07 0 0 0 .723-1.745 3.066 3.066 0 0 1 2.812-2.812m7.44 5.252a1 1 0 0 0-1.414-1.414L9 10.586 7.707 9.293a1 1 0 0 0-1.414 1.414l2 2a1 1 0 0 0 1.414 0z",
    clipRule: "evenodd"
  })));
};
/* harmony default export */ const solid_badge_check = (badge_check_SvgBadgeCheck);
;// ./react/ui/icon/icons/solid/ban.svg
var solid_ban_path;
function solid_ban_extends() { solid_ban_extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return solid_ban_extends.apply(this, arguments); }

var ban_SvgBan = function SvgBan(props) {
  return /*#__PURE__*/react.createElement("svg", solid_ban_extends({
    xmlns: "http://www.w3.org/2000/svg",
    fill: "currentColor",
    viewBox: "0 0 20 20"
  }, props), solid_ban_path || (solid_ban_path = /*#__PURE__*/react.createElement("path", {
    fillRule: "evenodd",
    d: "M13.477 14.89A6 6 0 0 1 5.11 6.524l8.367 8.368zm1.414-1.414L6.524 5.11a6 6 0 0 1 8.367 8.367zM18 10a8 8 0 1 1-16 0 8 8 0 0 1 16 0",
    clipRule: "evenodd"
  })));
};
/* harmony default export */ const solid_ban = (ban_SvgBan);
;// ./react/ui/icon/icons/solid/beaker.svg
var solid_beaker_path;
function solid_beaker_extends() { solid_beaker_extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return solid_beaker_extends.apply(this, arguments); }

var beaker_SvgBeaker = function SvgBeaker(props) {
  return /*#__PURE__*/react.createElement("svg", solid_beaker_extends({
    xmlns: "http://www.w3.org/2000/svg",
    fill: "currentColor",
    viewBox: "0 0 20 20"
  }, props), solid_beaker_path || (solid_beaker_path = /*#__PURE__*/react.createElement("path", {
    fillRule: "evenodd",
    d: "M7 2a1 1 0 0 0-.707 1.707L7 4.414v3.758a1 1 0 0 1-.293.707l-4 4C.817 14.769 2.156 18 4.828 18h10.343c2.673 0 4.012-3.231 2.122-5.121l-4-4A1 1 0 0 1 13 8.172V4.414l.707-.707A1 1 0 0 0 13 2zm2 6.172V4h2v4.172a3 3 0 0 0 .879 2.12l1.027 1.028a4 4 0 0 0-2.171.102l-.47.156a4 4 0 0 1-2.53 0l-.563-.187-.114-.035 1.063-1.063A3 3 0 0 0 9 8.172",
    clipRule: "evenodd"
  })));
};
/* harmony default export */ const solid_beaker = (beaker_SvgBeaker);
;// ./react/ui/icon/icons/solid/bell.svg
var solid_bell_path;
function solid_bell_extends() { solid_bell_extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return solid_bell_extends.apply(this, arguments); }

var bell_SvgBell = function SvgBell(props) {
  return /*#__PURE__*/react.createElement("svg", solid_bell_extends({
    xmlns: "http://www.w3.org/2000/svg",
    fill: "currentColor",
    viewBox: "0 0 20 20"
  }, props), solid_bell_path || (solid_bell_path = /*#__PURE__*/react.createElement("path", {
    d: "M10 2a6 6 0 0 0-6 6v3.586l-.707.707A1 1 0 0 0 4 14h12a1 1 0 0 0 .707-1.707L16 11.586V8a6 6 0 0 0-6-6m0 16a3 3 0 0 1-3-3h6a3 3 0 0 1-3 3"
  })));
};
/* harmony default export */ const solid_bell = (bell_SvgBell);
;// ./react/ui/icon/icons/solid/book-open.svg
var solid_book_open_path;
function solid_book_open_extends() { solid_book_open_extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return solid_book_open_extends.apply(this, arguments); }

var book_open_SvgBookOpen = function SvgBookOpen(props) {
  return /*#__PURE__*/react.createElement("svg", solid_book_open_extends({
    xmlns: "http://www.w3.org/2000/svg",
    fill: "currentColor",
    viewBox: "0 0 20 20"
  }, props), solid_book_open_path || (solid_book_open_path = /*#__PURE__*/react.createElement("path", {
    d: "M9 4.804A8 8 0 0 0 5.5 4c-1.255 0-2.443.29-3.5.804v10A8 8 0 0 1 5.5 14c1.669 0 3.218.51 4.5 1.385A7.96 7.96 0 0 1 14.5 14c1.255 0 2.443.29 3.5.804v-10A8 8 0 0 0 14.5 4c-1.255 0-2.443.29-3.5.804V12a1 1 0 1 1-2 0z"
  })));
};
/* harmony default export */ const solid_book_open = (book_open_SvgBookOpen);
;// ./react/ui/icon/icons/solid/bookmark-alt.svg
var solid_bookmark_alt_path;
function solid_bookmark_alt_extends() { solid_bookmark_alt_extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return solid_bookmark_alt_extends.apply(this, arguments); }

var bookmark_alt_SvgBookmarkAlt = function SvgBookmarkAlt(props) {
  return /*#__PURE__*/react.createElement("svg", solid_bookmark_alt_extends({
    xmlns: "http://www.w3.org/2000/svg",
    fill: "currentColor",
    viewBox: "0 0 20 20"
  }, props), solid_bookmark_alt_path || (solid_bookmark_alt_path = /*#__PURE__*/react.createElement("path", {
    fillRule: "evenodd",
    d: "M3 5a2 2 0 0 1 2-2h10a2 2 0 0 1 2 2v10a2 2 0 0 1-2 2H5a2 2 0 0 1-2-2zm11 1H6v8l4-2 4 2z",
    clipRule: "evenodd"
  })));
};
/* harmony default export */ const solid_bookmark_alt = (bookmark_alt_SvgBookmarkAlt);
;// ./react/ui/icon/icons/solid/bookmark.svg
var solid_bookmark_path;
function solid_bookmark_extends() { solid_bookmark_extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return solid_bookmark_extends.apply(this, arguments); }

var bookmark_SvgBookmark = function SvgBookmark(props) {
  return /*#__PURE__*/react.createElement("svg", solid_bookmark_extends({
    xmlns: "http://www.w3.org/2000/svg",
    fill: "currentColor",
    viewBox: "0 0 20 20"
  }, props), solid_bookmark_path || (solid_bookmark_path = /*#__PURE__*/react.createElement("path", {
    d: "M5 4a2 2 0 0 1 2-2h6a2 2 0 0 1 2 2v14l-5-2.5L5 18z"
  })));
};
/* harmony default export */ const solid_bookmark = (bookmark_SvgBookmark);
;// ./react/ui/icon/icons/solid/briefcase.svg
var solid_briefcase_path, briefcase_path2;
function solid_briefcase_extends() { solid_briefcase_extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return solid_briefcase_extends.apply(this, arguments); }

var briefcase_SvgBriefcase = function SvgBriefcase(props) {
  return /*#__PURE__*/react.createElement("svg", solid_briefcase_extends({
    xmlns: "http://www.w3.org/2000/svg",
    fill: "currentColor",
    viewBox: "0 0 20 20"
  }, props), solid_briefcase_path || (solid_briefcase_path = /*#__PURE__*/react.createElement("path", {
    fillRule: "evenodd",
    d: "M6 6V5a3 3 0 0 1 3-3h2a3 3 0 0 1 3 3v1h2a2 2 0 0 1 2 2v3.57A23 23 0 0 1 10 13a23 23 0 0 1-8-1.43V8a2 2 0 0 1 2-2zm2-1a1 1 0 0 1 1-1h2a1 1 0 0 1 1 1v1H8zm1 5a1 1 0 0 1 1-1h.01a1 1 0 1 1 0 2H10a1 1 0 0 1-1-1",
    clipRule: "evenodd"
  })), briefcase_path2 || (briefcase_path2 = /*#__PURE__*/react.createElement("path", {
    d: "M2 13.692V16a2 2 0 0 0 2 2h12a2 2 0 0 0 2-2v-2.308A25 25 0 0 1 10 15a25 25 0 0 1-8-1.308"
  })));
};
/* harmony default export */ const solid_briefcase = (briefcase_SvgBriefcase);
;// ./react/ui/icon/icons/solid/cake.svg
var solid_cake_path;
function solid_cake_extends() { solid_cake_extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return solid_cake_extends.apply(this, arguments); }

var cake_SvgCake = function SvgCake(props) {
  return /*#__PURE__*/react.createElement("svg", solid_cake_extends({
    xmlns: "http://www.w3.org/2000/svg",
    fill: "currentColor",
    viewBox: "0 0 20 20"
  }, props), solid_cake_path || (solid_cake_path = /*#__PURE__*/react.createElement("path", {
    fillRule: "evenodd",
    d: "M6 3a1 1 0 0 1 1-1h.01a1 1 0 0 1 0 2H7a1 1 0 0 1-1-1m2 3a1 1 0 0 0-2 0v1a2 2 0 0 0-2 2v1a2 2 0 0 0-2 2v.683a3.7 3.7 0 0 1 1.055.485 1.7 1.7 0 0 0 1.89 0 3.7 3.7 0 0 1 4.11 0 1.7 1.7 0 0 0 1.89 0 3.7 3.7 0 0 1 4.11 0 1.7 1.7 0 0 0 1.89 0A3.7 3.7 0 0 1 18 12.683V12a2 2 0 0 0-2-2V9a2 2 0 0 0-2-2V6a1 1 0 1 0-2 0v1h-1V6a1 1 0 1 0-2 0v1H8zm10 8.868a3.7 3.7 0 0 1-4.055-.036 1.7 1.7 0 0 0-1.89 0 3.7 3.7 0 0 1-4.11 0 1.7 1.7 0 0 0-1.89 0A3.7 3.7 0 0 1 2 14.868V17a1 1 0 0 0 1 1h14a1 1 0 0 0 1-1zM9 3a1 1 0 0 1 1-1h.01a1 1 0 1 1 0 2H10a1 1 0 0 1-1-1m3 0a1 1 0 0 1 1-1h.01a1 1 0 1 1 0 2H13a1 1 0 0 1-1-1",
    clipRule: "evenodd"
  })));
};
/* harmony default export */ const solid_cake = (cake_SvgCake);
;// ./react/ui/icon/icons/solid/calculator.svg
var solid_calculator_path;
function solid_calculator_extends() { solid_calculator_extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return solid_calculator_extends.apply(this, arguments); }

var calculator_SvgCalculator = function SvgCalculator(props) {
  return /*#__PURE__*/react.createElement("svg", solid_calculator_extends({
    xmlns: "http://www.w3.org/2000/svg",
    fill: "currentColor",
    viewBox: "0 0 20 20"
  }, props), solid_calculator_path || (solid_calculator_path = /*#__PURE__*/react.createElement("path", {
    fillRule: "evenodd",
    d: "M6 2a2 2 0 0 0-2 2v12a2 2 0 0 0 2 2h8a2 2 0 0 0 2-2V4a2 2 0 0 0-2-2zm1 2a1 1 0 0 0 0 2h6a1 1 0 1 0 0-2zm6 7a1 1 0 0 1 1 1v3a1 1 0 1 1-2 0v-3a1 1 0 0 1 1-1m-3 3a1 1 0 1 0 0 2h.01a1 1 0 1 0 0-2zm-4 1a1 1 0 0 1 1-1h.01a1 1 0 1 1 0 2H7a1 1 0 0 1-1-1m1-4a1 1 0 1 0 0 2h.01a1 1 0 1 0 0-2zm2 1a1 1 0 0 1 1-1h.01a1 1 0 1 1 0 2H10a1 1 0 0 1-1-1m4-4a1 1 0 1 0 0 2h.01a1 1 0 1 0 0-2zM9 9a1 1 0 0 1 1-1h.01a1 1 0 1 1 0 2H10a1 1 0 0 1-1-1M7 8a1 1 0 0 0 0 2h.01a1 1 0 0 0 0-2z",
    clipRule: "evenodd"
  })));
};
/* harmony default export */ const solid_calculator = (calculator_SvgCalculator);
;// ./react/ui/icon/icons/solid/calendar.svg
var solid_calendar_path;
function solid_calendar_extends() { solid_calendar_extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return solid_calendar_extends.apply(this, arguments); }

var calendar_SvgCalendar = function SvgCalendar(props) {
  return /*#__PURE__*/react.createElement("svg", solid_calendar_extends({
    xmlns: "http://www.w3.org/2000/svg",
    fill: "currentColor",
    viewBox: "0 0 20 20"
  }, props), solid_calendar_path || (solid_calendar_path = /*#__PURE__*/react.createElement("path", {
    fillRule: "evenodd",
    d: "M6 2a1 1 0 0 0-1 1v1H4a2 2 0 0 0-2 2v10a2 2 0 0 0 2 2h12a2 2 0 0 0 2-2V6a2 2 0 0 0-2-2h-1V3a1 1 0 1 0-2 0v1H7V3a1 1 0 0 0-1-1m0 5a1 1 0 0 0 0 2h8a1 1 0 1 0 0-2z",
    clipRule: "evenodd"
  })));
};
/* harmony default export */ const solid_calendar = (calendar_SvgCalendar);
;// ./react/ui/icon/icons/solid/camera.svg
var solid_camera_path;
function solid_camera_extends() { solid_camera_extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return solid_camera_extends.apply(this, arguments); }

var camera_SvgCamera = function SvgCamera(props) {
  return /*#__PURE__*/react.createElement("svg", solid_camera_extends({
    xmlns: "http://www.w3.org/2000/svg",
    fill: "currentColor",
    viewBox: "0 0 20 20"
  }, props), solid_camera_path || (solid_camera_path = /*#__PURE__*/react.createElement("path", {
    fillRule: "evenodd",
    d: "M4 5a2 2 0 0 0-2 2v8a2 2 0 0 0 2 2h12a2 2 0 0 0 2-2V7a2 2 0 0 0-2-2h-1.586a1 1 0 0 1-.707-.293l-1.121-1.121A2 2 0 0 0 11.172 3H8.828a2 2 0 0 0-1.414.586L6.293 4.707A1 1 0 0 1 5.586 5zm6 9a3 3 0 1 0 0-6 3 3 0 0 0 0 6",
    clipRule: "evenodd"
  })));
};
/* harmony default export */ const solid_camera = (camera_SvgCamera);
;// ./react/ui/icon/icons/solid/cash.svg
var solid_cash_path;
function solid_cash_extends() { solid_cash_extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return solid_cash_extends.apply(this, arguments); }

var cash_SvgCash = function SvgCash(props) {
  return /*#__PURE__*/react.createElement("svg", solid_cash_extends({
    xmlns: "http://www.w3.org/2000/svg",
    fill: "currentColor",
    viewBox: "0 0 20 20"
  }, props), solid_cash_path || (solid_cash_path = /*#__PURE__*/react.createElement("path", {
    fillRule: "evenodd",
    d: "M4 4a2 2 0 0 0-2 2v4a2 2 0 0 0 2 2V6h10a2 2 0 0 0-2-2zm2 6a2 2 0 0 1 2-2h8a2 2 0 0 1 2 2v4a2 2 0 0 1-2 2H8a2 2 0 0 1-2-2zm6 4a2 2 0 1 0 0-4 2 2 0 0 0 0 4",
    clipRule: "evenodd"
  })));
};
/* harmony default export */ const solid_cash = (cash_SvgCash);
;// ./react/ui/icon/icons/solid/chart-bar.svg
var solid_chart_bar_path;
function solid_chart_bar_extends() { solid_chart_bar_extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return solid_chart_bar_extends.apply(this, arguments); }

var chart_bar_SvgChartBar = function SvgChartBar(props) {
  return /*#__PURE__*/react.createElement("svg", solid_chart_bar_extends({
    xmlns: "http://www.w3.org/2000/svg",
    fill: "currentColor",
    viewBox: "0 0 20 20"
  }, props), solid_chart_bar_path || (solid_chart_bar_path = /*#__PURE__*/react.createElement("path", {
    d: "M2 11a1 1 0 0 1 1-1h2a1 1 0 0 1 1 1v5a1 1 0 0 1-1 1H3a1 1 0 0 1-1-1zm6-4a1 1 0 0 1 1-1h2a1 1 0 0 1 1 1v9a1 1 0 0 1-1 1H9a1 1 0 0 1-1-1zm6-3a1 1 0 0 1 1-1h2a1 1 0 0 1 1 1v12a1 1 0 0 1-1 1h-2a1 1 0 0 1-1-1z"
  })));
};
/* harmony default export */ const solid_chart_bar = (chart_bar_SvgChartBar);
;// ./react/ui/icon/icons/solid/chart-pie.svg
var solid_chart_pie_path, solid_chart_pie_path2;
function solid_chart_pie_extends() { solid_chart_pie_extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return solid_chart_pie_extends.apply(this, arguments); }

var chart_pie_SvgChartPie = function SvgChartPie(props) {
  return /*#__PURE__*/react.createElement("svg", solid_chart_pie_extends({
    xmlns: "http://www.w3.org/2000/svg",
    fill: "currentColor",
    viewBox: "0 0 24 24"
  }, props), solid_chart_pie_path || (solid_chart_pie_path = /*#__PURE__*/react.createElement("path", {
    fillRule: "evenodd",
    d: "M2.25 13.5a8.25 8.25 0 0 1 8.25-8.25.75.75 0 0 1 .75.75v6.75H18a.75.75 0 0 1 .75.75 8.25 8.25 0 0 1-16.5 0",
    clipRule: "evenodd"
  })), solid_chart_pie_path2 || (solid_chart_pie_path2 = /*#__PURE__*/react.createElement("path", {
    fillRule: "evenodd",
    d: "M12.75 3a.75.75 0 0 1 .75-.75 8.25 8.25 0 0 1 8.25 8.25.75.75 0 0 1-.75.75h-7.5a.75.75 0 0 1-.75-.75z",
    clipRule: "evenodd"
  })));
};
/* harmony default export */ const solid_chart_pie = (chart_pie_SvgChartPie);
;// ./react/ui/icon/icons/solid/chart-square-bar.svg
var solid_chart_square_bar_path;
function solid_chart_square_bar_extends() { solid_chart_square_bar_extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return solid_chart_square_bar_extends.apply(this, arguments); }

var chart_square_bar_SvgChartSquareBar = function SvgChartSquareBar(props) {
  return /*#__PURE__*/react.createElement("svg", solid_chart_square_bar_extends({
    xmlns: "http://www.w3.org/2000/svg",
    fill: "currentColor",
    viewBox: "0 0 20 20"
  }, props), solid_chart_square_bar_path || (solid_chart_square_bar_path = /*#__PURE__*/react.createElement("path", {
    fillRule: "evenodd",
    d: "M5 3a2 2 0 0 0-2 2v10a2 2 0 0 0 2 2h10a2 2 0 0 0 2-2V5a2 2 0 0 0-2-2zm9 4a1 1 0 1 0-2 0v6a1 1 0 1 0 2 0zm-3 2a1 1 0 1 0-2 0v4a1 1 0 1 0 2 0zm-3 3a1 1 0 1 0-2 0v1a1 1 0 1 0 2 0z",
    clipRule: "evenodd"
  })));
};
/* harmony default export */ const solid_chart_square_bar = (chart_square_bar_SvgChartSquareBar);
;// ./react/ui/icon/icons/solid/chat-alt-2.svg
var solid_chat_alt_2_path, chat_alt_2_path2;
function solid_chat_alt_2_extends() { solid_chat_alt_2_extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return solid_chat_alt_2_extends.apply(this, arguments); }

var chat_alt_2_SvgChatAlt2 = function SvgChatAlt2(props) {
  return /*#__PURE__*/react.createElement("svg", solid_chat_alt_2_extends({
    xmlns: "http://www.w3.org/2000/svg",
    fill: "currentColor",
    viewBox: "0 0 20 20"
  }, props), solid_chat_alt_2_path || (solid_chat_alt_2_path = /*#__PURE__*/react.createElement("path", {
    d: "M2 5a2 2 0 0 1 2-2h7a2 2 0 0 1 2 2v4a2 2 0 0 1-2 2H9l-3 3v-3H4a2 2 0 0 1-2-2z"
  })), chat_alt_2_path2 || (chat_alt_2_path2 = /*#__PURE__*/react.createElement("path", {
    d: "M15 7v2a4 4 0 0 1-4 4H9.828l-1.766 1.767c.28.149.599.233.938.233h2l3 3v-3h2a2 2 0 0 0 2-2V9a2 2 0 0 0-2-2z"
  })));
};
/* harmony default export */ const solid_chat_alt_2 = (chat_alt_2_SvgChatAlt2);
;// ./react/ui/icon/icons/solid/chat-alt.svg
var solid_chat_alt_path;
function solid_chat_alt_extends() { solid_chat_alt_extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return solid_chat_alt_extends.apply(this, arguments); }

var chat_alt_SvgChatAlt = function SvgChatAlt(props) {
  return /*#__PURE__*/react.createElement("svg", solid_chat_alt_extends({
    xmlns: "http://www.w3.org/2000/svg",
    fill: "currentColor",
    viewBox: "0 0 20 20"
  }, props), solid_chat_alt_path || (solid_chat_alt_path = /*#__PURE__*/react.createElement("path", {
    fillRule: "evenodd",
    d: "M18 5v8a2 2 0 0 1-2 2h-5l-5 4v-4H4a2 2 0 0 1-2-2V5a2 2 0 0 1 2-2h12a2 2 0 0 1 2 2M7 8H5v2h2zm2 0h2v2H9zm6 0h-2v2h2z",
    clipRule: "evenodd"
  })));
};
/* harmony default export */ const solid_chat_alt = (chat_alt_SvgChatAlt);
;// ./react/ui/icon/icons/solid/chat.svg
var solid_chat_path;
function solid_chat_extends() { solid_chat_extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return solid_chat_extends.apply(this, arguments); }

var chat_SvgChat = function SvgChat(props) {
  return /*#__PURE__*/react.createElement("svg", solid_chat_extends({
    xmlns: "http://www.w3.org/2000/svg",
    fill: "currentColor",
    viewBox: "0 0 20 20"
  }, props), solid_chat_path || (solid_chat_path = /*#__PURE__*/react.createElement("path", {
    fillRule: "evenodd",
    d: "M18 10c0 3.866-3.582 7-8 7a8.84 8.84 0 0 1-4.083-.98L2 17l1.338-3.123C2.493 12.767 2 11.434 2 10c0-3.866 3.582-7 8-7s8 3.134 8 7M7 9H5v2h2zm8 0h-2v2h2zM9 9h2v2H9z",
    clipRule: "evenodd"
  })));
};
/* harmony default export */ const solid_chat = (chat_SvgChat);
;// ./react/ui/icon/icons/solid/check-circle.svg
var solid_check_circle_path;
function solid_check_circle_extends() { solid_check_circle_extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return solid_check_circle_extends.apply(this, arguments); }

var check_circle_SvgCheckCircle = function SvgCheckCircle(props) {
  return /*#__PURE__*/react.createElement("svg", solid_check_circle_extends({
    xmlns: "http://www.w3.org/2000/svg",
    fill: "currentColor",
    viewBox: "0 0 20 20"
  }, props), solid_check_circle_path || (solid_check_circle_path = /*#__PURE__*/react.createElement("path", {
    fillRule: "evenodd",
    d: "M10 18a8 8 0 1 0 0-16 8 8 0 0 0 0 16m3.707-9.293a1 1 0 0 0-1.414-1.414L9 10.586 7.707 9.293a1 1 0 0 0-1.414 1.414l2 2a1 1 0 0 0 1.414 0z",
    clipRule: "evenodd"
  })));
};
/* harmony default export */ const solid_check_circle = (check_circle_SvgCheckCircle);
;// ./react/ui/icon/icons/solid/check.svg
var solid_check_path;
function solid_check_extends() { solid_check_extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return solid_check_extends.apply(this, arguments); }

var check_SvgCheck = function SvgCheck(props) {
  return /*#__PURE__*/react.createElement("svg", solid_check_extends({
    xmlns: "http://www.w3.org/2000/svg",
    fill: "currentColor",
    viewBox: "0 0 20 20"
  }, props), solid_check_path || (solid_check_path = /*#__PURE__*/react.createElement("path", {
    fillRule: "evenodd",
    d: "M16.707 5.293a1 1 0 0 1 0 1.414l-8 8a1 1 0 0 1-1.414 0l-4-4a1 1 0 0 1 1.414-1.414L8 12.586l7.293-7.293a1 1 0 0 1 1.414 0",
    clipRule: "evenodd"
  })));
};
/* harmony default export */ const solid_check = (check_SvgCheck);
;// ./react/ui/icon/icons/solid/chevron-double-down.svg
var solid_chevron_double_down_path;
function solid_chevron_double_down_extends() { solid_chevron_double_down_extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return solid_chevron_double_down_extends.apply(this, arguments); }

var chevron_double_down_SvgChevronDoubleDown = function SvgChevronDoubleDown(props) {
  return /*#__PURE__*/react.createElement("svg", solid_chevron_double_down_extends({
    xmlns: "http://www.w3.org/2000/svg",
    fill: "currentColor",
    viewBox: "0 0 20 20"
  }, props), solid_chevron_double_down_path || (solid_chevron_double_down_path = /*#__PURE__*/react.createElement("path", {
    fillRule: "evenodd",
    d: "M15.707 4.293a1 1 0 0 1 0 1.414l-5 5a1 1 0 0 1-1.414 0l-5-5a1 1 0 0 1 1.414-1.414L10 8.586l4.293-4.293a1 1 0 0 1 1.414 0m0 6a1 1 0 0 1 0 1.414l-5 5a1 1 0 0 1-1.414 0l-5-5a1 1 0 1 1 1.414-1.414L10 14.586l4.293-4.293a1 1 0 0 1 1.414 0",
    clipRule: "evenodd"
  })));
};
/* harmony default export */ const solid_chevron_double_down = (chevron_double_down_SvgChevronDoubleDown);
;// ./react/ui/icon/icons/solid/chevron-double-left.svg
var solid_chevron_double_left_path;
function solid_chevron_double_left_extends() { solid_chevron_double_left_extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return solid_chevron_double_left_extends.apply(this, arguments); }

var chevron_double_left_SvgChevronDoubleLeft = function SvgChevronDoubleLeft(props) {
  return /*#__PURE__*/react.createElement("svg", solid_chevron_double_left_extends({
    xmlns: "http://www.w3.org/2000/svg",
    fill: "currentColor",
    viewBox: "0 0 20 20"
  }, props), solid_chevron_double_left_path || (solid_chevron_double_left_path = /*#__PURE__*/react.createElement("path", {
    fillRule: "evenodd",
    d: "M15.707 15.707a1 1 0 0 1-1.414 0l-5-5a1 1 0 0 1 0-1.414l5-5a1 1 0 1 1 1.414 1.414L11.414 10l4.293 4.293a1 1 0 0 1 0 1.414m-6 0a1 1 0 0 1-1.414 0l-5-5a1 1 0 0 1 0-1.414l5-5a1 1 0 0 1 1.414 1.414L5.414 10l4.293 4.293a1 1 0 0 1 0 1.414",
    clipRule: "evenodd"
  })));
};
/* harmony default export */ const solid_chevron_double_left = (chevron_double_left_SvgChevronDoubleLeft);
;// ./react/ui/icon/icons/solid/chevron-double-right.svg
var solid_chevron_double_right_path, chevron_double_right_path2;
function solid_chevron_double_right_extends() { solid_chevron_double_right_extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return solid_chevron_double_right_extends.apply(this, arguments); }

var chevron_double_right_SvgChevronDoubleRight = function SvgChevronDoubleRight(props) {
  return /*#__PURE__*/react.createElement("svg", solid_chevron_double_right_extends({
    xmlns: "http://www.w3.org/2000/svg",
    fill: "currentColor",
    viewBox: "0 0 20 20"
  }, props), solid_chevron_double_right_path || (solid_chevron_double_right_path = /*#__PURE__*/react.createElement("path", {
    fillRule: "evenodd",
    d: "M10.293 15.707a1 1 0 0 1 0-1.414L14.586 10l-4.293-4.293a1 1 0 1 1 1.414-1.414l5 5a1 1 0 0 1 0 1.414l-5 5a1 1 0 0 1-1.414 0",
    clipRule: "evenodd"
  })), chevron_double_right_path2 || (chevron_double_right_path2 = /*#__PURE__*/react.createElement("path", {
    fillRule: "evenodd",
    d: "M4.293 15.707a1 1 0 0 1 0-1.414L8.586 10 4.293 5.707a1 1 0 0 1 1.414-1.414l5 5a1 1 0 0 1 0 1.414l-5 5a1 1 0 0 1-1.414 0",
    clipRule: "evenodd"
  })));
};
/* harmony default export */ const solid_chevron_double_right = (chevron_double_right_SvgChevronDoubleRight);
;// ./react/ui/icon/icons/solid/chevron-double-up.svg
var solid_chevron_double_up_path;
function solid_chevron_double_up_extends() { solid_chevron_double_up_extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return solid_chevron_double_up_extends.apply(this, arguments); }

var chevron_double_up_SvgChevronDoubleUp = function SvgChevronDoubleUp(props) {
  return /*#__PURE__*/react.createElement("svg", solid_chevron_double_up_extends({
    xmlns: "http://www.w3.org/2000/svg",
    fill: "currentColor",
    viewBox: "0 0 20 20"
  }, props), solid_chevron_double_up_path || (solid_chevron_double_up_path = /*#__PURE__*/react.createElement("path", {
    fillRule: "evenodd",
    d: "M4.293 15.707a1 1 0 0 1 0-1.414l5-5a1 1 0 0 1 1.414 0l5 5a1 1 0 0 1-1.414 1.414L10 11.414l-4.293 4.293a1 1 0 0 1-1.414 0m0-6a1 1 0 0 1 0-1.414l5-5a1 1 0 0 1 1.414 0l5 5a1 1 0 0 1-1.414 1.414L10 5.414 5.707 9.707a1 1 0 0 1-1.414 0",
    clipRule: "evenodd"
  })));
};
/* harmony default export */ const solid_chevron_double_up = (chevron_double_up_SvgChevronDoubleUp);
;// ./react/ui/icon/icons/solid/chevron-down.svg
var solid_chevron_down_path;
function solid_chevron_down_extends() { solid_chevron_down_extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return solid_chevron_down_extends.apply(this, arguments); }

var chevron_down_SvgChevronDown = function SvgChevronDown(props) {
  return /*#__PURE__*/react.createElement("svg", solid_chevron_down_extends({
    xmlns: "http://www.w3.org/2000/svg",
    fill: "currentColor",
    viewBox: "0 0 20 20"
  }, props), solid_chevron_down_path || (solid_chevron_down_path = /*#__PURE__*/react.createElement("path", {
    fillRule: "evenodd",
    d: "M5.293 7.293a1 1 0 0 1 1.414 0L10 10.586l3.293-3.293a1 1 0 1 1 1.414 1.414l-4 4a1 1 0 0 1-1.414 0l-4-4a1 1 0 0 1 0-1.414",
    clipRule: "evenodd"
  })));
};
/* harmony default export */ const solid_chevron_down = (chevron_down_SvgChevronDown);
;// ./react/ui/icon/icons/solid/chevron-left.svg
var solid_chevron_left_path;
function solid_chevron_left_extends() { solid_chevron_left_extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return solid_chevron_left_extends.apply(this, arguments); }

var chevron_left_SvgChevronLeft = function SvgChevronLeft(props) {
  return /*#__PURE__*/react.createElement("svg", solid_chevron_left_extends({
    xmlns: "http://www.w3.org/2000/svg",
    fill: "currentColor",
    viewBox: "0 0 20 20"
  }, props), solid_chevron_left_path || (solid_chevron_left_path = /*#__PURE__*/react.createElement("path", {
    fillRule: "evenodd",
    d: "M12.707 5.293a1 1 0 0 1 0 1.414L9.414 10l3.293 3.293a1 1 0 0 1-1.414 1.414l-4-4a1 1 0 0 1 0-1.414l4-4a1 1 0 0 1 1.414 0",
    clipRule: "evenodd"
  })));
};
/* harmony default export */ const solid_chevron_left = (chevron_left_SvgChevronLeft);
;// ./react/ui/icon/icons/solid/chevron-right.svg
var solid_chevron_right_path;
function solid_chevron_right_extends() { solid_chevron_right_extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return solid_chevron_right_extends.apply(this, arguments); }

var chevron_right_SvgChevronRight = function SvgChevronRight(props) {
  return /*#__PURE__*/react.createElement("svg", solid_chevron_right_extends({
    xmlns: "http://www.w3.org/2000/svg",
    fill: "currentColor",
    viewBox: "0 0 20 20"
  }, props), solid_chevron_right_path || (solid_chevron_right_path = /*#__PURE__*/react.createElement("path", {
    fillRule: "evenodd",
    d: "M7.293 14.707a1 1 0 0 1 0-1.414L10.586 10 7.293 6.707a1 1 0 0 1 1.414-1.414l4 4a1 1 0 0 1 0 1.414l-4 4a1 1 0 0 1-1.414 0",
    clipRule: "evenodd"
  })));
};
/* harmony default export */ const solid_chevron_right = (chevron_right_SvgChevronRight);
;// ./react/ui/icon/icons/solid/chevron-up.svg
var solid_chevron_up_path;
function solid_chevron_up_extends() { solid_chevron_up_extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return solid_chevron_up_extends.apply(this, arguments); }

var chevron_up_SvgChevronUp = function SvgChevronUp(props) {
  return /*#__PURE__*/react.createElement("svg", solid_chevron_up_extends({
    xmlns: "http://www.w3.org/2000/svg",
    fill: "currentColor",
    viewBox: "0 0 20 20"
  }, props), solid_chevron_up_path || (solid_chevron_up_path = /*#__PURE__*/react.createElement("path", {
    fillRule: "evenodd",
    d: "M14.707 12.707a1 1 0 0 1-1.414 0L10 9.414l-3.293 3.293a1 1 0 0 1-1.414-1.414l4-4a1 1 0 0 1 1.414 0l4 4a1 1 0 0 1 0 1.414",
    clipRule: "evenodd"
  })));
};
/* harmony default export */ const solid_chevron_up = (chevron_up_SvgChevronUp);
;// ./react/ui/icon/icons/solid/chip.svg
var solid_chip_path, chip_path2;
function solid_chip_extends() { solid_chip_extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return solid_chip_extends.apply(this, arguments); }

var chip_SvgChip = function SvgChip(props) {
  return /*#__PURE__*/react.createElement("svg", solid_chip_extends({
    xmlns: "http://www.w3.org/2000/svg",
    fill: "currentColor",
    viewBox: "0 0 20 20"
  }, props), solid_chip_path || (solid_chip_path = /*#__PURE__*/react.createElement("path", {
    d: "M13 7H7v6h6z"
  })), chip_path2 || (chip_path2 = /*#__PURE__*/react.createElement("path", {
    fillRule: "evenodd",
    d: "M7 2a1 1 0 0 1 2 0v1h2V2a1 1 0 1 1 2 0v1h2a2 2 0 0 1 2 2v2h1a1 1 0 1 1 0 2h-1v2h1a1 1 0 1 1 0 2h-1v2a2 2 0 0 1-2 2h-2v1a1 1 0 1 1-2 0v-1H9v1a1 1 0 1 1-2 0v-1H5a2 2 0 0 1-2-2v-2H2a1 1 0 1 1 0-2h1V9H2a1 1 0 0 1 0-2h1V5a2 2 0 0 1 2-2h2zM5 5h10v10H5z",
    clipRule: "evenodd"
  })));
};
/* harmony default export */ const solid_chip = (chip_SvgChip);
;// ./react/ui/icon/icons/solid/clipboard-check.svg
var solid_clipboard_check_path, clipboard_check_path2;
function solid_clipboard_check_extends() { solid_clipboard_check_extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return solid_clipboard_check_extends.apply(this, arguments); }

var clipboard_check_SvgClipboardCheck = function SvgClipboardCheck(props) {
  return /*#__PURE__*/react.createElement("svg", solid_clipboard_check_extends({
    xmlns: "http://www.w3.org/2000/svg",
    fill: "currentColor",
    viewBox: "0 0 20 20"
  }, props), solid_clipboard_check_path || (solid_clipboard_check_path = /*#__PURE__*/react.createElement("path", {
    d: "M9 2a1 1 0 0 0 0 2h2a1 1 0 1 0 0-2z"
  })), clipboard_check_path2 || (clipboard_check_path2 = /*#__PURE__*/react.createElement("path", {
    fillRule: "evenodd",
    d: "M4 5a2 2 0 0 1 2-2 3 3 0 0 0 3 3h2a3 3 0 0 0 3-3 2 2 0 0 1 2 2v11a2 2 0 0 1-2 2H6a2 2 0 0 1-2-2zm9.707 5.707a1 1 0 0 0-1.414-1.414L9 12.586l-1.293-1.293a1 1 0 0 0-1.414 1.414l2 2a1 1 0 0 0 1.414 0z",
    clipRule: "evenodd"
  })));
};
/* harmony default export */ const solid_clipboard_check = (clipboard_check_SvgClipboardCheck);
;// ./react/ui/icon/icons/solid/clipboard-copy.svg
var solid_clipboard_copy_path, clipboard_copy_path2;
function solid_clipboard_copy_extends() { solid_clipboard_copy_extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return solid_clipboard_copy_extends.apply(this, arguments); }

var clipboard_copy_SvgClipboardCopy = function SvgClipboardCopy(props) {
  return /*#__PURE__*/react.createElement("svg", solid_clipboard_copy_extends({
    xmlns: "http://www.w3.org/2000/svg",
    fill: "currentColor",
    viewBox: "0 0 20 20"
  }, props), solid_clipboard_copy_path || (solid_clipboard_copy_path = /*#__PURE__*/react.createElement("path", {
    d: "M8 2a1 1 0 0 0 0 2h2a1 1 0 1 0 0-2z"
  })), clipboard_copy_path2 || (clipboard_copy_path2 = /*#__PURE__*/react.createElement("path", {
    d: "M3 5a2 2 0 0 1 2-2 3 3 0 0 0 3 3h2a3 3 0 0 0 3-3 2 2 0 0 1 2 2v6h-4.586l1.293-1.293a1 1 0 0 0-1.414-1.414l-3 3a1 1 0 0 0 0 1.414l3 3a1 1 0 0 0 1.414-1.414L10.414 13H15v3a2 2 0 0 1-2 2H5a2 2 0 0 1-2-2zm12 6h2a1 1 0 1 1 0 2h-2z"
  })));
};
/* harmony default export */ const solid_clipboard_copy = (clipboard_copy_SvgClipboardCopy);
;// ./react/ui/icon/icons/solid/clipboard-list.svg
var solid_clipboard_list_path, clipboard_list_path2;
function solid_clipboard_list_extends() { solid_clipboard_list_extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return solid_clipboard_list_extends.apply(this, arguments); }

var clipboard_list_SvgClipboardList = function SvgClipboardList(props) {
  return /*#__PURE__*/react.createElement("svg", solid_clipboard_list_extends({
    xmlns: "http://www.w3.org/2000/svg",
    fill: "currentColor",
    viewBox: "0 0 20 20"
  }, props), solid_clipboard_list_path || (solid_clipboard_list_path = /*#__PURE__*/react.createElement("path", {
    d: "M9 2a1 1 0 0 0 0 2h2a1 1 0 1 0 0-2z"
  })), clipboard_list_path2 || (clipboard_list_path2 = /*#__PURE__*/react.createElement("path", {
    fillRule: "evenodd",
    d: "M4 5a2 2 0 0 1 2-2 3 3 0 0 0 3 3h2a3 3 0 0 0 3-3 2 2 0 0 1 2 2v11a2 2 0 0 1-2 2H6a2 2 0 0 1-2-2zm3 4a1 1 0 0 0 0 2h.01a1 1 0 1 0 0-2zm3 0a1 1 0 0 0 0 2h3a1 1 0 1 0 0-2zm-3 4a1 1 0 1 0 0 2h.01a1 1 0 1 0 0-2zm3 0a1 1 0 1 0 0 2h3a1 1 0 1 0 0-2z",
    clipRule: "evenodd"
  })));
};
/* harmony default export */ const solid_clipboard_list = (clipboard_list_SvgClipboardList);
;// ./react/ui/icon/icons/solid/clipboard.svg
var solid_clipboard_path, clipboard_path2;
function solid_clipboard_extends() { solid_clipboard_extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return solid_clipboard_extends.apply(this, arguments); }

var clipboard_SvgClipboard = function SvgClipboard(props) {
  return /*#__PURE__*/react.createElement("svg", solid_clipboard_extends({
    xmlns: "http://www.w3.org/2000/svg",
    fill: "currentColor",
    viewBox: "0 0 20 20"
  }, props), solid_clipboard_path || (solid_clipboard_path = /*#__PURE__*/react.createElement("path", {
    d: "M8 3a1 1 0 0 1 1-1h2a1 1 0 1 1 0 2H9a1 1 0 0 1-1-1"
  })), clipboard_path2 || (clipboard_path2 = /*#__PURE__*/react.createElement("path", {
    d: "M6 3a2 2 0 0 0-2 2v11a2 2 0 0 0 2 2h8a2 2 0 0 0 2-2V5a2 2 0 0 0-2-2 3 3 0 0 1-3 3H9a3 3 0 0 1-3-3"
  })));
};
/* harmony default export */ const solid_clipboard = (clipboard_SvgClipboard);
;// ./react/ui/icon/icons/solid/clock.svg
var solid_clock_path;
function solid_clock_extends() { solid_clock_extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return solid_clock_extends.apply(this, arguments); }

var clock_SvgClock = function SvgClock(props) {
  return /*#__PURE__*/react.createElement("svg", solid_clock_extends({
    xmlns: "http://www.w3.org/2000/svg",
    fill: "currentColor",
    viewBox: "0 0 20 20"
  }, props), solid_clock_path || (solid_clock_path = /*#__PURE__*/react.createElement("path", {
    fillRule: "evenodd",
    d: "M10 18a8 8 0 1 0 0-16 8 8 0 0 0 0 16m1-12a1 1 0 1 0-2 0v4a1 1 0 0 0 .293.707l2.828 2.829a1 1 0 1 0 1.415-1.415L11 9.586z",
    clipRule: "evenodd"
  })));
};
/* harmony default export */ const solid_clock = (clock_SvgClock);
;// ./react/ui/icon/icons/solid/cloud-download.svg
var solid_cloud_download_path;
function solid_cloud_download_extends() { solid_cloud_download_extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return solid_cloud_download_extends.apply(this, arguments); }

var cloud_download_SvgCloudDownload = function SvgCloudDownload(props) {
  return /*#__PURE__*/react.createElement("svg", solid_cloud_download_extends({
    xmlns: "http://www.w3.org/2000/svg",
    fill: "currentColor",
    viewBox: "0 0 20 20"
  }, props), solid_cloud_download_path || (solid_cloud_download_path = /*#__PURE__*/react.createElement("path", {
    fillRule: "evenodd",
    d: "M2 9.5A3.5 3.5 0 0 0 5.5 13H9v2.586l-1.293-1.293a1 1 0 0 0-1.414 1.414l3 3a1 1 0 0 0 1.414 0l3-3a1 1 0 0 0-1.414-1.414L11 15.586V13h2.5a4.5 4.5 0 1 0-.616-8.958 4.002 4.002 0 1 0-7.753 1.977A3.5 3.5 0 0 0 2 9.5m9 3.5H9V8a1 1 0 0 1 2 0z",
    clipRule: "evenodd"
  })));
};
/* harmony default export */ const solid_cloud_download = (cloud_download_SvgCloudDownload);
;// ./react/ui/icon/icons/solid/cloud-upload.svg
var solid_cloud_upload_path, cloud_upload_path2;
function solid_cloud_upload_extends() { solid_cloud_upload_extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return solid_cloud_upload_extends.apply(this, arguments); }

var cloud_upload_SvgCloudUpload = function SvgCloudUpload(props) {
  return /*#__PURE__*/react.createElement("svg", solid_cloud_upload_extends({
    xmlns: "http://www.w3.org/2000/svg",
    fill: "currentColor",
    viewBox: "0 0 20 20"
  }, props), solid_cloud_upload_path || (solid_cloud_upload_path = /*#__PURE__*/react.createElement("path", {
    d: "M5.5 13a3.5 3.5 0 0 1-.369-6.98 4 4 0 1 1 7.753-1.977A4.5 4.5 0 1 1 13.5 13H11V9.413l1.293 1.293a1 1 0 0 0 1.414-1.414l-3-3a1 1 0 0 0-1.414 0l-3 3a1 1 0 0 0 1.414 1.414L9 9.414V13z"
  })), cloud_upload_path2 || (cloud_upload_path2 = /*#__PURE__*/react.createElement("path", {
    d: "M9 13h2v5a1 1 0 1 1-2 0z"
  })));
};
/* harmony default export */ const solid_cloud_upload = (cloud_upload_SvgCloudUpload);
;// ./react/ui/icon/icons/solid/cloud.svg
var solid_cloud_path;
function solid_cloud_extends() { solid_cloud_extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return solid_cloud_extends.apply(this, arguments); }

var cloud_SvgCloud = function SvgCloud(props) {
  return /*#__PURE__*/react.createElement("svg", solid_cloud_extends({
    xmlns: "http://www.w3.org/2000/svg",
    fill: "currentColor",
    viewBox: "0 0 20 20"
  }, props), solid_cloud_path || (solid_cloud_path = /*#__PURE__*/react.createElement("path", {
    d: "M5.5 16a3.5 3.5 0 0 1-.369-6.98 4 4 0 1 1 7.753-1.977A4.5 4.5 0 1 1 13.5 16z"
  })));
};
/* harmony default export */ const solid_cloud = (cloud_SvgCloud);
;// ./react/ui/icon/icons/solid/code.svg
var solid_code_path;
function solid_code_extends() { solid_code_extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return solid_code_extends.apply(this, arguments); }

var code_SvgCode = function SvgCode(props) {
  return /*#__PURE__*/react.createElement("svg", solid_code_extends({
    xmlns: "http://www.w3.org/2000/svg",
    fill: "currentColor",
    viewBox: "0 0 20 20"
  }, props), solid_code_path || (solid_code_path = /*#__PURE__*/react.createElement("path", {
    fillRule: "evenodd",
    d: "M12.316 3.051a1 1 0 0 1 .633 1.265l-4 12a1 1 0 1 1-1.898-.632l4-12a1 1 0 0 1 1.265-.633M5.707 6.293a1 1 0 0 1 0 1.414L3.414 10l2.293 2.293a1 1 0 1 1-1.414 1.414l-3-3a1 1 0 0 1 0-1.414l3-3a1 1 0 0 1 1.414 0m8.586 0a1 1 0 0 1 1.414 0l3 3a1 1 0 0 1 0 1.414l-3 3a1 1 0 1 1-1.414-1.414L16.586 10l-2.293-2.293a1 1 0 0 1 0-1.414",
    clipRule: "evenodd"
  })));
};
/* harmony default export */ const solid_code = (code_SvgCode);
;// ./react/ui/icon/icons/solid/cog.svg
var solid_cog_path;
function solid_cog_extends() { solid_cog_extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return solid_cog_extends.apply(this, arguments); }

var cog_SvgCog = function SvgCog(props) {
  return /*#__PURE__*/react.createElement("svg", solid_cog_extends({
    xmlns: "http://www.w3.org/2000/svg",
    fill: "currentColor",
    viewBox: "0 0 20 20"
  }, props), solid_cog_path || (solid_cog_path = /*#__PURE__*/react.createElement("path", {
    fillRule: "evenodd",
    d: "M11.49 3.17c-.38-1.56-2.6-1.56-2.98 0a1.532 1.532 0 0 1-2.286.948c-1.372-.836-2.942.734-2.106 2.106.54.886.061 2.042-.947 2.287-1.561.379-1.561 2.6 0 2.978a1.532 1.532 0 0 1 .947 2.287c-.836 1.372.734 2.942 2.106 2.106a1.532 1.532 0 0 1 2.287.947c.379 1.561 2.6 1.561 2.978 0a1.533 1.533 0 0 1 2.287-.947c1.372.836 2.942-.734 2.106-2.106a1.533 1.533 0 0 1 .947-2.287c1.561-.379 1.561-2.6 0-2.978a1.532 1.532 0 0 1-.947-2.287c.836-1.372-.734-2.942-2.106-2.106a1.532 1.532 0 0 1-2.287-.947zM10 13a3 3 0 1 0 0-6 3 3 0 0 0 0 6",
    clipRule: "evenodd"
  })));
};
/* harmony default export */ const solid_cog = (cog_SvgCog);
;// ./react/ui/icon/icons/solid/collection.svg
var solid_collection_path;
function solid_collection_extends() { solid_collection_extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return solid_collection_extends.apply(this, arguments); }

var collection_SvgCollection = function SvgCollection(props) {
  return /*#__PURE__*/react.createElement("svg", solid_collection_extends({
    xmlns: "http://www.w3.org/2000/svg",
    fill: "currentColor",
    viewBox: "0 0 20 20"
  }, props), solid_collection_path || (solid_collection_path = /*#__PURE__*/react.createElement("path", {
    d: "M7 3a1 1 0 0 0 0 2h6a1 1 0 1 0 0-2zM4 7a1 1 0 0 1 1-1h10a1 1 0 1 1 0 2H5a1 1 0 0 1-1-1m-2 4a2 2 0 0 1 2-2h12a2 2 0 0 1 2 2v4a2 2 0 0 1-2 2H4a2 2 0 0 1-2-2z"
  })));
};
/* harmony default export */ const solid_collection = (collection_SvgCollection);
;// ./react/ui/icon/icons/solid/color-swatch.svg
var solid_color_swatch_path;
function solid_color_swatch_extends() { solid_color_swatch_extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return solid_color_swatch_extends.apply(this, arguments); }

var color_swatch_SvgColorSwatch = function SvgColorSwatch(props) {
  return /*#__PURE__*/react.createElement("svg", solid_color_swatch_extends({
    xmlns: "http://www.w3.org/2000/svg",
    fill: "currentColor",
    viewBox: "0 0 20 20"
  }, props), solid_color_swatch_path || (solid_color_swatch_path = /*#__PURE__*/react.createElement("path", {
    fillRule: "evenodd",
    d: "M4 2a2 2 0 0 0-2 2v11a3 3 0 1 0 6 0V4a2 2 0 0 0-2-2zm1 14a1 1 0 1 0 0-2 1 1 0 0 0 0 2m5-1.757 4.9-4.9a2 2 0 0 0 0-2.828L13.485 5.1a2 2 0 0 0-2.828 0L10 5.757zM16 18H9.071l6-6H16a2 2 0 0 1 2 2v2a2 2 0 0 1-2 2",
    clipRule: "evenodd"
  })));
};
/* harmony default export */ const solid_color_swatch = (color_swatch_SvgColorSwatch);
;// ./react/ui/icon/icons/solid/credit-card.svg
var solid_credit_card_path, credit_card_path2;
function solid_credit_card_extends() { solid_credit_card_extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return solid_credit_card_extends.apply(this, arguments); }

var credit_card_SvgCreditCard = function SvgCreditCard(props) {
  return /*#__PURE__*/react.createElement("svg", solid_credit_card_extends({
    xmlns: "http://www.w3.org/2000/svg",
    fill: "currentColor",
    viewBox: "0 0 20 20"
  }, props), solid_credit_card_path || (solid_credit_card_path = /*#__PURE__*/react.createElement("path", {
    d: "M4 4a2 2 0 0 0-2 2v1h16V6a2 2 0 0 0-2-2z"
  })), credit_card_path2 || (credit_card_path2 = /*#__PURE__*/react.createElement("path", {
    fillRule: "evenodd",
    d: "M18 9H2v5a2 2 0 0 0 2 2h12a2 2 0 0 0 2-2zM4 13a1 1 0 0 1 1-1h1a1 1 0 1 1 0 2H5a1 1 0 0 1-1-1m5-1a1 1 0 1 0 0 2h1a1 1 0 1 0 0-2z",
    clipRule: "evenodd"
  })));
};
/* harmony default export */ const solid_credit_card = (credit_card_SvgCreditCard);
;// ./react/ui/icon/icons/solid/cube-transparent.svg
var solid_cube_transparent_path;
function solid_cube_transparent_extends() { solid_cube_transparent_extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return solid_cube_transparent_extends.apply(this, arguments); }

var cube_transparent_SvgCubeTransparent = function SvgCubeTransparent(props) {
  return /*#__PURE__*/react.createElement("svg", solid_cube_transparent_extends({
    xmlns: "http://www.w3.org/2000/svg",
    fill: "currentColor",
    viewBox: "0 0 20 20"
  }, props), solid_cube_transparent_path || (solid_cube_transparent_path = /*#__PURE__*/react.createElement("path", {
    fillRule: "evenodd",
    d: "M9.504 1.132a1 1 0 0 1 .992 0l1.75 1a1 1 0 1 1-.992 1.736L10 3.152l-1.254.716a1 1 0 1 1-.992-1.736zM5.618 4.504a1 1 0 0 1-.372 1.364L5.016 6l.23.132a1 1 0 1 1-.992 1.736L4 7.723V8a1 1 0 0 1-2 0V6a1 1 0 0 1 .52-.878l1.734-.99a1 1 0 0 1 1.364.372m8.764 0a1 1 0 0 1 1.364-.372l1.733.99A1 1 0 0 1 18 6v2a1 1 0 1 1-2 0v-.277l-.254.145a1 1 0 1 1-.992-1.736l.23-.132-.23-.132a1 1 0 0 1-.372-1.364m-7 4a1 1 0 0 1 1.364-.372L10 8.848l1.254-.716a1 1 0 1 1 .992 1.736L11 10.58V12a1 1 0 1 1-2 0v-1.42l-1.246-.712a1 1 0 0 1-.372-1.364M3 11a1 1 0 0 1 1 1v1.42l1.246.712a1 1 0 1 1-.992 1.736l-1.75-1A1 1 0 0 1 2 14v-2a1 1 0 0 1 1-1m14 0a1 1 0 0 1 1 1v2a1 1 0 0 1-.504.868l-1.75 1a1 1 0 1 1-.992-1.736L16 13.42V12a1 1 0 0 1 1-1m-9.618 5.504a1 1 0 0 1 1.364-.372l.254.145V16a1 1 0 1 1 2 0v.277l.254-.145a1 1 0 1 1 .992 1.736l-1.735.992a1 1 0 0 1-1.022 0l-1.735-.992a1 1 0 0 1-.372-1.364",
    clipRule: "evenodd"
  })));
};
/* harmony default export */ const solid_cube_transparent = (cube_transparent_SvgCubeTransparent);
;// ./react/ui/icon/icons/solid/cube.svg
var solid_cube_path;
function solid_cube_extends() { solid_cube_extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return solid_cube_extends.apply(this, arguments); }

var cube_SvgCube = function SvgCube(props) {
  return /*#__PURE__*/react.createElement("svg", solid_cube_extends({
    xmlns: "http://www.w3.org/2000/svg",
    fill: "currentColor",
    viewBox: "0 0 20 20"
  }, props), solid_cube_path || (solid_cube_path = /*#__PURE__*/react.createElement("path", {
    d: "M11 17a1 1 0 0 0 1.447.894l4-2A1 1 0 0 0 17 15V9.236a1 1 0 0 0-1.447-.894l-4 2a1 1 0 0 0-.553.894zm4.211-10.724a1 1 0 0 0 0-1.788l-4.764-2.382a1 1 0 0 0-.894 0L4.789 4.488a1 1 0 0 0 0 1.788l4.764 2.382a1 1 0 0 0 .894 0zM4.447 8.342A1 1 0 0 0 3 9.236V15a1 1 0 0 0 .553.894l4 2A1 1 0 0 0 9 17v-5.764a1 1 0 0 0-.553-.894z"
  })));
};
/* harmony default export */ const solid_cube = (cube_SvgCube);
;// ./react/ui/icon/icons/solid/currency-bangladeshi.svg
var solid_currency_bangladeshi_path;
function solid_currency_bangladeshi_extends() { solid_currency_bangladeshi_extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return solid_currency_bangladeshi_extends.apply(this, arguments); }

var currency_bangladeshi_SvgCurrencyBangladeshi = function SvgCurrencyBangladeshi(props) {
  return /*#__PURE__*/react.createElement("svg", solid_currency_bangladeshi_extends({
    xmlns: "http://www.w3.org/2000/svg",
    fill: "currentColor",
    viewBox: "0 0 20 20"
  }, props), solid_currency_bangladeshi_path || (solid_currency_bangladeshi_path = /*#__PURE__*/react.createElement("path", {
    fillRule: "evenodd",
    d: "M10 18a8 8 0 1 0 0-16 8 8 0 0 0 0 16M7 4a1 1 0 0 0 0 2 1 1 0 0 1 1 1v1H7a1 1 0 0 0 0 2h1v3a3 3 0 1 0 6 0v-1a1 1 0 1 0-2 0v1a1 1 0 1 1-2 0v-3h3a1 1 0 1 0 0-2h-3V7a3 3 0 0 0-3-3",
    clipRule: "evenodd"
  })));
};
/* harmony default export */ const solid_currency_bangladeshi = (currency_bangladeshi_SvgCurrencyBangladeshi);
;// ./react/ui/icon/icons/solid/currency-dollar.svg
var solid_currency_dollar_path, currency_dollar_path2;
function solid_currency_dollar_extends() { solid_currency_dollar_extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return solid_currency_dollar_extends.apply(this, arguments); }

var currency_dollar_SvgCurrencyDollar = function SvgCurrencyDollar(props) {
  return /*#__PURE__*/react.createElement("svg", solid_currency_dollar_extends({
    xmlns: "http://www.w3.org/2000/svg",
    fill: "currentColor",
    viewBox: "0 0 20 20"
  }, props), solid_currency_dollar_path || (solid_currency_dollar_path = /*#__PURE__*/react.createElement("path", {
    d: "M8.433 7.418c.155-.103.346-.196.567-.267v1.698a2.3 2.3 0 0 1-.567-.267C8.07 8.34 8 8.114 8 8s.07-.34.433-.582M11 12.849v-1.698c.22.071.412.164.567.267.364.243.433.468.433.582s-.07.34-.433.582a2.3 2.3 0 0 1-.567.267"
  })), currency_dollar_path2 || (currency_dollar_path2 = /*#__PURE__*/react.createElement("path", {
    fillRule: "evenodd",
    d: "M10 18a8 8 0 1 0 0-16 8 8 0 0 0 0 16m1-13a1 1 0 1 0-2 0v.092a4.5 4.5 0 0 0-1.676.662C6.602 6.234 6 7.009 6 8c0 .99.602 1.765 1.324 2.246.48.32 1.054.545 1.676.662v1.941c-.391-.127-.68-.317-.843-.504a1 1 0 1 0-1.51 1.31c.562.649 1.413 1.076 2.353 1.253V15a1 1 0 1 0 2 0v-.092a4.5 4.5 0 0 0 1.676-.662C13.398 13.766 14 12.991 14 12c0-.99-.602-1.765-1.324-2.246A4.5 4.5 0 0 0 11 9.092V7.151c.391.127.68.317.843.504a1 1 0 1 0 1.511-1.31c-.563-.649-1.413-1.076-2.354-1.253z",
    clipRule: "evenodd"
  })));
};
/* harmony default export */ const solid_currency_dollar = (currency_dollar_SvgCurrencyDollar);
;// ./react/ui/icon/icons/solid/currency-euro.svg
var solid_currency_euro_path;
function solid_currency_euro_extends() { solid_currency_euro_extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return solid_currency_euro_extends.apply(this, arguments); }

var currency_euro_SvgCurrencyEuro = function SvgCurrencyEuro(props) {
  return /*#__PURE__*/react.createElement("svg", solid_currency_euro_extends({
    xmlns: "http://www.w3.org/2000/svg",
    fill: "currentColor",
    viewBox: "0 0 20 20"
  }, props), solid_currency_euro_path || (solid_currency_euro_path = /*#__PURE__*/react.createElement("path", {
    fillRule: "evenodd",
    d: "M10 18a8 8 0 1 0 0-16 8 8 0 0 0 0 16M8.736 6.979C9.208 6.193 9.696 6 10 6s.792.193 1.264.979a1 1 0 0 0 1.715-1.029C12.279 4.784 11.232 4 10 4s-2.279.784-2.979 1.95c-.285.475-.507 1-.67 1.55H6a1 1 0 0 0 0 2h.013a9 9 0 0 0 0 1H6a1 1 0 1 0 0 2h.351c.163.55.385 1.075.67 1.55C7.721 15.216 8.768 16 10 16s2.279-.784 2.979-1.95a1 1 0 1 0-1.715-1.029c-.472.786-.96.979-1.264.979s-.792-.193-1.264-.979a4 4 0 0 1-.264-.521H10a1 1 0 1 0 0-2H8.017a7 7 0 0 1 0-1H10a1 1 0 1 0 0-2H8.472q.12-.279.264-.521",
    clipRule: "evenodd"
  })));
};
/* harmony default export */ const solid_currency_euro = (currency_euro_SvgCurrencyEuro);
;// ./react/ui/icon/icons/solid/currency-pound.svg
var solid_currency_pound_path;
function solid_currency_pound_extends() { solid_currency_pound_extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return solid_currency_pound_extends.apply(this, arguments); }

var currency_pound_SvgCurrencyPound = function SvgCurrencyPound(props) {
  return /*#__PURE__*/react.createElement("svg", solid_currency_pound_extends({
    xmlns: "http://www.w3.org/2000/svg",
    fill: "currentColor",
    viewBox: "0 0 20 20"
  }, props), solid_currency_pound_path || (solid_currency_pound_path = /*#__PURE__*/react.createElement("path", {
    fillRule: "evenodd",
    d: "M10 18a8 8 0 1 0 0-16 8 8 0 0 0 0 16m1-14a3 3 0 0 0-3 3v2H7a1 1 0 0 0 0 2h1v1a1 1 0 0 1-1 1 1 1 0 1 0 0 2h6a1 1 0 1 0 0-2H9.83c.11-.313.17-.65.17-1v-1h1a1 1 0 1 0 0-2h-1V7a1 1 0 1 1 2 0 1 1 0 1 0 2 0 3 3 0 0 0-3-3",
    clipRule: "evenodd"
  })));
};
/* harmony default export */ const solid_currency_pound = (currency_pound_SvgCurrencyPound);
;// ./react/ui/icon/icons/solid/currency-rupee.svg
var solid_currency_rupee_path;
function solid_currency_rupee_extends() { solid_currency_rupee_extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return solid_currency_rupee_extends.apply(this, arguments); }

var currency_rupee_SvgCurrencyRupee = function SvgCurrencyRupee(props) {
  return /*#__PURE__*/react.createElement("svg", solid_currency_rupee_extends({
    xmlns: "http://www.w3.org/2000/svg",
    fill: "currentColor",
    viewBox: "0 0 20 20"
  }, props), solid_currency_rupee_path || (solid_currency_rupee_path = /*#__PURE__*/react.createElement("path", {
    fillRule: "evenodd",
    d: "M10 18a8 8 0 1 0 0-16 8 8 0 0 0 0 16M7 5a1 1 0 1 0 0 2h1a2 2 0 0 1 1.732 1H7a1 1 0 1 0 0 2h2.732A2 2 0 0 1 8 11H7a1 1 0 0 0-.707 1.707l3 3a1 1 0 0 0 1.414-1.414l-1.483-1.484A4.01 4.01 0 0 0 11.874 10H13a1 1 0 1 0 0-2h-1.126a4 4 0 0 0-.41-1H13a1 1 0 1 0 0-2z",
    clipRule: "evenodd"
  })));
};
/* harmony default export */ const solid_currency_rupee = (currency_rupee_SvgCurrencyRupee);
;// ./react/ui/icon/icons/solid/currency-yen.svg
var solid_currency_yen_path;
function solid_currency_yen_extends() { solid_currency_yen_extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return solid_currency_yen_extends.apply(this, arguments); }

var currency_yen_SvgCurrencyYen = function SvgCurrencyYen(props) {
  return /*#__PURE__*/react.createElement("svg", solid_currency_yen_extends({
    xmlns: "http://www.w3.org/2000/svg",
    fill: "currentColor",
    viewBox: "0 0 20 20"
  }, props), solid_currency_yen_path || (solid_currency_yen_path = /*#__PURE__*/react.createElement("path", {
    fillRule: "evenodd",
    d: "M10 18a8 8 0 1 0 0-16 8 8 0 0 0 0 16M7.858 5.485a1 1 0 0 0-1.715 1.03L7.633 9H7a1 1 0 1 0 0 2h1.834l.166.277V12H7a1 1 0 1 0 0 2h2v1a1 1 0 1 0 2 0v-1h2a1 1 0 1 0 0-2h-2v-.723l.166-.277H13a1 1 0 1 0 0-2h-.634l1.492-2.486a1 1 0 1 0-1.716-1.029L10.034 9h-.068z",
    clipRule: "evenodd"
  })));
};
/* harmony default export */ const solid_currency_yen = (currency_yen_SvgCurrencyYen);
;// ./react/ui/icon/icons/solid/cursor-click.svg
var solid_cursor_click_path;
function solid_cursor_click_extends() { solid_cursor_click_extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return solid_cursor_click_extends.apply(this, arguments); }

var cursor_click_SvgCursorClick = function SvgCursorClick(props) {
  return /*#__PURE__*/react.createElement("svg", solid_cursor_click_extends({
    xmlns: "http://www.w3.org/2000/svg",
    fill: "currentColor",
    viewBox: "0 0 20 20"
  }, props), solid_cursor_click_path || (solid_cursor_click_path = /*#__PURE__*/react.createElement("path", {
    fillRule: "evenodd",
    d: "M6.672 1.911a1 1 0 1 0-1.932.518l.259.966a1 1 0 0 0 1.932-.518zM2.429 4.74a1 1 0 1 0-.517 1.932l.966.259a1 1 0 0 0 .517-1.932zm8.814-.569a1 1 0 0 0-1.415-1.414l-.707.707a1 1 0 1 0 1.415 1.415zm-7.071 7.072.707-.707A1 1 0 0 0 3.465 9.12l-.708.707a1 1 0 0 0 1.415 1.415zm3.2-5.171a1 1 0 0 0-1.3 1.3l4 10a1 1 0 0 0 1.823.075l1.38-2.759 3.018 3.02a1 1 0 0 0 1.414-1.415l-3.019-3.02 2.76-1.379a1 1 0 0 0-.076-1.822z",
    clipRule: "evenodd"
  })));
};
/* harmony default export */ const solid_cursor_click = (cursor_click_SvgCursorClick);
;// ./react/ui/icon/icons/solid/database.svg
var solid_database_path, database_path2, database_path3;
function solid_database_extends() { solid_database_extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return solid_database_extends.apply(this, arguments); }

var database_SvgDatabase = function SvgDatabase(props) {
  return /*#__PURE__*/react.createElement("svg", solid_database_extends({
    xmlns: "http://www.w3.org/2000/svg",
    fill: "currentColor",
    viewBox: "0 0 20 20"
  }, props), solid_database_path || (solid_database_path = /*#__PURE__*/react.createElement("path", {
    d: "M3 12v3c0 1.657 3.134 3 7 3s7-1.343 7-3v-3c0 1.657-3.134 3-7 3s-7-1.343-7-3"
  })), database_path2 || (database_path2 = /*#__PURE__*/react.createElement("path", {
    d: "M3 7v3c0 1.657 3.134 3 7 3s7-1.343 7-3V7c0 1.657-3.134 3-7 3S3 8.657 3 7"
  })), database_path3 || (database_path3 = /*#__PURE__*/react.createElement("path", {
    d: "M17 5c0 1.657-3.134 3-7 3S3 6.657 3 5s3.134-3 7-3 7 1.343 7 3"
  })));
};
/* harmony default export */ const solid_database = (database_SvgDatabase);
;// ./react/ui/icon/icons/solid/desktop-computer.svg
var solid_desktop_computer_path;
function solid_desktop_computer_extends() { solid_desktop_computer_extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return solid_desktop_computer_extends.apply(this, arguments); }

var desktop_computer_SvgDesktopComputer = function SvgDesktopComputer(props) {
  return /*#__PURE__*/react.createElement("svg", solid_desktop_computer_extends({
    xmlns: "http://www.w3.org/2000/svg",
    fill: "currentColor",
    viewBox: "0 0 20 20"
  }, props), solid_desktop_computer_path || (solid_desktop_computer_path = /*#__PURE__*/react.createElement("path", {
    fillRule: "evenodd",
    d: "M3 5a2 2 0 0 1 2-2h10a2 2 0 0 1 2 2v8a2 2 0 0 1-2 2h-2.22l.123.489.804.804A1 1 0 0 1 13 18H7a1 1 0 0 1-.707-1.707l.804-.804L7.22 15H5a2 2 0 0 1-2-2zm5.771 7H5V5h10v7z",
    clipRule: "evenodd"
  })));
};
/* harmony default export */ const solid_desktop_computer = (desktop_computer_SvgDesktopComputer);
;// ./react/ui/icon/icons/solid/device-mobile.svg
var solid_device_mobile_path;
function solid_device_mobile_extends() { solid_device_mobile_extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return solid_device_mobile_extends.apply(this, arguments); }

var device_mobile_SvgDeviceMobile = function SvgDeviceMobile(props) {
  return /*#__PURE__*/react.createElement("svg", solid_device_mobile_extends({
    xmlns: "http://www.w3.org/2000/svg",
    fill: "currentColor",
    viewBox: "0 0 20 20"
  }, props), solid_device_mobile_path || (solid_device_mobile_path = /*#__PURE__*/react.createElement("path", {
    fillRule: "evenodd",
    d: "M7 2a2 2 0 0 0-2 2v12a2 2 0 0 0 2 2h6a2 2 0 0 0 2-2V4a2 2 0 0 0-2-2zm3 14a1 1 0 1 0 0-2 1 1 0 0 0 0 2",
    clipRule: "evenodd"
  })));
};
/* harmony default export */ const solid_device_mobile = (device_mobile_SvgDeviceMobile);
;// ./react/ui/icon/icons/solid/device-tablet.svg
var solid_device_tablet_path;
function solid_device_tablet_extends() { solid_device_tablet_extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return solid_device_tablet_extends.apply(this, arguments); }

var device_tablet_SvgDeviceTablet = function SvgDeviceTablet(props) {
  return /*#__PURE__*/react.createElement("svg", solid_device_tablet_extends({
    xmlns: "http://www.w3.org/2000/svg",
    fill: "currentColor",
    viewBox: "0 0 20 20"
  }, props), solid_device_tablet_path || (solid_device_tablet_path = /*#__PURE__*/react.createElement("path", {
    fillRule: "evenodd",
    d: "M6 2a2 2 0 0 0-2 2v12a2 2 0 0 0 2 2h8a2 2 0 0 0 2-2V4a2 2 0 0 0-2-2zm4 14a1 1 0 1 0 0-2 1 1 0 0 0 0 2",
    clipRule: "evenodd"
  })));
};
/* harmony default export */ const solid_device_tablet = (device_tablet_SvgDeviceTablet);
;// ./react/ui/icon/icons/solid/document-add.svg
var solid_document_add_path;
function solid_document_add_extends() { solid_document_add_extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return solid_document_add_extends.apply(this, arguments); }

var document_add_SvgDocumentAdd = function SvgDocumentAdd(props) {
  return /*#__PURE__*/react.createElement("svg", solid_document_add_extends({
    xmlns: "http://www.w3.org/2000/svg",
    fill: "currentColor",
    viewBox: "0 0 20 20"
  }, props), solid_document_add_path || (solid_document_add_path = /*#__PURE__*/react.createElement("path", {
    fillRule: "evenodd",
    d: "M6 2a2 2 0 0 0-2 2v12a2 2 0 0 0 2 2h8a2 2 0 0 0 2-2V7.414A2 2 0 0 0 15.414 6L12 2.586A2 2 0 0 0 10.586 2zm5 6a1 1 0 1 0-2 0v2H7a1 1 0 1 0 0 2h2v2a1 1 0 1 0 2 0v-2h2a1 1 0 1 0 0-2h-2z",
    clipRule: "evenodd"
  })));
};
/* harmony default export */ const solid_document_add = (document_add_SvgDocumentAdd);
;// ./react/ui/icon/icons/solid/document-download.svg
var solid_document_download_path;
function solid_document_download_extends() { solid_document_download_extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return solid_document_download_extends.apply(this, arguments); }

var document_download_SvgDocumentDownload = function SvgDocumentDownload(props) {
  return /*#__PURE__*/react.createElement("svg", solid_document_download_extends({
    xmlns: "http://www.w3.org/2000/svg",
    fill: "currentColor",
    viewBox: "0 0 20 20"
  }, props), solid_document_download_path || (solid_document_download_path = /*#__PURE__*/react.createElement("path", {
    fillRule: "evenodd",
    d: "M6 2a2 2 0 0 0-2 2v12a2 2 0 0 0 2 2h8a2 2 0 0 0 2-2V7.414A2 2 0 0 0 15.414 6L12 2.586A2 2 0 0 0 10.586 2zm5 6a1 1 0 1 0-2 0v3.586l-1.293-1.293a1 1 0 1 0-1.414 1.414l3 3a1 1 0 0 0 1.414 0l3-3a1 1 0 0 0-1.414-1.414L11 11.586z",
    clipRule: "evenodd"
  })));
};
/* harmony default export */ const solid_document_download = (document_download_SvgDocumentDownload);
;// ./react/ui/icon/icons/solid/document-duplicate.svg
var solid_document_duplicate_path, document_duplicate_path2;
function solid_document_duplicate_extends() { solid_document_duplicate_extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return solid_document_duplicate_extends.apply(this, arguments); }

var document_duplicate_SvgDocumentDuplicate = function SvgDocumentDuplicate(props) {
  return /*#__PURE__*/react.createElement("svg", solid_document_duplicate_extends({
    xmlns: "http://www.w3.org/2000/svg",
    fill: "currentColor",
    viewBox: "0 0 20 20"
  }, props), solid_document_duplicate_path || (solid_document_duplicate_path = /*#__PURE__*/react.createElement("path", {
    d: "M9 2a2 2 0 0 0-2 2v8a2 2 0 0 0 2 2h6a2 2 0 0 0 2-2V6.414A2 2 0 0 0 16.414 5L14 2.586A2 2 0 0 0 12.586 2z"
  })), document_duplicate_path2 || (document_duplicate_path2 = /*#__PURE__*/react.createElement("path", {
    d: "M3 8a2 2 0 0 1 2-2v10h8a2 2 0 0 1-2 2H5a2 2 0 0 1-2-2z"
  })));
};
/* harmony default export */ const solid_document_duplicate = (document_duplicate_SvgDocumentDuplicate);
;// ./react/ui/icon/icons/solid/document-remove.svg
var solid_document_remove_path;
function solid_document_remove_extends() { solid_document_remove_extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return solid_document_remove_extends.apply(this, arguments); }

var document_remove_SvgDocumentRemove = function SvgDocumentRemove(props) {
  return /*#__PURE__*/react.createElement("svg", solid_document_remove_extends({
    xmlns: "http://www.w3.org/2000/svg",
    fill: "currentColor",
    viewBox: "0 0 20 20"
  }, props), solid_document_remove_path || (solid_document_remove_path = /*#__PURE__*/react.createElement("path", {
    fillRule: "evenodd",
    d: "M6 2a2 2 0 0 0-2 2v12a2 2 0 0 0 2 2h8a2 2 0 0 0 2-2V7.414A2 2 0 0 0 15.414 6L12 2.586A2 2 0 0 0 10.586 2zm1 8a1 1 0 1 0 0 2h6a1 1 0 1 0 0-2z",
    clipRule: "evenodd"
  })));
};
/* harmony default export */ const solid_document_remove = (document_remove_SvgDocumentRemove);
;// ./react/ui/icon/icons/solid/document-report.svg
var solid_document_report_path;
function solid_document_report_extends() { solid_document_report_extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return solid_document_report_extends.apply(this, arguments); }

var document_report_SvgDocumentReport = function SvgDocumentReport(props) {
  return /*#__PURE__*/react.createElement("svg", solid_document_report_extends({
    xmlns: "http://www.w3.org/2000/svg",
    fill: "currentColor",
    viewBox: "0 0 20 20"
  }, props), solid_document_report_path || (solid_document_report_path = /*#__PURE__*/react.createElement("path", {
    fillRule: "evenodd",
    d: "M6 2a2 2 0 0 0-2 2v12a2 2 0 0 0 2 2h8a2 2 0 0 0 2-2V7.414A2 2 0 0 0 15.414 6L12 2.586A2 2 0 0 0 10.586 2zm2 10a1 1 0 1 0-2 0v3a1 1 0 1 0 2 0zm2-3a1 1 0 0 1 1 1v5a1 1 0 1 1-2 0v-5a1 1 0 0 1 1-1m4-1a1 1 0 1 0-2 0v7a1 1 0 1 0 2 0z",
    clipRule: "evenodd"
  })));
};
/* harmony default export */ const solid_document_report = (document_report_SvgDocumentReport);
;// ./react/ui/icon/icons/solid/document-search.svg
var solid_document_search_path, document_search_path2;
function solid_document_search_extends() { solid_document_search_extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return solid_document_search_extends.apply(this, arguments); }

var document_search_SvgDocumentSearch = function SvgDocumentSearch(props) {
  return /*#__PURE__*/react.createElement("svg", solid_document_search_extends({
    xmlns: "http://www.w3.org/2000/svg",
    fill: "currentColor",
    viewBox: "0 0 20 20"
  }, props), solid_document_search_path || (solid_document_search_path = /*#__PURE__*/react.createElement("path", {
    d: "M4 4a2 2 0 0 1 2-2h4.586A2 2 0 0 1 12 2.586L15.414 6A2 2 0 0 1 16 7.414V16a2 2 0 0 1-2 2h-1.528A6 6 0 0 0 4 9.528z"
  })), document_search_path2 || (document_search_path2 = /*#__PURE__*/react.createElement("path", {
    fillRule: "evenodd",
    d: "M8 10a4 4 0 0 0-3.446 6.032l-1.261 1.26a1 1 0 1 0 1.414 1.415l1.261-1.261A4 4 0 1 0 8 10m-2 4a2 2 0 1 1 4 0 2 2 0 0 1-4 0",
    clipRule: "evenodd"
  })));
};
/* harmony default export */ const solid_document_search = (document_search_SvgDocumentSearch);
;// ./react/ui/icon/icons/solid/document-text.svg
var solid_document_text_path;
function solid_document_text_extends() { solid_document_text_extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return solid_document_text_extends.apply(this, arguments); }

var document_text_SvgDocumentText = function SvgDocumentText(props) {
  return /*#__PURE__*/react.createElement("svg", solid_document_text_extends({
    xmlns: "http://www.w3.org/2000/svg",
    fill: "currentColor",
    viewBox: "0 0 20 20"
  }, props), solid_document_text_path || (solid_document_text_path = /*#__PURE__*/react.createElement("path", {
    fillRule: "evenodd",
    d: "M4 4a2 2 0 0 1 2-2h4.586A2 2 0 0 1 12 2.586L15.414 6A2 2 0 0 1 16 7.414V16a2 2 0 0 1-2 2H6a2 2 0 0 1-2-2zm2 6a1 1 0 0 1 1-1h6a1 1 0 1 1 0 2H7a1 1 0 0 1-1-1m1 3a1 1 0 1 0 0 2h6a1 1 0 1 0 0-2z",
    clipRule: "evenodd"
  })));
};
/* harmony default export */ const solid_document_text = (document_text_SvgDocumentText);
;// ./react/ui/icon/icons/solid/document.svg
var solid_document_path;
function solid_document_extends() { solid_document_extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return solid_document_extends.apply(this, arguments); }

var document_SvgDocument = function SvgDocument(props) {
  return /*#__PURE__*/react.createElement("svg", solid_document_extends({
    xmlns: "http://www.w3.org/2000/svg",
    fill: "currentColor",
    viewBox: "0 0 20 20"
  }, props), solid_document_path || (solid_document_path = /*#__PURE__*/react.createElement("path", {
    fillRule: "evenodd",
    d: "M4 4a2 2 0 0 1 2-2h4.586A2 2 0 0 1 12 2.586L15.414 6A2 2 0 0 1 16 7.414V16a2 2 0 0 1-2 2H6a2 2 0 0 1-2-2z",
    clipRule: "evenodd"
  })));
};
/* harmony default export */ const solid_document = (document_SvgDocument);
;// ./react/ui/icon/icons/solid/dots-circle-horizontal.svg
var solid_dots_circle_horizontal_path;
function solid_dots_circle_horizontal_extends() { solid_dots_circle_horizontal_extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return solid_dots_circle_horizontal_extends.apply(this, arguments); }

var dots_circle_horizontal_SvgDotsCircleHorizontal = function SvgDotsCircleHorizontal(props) {
  return /*#__PURE__*/react.createElement("svg", solid_dots_circle_horizontal_extends({
    xmlns: "http://www.w3.org/2000/svg",
    fill: "currentColor",
    viewBox: "0 0 20 20"
  }, props), solid_dots_circle_horizontal_path || (solid_dots_circle_horizontal_path = /*#__PURE__*/react.createElement("path", {
    fillRule: "evenodd",
    d: "M10 18a8 8 0 1 0 0-16 8 8 0 0 0 0 16M7 9H5v2h2zm8 0h-2v2h2zM9 9h2v2H9z",
    clipRule: "evenodd"
  })));
};
/* harmony default export */ const solid_dots_circle_horizontal = (dots_circle_horizontal_SvgDotsCircleHorizontal);
;// ./react/ui/icon/icons/solid/dots-horizontal.svg
var solid_dots_horizontal_path;
function solid_dots_horizontal_extends() { solid_dots_horizontal_extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return solid_dots_horizontal_extends.apply(this, arguments); }

var dots_horizontal_SvgDotsHorizontal = function SvgDotsHorizontal(props) {
  return /*#__PURE__*/react.createElement("svg", solid_dots_horizontal_extends({
    xmlns: "http://www.w3.org/2000/svg",
    fill: "currentColor",
    viewBox: "0 0 20 20"
  }, props), solid_dots_horizontal_path || (solid_dots_horizontal_path = /*#__PURE__*/react.createElement("path", {
    d: "M6 10a2 2 0 1 1-4 0 2 2 0 0 1 4 0m6 0a2 2 0 1 1-4 0 2 2 0 0 1 4 0m4 2a2 2 0 1 0 0-4 2 2 0 0 0 0 4"
  })));
};
/* harmony default export */ const solid_dots_horizontal = (dots_horizontal_SvgDotsHorizontal);
;// ./react/ui/icon/icons/solid/dots-vertical.svg
var solid_dots_vertical_path;
function solid_dots_vertical_extends() { solid_dots_vertical_extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return solid_dots_vertical_extends.apply(this, arguments); }

var dots_vertical_SvgDotsVertical = function SvgDotsVertical(props) {
  return /*#__PURE__*/react.createElement("svg", solid_dots_vertical_extends({
    xmlns: "http://www.w3.org/2000/svg",
    fill: "currentColor",
    viewBox: "0 0 20 20"
  }, props), solid_dots_vertical_path || (solid_dots_vertical_path = /*#__PURE__*/react.createElement("path", {
    d: "M10 6a2 2 0 1 1 0-4 2 2 0 0 1 0 4m0 6a2 2 0 1 1 0-4 2 2 0 0 1 0 4m0 6a2 2 0 1 1 0-4 2 2 0 0 1 0 4"
  })));
};
/* harmony default export */ const solid_dots_vertical = (dots_vertical_SvgDotsVertical);
;// ./react/ui/icon/icons/solid/download.svg
var solid_download_path;
function solid_download_extends() { solid_download_extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return solid_download_extends.apply(this, arguments); }

var download_SvgDownload = function SvgDownload(props) {
  return /*#__PURE__*/react.createElement("svg", solid_download_extends({
    xmlns: "http://www.w3.org/2000/svg",
    fill: "currentColor",
    viewBox: "0 0 20 20"
  }, props), solid_download_path || (solid_download_path = /*#__PURE__*/react.createElement("path", {
    fillRule: "evenodd",
    d: "M3 17a1 1 0 0 1 1-1h12a1 1 0 1 1 0 2H4a1 1 0 0 1-1-1m3.293-7.707a1 1 0 0 1 1.414 0L9 10.586V3a1 1 0 1 1 2 0v7.586l1.293-1.293a1 1 0 1 1 1.414 1.414l-3 3a1 1 0 0 1-1.414 0l-3-3a1 1 0 0 1 0-1.414",
    clipRule: "evenodd"
  })));
};
/* harmony default export */ const solid_download = (download_SvgDownload);
;// ./react/ui/icon/icons/solid/duplicate.svg
var solid_duplicate_path, duplicate_path2;
function solid_duplicate_extends() { solid_duplicate_extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return solid_duplicate_extends.apply(this, arguments); }

var duplicate_SvgDuplicate = function SvgDuplicate(props) {
  return /*#__PURE__*/react.createElement("svg", solid_duplicate_extends({
    xmlns: "http://www.w3.org/2000/svg",
    fill: "currentColor",
    viewBox: "0 0 20 20"
  }, props), solid_duplicate_path || (solid_duplicate_path = /*#__PURE__*/react.createElement("path", {
    d: "M7 9a2 2 0 0 1 2-2h6a2 2 0 0 1 2 2v6a2 2 0 0 1-2 2H9a2 2 0 0 1-2-2z"
  })), duplicate_path2 || (duplicate_path2 = /*#__PURE__*/react.createElement("path", {
    d: "M5 3a2 2 0 0 0-2 2v6a2 2 0 0 0 2 2V5h8a2 2 0 0 0-2-2z"
  })));
};
/* harmony default export */ const solid_duplicate = (duplicate_SvgDuplicate);
;// ./react/ui/icon/icons/solid/emoji-happy.svg
var solid_emoji_happy_path;
function solid_emoji_happy_extends() { solid_emoji_happy_extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return solid_emoji_happy_extends.apply(this, arguments); }

var emoji_happy_SvgEmojiHappy = function SvgEmojiHappy(props) {
  return /*#__PURE__*/react.createElement("svg", solid_emoji_happy_extends({
    xmlns: "http://www.w3.org/2000/svg",
    fill: "currentColor",
    viewBox: "0 0 20 20"
  }, props), solid_emoji_happy_path || (solid_emoji_happy_path = /*#__PURE__*/react.createElement("path", {
    fillRule: "evenodd",
    d: "M10 18a8 8 0 1 0 0-16 8 8 0 0 0 0 16M7 9a1 1 0 1 0 0-2 1 1 0 0 0 0 2m7-1a1 1 0 1 1-2 0 1 1 0 0 1 2 0m-.464 5.535a1 1 0 1 0-1.415-1.414 3 3 0 0 1-4.242 0 1 1 0 0 0-1.415 1.414 5 5 0 0 0 7.072 0",
    clipRule: "evenodd"
  })));
};
/* harmony default export */ const solid_emoji_happy = (emoji_happy_SvgEmojiHappy);
;// ./react/ui/icon/icons/solid/emoji-sad.svg
var solid_emoji_sad_path;
function solid_emoji_sad_extends() { solid_emoji_sad_extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return solid_emoji_sad_extends.apply(this, arguments); }

var emoji_sad_SvgEmojiSad = function SvgEmojiSad(props) {
  return /*#__PURE__*/react.createElement("svg", solid_emoji_sad_extends({
    xmlns: "http://www.w3.org/2000/svg",
    fill: "currentColor",
    viewBox: "0 0 20 20"
  }, props), solid_emoji_sad_path || (solid_emoji_sad_path = /*#__PURE__*/react.createElement("path", {
    fillRule: "evenodd",
    d: "M10 18a8 8 0 1 0 0-16 8 8 0 0 0 0 16M7 9a1 1 0 1 0 0-2 1 1 0 0 0 0 2m7-1a1 1 0 1 1-2 0 1 1 0 0 1 2 0m-7.536 5.879a1 1 0 0 0 1.415 0 3 3 0 0 1 4.242 0 1 1 0 0 0 1.415-1.415 5 5 0 0 0-7.072 0 1 1 0 0 0 0 1.415",
    clipRule: "evenodd"
  })));
};
/* harmony default export */ const solid_emoji_sad = (emoji_sad_SvgEmojiSad);
;// ./react/ui/icon/icons/solid/exclamation-circle.svg
var solid_exclamation_circle_path;
function solid_exclamation_circle_extends() { solid_exclamation_circle_extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return solid_exclamation_circle_extends.apply(this, arguments); }

var exclamation_circle_SvgExclamationCircle = function SvgExclamationCircle(props) {
  return /*#__PURE__*/react.createElement("svg", solid_exclamation_circle_extends({
    xmlns: "http://www.w3.org/2000/svg",
    fill: "currentColor",
    viewBox: "0 0 20 20"
  }, props), solid_exclamation_circle_path || (solid_exclamation_circle_path = /*#__PURE__*/react.createElement("path", {
    fillRule: "evenodd",
    d: "M18 10a8 8 0 1 1-16 0 8 8 0 0 1 16 0m-7 4a1 1 0 1 1-2 0 1 1 0 0 1 2 0m-1-9a1 1 0 0 0-1 1v4a1 1 0 1 0 2 0V6a1 1 0 0 0-1-1",
    clipRule: "evenodd"
  })));
};
/* harmony default export */ const solid_exclamation_circle = (exclamation_circle_SvgExclamationCircle);
;// ./react/ui/icon/icons/solid/exclamation.svg
var solid_exclamation_path;
function solid_exclamation_extends() { solid_exclamation_extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return solid_exclamation_extends.apply(this, arguments); }

var exclamation_SvgExclamation = function SvgExclamation(props) {
  return /*#__PURE__*/react.createElement("svg", solid_exclamation_extends({
    xmlns: "http://www.w3.org/2000/svg",
    fill: "currentColor",
    viewBox: "0 0 20 20"
  }, props), solid_exclamation_path || (solid_exclamation_path = /*#__PURE__*/react.createElement("path", {
    fillRule: "evenodd",
    d: "M8.257 3.099c.765-1.36 2.722-1.36 3.486 0l5.58 9.92c.75 1.334-.213 2.98-1.742 2.98H4.42c-1.53 0-2.493-1.646-1.743-2.98zM11 13a1 1 0 1 1-2 0 1 1 0 0 1 2 0m-1-8a1 1 0 0 0-1 1v3a1 1 0 0 0 2 0V6a1 1 0 0 0-1-1",
    clipRule: "evenodd"
  })));
};
/* harmony default export */ const solid_exclamation = (exclamation_SvgExclamation);
;// ./react/ui/icon/icons/solid/external-link.svg
var solid_external_link_path, external_link_path2;
function solid_external_link_extends() { solid_external_link_extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return solid_external_link_extends.apply(this, arguments); }

var external_link_SvgExternalLink = function SvgExternalLink(props) {
  return /*#__PURE__*/react.createElement("svg", solid_external_link_extends({
    xmlns: "http://www.w3.org/2000/svg",
    fill: "currentColor",
    viewBox: "0 0 20 20"
  }, props), solid_external_link_path || (solid_external_link_path = /*#__PURE__*/react.createElement("path", {
    d: "M11 3a1 1 0 1 0 0 2h2.586l-6.293 6.293a1 1 0 1 0 1.414 1.414L15 6.414V9a1 1 0 1 0 2 0V4a1 1 0 0 0-1-1z"
  })), external_link_path2 || (external_link_path2 = /*#__PURE__*/react.createElement("path", {
    d: "M5 5a2 2 0 0 0-2 2v8a2 2 0 0 0 2 2h8a2 2 0 0 0 2-2v-3a1 1 0 1 0-2 0v3H5V7h3a1 1 0 0 0 0-2z"
  })));
};
/* harmony default export */ const solid_external_link = (external_link_SvgExternalLink);
;// ./react/ui/icon/icons/solid/eye-off.svg
var solid_eye_off_path, eye_off_path2;
function solid_eye_off_extends() { solid_eye_off_extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return solid_eye_off_extends.apply(this, arguments); }

var eye_off_SvgEyeOff = function SvgEyeOff(props) {
  return /*#__PURE__*/react.createElement("svg", solid_eye_off_extends({
    xmlns: "http://www.w3.org/2000/svg",
    fill: "currentColor",
    viewBox: "0 0 20 20"
  }, props), solid_eye_off_path || (solid_eye_off_path = /*#__PURE__*/react.createElement("path", {
    fillRule: "evenodd",
    d: "M3.707 2.293a1 1 0 0 0-1.414 1.414l14 14a1 1 0 0 0 1.414-1.414l-1.473-1.473A10 10 0 0 0 19.542 10C18.268 5.943 14.478 3 10 3a9.96 9.96 0 0 0-4.512 1.074l-1.78-1.781zm4.261 4.26 1.514 1.515a2.003 2.003 0 0 1 2.45 2.45l1.514 1.514a4 4 0 0 0-5.478-5.478z",
    clipRule: "evenodd"
  })), eye_off_path2 || (eye_off_path2 = /*#__PURE__*/react.createElement("path", {
    d: "M12.454 16.697 9.75 13.992a4 4 0 0 1-3.742-3.741L2.335 6.578A10 10 0 0 0 .458 10c1.274 4.057 5.065 7 9.542 7 .847 0 1.669-.105 2.454-.303"
  })));
};
/* harmony default export */ const solid_eye_off = (eye_off_SvgEyeOff);
;// ./react/ui/icon/icons/solid/eye.svg
var solid_eye_path, solid_eye_path2;
function solid_eye_extends() { solid_eye_extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return solid_eye_extends.apply(this, arguments); }

var eye_SvgEye = function SvgEye(props) {
  return /*#__PURE__*/react.createElement("svg", solid_eye_extends({
    xmlns: "http://www.w3.org/2000/svg",
    fill: "currentColor",
    viewBox: "0 0 20 20"
  }, props), solid_eye_path || (solid_eye_path = /*#__PURE__*/react.createElement("path", {
    d: "M10 12a2 2 0 1 0 0-4 2 2 0 0 0 0 4"
  })), solid_eye_path2 || (solid_eye_path2 = /*#__PURE__*/react.createElement("path", {
    fillRule: "evenodd",
    d: "M.458 10C1.732 5.943 5.522 3 10 3s8.268 2.943 9.542 7c-1.274 4.057-5.064 7-9.542 7S1.732 14.057.458 10M14 10a4 4 0 1 1-8 0 4 4 0 0 1 8 0",
    clipRule: "evenodd"
  })));
};
/* harmony default export */ const solid_eye = (eye_SvgEye);
;// ./react/ui/icon/icons/solid/fast-forward.svg
var solid_fast_forward_path;
function solid_fast_forward_extends() { solid_fast_forward_extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return solid_fast_forward_extends.apply(this, arguments); }

var fast_forward_SvgFastForward = function SvgFastForward(props) {
  return /*#__PURE__*/react.createElement("svg", solid_fast_forward_extends({
    xmlns: "http://www.w3.org/2000/svg",
    fill: "currentColor",
    viewBox: "0 0 20 20"
  }, props), solid_fast_forward_path || (solid_fast_forward_path = /*#__PURE__*/react.createElement("path", {
    d: "M4.555 5.168A1 1 0 0 0 3 6v8a1 1 0 0 0 1.555.832L10 11.202V14a1 1 0 0 0 1.555.832l6-4a1 1 0 0 0 0-1.664l-6-4A1 1 0 0 0 10 6v2.798z"
  })));
};
/* harmony default export */ const solid_fast_forward = (fast_forward_SvgFastForward);
;// ./react/ui/icon/icons/solid/film.svg
var solid_film_path;
function solid_film_extends() { solid_film_extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return solid_film_extends.apply(this, arguments); }

var film_SvgFilm = function SvgFilm(props) {
  return /*#__PURE__*/react.createElement("svg", solid_film_extends({
    xmlns: "http://www.w3.org/2000/svg",
    fill: "currentColor",
    viewBox: "0 0 20 20"
  }, props), solid_film_path || (solid_film_path = /*#__PURE__*/react.createElement("path", {
    fillRule: "evenodd",
    d: "M4 3a2 2 0 0 0-2 2v10a2 2 0 0 0 2 2h12a2 2 0 0 0 2-2V5a2 2 0 0 0-2-2zm3 2h6v4H7zm8 8v2h1v-2zm-2-2H7v4h6zm2 0h1V9h-1zm1-4V5h-1v2zM5 5v2H4V5zm0 4H4v2h1zm-1 4h1v2H4z",
    clipRule: "evenodd"
  })));
};
/* harmony default export */ const solid_film = (film_SvgFilm);
;// ./react/ui/icon/icons/solid/filter.svg
var solid_filter_path;
function solid_filter_extends() { solid_filter_extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return solid_filter_extends.apply(this, arguments); }

var filter_SvgFilter = function SvgFilter(props) {
  return /*#__PURE__*/react.createElement("svg", solid_filter_extends({
    xmlns: "http://www.w3.org/2000/svg",
    fill: "currentColor",
    viewBox: "0 0 20 20"
  }, props), solid_filter_path || (solid_filter_path = /*#__PURE__*/react.createElement("path", {
    fillRule: "evenodd",
    d: "M3 3a1 1 0 0 1 1-1h12a1 1 0 0 1 1 1v3a1 1 0 0 1-.293.707L12 11.414V15a1 1 0 0 1-.293.707l-2 2A1 1 0 0 1 8 17v-5.586L3.293 6.707A1 1 0 0 1 3 6z",
    clipRule: "evenodd"
  })));
};
/* harmony default export */ const solid_filter = (filter_SvgFilter);
;// ./react/ui/icon/icons/solid/finger-print.svg
var solid_finger_print_path, finger_print_path2, finger_print_path3;
function solid_finger_print_extends() { solid_finger_print_extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return solid_finger_print_extends.apply(this, arguments); }

var finger_print_SvgFingerPrint = function SvgFingerPrint(props) {
  return /*#__PURE__*/react.createElement("svg", solid_finger_print_extends({
    xmlns: "http://www.w3.org/2000/svg",
    fill: "currentColor",
    viewBox: "0 0 20 20"
  }, props), solid_finger_print_path || (solid_finger_print_path = /*#__PURE__*/react.createElement("path", {
    fillRule: "evenodd",
    d: "M6.625 2.655A9 9 0 0 1 19 11a1 1 0 1 1-2 0 7 7 0 0 0-9.625-6.492 1 1 0 1 1-.75-1.853M4.662 4.959A1 1 0 0 1 4.75 6.37 6.97 6.97 0 0 0 3 11a1 1 0 1 1-2 0 8.97 8.97 0 0 1 2.25-5.953 1 1 0 0 1 1.412-.088",
    clipRule: "evenodd"
  })), finger_print_path2 || (finger_print_path2 = /*#__PURE__*/react.createElement("path", {
    fillRule: "evenodd",
    d: "M5 11a5 5 0 1 1 10 0 1 1 0 1 1-2 0 3 3 0 1 0-6 0c0 1.677-.345 3.276-.968 4.729a1 1 0 1 1-1.838-.789A10 10 0 0 0 5 11m8.921 2.012a1 1 0 0 1 .831 1.145 20 20 0 0 1-.545 2.436 1 1 0 1 1-1.92-.558q.311-1.07.49-2.192a1 1 0 0 1 1.144-.83z",
    clipRule: "evenodd"
  })), finger_print_path3 || (finger_print_path3 = /*#__PURE__*/react.createElement("path", {
    fillRule: "evenodd",
    d: "M10 10a1 1 0 0 1 1 1c0 2.236-.46 4.368-1.29 6.304a1 1 0 0 1-1.838-.789A13.95 13.95 0 0 0 9 11a1 1 0 0 1 1-1",
    clipRule: "evenodd"
  })));
};
/* harmony default export */ const solid_finger_print = (finger_print_SvgFingerPrint);
;// ./react/ui/icon/icons/solid/fire.svg
var solid_fire_path;
function solid_fire_extends() { solid_fire_extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return solid_fire_extends.apply(this, arguments); }

var fire_SvgFire = function SvgFire(props) {
  return /*#__PURE__*/react.createElement("svg", solid_fire_extends({
    xmlns: "http://www.w3.org/2000/svg",
    fill: "currentColor",
    viewBox: "0 0 20 20"
  }, props), solid_fire_path || (solid_fire_path = /*#__PURE__*/react.createElement("path", {
    fillRule: "evenodd",
    d: "M12.395 2.553a1 1 0 0 0-1.45-.385c-.345.23-.614.558-.822.88-.214.33-.403.713-.57 1.116-.334.804-.614 1.768-.84 2.734a31 31 0 0 0-.613 3.58 2.64 2.64 0 0 1-.945-1.067c-.328-.68-.398-1.534-.398-2.654A1 1 0 0 0 5.05 6.05 6.98 6.98 0 0 0 3 11a7 7 0 1 0 11.95-4.95c-.592-.591-.98-.985-1.348-1.467-.363-.476-.724-1.063-1.207-2.03M12.12 15.12A3 3 0 0 1 7 13s.879.5 2.5.5c0-1 .5-4 1.25-4.5.5 1 .786 1.293 1.371 1.879A3 3 0 0 1 13 13a3 3 0 0 1-.879 2.121z",
    clipRule: "evenodd"
  })));
};
/* harmony default export */ const solid_fire = (fire_SvgFire);
;// ./react/ui/icon/icons/solid/flag.svg
var solid_flag_path;
function solid_flag_extends() { solid_flag_extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return solid_flag_extends.apply(this, arguments); }

var flag_SvgFlag = function SvgFlag(props) {
  return /*#__PURE__*/react.createElement("svg", solid_flag_extends({
    xmlns: "http://www.w3.org/2000/svg",
    fill: "currentColor",
    viewBox: "0 0 20 20"
  }, props), solid_flag_path || (solid_flag_path = /*#__PURE__*/react.createElement("path", {
    fillRule: "evenodd",
    d: "M3 6a3 3 0 0 1 3-3h10a1 1 0 0 1 .8 1.6L14.25 8l2.55 3.4A1 1 0 0 1 16 13H6a1 1 0 0 0-1 1v3a1 1 0 1 1-2 0z",
    clipRule: "evenodd"
  })));
};
/* harmony default export */ const solid_flag = (flag_SvgFlag);
;// ./react/ui/icon/icons/solid/folder-add.svg
var solid_folder_add_path, folder_add_path2;
function solid_folder_add_extends() { solid_folder_add_extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return solid_folder_add_extends.apply(this, arguments); }

var folder_add_SvgFolderAdd = function SvgFolderAdd(props) {
  return /*#__PURE__*/react.createElement("svg", solid_folder_add_extends({
    xmlns: "http://www.w3.org/2000/svg",
    fill: "currentColor",
    viewBox: "0 0 20 20"
  }, props), solid_folder_add_path || (solid_folder_add_path = /*#__PURE__*/react.createElement("path", {
    d: "M2 6a2 2 0 0 1 2-2h5l2 2h5a2 2 0 0 1 2 2v6a2 2 0 0 1-2 2H4a2 2 0 0 1-2-2z"
  })), folder_add_path2 || (folder_add_path2 = /*#__PURE__*/react.createElement("path", {
    stroke: "#fff",
    strokeLinecap: "round",
    strokeLinejoin: "round",
    strokeWidth: 2,
    d: "M8 11h4m-2-2v4"
  })));
};
/* harmony default export */ const solid_folder_add = (folder_add_SvgFolderAdd);
;// ./react/ui/icon/icons/solid/folder-download.svg
var solid_folder_download_path, folder_download_path2;
function solid_folder_download_extends() { solid_folder_download_extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return solid_folder_download_extends.apply(this, arguments); }

var folder_download_SvgFolderDownload = function SvgFolderDownload(props) {
  return /*#__PURE__*/react.createElement("svg", solid_folder_download_extends({
    xmlns: "http://www.w3.org/2000/svg",
    fill: "currentColor",
    viewBox: "0 0 20 20"
  }, props), solid_folder_download_path || (solid_folder_download_path = /*#__PURE__*/react.createElement("path", {
    d: "M2 6a2 2 0 0 1 2-2h5l2 2h5a2 2 0 0 1 2 2v6a2 2 0 0 1-2 2H4a2 2 0 0 1-2-2z"
  })), folder_download_path2 || (folder_download_path2 = /*#__PURE__*/react.createElement("path", {
    stroke: "#fff",
    strokeLinecap: "round",
    strokeLinejoin: "round",
    strokeWidth: 2,
    d: "M10 9v4m0 0-2-2m2 2 2-2"
  })));
};
/* harmony default export */ const solid_folder_download = (folder_download_SvgFolderDownload);
;// ./react/ui/icon/icons/solid/folder-open.svg
var solid_folder_open_path, folder_open_path2;
function solid_folder_open_extends() { solid_folder_open_extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return solid_folder_open_extends.apply(this, arguments); }

var folder_open_SvgFolderOpen = function SvgFolderOpen(props) {
  return /*#__PURE__*/react.createElement("svg", solid_folder_open_extends({
    xmlns: "http://www.w3.org/2000/svg",
    fill: "currentColor",
    viewBox: "0 0 20 20"
  }, props), solid_folder_open_path || (solid_folder_open_path = /*#__PURE__*/react.createElement("path", {
    fillRule: "evenodd",
    d: "M2 6a2 2 0 0 1 2-2h4l2 2h4a2 2 0 0 1 2 2v1H8a3 3 0 0 0-3 3v1.5a1.5 1.5 0 0 1-3 0z",
    clipRule: "evenodd"
  })), folder_open_path2 || (folder_open_path2 = /*#__PURE__*/react.createElement("path", {
    d: "M6 12a2 2 0 0 1 2-2h8a2 2 0 0 1 2 2v2a2 2 0 0 1-2 2H2h2a2 2 0 0 0 2-2z"
  })));
};
/* harmony default export */ const solid_folder_open = (folder_open_SvgFolderOpen);
;// ./react/ui/icon/icons/solid/folder-remove.svg
var solid_folder_remove_path, folder_remove_path2;
function solid_folder_remove_extends() { solid_folder_remove_extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return solid_folder_remove_extends.apply(this, arguments); }

var folder_remove_SvgFolderRemove = function SvgFolderRemove(props) {
  return /*#__PURE__*/react.createElement("svg", solid_folder_remove_extends({
    xmlns: "http://www.w3.org/2000/svg",
    fill: "currentColor",
    viewBox: "0 0 20 20"
  }, props), solid_folder_remove_path || (solid_folder_remove_path = /*#__PURE__*/react.createElement("path", {
    d: "M2 6a2 2 0 0 1 2-2h5l2 2h5a2 2 0 0 1 2 2v6a2 2 0 0 1-2 2H4a2 2 0 0 1-2-2z"
  })), folder_remove_path2 || (folder_remove_path2 = /*#__PURE__*/react.createElement("path", {
    stroke: "#fff",
    strokeLinecap: "round",
    strokeLinejoin: "round",
    strokeWidth: 2,
    d: "M8 11h4"
  })));
};
/* harmony default export */ const solid_folder_remove = (folder_remove_SvgFolderRemove);
;// ./react/ui/icon/icons/solid/folder.svg
var solid_folder_path;
function solid_folder_extends() { solid_folder_extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return solid_folder_extends.apply(this, arguments); }

var folder_SvgFolder = function SvgFolder(props) {
  return /*#__PURE__*/react.createElement("svg", solid_folder_extends({
    xmlns: "http://www.w3.org/2000/svg",
    fill: "currentColor",
    viewBox: "0 0 20 20"
  }, props), solid_folder_path || (solid_folder_path = /*#__PURE__*/react.createElement("path", {
    d: "M2 6a2 2 0 0 1 2-2h5l2 2h5a2 2 0 0 1 2 2v6a2 2 0 0 1-2 2H4a2 2 0 0 1-2-2z"
  })));
};
/* harmony default export */ const solid_folder = (folder_SvgFolder);
;// ./react/ui/icon/icons/solid/gift.svg
var solid_gift_path, gift_path2;
function solid_gift_extends() { solid_gift_extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return solid_gift_extends.apply(this, arguments); }

var gift_SvgGift = function SvgGift(props) {
  return /*#__PURE__*/react.createElement("svg", solid_gift_extends({
    xmlns: "http://www.w3.org/2000/svg",
    fill: "currentColor",
    viewBox: "0 0 20 20"
  }, props), solid_gift_path || (solid_gift_path = /*#__PURE__*/react.createElement("path", {
    fillRule: "evenodd",
    d: "M5 5a3 3 0 0 1 5-2.236A3 3 0 0 1 14.83 6H16a2 2 0 1 1 0 4h-5V9a1 1 0 1 0-2 0v1H4a2 2 0 1 1 0-4h1.17C5.06 5.687 5 5.35 5 5m4 1V5a1 1 0 1 0-1 1zm3 0a1 1 0 1 0-1-1v1z",
    clipRule: "evenodd"
  })), gift_path2 || (gift_path2 = /*#__PURE__*/react.createElement("path", {
    d: "M9 11H3v5a2 2 0 0 0 2 2h4zm2 7h4a2 2 0 0 0 2-2v-5h-6z"
  })));
};
/* harmony default export */ const solid_gift = (gift_SvgGift);
;// ./react/ui/icon/icons/solid/globe-alt.svg
var solid_globe_alt_path;
function solid_globe_alt_extends() { solid_globe_alt_extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return solid_globe_alt_extends.apply(this, arguments); }

var globe_alt_SvgGlobeAlt = function SvgGlobeAlt(props) {
  return /*#__PURE__*/react.createElement("svg", solid_globe_alt_extends({
    xmlns: "http://www.w3.org/2000/svg",
    fill: "currentColor",
    viewBox: "0 0 20 20"
  }, props), solid_globe_alt_path || (solid_globe_alt_path = /*#__PURE__*/react.createElement("path", {
    fillRule: "evenodd",
    d: "M4.083 9h1.946c.089-1.546.383-2.97.837-4.118A6 6 0 0 0 4.083 9M10 2a8 8 0 1 0 0 16 8 8 0 0 0 0-16m0 2c-.076 0-.232.032-.465.262-.238.234-.497.623-.737 1.182-.389.907-.673 2.142-.766 3.556h3.936c-.093-1.414-.377-2.649-.766-3.556-.24-.56-.5-.948-.737-1.182C10.232 4.032 10.076 4 10 4m3.971 5c-.089-1.546-.383-2.97-.837-4.118A6 6 0 0 1 15.917 9zm-2.003 2H8.032c.093 1.414.377 2.649.766 3.556.24.56.5.948.737 1.182.233.23.389.262.465.262s.232-.032.465-.262c.238-.234.498-.623.737-1.182.389-.907.673-2.142.766-3.556m1.166 4.118c.454-1.147.748-2.572.837-4.118h1.946a6 6 0 0 1-2.783 4.118m-6.268 0C6.412 13.97 6.118 12.546 6.03 11H4.083a6 6 0 0 0 2.783 4.118",
    clipRule: "evenodd"
  })));
};
/* harmony default export */ const solid_globe_alt = (globe_alt_SvgGlobeAlt);
;// ./react/ui/icon/icons/solid/globe.svg
var solid_globe_path;
function solid_globe_extends() { solid_globe_extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return solid_globe_extends.apply(this, arguments); }

var globe_SvgGlobe = function SvgGlobe(props) {
  return /*#__PURE__*/react.createElement("svg", solid_globe_extends({
    xmlns: "http://www.w3.org/2000/svg",
    fill: "currentColor",
    viewBox: "0 0 20 20"
  }, props), solid_globe_path || (solid_globe_path = /*#__PURE__*/react.createElement("path", {
    fillRule: "evenodd",
    d: "M10 18a8 8 0 1 0 0-16 8 8 0 0 0 0 16M4.332 8.027a6 6 0 0 1 1.912-2.706C6.512 5.73 6.974 6 7.5 6A1.5 1.5 0 0 1 9 7.5V8a2 2 0 0 0 4 0 2 2 0 0 1 1.523-1.943A5.98 5.98 0 0 1 16 10q0 .511-.083 1H15a2 2 0 0 0-2 2v2.197A6 6 0 0 1 10 16v-2a2 2 0 0 0-2-2 2 2 0 0 1-2-2 2 2 0 0 0-1.668-1.973",
    clipRule: "evenodd"
  })));
};
/* harmony default export */ const solid_globe = (globe_SvgGlobe);
;// ./react/ui/icon/icons/solid/hand.svg
var solid_hand_path;
function solid_hand_extends() { solid_hand_extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return solid_hand_extends.apply(this, arguments); }

var hand_SvgHand = function SvgHand(props) {
  return /*#__PURE__*/react.createElement("svg", solid_hand_extends({
    xmlns: "http://www.w3.org/2000/svg",
    fill: "currentColor",
    viewBox: "0 0 20 20"
  }, props), solid_hand_path || (solid_hand_path = /*#__PURE__*/react.createElement("path", {
    fillRule: "evenodd",
    d: "M9 3a1 1 0 0 1 2 0v5.5a.5.5 0 0 0 1 0V4a1 1 0 1 1 2 0v4.5a.5.5 0 0 0 1 0V6a1 1 0 1 1 2 0v5a7 7 0 1 1-14 0V9a1 1 0 0 1 2 0v2.5a.5.5 0 0 0 1 0V4a1 1 0 0 1 2 0v4.5a.5.5 0 0 0 1 0z",
    clipRule: "evenodd"
  })));
};
/* harmony default export */ const solid_hand = (hand_SvgHand);
;// ./react/ui/icon/icons/solid/hashtag.svg
var solid_hashtag_path;
function solid_hashtag_extends() { solid_hashtag_extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return solid_hashtag_extends.apply(this, arguments); }

var hashtag_SvgHashtag = function SvgHashtag(props) {
  return /*#__PURE__*/react.createElement("svg", solid_hashtag_extends({
    xmlns: "http://www.w3.org/2000/svg",
    fill: "currentColor",
    viewBox: "0 0 20 20"
  }, props), solid_hashtag_path || (solid_hashtag_path = /*#__PURE__*/react.createElement("path", {
    fillRule: "evenodd",
    d: "M9.243 3.03a1 1 0 0 1 .727 1.213L9.53 6h2.94l.56-2.243a1 1 0 1 1 1.94.486L14.53 6H17a1 1 0 1 1 0 2h-2.97l-1 4H15a1 1 0 1 1 0 2h-2.47l-.56 2.242a1 1 0 1 1-1.94-.485L10.47 14H7.53l-.56 2.242a1 1 0 1 1-1.94-.485L5.47 14H3a1 1 0 1 1 0-2h2.97l1-4H5a1 1 0 1 1 0-2h2.47l.56-2.243a1 1 0 0 1 1.213-.727M9.03 8l-1 4h2.938l1-4H9.031z",
    clipRule: "evenodd"
  })));
};
/* harmony default export */ const solid_hashtag = (hashtag_SvgHashtag);
;// ./react/ui/icon/icons/solid/heart.svg
var solid_heart_path;
function solid_heart_extends() { solid_heart_extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return solid_heart_extends.apply(this, arguments); }

var heart_SvgHeart = function SvgHeart(props) {
  return /*#__PURE__*/react.createElement("svg", solid_heart_extends({
    xmlns: "http://www.w3.org/2000/svg",
    fill: "currentColor",
    viewBox: "0 0 20 20"
  }, props), solid_heart_path || (solid_heart_path = /*#__PURE__*/react.createElement("path", {
    fillRule: "evenodd",
    d: "M3.172 5.172a4 4 0 0 1 5.656 0L10 6.343l1.172-1.171a4 4 0 1 1 5.656 5.656L10 17.657l-6.828-6.829a4 4 0 0 1 0-5.656",
    clipRule: "evenodd"
  })));
};
/* harmony default export */ const solid_heart = (heart_SvgHeart);
;// ./react/ui/icon/icons/solid/home.svg
var solid_home_path;
function solid_home_extends() { solid_home_extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return solid_home_extends.apply(this, arguments); }

var home_SvgHome = function SvgHome(props) {
  return /*#__PURE__*/react.createElement("svg", solid_home_extends({
    xmlns: "http://www.w3.org/2000/svg",
    fill: "currentColor",
    viewBox: "0 0 20 20"
  }, props), solid_home_path || (solid_home_path = /*#__PURE__*/react.createElement("path", {
    d: "M10.707 2.293a1 1 0 0 0-1.414 0l-7 7a1 1 0 0 0 1.414 1.414L4 10.414V17a1 1 0 0 0 1 1h2a1 1 0 0 0 1-1v-2a1 1 0 0 1 1-1h2a1 1 0 0 1 1 1v2a1 1 0 0 0 1 1h2a1 1 0 0 0 1-1v-6.586l.293.293a1 1 0 0 0 1.414-1.414z"
  })));
};
/* harmony default export */ const solid_home = (home_SvgHome);
;// ./react/ui/icon/icons/solid/identification.svg
var solid_identification_path;
function solid_identification_extends() { solid_identification_extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return solid_identification_extends.apply(this, arguments); }

var identification_SvgIdentification = function SvgIdentification(props) {
  return /*#__PURE__*/react.createElement("svg", solid_identification_extends({
    xmlns: "http://www.w3.org/2000/svg",
    fill: "currentColor",
    viewBox: "0 0 20 20"
  }, props), solid_identification_path || (solid_identification_path = /*#__PURE__*/react.createElement("path", {
    fillRule: "evenodd",
    d: "M10 2a1 1 0 0 0-1 1v1a1 1 0 0 0 2 0V3a1 1 0 0 0-1-1M4 4h3a3 3 0 0 0 6 0h3a2 2 0 0 1 2 2v9a2 2 0 0 1-2 2H4a2 2 0 0 1-2-2V6a2 2 0 0 1 2-2m2.5 7a1.5 1.5 0 1 0 0-3 1.5 1.5 0 0 0 0 3m2.45 4a2.5 2.5 0 1 0-4.9 0zM12 9a1 1 0 1 0 0 2h3a1 1 0 1 0 0-2zm-1 4a1 1 0 0 1 1-1h2a1 1 0 1 1 0 2h-2a1 1 0 0 1-1-1",
    clipRule: "evenodd"
  })));
};
/* harmony default export */ const solid_identification = (identification_SvgIdentification);
;// ./react/ui/icon/icons/solid/inbox-in.svg
var solid_inbox_in_path, inbox_in_path2;
function solid_inbox_in_extends() { solid_inbox_in_extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return solid_inbox_in_extends.apply(this, arguments); }

var inbox_in_SvgInboxIn = function SvgInboxIn(props) {
  return /*#__PURE__*/react.createElement("svg", solid_inbox_in_extends({
    xmlns: "http://www.w3.org/2000/svg",
    fill: "currentColor",
    viewBox: "0 0 20 20"
  }, props), solid_inbox_in_path || (solid_inbox_in_path = /*#__PURE__*/react.createElement("path", {
    d: "M8.707 7.293a1 1 0 0 0-1.414 1.414l2 2a1 1 0 0 0 1.414 0l2-2a1 1 0 0 0-1.414-1.414L11 7.586V3a1 1 0 1 0-2 0v4.586z"
  })), inbox_in_path2 || (inbox_in_path2 = /*#__PURE__*/react.createElement("path", {
    d: "M3 5a2 2 0 0 1 2-2h1a1 1 0 0 1 0 2H5v7h2l1 2h4l1-2h2V5h-1a1 1 0 1 1 0-2h1a2 2 0 0 1 2 2v10a2 2 0 0 1-2 2H5a2 2 0 0 1-2-2z"
  })));
};
/* harmony default export */ const solid_inbox_in = (inbox_in_SvgInboxIn);
;// ./react/ui/icon/icons/solid/inbox.svg
var solid_inbox_path;
function solid_inbox_extends() { solid_inbox_extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return solid_inbox_extends.apply(this, arguments); }

var inbox_SvgInbox = function SvgInbox(props) {
  return /*#__PURE__*/react.createElement("svg", solid_inbox_extends({
    xmlns: "http://www.w3.org/2000/svg",
    fill: "currentColor",
    viewBox: "0 0 20 20"
  }, props), solid_inbox_path || (solid_inbox_path = /*#__PURE__*/react.createElement("path", {
    fillRule: "evenodd",
    d: "M5 3a2 2 0 0 0-2 2v10a2 2 0 0 0 2 2h10a2 2 0 0 0 2-2V5a2 2 0 0 0-2-2zm0 2h10v7h-2l-1 2H8l-1-2H5z",
    clipRule: "evenodd"
  })));
};
/* harmony default export */ const solid_inbox = (inbox_SvgInbox);
;// ./react/ui/icon/icons/solid/information-circle.svg
var solid_information_circle_path;
function solid_information_circle_extends() { solid_information_circle_extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return solid_information_circle_extends.apply(this, arguments); }

var information_circle_SvgInformationCircle = function SvgInformationCircle(props) {
  return /*#__PURE__*/react.createElement("svg", solid_information_circle_extends({
    xmlns: "http://www.w3.org/2000/svg",
    fill: "currentColor",
    viewBox: "0 0 20 20"
  }, props), solid_information_circle_path || (solid_information_circle_path = /*#__PURE__*/react.createElement("path", {
    fillRule: "evenodd",
    d: "M18 10a8 8 0 1 1-16 0 8 8 0 0 1 16 0m-7-4a1 1 0 1 1-2 0 1 1 0 0 1 2 0M9 9a1 1 0 0 0 0 2v3a1 1 0 0 0 1 1h1a1 1 0 1 0 0-2v-3a1 1 0 0 0-1-1z",
    clipRule: "evenodd"
  })));
};
/* harmony default export */ const solid_information_circle = (information_circle_SvgInformationCircle);
;// ./react/ui/icon/icons/solid/key.svg
var solid_key_path;
function solid_key_extends() { solid_key_extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return solid_key_extends.apply(this, arguments); }

var key_SvgKey = function SvgKey(props) {
  return /*#__PURE__*/react.createElement("svg", solid_key_extends({
    xmlns: "http://www.w3.org/2000/svg",
    fill: "currentColor",
    viewBox: "0 0 20 20"
  }, props), solid_key_path || (solid_key_path = /*#__PURE__*/react.createElement("path", {
    fillRule: "evenodd",
    d: "M18 8a6 6 0 0 1-7.743 5.743L10 14l-1 1-1 1H6v2H2v-4l4.257-4.257A6 6 0 1 1 18 8m-6-4a1 1 0 1 0 0 2 2 2 0 0 1 2 2 1 1 0 1 0 2 0 4 4 0 0 0-4-4",
    clipRule: "evenodd"
  })));
};
/* harmony default export */ const solid_key = (key_SvgKey);
;// ./react/ui/icon/icons/solid/library.svg
var solid_library_path;
function solid_library_extends() { solid_library_extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return solid_library_extends.apply(this, arguments); }

var library_SvgLibrary = function SvgLibrary(props) {
  return /*#__PURE__*/react.createElement("svg", solid_library_extends({
    xmlns: "http://www.w3.org/2000/svg",
    fill: "currentColor",
    viewBox: "0 0 20 20"
  }, props), solid_library_path || (solid_library_path = /*#__PURE__*/react.createElement("path", {
    fillRule: "evenodd",
    d: "M10.496 2.132a1 1 0 0 0-.992 0l-7 4A1 1 0 0 0 3 8v7a1 1 0 1 0 0 2h14a1 1 0 1 0 0-2V8a1 1 0 0 0 .496-1.868zM6 9a1 1 0 0 0-1 1v3a1 1 0 1 0 2 0v-3a1 1 0 0 0-1-1m3 1a1 1 0 0 1 2 0v3a1 1 0 1 1-2 0zm5-1a1 1 0 0 0-1 1v3a1 1 0 1 0 2 0v-3a1 1 0 0 0-1-1",
    clipRule: "evenodd"
  })));
};
/* harmony default export */ const solid_library = (library_SvgLibrary);
;// ./react/ui/icon/icons/solid/light-bulb.svg
var solid_light_bulb_path;
function solid_light_bulb_extends() { solid_light_bulb_extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return solid_light_bulb_extends.apply(this, arguments); }

var light_bulb_SvgLightBulb = function SvgLightBulb(props) {
  return /*#__PURE__*/react.createElement("svg", solid_light_bulb_extends({
    xmlns: "http://www.w3.org/2000/svg",
    fill: "currentColor",
    viewBox: "0 0 20 20"
  }, props), solid_light_bulb_path || (solid_light_bulb_path = /*#__PURE__*/react.createElement("path", {
    d: "M11 3a1 1 0 1 0-2 0v1a1 1 0 1 0 2 0zm4.657 2.757a1 1 0 0 0-1.414-1.414l-.707.707a1 1 0 0 0 1.414 1.414zM18 10a1 1 0 0 1-1 1h-1a1 1 0 1 1 0-2h1a1 1 0 0 1 1 1M5.05 6.464A1 1 0 1 0 6.464 5.05l-.707-.707a1 1 0 0 0-1.414 1.414zM5 10a1 1 0 0 1-1 1H3a1 1 0 1 1 0-2h1a1 1 0 0 1 1 1m3 6v-1h4v1a2 2 0 1 1-4 0m4-2c.015-.34.208-.646.477-.859a4 4 0 1 0-4.954 0c.27.213.462.519.476.859h4.002z"
  })));
};
/* harmony default export */ const solid_light_bulb = (light_bulb_SvgLightBulb);
;// ./react/ui/icon/icons/solid/lightning-bolt.svg
var solid_lightning_bolt_path;
function solid_lightning_bolt_extends() { solid_lightning_bolt_extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return solid_lightning_bolt_extends.apply(this, arguments); }

var lightning_bolt_SvgLightningBolt = function SvgLightningBolt(props) {
  return /*#__PURE__*/react.createElement("svg", solid_lightning_bolt_extends({
    xmlns: "http://www.w3.org/2000/svg",
    fill: "currentColor",
    viewBox: "0 0 20 20"
  }, props), solid_lightning_bolt_path || (solid_lightning_bolt_path = /*#__PURE__*/react.createElement("path", {
    fillRule: "evenodd",
    d: "M11.3 1.046A1 1 0 0 1 12 2v5h4a1 1 0 0 1 .82 1.573l-7 10A1 1 0 0 1 8 18v-5H4a1 1 0 0 1-.82-1.573l7-10a1 1 0 0 1 1.12-.38z",
    clipRule: "evenodd"
  })));
};
/* harmony default export */ const solid_lightning_bolt = (lightning_bolt_SvgLightningBolt);
;// ./react/ui/icon/icons/solid/link.svg
var solid_link_path;
function solid_link_extends() { solid_link_extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return solid_link_extends.apply(this, arguments); }

var link_SvgLink = function SvgLink(props) {
  return /*#__PURE__*/react.createElement("svg", solid_link_extends({
    xmlns: "http://www.w3.org/2000/svg",
    fill: "currentColor",
    viewBox: "0 0 20 20"
  }, props), solid_link_path || (solid_link_path = /*#__PURE__*/react.createElement("path", {
    fillRule: "evenodd",
    d: "M12.586 4.586a2 2 0 1 1 2.828 2.828l-3 3a2 2 0 0 1-2.828 0 1 1 0 0 0-1.414 1.414 4 4 0 0 0 5.656 0l3-3a4 4 0 0 0-5.656-5.656l-1.5 1.5a1 1 0 1 0 1.414 1.414zm-5 5a2 2 0 0 1 2.828 0 1 1 0 1 0 1.414-1.414 4 4 0 0 0-5.656 0l-3 3a4 4 0 1 0 5.656 5.656l1.5-1.5a1 1 0 1 0-1.414-1.414l-1.5 1.5a2 2 0 1 1-2.828-2.828z",
    clipRule: "evenodd"
  })));
};
/* harmony default export */ const solid_link = (link_SvgLink);
;// ./react/ui/icon/icons/solid/location-marker.svg
var solid_location_marker_path;
function solid_location_marker_extends() { solid_location_marker_extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return solid_location_marker_extends.apply(this, arguments); }

var location_marker_SvgLocationMarker = function SvgLocationMarker(props) {
  return /*#__PURE__*/react.createElement("svg", solid_location_marker_extends({
    xmlns: "http://www.w3.org/2000/svg",
    fill: "currentColor",
    viewBox: "0 0 20 20"
  }, props), solid_location_marker_path || (solid_location_marker_path = /*#__PURE__*/react.createElement("path", {
    fillRule: "evenodd",
    d: "M5.05 4.05a7 7 0 1 1 9.9 9.9L10 18.9l-4.95-4.95a7 7 0 0 1 0-9.9M10 11a2 2 0 1 0 0-4 2 2 0 0 0 0 4",
    clipRule: "evenodd"
  })));
};
/* harmony default export */ const solid_location_marker = (location_marker_SvgLocationMarker);
;// ./react/ui/icon/icons/solid/lock-closed.svg
var solid_lock_closed_path;
function solid_lock_closed_extends() { solid_lock_closed_extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return solid_lock_closed_extends.apply(this, arguments); }

var lock_closed_SvgLockClosed = function SvgLockClosed(props) {
  return /*#__PURE__*/react.createElement("svg", solid_lock_closed_extends({
    xmlns: "http://www.w3.org/2000/svg",
    fill: "currentColor",
    viewBox: "0 0 20 20"
  }, props), solid_lock_closed_path || (solid_lock_closed_path = /*#__PURE__*/react.createElement("path", {
    fillRule: "evenodd",
    d: "M5 9V7a5 5 0 0 1 10 0v2a2 2 0 0 1 2 2v5a2 2 0 0 1-2 2H5a2 2 0 0 1-2-2v-5a2 2 0 0 1 2-2m8-2v2H7V7a3 3 0 0 1 6 0",
    clipRule: "evenodd"
  })));
};
/* harmony default export */ const solid_lock_closed = (lock_closed_SvgLockClosed);
;// ./react/ui/icon/icons/solid/lock-open.svg
var solid_lock_open_path;
function solid_lock_open_extends() { solid_lock_open_extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return solid_lock_open_extends.apply(this, arguments); }

var lock_open_SvgLockOpen = function SvgLockOpen(props) {
  return /*#__PURE__*/react.createElement("svg", solid_lock_open_extends({
    xmlns: "http://www.w3.org/2000/svg",
    fill: "currentColor",
    viewBox: "0 0 20 20"
  }, props), solid_lock_open_path || (solid_lock_open_path = /*#__PURE__*/react.createElement("path", {
    d: "M10 2a5 5 0 0 0-5 5v2a2 2 0 0 0-2 2v5a2 2 0 0 0 2 2h10a2 2 0 0 0 2-2v-5a2 2 0 0 0-2-2H7V7a3 3 0 0 1 5.905-.75 1 1 0 0 0 1.937-.5A5 5 0 0 0 10 2"
  })));
};
/* harmony default export */ const solid_lock_open = (lock_open_SvgLockOpen);
;// ./react/ui/icon/icons/solid/login.svg
var solid_login_path;
function solid_login_extends() { solid_login_extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return solid_login_extends.apply(this, arguments); }

var login_SvgLogin = function SvgLogin(props) {
  return /*#__PURE__*/react.createElement("svg", solid_login_extends({
    xmlns: "http://www.w3.org/2000/svg",
    fill: "currentColor",
    viewBox: "0 0 20 20"
  }, props), solid_login_path || (solid_login_path = /*#__PURE__*/react.createElement("path", {
    fillRule: "evenodd",
    d: "M3 3a1 1 0 0 1 1 1v12a1 1 0 1 1-2 0V4a1 1 0 0 1 1-1m7.707 3.293a1 1 0 0 1 0 1.414L9.414 9H17a1 1 0 1 1 0 2H9.414l1.293 1.293a1 1 0 0 1-1.414 1.414l-3-3a1 1 0 0 1 0-1.414l3-3a1 1 0 0 1 1.414 0",
    clipRule: "evenodd"
  })));
};
/* harmony default export */ const solid_login = (login_SvgLogin);
;// ./react/ui/icon/icons/solid/logout.svg
var solid_logout_path;
function solid_logout_extends() { solid_logout_extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return solid_logout_extends.apply(this, arguments); }

var logout_SvgLogout = function SvgLogout(props) {
  return /*#__PURE__*/react.createElement("svg", solid_logout_extends({
    xmlns: "http://www.w3.org/2000/svg",
    fill: "currentColor",
    viewBox: "0 0 20 20"
  }, props), solid_logout_path || (solid_logout_path = /*#__PURE__*/react.createElement("path", {
    fillRule: "evenodd",
    d: "M3 3a1 1 0 0 0-1 1v12a1 1 0 1 0 2 0V4a1 1 0 0 0-1-1m10.293 9.293a1 1 0 0 0 1.414 1.414l3-3a1 1 0 0 0 0-1.414l-3-3a1 1 0 1 0-1.414 1.414L14.586 9H7a1 1 0 1 0 0 2h7.586z",
    clipRule: "evenodd"
  })));
};
/* harmony default export */ const solid_logout = (logout_SvgLogout);
;// ./react/ui/icon/icons/solid/mail-open.svg
var solid_mail_open_path;
function solid_mail_open_extends() { solid_mail_open_extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return solid_mail_open_extends.apply(this, arguments); }

var mail_open_SvgMailOpen = function SvgMailOpen(props) {
  return /*#__PURE__*/react.createElement("svg", solid_mail_open_extends({
    xmlns: "http://www.w3.org/2000/svg",
    fill: "currentColor",
    viewBox: "0 0 20 20"
  }, props), solid_mail_open_path || (solid_mail_open_path = /*#__PURE__*/react.createElement("path", {
    fillRule: "evenodd",
    d: "M2.94 6.412A2 2 0 0 0 2 8.108V16a2 2 0 0 0 2 2h12a2 2 0 0 0 2-2V8.108a2 2 0 0 0-.94-1.696l-6-3.75a2 2 0 0 0-2.12 0zm2.615 2.423a1 1 0 1 0-1.11 1.664l5 3.333a1 1 0 0 0 1.11 0l5-3.333a1 1 0 0 0-1.11-1.664L10 11.798z",
    clipRule: "evenodd"
  })));
};
/* harmony default export */ const solid_mail_open = (mail_open_SvgMailOpen);
;// ./react/ui/icon/icons/solid/mail.svg
var solid_mail_path, mail_path2;
function solid_mail_extends() { solid_mail_extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return solid_mail_extends.apply(this, arguments); }

var mail_SvgMail = function SvgMail(props) {
  return /*#__PURE__*/react.createElement("svg", solid_mail_extends({
    xmlns: "http://www.w3.org/2000/svg",
    fill: "currentColor",
    viewBox: "0 0 20 20"
  }, props), solid_mail_path || (solid_mail_path = /*#__PURE__*/react.createElement("path", {
    d: "M2.003 5.884 10 9.882l7.997-3.998A2 2 0 0 0 16 4H4a2 2 0 0 0-1.997 1.884"
  })), mail_path2 || (mail_path2 = /*#__PURE__*/react.createElement("path", {
    d: "m18 8.118-8 4-8-4V14a2 2 0 0 0 2 2h12a2 2 0 0 0 2-2z"
  })));
};
/* harmony default export */ const solid_mail = (mail_SvgMail);
;// ./react/ui/icon/icons/solid/map.svg
var solid_map_path;
function solid_map_extends() { solid_map_extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return solid_map_extends.apply(this, arguments); }

var map_SvgMap = function SvgMap(props) {
  return /*#__PURE__*/react.createElement("svg", solid_map_extends({
    xmlns: "http://www.w3.org/2000/svg",
    fill: "currentColor",
    viewBox: "0 0 20 20"
  }, props), solid_map_path || (solid_map_path = /*#__PURE__*/react.createElement("path", {
    fillRule: "evenodd",
    d: "m12 1.586-4 4v12.828l4-4zM3.707 3.293A1 1 0 0 0 2 4v10a1 1 0 0 0 .293.707L6 18.414V5.586zm14 2L14 1.586v12.828l2.293 2.293A1 1 0 0 0 18 16V6a1 1 0 0 0-.293-.707",
    clipRule: "evenodd"
  })));
};
/* harmony default export */ const solid_map = (map_SvgMap);
;// ./react/ui/icon/icons/solid/menu-alt-1.svg
var solid_menu_alt_1_path;
function solid_menu_alt_1_extends() { solid_menu_alt_1_extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return solid_menu_alt_1_extends.apply(this, arguments); }

var menu_alt_1_SvgMenuAlt1 = function SvgMenuAlt1(props) {
  return /*#__PURE__*/react.createElement("svg", solid_menu_alt_1_extends({
    xmlns: "http://www.w3.org/2000/svg",
    fill: "currentColor",
    viewBox: "0 0 20 20"
  }, props), solid_menu_alt_1_path || (solid_menu_alt_1_path = /*#__PURE__*/react.createElement("path", {
    fillRule: "evenodd",
    d: "M3 5a1 1 0 0 1 1-1h12a1 1 0 1 1 0 2H4a1 1 0 0 1-1-1m0 5a1 1 0 0 1 1-1h6a1 1 0 1 1 0 2H4a1 1 0 0 1-1-1m0 5a1 1 0 0 1 1-1h12a1 1 0 1 1 0 2H4a1 1 0 0 1-1-1",
    clipRule: "evenodd"
  })));
};
/* harmony default export */ const solid_menu_alt_1 = (menu_alt_1_SvgMenuAlt1);
;// ./react/ui/icon/icons/solid/menu-alt-2.svg
var solid_menu_alt_2_path;
function solid_menu_alt_2_extends() { solid_menu_alt_2_extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return solid_menu_alt_2_extends.apply(this, arguments); }

var menu_alt_2_SvgMenuAlt2 = function SvgMenuAlt2(props) {
  return /*#__PURE__*/react.createElement("svg", solid_menu_alt_2_extends({
    xmlns: "http://www.w3.org/2000/svg",
    fill: "currentColor",
    viewBox: "0 0 20 20"
  }, props), solid_menu_alt_2_path || (solid_menu_alt_2_path = /*#__PURE__*/react.createElement("path", {
    fillRule: "evenodd",
    d: "M3 5a1 1 0 0 1 1-1h12a1 1 0 1 1 0 2H4a1 1 0 0 1-1-1m0 5a1 1 0 0 1 1-1h12a1 1 0 1 1 0 2H4a1 1 0 0 1-1-1m0 5a1 1 0 0 1 1-1h6a1 1 0 1 1 0 2H4a1 1 0 0 1-1-1",
    clipRule: "evenodd"
  })));
};
/* harmony default export */ const solid_menu_alt_2 = (menu_alt_2_SvgMenuAlt2);
;// ./react/ui/icon/icons/solid/menu-alt-3.svg
var solid_menu_alt_3_path;
function solid_menu_alt_3_extends() { solid_menu_alt_3_extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return solid_menu_alt_3_extends.apply(this, arguments); }

var menu_alt_3_SvgMenuAlt3 = function SvgMenuAlt3(props) {
  return /*#__PURE__*/react.createElement("svg", solid_menu_alt_3_extends({
    xmlns: "http://www.w3.org/2000/svg",
    fill: "currentColor",
    viewBox: "0 0 20 20"
  }, props), solid_menu_alt_3_path || (solid_menu_alt_3_path = /*#__PURE__*/react.createElement("path", {
    fillRule: "evenodd",
    d: "M3 5a1 1 0 0 1 1-1h12a1 1 0 1 1 0 2H4a1 1 0 0 1-1-1m0 5a1 1 0 0 1 1-1h12a1 1 0 1 1 0 2H4a1 1 0 0 1-1-1m6 5a1 1 0 0 1 1-1h6a1 1 0 1 1 0 2h-6a1 1 0 0 1-1-1",
    clipRule: "evenodd"
  })));
};
/* harmony default export */ const solid_menu_alt_3 = (menu_alt_3_SvgMenuAlt3);
;// ./react/ui/icon/icons/solid/menu-alt-4.svg
var solid_menu_alt_4_path;
function solid_menu_alt_4_extends() { solid_menu_alt_4_extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return solid_menu_alt_4_extends.apply(this, arguments); }

var menu_alt_4_SvgMenuAlt4 = function SvgMenuAlt4(props) {
  return /*#__PURE__*/react.createElement("svg", solid_menu_alt_4_extends({
    xmlns: "http://www.w3.org/2000/svg",
    fill: "currentColor",
    viewBox: "0 0 20 20"
  }, props), solid_menu_alt_4_path || (solid_menu_alt_4_path = /*#__PURE__*/react.createElement("path", {
    fillRule: "evenodd",
    d: "M3 7a1 1 0 0 1 1-1h12a1 1 0 1 1 0 2H4a1 1 0 0 1-1-1m0 6a1 1 0 0 1 1-1h12a1 1 0 1 1 0 2H4a1 1 0 0 1-1-1",
    clipRule: "evenodd"
  })));
};
/* harmony default export */ const solid_menu_alt_4 = (menu_alt_4_SvgMenuAlt4);
;// ./react/ui/icon/icons/solid/menu.svg
var solid_menu_path;
function solid_menu_extends() { solid_menu_extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return solid_menu_extends.apply(this, arguments); }

var menu_SvgMenu = function SvgMenu(props) {
  return /*#__PURE__*/react.createElement("svg", solid_menu_extends({
    xmlns: "http://www.w3.org/2000/svg",
    fill: "currentColor",
    viewBox: "0 0 20 20"
  }, props), solid_menu_path || (solid_menu_path = /*#__PURE__*/react.createElement("path", {
    fillRule: "evenodd",
    d: "M3 5a1 1 0 0 1 1-1h12a1 1 0 1 1 0 2H4a1 1 0 0 1-1-1m0 5a1 1 0 0 1 1-1h12a1 1 0 1 1 0 2H4a1 1 0 0 1-1-1m0 5a1 1 0 0 1 1-1h12a1 1 0 1 1 0 2H4a1 1 0 0 1-1-1",
    clipRule: "evenodd"
  })));
};
/* harmony default export */ const solid_menu = (menu_SvgMenu);
;// ./react/ui/icon/icons/solid/microphone.svg
var solid_microphone_path;
function solid_microphone_extends() { solid_microphone_extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return solid_microphone_extends.apply(this, arguments); }

var microphone_SvgMicrophone = function SvgMicrophone(props) {
  return /*#__PURE__*/react.createElement("svg", solid_microphone_extends({
    xmlns: "http://www.w3.org/2000/svg",
    fill: "currentColor",
    viewBox: "0 0 20 20"
  }, props), solid_microphone_path || (solid_microphone_path = /*#__PURE__*/react.createElement("path", {
    fillRule: "evenodd",
    d: "M7 4a3 3 0 0 1 6 0v4a3 3 0 1 1-6 0zm4 10.93A7 7 0 0 0 17 8a1 1 0 1 0-2 0A5 5 0 0 1 5 8a1 1 0 0 0-2 0 7 7 0 0 0 6 6.93V17H6a1 1 0 1 0 0 2h8a1 1 0 1 0 0-2h-3z",
    clipRule: "evenodd"
  })));
};
/* harmony default export */ const solid_microphone = (microphone_SvgMicrophone);
;// ./react/ui/icon/icons/solid/minus-circle.svg
var solid_minus_circle_path;
function solid_minus_circle_extends() { solid_minus_circle_extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return solid_minus_circle_extends.apply(this, arguments); }

var minus_circle_SvgMinusCircle = function SvgMinusCircle(props) {
  return /*#__PURE__*/react.createElement("svg", solid_minus_circle_extends({
    xmlns: "http://www.w3.org/2000/svg",
    fill: "currentColor",
    viewBox: "0 0 20 20"
  }, props), solid_minus_circle_path || (solid_minus_circle_path = /*#__PURE__*/react.createElement("path", {
    fillRule: "evenodd",
    d: "M10 18a8 8 0 1 0 0-16 8 8 0 0 0 0 16M7 9a1 1 0 0 0 0 2h6a1 1 0 1 0 0-2z",
    clipRule: "evenodd"
  })));
};
/* harmony default export */ const solid_minus_circle = (minus_circle_SvgMinusCircle);
;// ./react/ui/icon/icons/solid/minus-sm.svg
var solid_minus_sm_path;
function solid_minus_sm_extends() { solid_minus_sm_extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return solid_minus_sm_extends.apply(this, arguments); }

var minus_sm_SvgMinusSm = function SvgMinusSm(props) {
  return /*#__PURE__*/react.createElement("svg", solid_minus_sm_extends({
    xmlns: "http://www.w3.org/2000/svg",
    fill: "currentColor",
    viewBox: "0 0 20 20"
  }, props), solid_minus_sm_path || (solid_minus_sm_path = /*#__PURE__*/react.createElement("path", {
    fillRule: "evenodd",
    d: "M5 10a1 1 0 0 1 1-1h8a1 1 0 1 1 0 2H6a1 1 0 0 1-1-1",
    clipRule: "evenodd"
  })));
};
/* harmony default export */ const solid_minus_sm = (minus_sm_SvgMinusSm);
;// ./react/ui/icon/icons/solid/minus.svg
var solid_minus_path;
function solid_minus_extends() { solid_minus_extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return solid_minus_extends.apply(this, arguments); }

var minus_SvgMinus = function SvgMinus(props) {
  return /*#__PURE__*/react.createElement("svg", solid_minus_extends({
    xmlns: "http://www.w3.org/2000/svg",
    fill: "currentColor",
    viewBox: "0 0 20 20"
  }, props), solid_minus_path || (solid_minus_path = /*#__PURE__*/react.createElement("path", {
    fillRule: "evenodd",
    d: "M3 10a1 1 0 0 1 1-1h12a1 1 0 1 1 0 2H4a1 1 0 0 1-1-1",
    clipRule: "evenodd"
  })));
};
/* harmony default export */ const solid_minus = (minus_SvgMinus);
;// ./react/ui/icon/icons/solid/moon.svg
var solid_moon_path;
function solid_moon_extends() { solid_moon_extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return solid_moon_extends.apply(this, arguments); }

var moon_SvgMoon = function SvgMoon(props) {
  return /*#__PURE__*/react.createElement("svg", solid_moon_extends({
    xmlns: "http://www.w3.org/2000/svg",
    fill: "currentColor",
    viewBox: "0 0 20 20"
  }, props), solid_moon_path || (solid_moon_path = /*#__PURE__*/react.createElement("path", {
    d: "M17.293 13.293A8 8 0 0 1 6.707 2.707a8.001 8.001 0 1 0 10.586 10.586"
  })));
};
/* harmony default export */ const solid_moon = (moon_SvgMoon);
;// ./react/ui/icon/icons/solid/music-note.svg
var solid_music_note_path;
function solid_music_note_extends() { solid_music_note_extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return solid_music_note_extends.apply(this, arguments); }

var music_note_SvgMusicNote = function SvgMusicNote(props) {
  return /*#__PURE__*/react.createElement("svg", solid_music_note_extends({
    xmlns: "http://www.w3.org/2000/svg",
    fill: "currentColor",
    viewBox: "0 0 20 20"
  }, props), solid_music_note_path || (solid_music_note_path = /*#__PURE__*/react.createElement("path", {
    d: "M18 3a1 1 0 0 0-1.196-.98l-10 2A1 1 0 0 0 6 5v9.114A4.4 4.4 0 0 0 5 14c-1.657 0-3 .895-3 2s1.343 2 3 2 3-.895 3-2V7.82l8-1.6v5.894A4.4 4.4 0 0 0 15 12c-1.657 0-3 .895-3 2s1.343 2 3 2 3-.895 3-2z"
  })));
};
/* harmony default export */ const solid_music_note = (music_note_SvgMusicNote);
;// ./react/ui/icon/icons/solid/newspaper.svg
var solid_newspaper_path, newspaper_path2;
function solid_newspaper_extends() { solid_newspaper_extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return solid_newspaper_extends.apply(this, arguments); }

var newspaper_SvgNewspaper = function SvgNewspaper(props) {
  return /*#__PURE__*/react.createElement("svg", solid_newspaper_extends({
    xmlns: "http://www.w3.org/2000/svg",
    fill: "currentColor",
    viewBox: "0 0 20 20"
  }, props), solid_newspaper_path || (solid_newspaper_path = /*#__PURE__*/react.createElement("path", {
    fillRule: "evenodd",
    d: "M2 5a2 2 0 0 1 2-2h8a2 2 0 0 1 2 2v10a2 2 0 0 0 2 2H4a2 2 0 0 1-2-2zm3 1h6v4H5zm6 6H5v2h6z",
    clipRule: "evenodd"
  })), newspaper_path2 || (newspaper_path2 = /*#__PURE__*/react.createElement("path", {
    d: "M15 7h1a2 2 0 0 1 2 2v5.5a1.5 1.5 0 0 1-3 0z"
  })));
};
/* harmony default export */ const solid_newspaper = (newspaper_SvgNewspaper);
;// ./react/ui/icon/icons/solid/no-symbol.svg
var solid_no_symbol_path;
function solid_no_symbol_extends() { solid_no_symbol_extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return solid_no_symbol_extends.apply(this, arguments); }

var no_symbol_SvgNoSymbol = function SvgNoSymbol(props) {
  return /*#__PURE__*/react.createElement("svg", solid_no_symbol_extends({
    xmlns: "http://www.w3.org/2000/svg",
    fill: "currentColor",
    className: "no-symbol_svg__size-6",
    viewBox: "0 0 24 24"
  }, props), solid_no_symbol_path || (solid_no_symbol_path = /*#__PURE__*/react.createElement("path", {
    fillRule: "evenodd",
    d: "m6.72 5.66 11.62 11.62A8.25 8.25 0 0 0 6.72 5.66m10.56 12.68L5.66 6.72a8.25 8.25 0 0 0 11.62 11.62M5.105 5.106c3.807-3.808 9.98-3.808 13.788 0s3.808 9.98 0 13.788-9.98 3.808-13.788 0-3.808-9.98 0-13.788",
    clipRule: "evenodd"
  })));
};
/* harmony default export */ const solid_no_symbol = (no_symbol_SvgNoSymbol);
;// ./react/ui/icon/icons/solid/office-building.svg
var solid_office_building_path;
function solid_office_building_extends() { solid_office_building_extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return solid_office_building_extends.apply(this, arguments); }

var office_building_SvgOfficeBuilding = function SvgOfficeBuilding(props) {
  return /*#__PURE__*/react.createElement("svg", solid_office_building_extends({
    xmlns: "http://www.w3.org/2000/svg",
    fill: "currentColor",
    viewBox: "0 0 20 20"
  }, props), solid_office_building_path || (solid_office_building_path = /*#__PURE__*/react.createElement("path", {
    fillRule: "evenodd",
    d: "M4 4a2 2 0 0 1 2-2h8a2 2 0 0 1 2 2v12a1 1 0 1 1 0 2h-3a1 1 0 0 1-1-1v-2a1 1 0 0 0-1-1H9a1 1 0 0 0-1 1v2a1 1 0 0 1-1 1H4a1 1 0 1 1 0-2zm3 1h2v2H7zm2 4H7v2h2zm2-4h2v2h-2zm2 4h-2v2h2z",
    clipRule: "evenodd"
  })));
};
/* harmony default export */ const solid_office_building = (office_building_SvgOfficeBuilding);
;// ./react/ui/icon/icons/solid/paper-airplane.svg
var solid_paper_airplane_path;
function solid_paper_airplane_extends() { solid_paper_airplane_extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return solid_paper_airplane_extends.apply(this, arguments); }

var paper_airplane_SvgPaperAirplane = function SvgPaperAirplane(props) {
  return /*#__PURE__*/react.createElement("svg", solid_paper_airplane_extends({
    xmlns: "http://www.w3.org/2000/svg",
    fill: "currentColor",
    viewBox: "0 0 20 20"
  }, props), solid_paper_airplane_path || (solid_paper_airplane_path = /*#__PURE__*/react.createElement("path", {
    d: "M10.894 2.553a1 1 0 0 0-1.788 0l-7 14a1 1 0 0 0 1.169 1.409l5-1.429A1 1 0 0 0 9 15.571V11a1 1 0 1 1 2 0v4.571a1 1 0 0 0 .725.962l5 1.428a1 1 0 0 0 1.17-1.408l-7-14z"
  })));
};
/* harmony default export */ const solid_paper_airplane = (paper_airplane_SvgPaperAirplane);
;// ./react/ui/icon/icons/solid/paper-clip.svg
var solid_paper_clip_path;
function solid_paper_clip_extends() { solid_paper_clip_extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return solid_paper_clip_extends.apply(this, arguments); }

var paper_clip_SvgPaperClip = function SvgPaperClip(props) {
  return /*#__PURE__*/react.createElement("svg", solid_paper_clip_extends({
    xmlns: "http://www.w3.org/2000/svg",
    fill: "currentColor",
    viewBox: "0 0 20 20"
  }, props), solid_paper_clip_path || (solid_paper_clip_path = /*#__PURE__*/react.createElement("path", {
    fillRule: "evenodd",
    d: "M8 4a3 3 0 0 0-3 3v4a5 5 0 0 0 10 0V7a1 1 0 1 1 2 0v4a7 7 0 1 1-14 0V7a5 5 0 0 1 10 0v4a3 3 0 1 1-6 0V7a1 1 0 0 1 2 0v4a1 1 0 1 0 2 0V7a3 3 0 0 0-3-3",
    clipRule: "evenodd"
  })));
};
/* harmony default export */ const solid_paper_clip = (paper_clip_SvgPaperClip);
;// ./react/ui/icon/icons/solid/pause.svg
var solid_pause_path;
function solid_pause_extends() { solid_pause_extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return solid_pause_extends.apply(this, arguments); }

var pause_SvgPause = function SvgPause(props) {
  return /*#__PURE__*/react.createElement("svg", solid_pause_extends({
    xmlns: "http://www.w3.org/2000/svg",
    fill: "currentColor",
    viewBox: "0 0 20 20"
  }, props), solid_pause_path || (solid_pause_path = /*#__PURE__*/react.createElement("path", {
    fillRule: "evenodd",
    d: "M18 10a8 8 0 1 1-16 0 8 8 0 0 1 16 0M7 8a1 1 0 0 1 2 0v4a1 1 0 1 1-2 0zm5-1a1 1 0 0 0-1 1v4a1 1 0 1 0 2 0V8a1 1 0 0 0-1-1",
    clipRule: "evenodd"
  })));
};
/* harmony default export */ const solid_pause = (pause_SvgPause);
;// ./react/ui/icon/icons/solid/pencil-alt.svg
var solid_pencil_alt_path, pencil_alt_path2;
function solid_pencil_alt_extends() { solid_pencil_alt_extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return solid_pencil_alt_extends.apply(this, arguments); }

var pencil_alt_SvgPencilAlt = function SvgPencilAlt(props) {
  return /*#__PURE__*/react.createElement("svg", solid_pencil_alt_extends({
    xmlns: "http://www.w3.org/2000/svg",
    fill: "currentColor",
    viewBox: "0 0 20 20"
  }, props), solid_pencil_alt_path || (solid_pencil_alt_path = /*#__PURE__*/react.createElement("path", {
    d: "M17.414 2.586a2 2 0 0 0-2.828 0L7 10.172V13h2.828l7.586-7.586a2 2 0 0 0 0-2.828"
  })), pencil_alt_path2 || (pencil_alt_path2 = /*#__PURE__*/react.createElement("path", {
    fillRule: "evenodd",
    d: "M2 6a2 2 0 0 1 2-2h4a1 1 0 0 1 0 2H4v10h10v-4a1 1 0 1 1 2 0v4a2 2 0 0 1-2 2H4a2 2 0 0 1-2-2z",
    clipRule: "evenodd"
  })));
};
/* harmony default export */ const solid_pencil_alt = (pencil_alt_SvgPencilAlt);
;// ./react/ui/icon/icons/solid/pencil.svg
var solid_pencil_path;
function solid_pencil_extends() { solid_pencil_extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return solid_pencil_extends.apply(this, arguments); }

var pencil_SvgPencil = function SvgPencil(props) {
  return /*#__PURE__*/react.createElement("svg", solid_pencil_extends({
    xmlns: "http://www.w3.org/2000/svg",
    fill: "currentColor",
    viewBox: "0 0 20 20"
  }, props), solid_pencil_path || (solid_pencil_path = /*#__PURE__*/react.createElement("path", {
    d: "M13.586 3.586a2 2 0 1 1 2.828 2.828l-.793.793-2.828-2.828zm-2.207 2.207L3 14.172V17h2.828l8.38-8.379z"
  })));
};
/* harmony default export */ const solid_pencil = (pencil_SvgPencil);
;// ./react/ui/icon/icons/solid/phone-incoming.svg
var solid_phone_incoming_path, phone_incoming_path2;
function solid_phone_incoming_extends() { solid_phone_incoming_extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return solid_phone_incoming_extends.apply(this, arguments); }

var phone_incoming_SvgPhoneIncoming = function SvgPhoneIncoming(props) {
  return /*#__PURE__*/react.createElement("svg", solid_phone_incoming_extends({
    xmlns: "http://www.w3.org/2000/svg",
    fill: "currentColor",
    viewBox: "0 0 20 20"
  }, props), solid_phone_incoming_path || (solid_phone_incoming_path = /*#__PURE__*/react.createElement("path", {
    d: "m14.414 7 3.293-3.293a1 1 0 0 0-1.414-1.414L13 5.586V4a1 1 0 1 0-2 0v4.003a1 1 0 0 0 .617.921A1 1 0 0 0 12 9h4a1 1 0 1 0 0-2z"
  })), phone_incoming_path2 || (phone_incoming_path2 = /*#__PURE__*/react.createElement("path", {
    d: "M2 3a1 1 0 0 1 1-1h2.153a1 1 0 0 1 .986.836l.74 4.435a1 1 0 0 1-.54 1.06l-1.548.773a11.04 11.04 0 0 0 6.105 6.105l.774-1.548a1 1 0 0 1 1.059-.54l4.435.74a1 1 0 0 1 .836.986V17a1 1 0 0 1-1 1h-2C7.82 18 2 12.18 2 5z"
  })));
};
/* harmony default export */ const solid_phone_incoming = (phone_incoming_SvgPhoneIncoming);
;// ./react/ui/icon/icons/solid/phone-missed-call.svg
var solid_phone_missed_call_path, phone_missed_call_path2;
function solid_phone_missed_call_extends() { solid_phone_missed_call_extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return solid_phone_missed_call_extends.apply(this, arguments); }

var phone_missed_call_SvgPhoneMissedCall = function SvgPhoneMissedCall(props) {
  return /*#__PURE__*/react.createElement("svg", solid_phone_missed_call_extends({
    xmlns: "http://www.w3.org/2000/svg",
    fill: "currentColor",
    viewBox: "0 0 20 20"
  }, props), solid_phone_missed_call_path || (solid_phone_missed_call_path = /*#__PURE__*/react.createElement("path", {
    d: "M2 3a1 1 0 0 1 1-1h2.153a1 1 0 0 1 .986.836l.74 4.435a1 1 0 0 1-.54 1.06l-1.548.773a11.04 11.04 0 0 0 6.105 6.105l.774-1.548a1 1 0 0 1 1.059-.54l4.435.74a1 1 0 0 1 .836.986V17a1 1 0 0 1-1 1h-2C7.82 18 2 12.18 2 5z"
  })), phone_missed_call_path2 || (phone_missed_call_path2 = /*#__PURE__*/react.createElement("path", {
    d: "M16.707 3.293a1 1 0 0 1 0 1.414L15.414 6l1.293 1.293a1 1 0 0 1-1.414 1.414L14 7.414l-1.293 1.293a1 1 0 1 1-1.414-1.414L12.586 6l-1.293-1.293a1 1 0 0 1 1.414-1.414L14 4.586l1.293-1.293a1 1 0 0 1 1.414 0"
  })));
};
/* harmony default export */ const solid_phone_missed_call = (phone_missed_call_SvgPhoneMissedCall);
;// ./react/ui/icon/icons/solid/phone-outgoing.svg
var solid_phone_outgoing_path, phone_outgoing_path2;
function solid_phone_outgoing_extends() { solid_phone_outgoing_extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return solid_phone_outgoing_extends.apply(this, arguments); }

var phone_outgoing_SvgPhoneOutgoing = function SvgPhoneOutgoing(props) {
  return /*#__PURE__*/react.createElement("svg", solid_phone_outgoing_extends({
    xmlns: "http://www.w3.org/2000/svg",
    fill: "currentColor",
    viewBox: "0 0 20 20"
  }, props), solid_phone_outgoing_path || (solid_phone_outgoing_path = /*#__PURE__*/react.createElement("path", {
    d: "M17.924 2.617a1 1 0 0 0-.215-.322l-.004-.004A1 1 0 0 0 17 2h-4a1 1 0 1 0 0 2h1.586l-3.293 3.293a1 1 0 0 0 1.414 1.414L16 5.414V7a1 1 0 1 0 2 0V3a1 1 0 0 0-.076-.383"
  })), phone_outgoing_path2 || (phone_outgoing_path2 = /*#__PURE__*/react.createElement("path", {
    d: "M2 3a1 1 0 0 1 1-1h2.153a1 1 0 0 1 .986.836l.74 4.435a1 1 0 0 1-.54 1.06l-1.548.773a11.04 11.04 0 0 0 6.105 6.105l.774-1.548a1 1 0 0 1 1.059-.54l4.435.74a1 1 0 0 1 .836.986V17a1 1 0 0 1-1 1h-2C7.82 18 2 12.18 2 5z"
  })));
};
/* harmony default export */ const solid_phone_outgoing = (phone_outgoing_SvgPhoneOutgoing);
;// ./react/ui/icon/icons/solid/phone.svg
var solid_phone_path;
function solid_phone_extends() { solid_phone_extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return solid_phone_extends.apply(this, arguments); }

var phone_SvgPhone = function SvgPhone(props) {
  return /*#__PURE__*/react.createElement("svg", solid_phone_extends({
    xmlns: "http://www.w3.org/2000/svg",
    fill: "currentColor",
    viewBox: "0 0 20 20"
  }, props), solid_phone_path || (solid_phone_path = /*#__PURE__*/react.createElement("path", {
    d: "M2 3a1 1 0 0 1 1-1h2.153a1 1 0 0 1 .986.836l.74 4.435a1 1 0 0 1-.54 1.06l-1.548.773a11.04 11.04 0 0 0 6.105 6.105l.774-1.548a1 1 0 0 1 1.059-.54l4.435.74a1 1 0 0 1 .836.986V17a1 1 0 0 1-1 1h-2C7.82 18 2 12.18 2 5z"
  })));
};
/* harmony default export */ const solid_phone = (phone_SvgPhone);
;// ./react/ui/icon/icons/solid/photograph.svg
var solid_photograph_path;
function solid_photograph_extends() { solid_photograph_extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return solid_photograph_extends.apply(this, arguments); }

var photograph_SvgPhotograph = function SvgPhotograph(props) {
  return /*#__PURE__*/react.createElement("svg", solid_photograph_extends({
    xmlns: "http://www.w3.org/2000/svg",
    fill: "currentColor",
    viewBox: "0 0 20 20"
  }, props), solid_photograph_path || (solid_photograph_path = /*#__PURE__*/react.createElement("path", {
    fillRule: "evenodd",
    d: "M4 3a2 2 0 0 0-2 2v10a2 2 0 0 0 2 2h12a2 2 0 0 0 2-2V5a2 2 0 0 0-2-2zm12 12H4l4-8 3 6 2-4z",
    clipRule: "evenodd"
  })));
};
/* harmony default export */ const solid_photograph = (photograph_SvgPhotograph);
;// ./react/ui/icon/icons/solid/play.svg
var solid_play_path;
function solid_play_extends() { solid_play_extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return solid_play_extends.apply(this, arguments); }

var play_SvgPlay = function SvgPlay(props) {
  return /*#__PURE__*/react.createElement("svg", solid_play_extends({
    xmlns: "http://www.w3.org/2000/svg",
    fill: "currentColor",
    viewBox: "0 0 20 20"
  }, props), solid_play_path || (solid_play_path = /*#__PURE__*/react.createElement("path", {
    fillRule: "evenodd",
    d: "M10 18a8 8 0 1 0 0-16 8 8 0 0 0 0 16M9.555 7.168A1 1 0 0 0 8 8v4a1 1 0 0 0 1.555.832l3-2a1 1 0 0 0 0-1.664z",
    clipRule: "evenodd"
  })));
};
/* harmony default export */ const solid_play = (play_SvgPlay);
;// ./react/ui/icon/icons/solid/plus-circle.svg
var solid_plus_circle_path;
function solid_plus_circle_extends() { solid_plus_circle_extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return solid_plus_circle_extends.apply(this, arguments); }

var plus_circle_SvgPlusCircle = function SvgPlusCircle(props) {
  return /*#__PURE__*/react.createElement("svg", solid_plus_circle_extends({
    xmlns: "http://www.w3.org/2000/svg",
    fill: "currentColor",
    viewBox: "0 0 20 20"
  }, props), solid_plus_circle_path || (solid_plus_circle_path = /*#__PURE__*/react.createElement("path", {
    fillRule: "evenodd",
    d: "M10 18a8 8 0 1 0 0-16 8 8 0 0 0 0 16m1-11a1 1 0 1 0-2 0v2H7a1 1 0 1 0 0 2h2v2a1 1 0 1 0 2 0v-2h2a1 1 0 1 0 0-2h-2z",
    clipRule: "evenodd"
  })));
};
/* harmony default export */ const solid_plus_circle = (plus_circle_SvgPlusCircle);
;// ./react/ui/icon/icons/solid/plus-sm.svg
var solid_plus_sm_path;
function solid_plus_sm_extends() { solid_plus_sm_extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return solid_plus_sm_extends.apply(this, arguments); }

var plus_sm_SvgPlusSm = function SvgPlusSm(props) {
  return /*#__PURE__*/react.createElement("svg", solid_plus_sm_extends({
    xmlns: "http://www.w3.org/2000/svg",
    fill: "currentColor",
    viewBox: "0 0 20 20"
  }, props), solid_plus_sm_path || (solid_plus_sm_path = /*#__PURE__*/react.createElement("path", {
    fillRule: "evenodd",
    d: "M10 5a1 1 0 0 1 1 1v3h3a1 1 0 1 1 0 2h-3v3a1 1 0 1 1-2 0v-3H6a1 1 0 1 1 0-2h3V6a1 1 0 0 1 1-1",
    clipRule: "evenodd"
  })));
};
/* harmony default export */ const solid_plus_sm = (plus_sm_SvgPlusSm);
;// ./react/ui/icon/icons/solid/plus.svg
var solid_plus_path;
function solid_plus_extends() { solid_plus_extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return solid_plus_extends.apply(this, arguments); }

var plus_SvgPlus = function SvgPlus(props) {
  return /*#__PURE__*/react.createElement("svg", solid_plus_extends({
    xmlns: "http://www.w3.org/2000/svg",
    fill: "currentColor",
    viewBox: "0 0 20 20"
  }, props), solid_plus_path || (solid_plus_path = /*#__PURE__*/react.createElement("path", {
    fillRule: "evenodd",
    d: "M10 5a1 1 0 0 1 1 1v3h3a1 1 0 1 1 0 2h-3v3a1 1 0 1 1-2 0v-3H6a1 1 0 1 1 0-2h3V6a1 1 0 0 1 1-1",
    clipRule: "evenodd"
  })));
};
/* harmony default export */ const solid_plus = (plus_SvgPlus);
;// ./react/ui/icon/icons/solid/presentation-chart-bar.svg
var solid_presentation_chart_bar_path;
function solid_presentation_chart_bar_extends() { solid_presentation_chart_bar_extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return solid_presentation_chart_bar_extends.apply(this, arguments); }

var presentation_chart_bar_SvgPresentationChartBar = function SvgPresentationChartBar(props) {
  return /*#__PURE__*/react.createElement("svg", solid_presentation_chart_bar_extends({
    xmlns: "http://www.w3.org/2000/svg",
    fill: "currentColor",
    viewBox: "0 0 20 20"
  }, props), solid_presentation_chart_bar_path || (solid_presentation_chart_bar_path = /*#__PURE__*/react.createElement("path", {
    fillRule: "evenodd",
    d: "M3 3a1 1 0 0 0 0 2v8a2 2 0 0 0 2 2h2.586l-1.293 1.293a1 1 0 1 0 1.414 1.414L10 15.414l2.293 2.293a1 1 0 0 0 1.414-1.414L12.414 15H15a2 2 0 0 0 2-2V5a1 1 0 1 0 0-2zm11 4a1 1 0 1 0-2 0v4a1 1 0 1 0 2 0zm-3 1a1 1 0 1 0-2 0v3a1 1 0 1 0 2 0zM8 9a1 1 0 0 0-2 0v2a1 1 0 1 0 2 0z",
    clipRule: "evenodd"
  })));
};
/* harmony default export */ const solid_presentation_chart_bar = (presentation_chart_bar_SvgPresentationChartBar);
;// ./react/ui/icon/icons/solid/presentation-chart-line.svg
var solid_presentation_chart_line_path;
function solid_presentation_chart_line_extends() { solid_presentation_chart_line_extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return solid_presentation_chart_line_extends.apply(this, arguments); }

var presentation_chart_line_SvgPresentationChartLine = function SvgPresentationChartLine(props) {
  return /*#__PURE__*/react.createElement("svg", solid_presentation_chart_line_extends({
    xmlns: "http://www.w3.org/2000/svg",
    fill: "currentColor",
    viewBox: "0 0 20 20"
  }, props), solid_presentation_chart_line_path || (solid_presentation_chart_line_path = /*#__PURE__*/react.createElement("path", {
    fillRule: "evenodd",
    d: "M3 3a1 1 0 0 0 0 2v8a2 2 0 0 0 2 2h2.586l-1.293 1.293a1 1 0 1 0 1.414 1.414L10 15.414l2.293 2.293a1 1 0 0 0 1.414-1.414L12.414 15H15a2 2 0 0 0 2-2V5a1 1 0 1 0 0-2zm11.707 4.707a1 1 0 0 0-1.414-1.414L10 9.586 8.707 8.293a1 1 0 0 0-1.414 0l-2 2a1 1 0 1 0 1.414 1.414L8 10.414l1.293 1.293a1 1 0 0 0 1.414 0z",
    clipRule: "evenodd"
  })));
};
/* harmony default export */ const solid_presentation_chart_line = (presentation_chart_line_SvgPresentationChartLine);
;// ./react/ui/icon/icons/solid/printer.svg
var solid_printer_path;
function solid_printer_extends() { solid_printer_extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return solid_printer_extends.apply(this, arguments); }

var printer_SvgPrinter = function SvgPrinter(props) {
  return /*#__PURE__*/react.createElement("svg", solid_printer_extends({
    xmlns: "http://www.w3.org/2000/svg",
    fill: "currentColor",
    viewBox: "0 0 20 20"
  }, props), solid_printer_path || (solid_printer_path = /*#__PURE__*/react.createElement("path", {
    fillRule: "evenodd",
    d: "M5 4v3H4a2 2 0 0 0-2 2v3a2 2 0 0 0 2 2h1v2a2 2 0 0 0 2 2h6a2 2 0 0 0 2-2v-2h1a2 2 0 0 0 2-2V9a2 2 0 0 0-2-2h-1V4a2 2 0 0 0-2-2H7a2 2 0 0 0-2 2m8 0H7v3h6zm0 8H7v4h6z",
    clipRule: "evenodd"
  })));
};
/* harmony default export */ const solid_printer = (printer_SvgPrinter);
;// ./react/ui/icon/icons/solid/puzzle.svg
var solid_puzzle_path;
function solid_puzzle_extends() { solid_puzzle_extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return solid_puzzle_extends.apply(this, arguments); }

var puzzle_SvgPuzzle = function SvgPuzzle(props) {
  return /*#__PURE__*/react.createElement("svg", solid_puzzle_extends({
    xmlns: "http://www.w3.org/2000/svg",
    fill: "currentColor",
    viewBox: "0 0 20 20"
  }, props), solid_puzzle_path || (solid_puzzle_path = /*#__PURE__*/react.createElement("path", {
    d: "M10 3.5a1.5 1.5 0 0 1 3 0V4a1 1 0 0 0 1 1h3a1 1 0 0 1 1 1v3a1 1 0 0 1-1 1h-.5a1.5 1.5 0 0 0 0 3h.5a1 1 0 0 1 1 1v3a1 1 0 0 1-1 1h-3a1 1 0 0 1-1-1v-.5a1.5 1.5 0 0 0-3 0v.5a1 1 0 0 1-1 1H6a1 1 0 0 1-1-1v-3a1 1 0 0 0-1-1h-.5a1.5 1.5 0 0 1 0-3H4a1 1 0 0 0 1-1V6a1 1 0 0 1 1-1h3a1 1 0 0 0 1-1z"
  })));
};
/* harmony default export */ const solid_puzzle = (puzzle_SvgPuzzle);
;// ./react/ui/icon/icons/solid/qrcode.svg
var solid_qrcode_path, qrcode_path2;
function solid_qrcode_extends() { solid_qrcode_extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return solid_qrcode_extends.apply(this, arguments); }

var qrcode_SvgQrcode = function SvgQrcode(props) {
  return /*#__PURE__*/react.createElement("svg", solid_qrcode_extends({
    xmlns: "http://www.w3.org/2000/svg",
    fill: "currentColor",
    viewBox: "0 0 20 20"
  }, props), solid_qrcode_path || (solid_qrcode_path = /*#__PURE__*/react.createElement("path", {
    fillRule: "evenodd",
    d: "M3 4a1 1 0 0 1 1-1h3a1 1 0 0 1 1 1v3a1 1 0 0 1-1 1H4a1 1 0 0 1-1-1zm2 2V5h1v1zm-2 7a1 1 0 0 1 1-1h3a1 1 0 0 1 1 1v3a1 1 0 0 1-1 1H4a1 1 0 0 1-1-1zm2 2v-1h1v1zm8-12a1 1 0 0 0-1 1v3a1 1 0 0 0 1 1h3a1 1 0 0 0 1-1V4a1 1 0 0 0-1-1zm1 2v1h1V5z",
    clipRule: "evenodd"
  })), qrcode_path2 || (qrcode_path2 = /*#__PURE__*/react.createElement("path", {
    d: "M11 4a1 1 0 1 0-2 0v1a1 1 0 0 0 2 0zm-1 3a1 1 0 0 1 1 1v1h2a1 1 0 1 1 0 2h-3a1 1 0 0 1-1-1V8a1 1 0 0 1 1-1m6 2a1 1 0 1 0 0 2 1 1 0 0 0 0-2m-7 4a1 1 0 0 1 1-1h1a1 1 0 1 1 0 2v2a1 1 0 1 1-2 0zm-2-2a1 1 0 1 0 0-2H4a1 1 0 1 0 0 2zm10 2a1 1 0 0 1-1 1h-2a1 1 0 1 1 0-2h2a1 1 0 0 1 1 1m-1 4a1 1 0 1 0 0-2h-3a1 1 0 1 0 0 2z"
  })));
};
/* harmony default export */ const solid_qrcode = (qrcode_SvgQrcode);
;// ./react/ui/icon/icons/solid/question-mark-circle.svg
var solid_question_mark_circle_path;
function solid_question_mark_circle_extends() { solid_question_mark_circle_extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return solid_question_mark_circle_extends.apply(this, arguments); }

var question_mark_circle_SvgQuestionMarkCircle = function SvgQuestionMarkCircle(props) {
  return /*#__PURE__*/react.createElement("svg", solid_question_mark_circle_extends({
    xmlns: "http://www.w3.org/2000/svg",
    fill: "currentColor",
    viewBox: "0 0 20 20"
  }, props), solid_question_mark_circle_path || (solid_question_mark_circle_path = /*#__PURE__*/react.createElement("path", {
    fillRule: "evenodd",
    d: "M18 10a8 8 0 1 1-16 0 8 8 0 0 1 16 0m-8-3a1 1 0 0 0-.867.5 1 1 0 1 1-1.731-1A3 3 0 0 1 13 8a3 3 0 0 1-2 2.83V11a1 1 0 1 1-2 0v-1a1 1 0 0 1 1-1 1 1 0 1 0 0-2m0 8a1 1 0 1 0 0-2 1 1 0 0 0 0 2",
    clipRule: "evenodd"
  })));
};
/* harmony default export */ const solid_question_mark_circle = (question_mark_circle_SvgQuestionMarkCircle);
;// ./react/ui/icon/icons/solid/receipt-refund.svg
var solid_receipt_refund_path;
function solid_receipt_refund_extends() { solid_receipt_refund_extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return solid_receipt_refund_extends.apply(this, arguments); }

var receipt_refund_SvgReceiptRefund = function SvgReceiptRefund(props) {
  return /*#__PURE__*/react.createElement("svg", solid_receipt_refund_extends({
    xmlns: "http://www.w3.org/2000/svg",
    fill: "currentColor",
    viewBox: "0 0 20 20"
  }, props), solid_receipt_refund_path || (solid_receipt_refund_path = /*#__PURE__*/react.createElement("path", {
    fillRule: "evenodd",
    d: "M5 2a2 2 0 0 0-2 2v14l3.5-2 3.5 2 3.5-2 3.5 2V4a2 2 0 0 0-2-2zm4.707 3.707a1 1 0 0 0-1.414-1.414l-3 3a1 1 0 0 0 0 1.414l3 3a1 1 0 0 0 1.414-1.414L8.414 9H10a3 3 0 0 1 3 3v1a1 1 0 1 0 2 0v-1a5 5 0 0 0-5-5H8.414z",
    clipRule: "evenodd"
  })));
};
/* harmony default export */ const solid_receipt_refund = (receipt_refund_SvgReceiptRefund);
;// ./react/ui/icon/icons/solid/receipt-tax.svg
var solid_receipt_tax_path;
function solid_receipt_tax_extends() { solid_receipt_tax_extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return solid_receipt_tax_extends.apply(this, arguments); }

var receipt_tax_SvgReceiptTax = function SvgReceiptTax(props) {
  return /*#__PURE__*/react.createElement("svg", solid_receipt_tax_extends({
    xmlns: "http://www.w3.org/2000/svg",
    fill: "currentColor",
    viewBox: "0 0 20 20"
  }, props), solid_receipt_tax_path || (solid_receipt_tax_path = /*#__PURE__*/react.createElement("path", {
    fillRule: "evenodd",
    d: "M5 2a2 2 0 0 0-2 2v14l3.5-2 3.5 2 3.5-2 3.5 2V4a2 2 0 0 0-2-2zm2.5 3a1.5 1.5 0 1 0 0 3 1.5 1.5 0 0 0 0-3m6.207.293a1 1 0 0 0-1.414 0l-6 6a1 1 0 1 0 1.414 1.414l6-6a1 1 0 0 0 0-1.414M12.5 10a1.5 1.5 0 1 0 0 3 1.5 1.5 0 0 0 0-3",
    clipRule: "evenodd"
  })));
};
/* harmony default export */ const solid_receipt_tax = (receipt_tax_SvgReceiptTax);
;// ./react/ui/icon/icons/solid/refresh.svg
var solid_refresh_path;
function solid_refresh_extends() { solid_refresh_extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return solid_refresh_extends.apply(this, arguments); }

var refresh_SvgRefresh = function SvgRefresh(props) {
  return /*#__PURE__*/react.createElement("svg", solid_refresh_extends({
    xmlns: "http://www.w3.org/2000/svg",
    fill: "currentColor",
    viewBox: "0 0 20 20"
  }, props), solid_refresh_path || (solid_refresh_path = /*#__PURE__*/react.createElement("path", {
    fillRule: "evenodd",
    d: "M4 2a1 1 0 0 1 1 1v2.101a7.002 7.002 0 0 1 11.601 2.566 1 1 0 1 1-1.885.666A5.002 5.002 0 0 0 5.999 7H9a1 1 0 0 1 0 2H4a1 1 0 0 1-1-1V3a1 1 0 0 1 1-1m.008 9.057a1 1 0 0 1 1.276.61A5.002 5.002 0 0 0 14.001 13H11a1 1 0 1 1 0-2h5a1 1 0 0 1 1 1v5a1 1 0 1 1-2 0v-2.101a7.002 7.002 0 0 1-11.601-2.566 1 1 0 0 1 .61-1.276z",
    clipRule: "evenodd"
  })));
};
/* harmony default export */ const solid_refresh = (refresh_SvgRefresh);
;// ./react/ui/icon/icons/solid/reply.svg
var solid_reply_path;
function solid_reply_extends() { solid_reply_extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return solid_reply_extends.apply(this, arguments); }

var reply_SvgReply = function SvgReply(props) {
  return /*#__PURE__*/react.createElement("svg", solid_reply_extends({
    xmlns: "http://www.w3.org/2000/svg",
    fill: "currentColor",
    viewBox: "0 0 20 20"
  }, props), solid_reply_path || (solid_reply_path = /*#__PURE__*/react.createElement("path", {
    fillRule: "evenodd",
    d: "M7.707 3.293a1 1 0 0 1 0 1.414L5.414 7H11a7 7 0 0 1 7 7v2a1 1 0 1 1-2 0v-2a5 5 0 0 0-5-5H5.414l2.293 2.293a1 1 0 1 1-1.414 1.414l-4-4a1 1 0 0 1 0-1.414l4-4a1 1 0 0 1 1.414 0",
    clipRule: "evenodd"
  })));
};
/* harmony default export */ const solid_reply = (reply_SvgReply);
;// ./react/ui/icon/icons/solid/rewind.svg
var solid_rewind_path;
function solid_rewind_extends() { solid_rewind_extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return solid_rewind_extends.apply(this, arguments); }

var rewind_SvgRewind = function SvgRewind(props) {
  return /*#__PURE__*/react.createElement("svg", solid_rewind_extends({
    xmlns: "http://www.w3.org/2000/svg",
    fill: "currentColor",
    viewBox: "0 0 20 20"
  }, props), solid_rewind_path || (solid_rewind_path = /*#__PURE__*/react.createElement("path", {
    d: "M8.445 14.832A1 1 0 0 0 10 14v-2.798l5.445 3.63A1 1 0 0 0 17 14V6a1 1 0 0 0-1.555-.832L10 8.798V6a1 1 0 0 0-1.555-.832l-6 4a1 1 0 0 0 0 1.664z"
  })));
};
/* harmony default export */ const solid_rewind = (rewind_SvgRewind);
;// ./react/ui/icon/icons/solid/rss.svg
var solid_rss_path, rss_path2;
function solid_rss_extends() { solid_rss_extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return solid_rss_extends.apply(this, arguments); }

var rss_SvgRss = function SvgRss(props) {
  return /*#__PURE__*/react.createElement("svg", solid_rss_extends({
    xmlns: "http://www.w3.org/2000/svg",
    fill: "currentColor",
    viewBox: "0 0 20 20"
  }, props), solid_rss_path || (solid_rss_path = /*#__PURE__*/react.createElement("path", {
    d: "M5 3a1 1 0 0 0 0 2c5.523 0 10 4.477 10 10a1 1 0 1 0 2 0C17 8.373 11.627 3 5 3"
  })), rss_path2 || (rss_path2 = /*#__PURE__*/react.createElement("path", {
    d: "M4 9a1 1 0 0 1 1-1 7 7 0 0 1 7 7 1 1 0 1 1-2 0 5 5 0 0 0-5-5 1 1 0 0 1-1-1m-1 6a2 2 0 1 1 4 0 2 2 0 0 1-4 0"
  })));
};
/* harmony default export */ const solid_rss = (rss_SvgRss);
;// ./react/ui/icon/icons/solid/save-as.svg
var solid_save_as_path, save_as_path2;
function solid_save_as_extends() { solid_save_as_extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return solid_save_as_extends.apply(this, arguments); }

var save_as_SvgSaveAs = function SvgSaveAs(props) {
  return /*#__PURE__*/react.createElement("svg", solid_save_as_extends({
    xmlns: "http://www.w3.org/2000/svg",
    fill: "currentColor",
    viewBox: "0 0 20 20"
  }, props), solid_save_as_path || (solid_save_as_path = /*#__PURE__*/react.createElement("path", {
    d: "M9.707 7.293a1 1 0 0 0-1.414 1.414l3 3a1 1 0 0 0 1.414 0l3-3a1 1 0 0 0-1.414-1.414L13 8.586V5h3a2 2 0 0 1 2 2v5a2 2 0 0 1-2 2H8a2 2 0 0 1-2-2V7a2 2 0 0 1 2-2h3v3.586zM11 3a1 1 0 1 1 2 0v2h-2z"
  })), save_as_path2 || (save_as_path2 = /*#__PURE__*/react.createElement("path", {
    d: "M4 9a2 2 0 0 0-2 2v5a2 2 0 0 0 2 2h8a2 2 0 0 0 2-2H4z"
  })));
};
/* harmony default export */ const solid_save_as = (save_as_SvgSaveAs);
;// ./react/ui/icon/icons/solid/save.svg
var solid_save_path;
function solid_save_extends() { solid_save_extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return solid_save_extends.apply(this, arguments); }

var save_SvgSave = function SvgSave(props) {
  return /*#__PURE__*/react.createElement("svg", solid_save_extends({
    xmlns: "http://www.w3.org/2000/svg",
    fill: "currentColor",
    viewBox: "0 0 20 20"
  }, props), solid_save_path || (solid_save_path = /*#__PURE__*/react.createElement("path", {
    d: "M7.707 10.293a1 1 0 1 0-1.414 1.414l3 3a1 1 0 0 0 1.414 0l3-3a1 1 0 0 0-1.414-1.414L11 11.586V6h5a2 2 0 0 1 2 2v7a2 2 0 0 1-2 2H4a2 2 0 0 1-2-2V8a2 2 0 0 1 2-2h5v5.586zM9 4a1 1 0 0 1 2 0v2H9z"
  })));
};
/* harmony default export */ const solid_save = (save_SvgSave);
;// ./react/ui/icon/icons/solid/scale.svg
var solid_scale_path;
function solid_scale_extends() { solid_scale_extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return solid_scale_extends.apply(this, arguments); }

var scale_SvgScale = function SvgScale(props) {
  return /*#__PURE__*/react.createElement("svg", solid_scale_extends({
    xmlns: "http://www.w3.org/2000/svg",
    fill: "currentColor",
    viewBox: "0 0 20 20"
  }, props), solid_scale_path || (solid_scale_path = /*#__PURE__*/react.createElement("path", {
    fillRule: "evenodd",
    d: "M10 2a1 1 0 0 1 1 1v1.323l3.954 1.582 1.599-.8a1 1 0 0 1 .894 1.79l-1.233.616 1.738 5.42a1 1 0 0 1-.285 1.05A4 4 0 0 1 15 15a4 4 0 0 1-2.667-1.019 1 1 0 0 1-.285-1.05l1.715-5.349L11 6.477V16h2a1 1 0 1 1 0 2H7a1 1 0 1 1 0-2h2V6.477L6.237 7.582l1.715 5.349a1 1 0 0 1-.285 1.05A4 4 0 0 1 5 15a4 4 0 0 1-2.667-1.019 1 1 0 0 1-.285-1.05l1.738-5.42-1.233-.617a1 1 0 0 1 .894-1.788l1.599.799L9 4.323V3a1 1 0 0 1 1-1m-5 8.274-.818 2.552c.25.112.526.174.818.174s.569-.062.818-.174zm10 0-.818 2.552c.25.112.526.174.818.174s.569-.062.818-.174z",
    clipRule: "evenodd"
  })));
};
/* harmony default export */ const solid_scale = (scale_SvgScale);
;// ./react/ui/icon/icons/solid/scissors.svg
var solid_scissors_path, scissors_path2;
function solid_scissors_extends() { solid_scissors_extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return solid_scissors_extends.apply(this, arguments); }

var scissors_SvgScissors = function SvgScissors(props) {
  return /*#__PURE__*/react.createElement("svg", solid_scissors_extends({
    xmlns: "http://www.w3.org/2000/svg",
    fill: "currentColor",
    viewBox: "0 0 20 20"
  }, props), solid_scissors_path || (solid_scissors_path = /*#__PURE__*/react.createElement("path", {
    fillRule: "evenodd",
    d: "M5.5 2a3.5 3.5 0 1 0 1.665 6.58L8.585 10l-1.42 1.42a3.5 3.5 0 1 0 1.414 1.414l8.128-8.127a1 1 0 0 0-1.414-1.414L10 8.586l-1.42-1.42A3.5 3.5 0 0 0 5.5 2M4 5.5a1.5 1.5 0 1 1 3 0 1.5 1.5 0 0 1-3 0m0 9a1.5 1.5 0 1 1 3 0 1.5 1.5 0 0 1-3 0",
    clipRule: "evenodd"
  })), scissors_path2 || (scissors_path2 = /*#__PURE__*/react.createElement("path", {
    d: "M12.828 11.414a1 1 0 0 0-1.414 1.414l3.879 3.88a1 1 0 0 0 1.414-1.415z"
  })));
};
/* harmony default export */ const solid_scissors = (scissors_SvgScissors);
;// ./react/ui/icon/icons/solid/search-circle.svg
var solid_search_circle_path, search_circle_path2;
function solid_search_circle_extends() { solid_search_circle_extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return solid_search_circle_extends.apply(this, arguments); }

var search_circle_SvgSearchCircle = function SvgSearchCircle(props) {
  return /*#__PURE__*/react.createElement("svg", solid_search_circle_extends({
    xmlns: "http://www.w3.org/2000/svg",
    fill: "currentColor",
    viewBox: "0 0 20 20"
  }, props), solid_search_circle_path || (solid_search_circle_path = /*#__PURE__*/react.createElement("path", {
    d: "M9 9a2 2 0 1 1 4 0 2 2 0 0 1-4 0"
  })), search_circle_path2 || (search_circle_path2 = /*#__PURE__*/react.createElement("path", {
    fillRule: "evenodd",
    d: "M10 18a8 8 0 1 0 0-16 8 8 0 0 0 0 16m1-13a4 4 0 0 0-3.446 6.032l-2.261 2.26a1 1 0 1 0 1.414 1.415l2.261-2.261A4 4 0 1 0 11 5",
    clipRule: "evenodd"
  })));
};
/* harmony default export */ const solid_search_circle = (search_circle_SvgSearchCircle);
;// ./react/ui/icon/icons/solid/search.svg
var solid_search_path;
function solid_search_extends() { solid_search_extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return solid_search_extends.apply(this, arguments); }

var search_SvgSearch = function SvgSearch(props) {
  return /*#__PURE__*/react.createElement("svg", solid_search_extends({
    xmlns: "http://www.w3.org/2000/svg",
    fill: "currentColor",
    viewBox: "0 0 20 20"
  }, props), solid_search_path || (solid_search_path = /*#__PURE__*/react.createElement("path", {
    fillRule: "evenodd",
    d: "M8 4a4 4 0 1 0 0 8 4 4 0 0 0 0-8M2 8a6 6 0 1 1 10.89 3.476l4.817 4.817a1 1 0 0 1-1.414 1.414l-4.816-4.816A6 6 0 0 1 2 8",
    clipRule: "evenodd"
  })));
};
/* harmony default export */ const solid_search = (search_SvgSearch);
;// ./react/ui/icon/icons/solid/selector.svg
var solid_selector_path;
function solid_selector_extends() { solid_selector_extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return solid_selector_extends.apply(this, arguments); }

var selector_SvgSelector = function SvgSelector(props) {
  return /*#__PURE__*/react.createElement("svg", solid_selector_extends({
    xmlns: "http://www.w3.org/2000/svg",
    fill: "currentColor",
    viewBox: "0 0 20 20"
  }, props), solid_selector_path || (solid_selector_path = /*#__PURE__*/react.createElement("path", {
    fillRule: "evenodd",
    d: "M10 3a1 1 0 0 1 .707.293l3 3a1 1 0 0 1-1.414 1.414L10 5.414 7.707 7.707a1 1 0 0 1-1.414-1.414l3-3A1 1 0 0 1 10 3m-3.707 9.293a1 1 0 0 1 1.414 0L10 14.586l2.293-2.293a1 1 0 0 1 1.414 1.414l-3 3a1 1 0 0 1-1.414 0l-3-3a1 1 0 0 1 0-1.414",
    clipRule: "evenodd"
  })));
};
/* harmony default export */ const solid_selector = (selector_SvgSelector);
;// ./react/ui/icon/icons/solid/server.svg
var solid_server_path;
function solid_server_extends() { solid_server_extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return solid_server_extends.apply(this, arguments); }

var server_SvgServer = function SvgServer(props) {
  return /*#__PURE__*/react.createElement("svg", solid_server_extends({
    xmlns: "http://www.w3.org/2000/svg",
    fill: "currentColor",
    viewBox: "0 0 20 20"
  }, props), solid_server_path || (solid_server_path = /*#__PURE__*/react.createElement("path", {
    fillRule: "evenodd",
    d: "M2 5a2 2 0 0 1 2-2h12a2 2 0 0 1 2 2v2a2 2 0 0 1-2 2H4a2 2 0 0 1-2-2zm14 1a1 1 0 1 1-2 0 1 1 0 0 1 2 0M2 13a2 2 0 0 1 2-2h12a2 2 0 0 1 2 2v2a2 2 0 0 1-2 2H4a2 2 0 0 1-2-2zm14 1a1 1 0 1 1-2 0 1 1 0 0 1 2 0",
    clipRule: "evenodd"
  })));
};
/* harmony default export */ const solid_server = (server_SvgServer);
;// ./react/ui/icon/icons/solid/share.svg
var solid_share_path;
function solid_share_extends() { solid_share_extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return solid_share_extends.apply(this, arguments); }

var share_SvgShare = function SvgShare(props) {
  return /*#__PURE__*/react.createElement("svg", solid_share_extends({
    xmlns: "http://www.w3.org/2000/svg",
    fill: "currentColor",
    viewBox: "0 0 20 20"
  }, props), solid_share_path || (solid_share_path = /*#__PURE__*/react.createElement("path", {
    d: "M15 8a3 3 0 1 0-2.977-2.63l-4.94 2.47a3 3 0 1 0 0 4.319l4.94 2.47a3 3 0 1 0 .895-1.789l-4.94-2.47a3 3 0 0 0 0-.74l4.94-2.47C13.456 7.68 14.19 8 15 8"
  })));
};
/* harmony default export */ const solid_share = (share_SvgShare);
;// ./react/ui/icon/icons/solid/shield-check.svg
var solid_shield_check_path;
function solid_shield_check_extends() { solid_shield_check_extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return solid_shield_check_extends.apply(this, arguments); }

var shield_check_SvgShieldCheck = function SvgShieldCheck(props) {
  return /*#__PURE__*/react.createElement("svg", solid_shield_check_extends({
    xmlns: "http://www.w3.org/2000/svg",
    fill: "currentColor",
    viewBox: "0 0 20 20"
  }, props), solid_shield_check_path || (solid_shield_check_path = /*#__PURE__*/react.createElement("path", {
    fillRule: "evenodd",
    d: "M2.166 4.999A11.95 11.95 0 0 0 10 1.944 11.95 11.95 0 0 0 17.834 5c.11.65.166 1.32.166 2.001 0 5.225-3.34 9.67-8 11.317C5.34 16.67 2 12.225 2 7q.001-1.024.166-2.001m11.541 3.708a1 1 0 0 0-1.414-1.414L9 10.586 7.707 9.293a1 1 0 0 0-1.414 1.414l2 2a1 1 0 0 0 1.414 0z",
    clipRule: "evenodd"
  })));
};
/* harmony default export */ const solid_shield_check = (shield_check_SvgShieldCheck);
;// ./react/ui/icon/icons/solid/shield-exclamation.svg
var solid_shield_exclamation_path;
function solid_shield_exclamation_extends() { solid_shield_exclamation_extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return solid_shield_exclamation_extends.apply(this, arguments); }

var shield_exclamation_SvgShieldExclamation = function SvgShieldExclamation(props) {
  return /*#__PURE__*/react.createElement("svg", solid_shield_exclamation_extends({
    xmlns: "http://www.w3.org/2000/svg",
    fill: "currentColor",
    viewBox: "0 0 20 20"
  }, props), solid_shield_exclamation_path || (solid_shield_exclamation_path = /*#__PURE__*/react.createElement("path", {
    fillRule: "evenodd",
    d: "M10 1.944A11.95 11.95 0 0 1 2.166 5C2.056 5.649 2 6.319 2 7c0 5.225 3.34 9.67 8 11.317C14.66 16.67 18 12.225 18 7q-.001-1.024-.166-2.001A11.95 11.95 0 0 1 10 1.944M11 14a1 1 0 1 1-2 0 1 1 0 0 1 2 0m0-7a1 1 0 1 0-2 0v3a1 1 0 1 0 2 0z",
    clipRule: "evenodd"
  })));
};
/* harmony default export */ const solid_shield_exclamation = (shield_exclamation_SvgShieldExclamation);
;// ./react/ui/icon/icons/solid/shopping-bag.svg
var solid_shopping_bag_path;
function solid_shopping_bag_extends() { solid_shopping_bag_extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return solid_shopping_bag_extends.apply(this, arguments); }

var shopping_bag_SvgShoppingBag = function SvgShoppingBag(props) {
  return /*#__PURE__*/react.createElement("svg", solid_shopping_bag_extends({
    xmlns: "http://www.w3.org/2000/svg",
    fill: "currentColor",
    viewBox: "0 0 20 20"
  }, props), solid_shopping_bag_path || (solid_shopping_bag_path = /*#__PURE__*/react.createElement("path", {
    fillRule: "evenodd",
    d: "M10 2a4 4 0 0 0-4 4v1H5a1 1 0 0 0-.994.89l-1 9A1 1 0 0 0 4 18h12a1 1 0 0 0 .994-1.11l-1-9A1 1 0 0 0 15 7h-1V6a4 4 0 0 0-4-4m2 5V6a2 2 0 1 0-4 0v1zm-6 3a1 1 0 1 1 2 0 1 1 0 0 1-2 0m7-1a1 1 0 1 0 0 2 1 1 0 0 0 0-2",
    clipRule: "evenodd"
  })));
};
/* harmony default export */ const solid_shopping_bag = (shopping_bag_SvgShoppingBag);
;// ./react/ui/icon/icons/solid/shopping-cart.svg
var solid_shopping_cart_path;
function solid_shopping_cart_extends() { solid_shopping_cart_extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return solid_shopping_cart_extends.apply(this, arguments); }

var shopping_cart_SvgShoppingCart = function SvgShoppingCart(props) {
  return /*#__PURE__*/react.createElement("svg", solid_shopping_cart_extends({
    xmlns: "http://www.w3.org/2000/svg",
    fill: "currentColor",
    viewBox: "0 0 20 20"
  }, props), solid_shopping_cart_path || (solid_shopping_cart_path = /*#__PURE__*/react.createElement("path", {
    d: "M3 1a1 1 0 0 0 0 2h1.22l.305 1.222.01.042 1.358 5.43-.893.892C3.74 11.846 4.632 14 6.414 14H15a1 1 0 0 0 0-2H6.414l1-1H14a1 1 0 0 0 .894-.553l3-6A1 1 0 0 0 17 3H6.28l-.31-1.243A1 1 0 0 0 5 1zm13 15.5a1.5 1.5 0 1 1-3 0 1.5 1.5 0 0 1 3 0M6.5 18a1.5 1.5 0 1 0 0-3 1.5 1.5 0 0 0 0 3"
  })));
};
/* harmony default export */ const solid_shopping_cart = (shopping_cart_SvgShoppingCart);
;// ./react/ui/icon/icons/solid/sort-ascending.svg
var solid_sort_ascending_path;
function solid_sort_ascending_extends() { solid_sort_ascending_extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return solid_sort_ascending_extends.apply(this, arguments); }

var sort_ascending_SvgSortAscending = function SvgSortAscending(props) {
  return /*#__PURE__*/react.createElement("svg", solid_sort_ascending_extends({
    xmlns: "http://www.w3.org/2000/svg",
    fill: "currentColor",
    viewBox: "0 0 20 20"
  }, props), solid_sort_ascending_path || (solid_sort_ascending_path = /*#__PURE__*/react.createElement("path", {
    d: "M3 3a1 1 0 0 0 0 2h11a1 1 0 1 0 0-2zm0 4a1 1 0 0 0 0 2h5a1 1 0 0 0 0-2zm0 4a1 1 0 1 0 0 2h4a1 1 0 1 0 0-2zm10 5a1 1 0 1 0 2 0v-5.586l1.293 1.293a1 1 0 0 0 1.414-1.414l-3-3a1 1 0 0 0-1.414 0l-3 3a1 1 0 1 0 1.414 1.414L13 10.414z"
  })));
};
/* harmony default export */ const solid_sort_ascending = (sort_ascending_SvgSortAscending);
;// ./react/ui/icon/icons/solid/sort-descending.svg
var solid_sort_descending_path;
function solid_sort_descending_extends() { solid_sort_descending_extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return solid_sort_descending_extends.apply(this, arguments); }

var sort_descending_SvgSortDescending = function SvgSortDescending(props) {
  return /*#__PURE__*/react.createElement("svg", solid_sort_descending_extends({
    xmlns: "http://www.w3.org/2000/svg",
    fill: "currentColor",
    viewBox: "0 0 20 20"
  }, props), solid_sort_descending_path || (solid_sort_descending_path = /*#__PURE__*/react.createElement("path", {
    d: "M3 3a1 1 0 0 0 0 2h11a1 1 0 1 0 0-2zm0 4a1 1 0 0 0 0 2h7a1 1 0 1 0 0-2zm0 4a1 1 0 1 0 0 2h4a1 1 0 1 0 0-2zm12-3a1 1 0 1 0-2 0v5.586l-1.293-1.293a1 1 0 0 0-1.414 1.414l3 3a1 1 0 0 0 1.414 0l3-3a1 1 0 0 0-1.414-1.414L15 13.586z"
  })));
};
/* harmony default export */ const solid_sort_descending = (sort_descending_SvgSortDescending);
;// ./react/ui/icon/icons/solid/sparkles.svg
var solid_sparkles_path;
function solid_sparkles_extends() { solid_sparkles_extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return solid_sparkles_extends.apply(this, arguments); }

var sparkles_SvgSparkles = function SvgSparkles(props) {
  return /*#__PURE__*/react.createElement("svg", solid_sparkles_extends({
    xmlns: "http://www.w3.org/2000/svg",
    fill: "currentColor",
    viewBox: "0 0 20 20"
  }, props), solid_sparkles_path || (solid_sparkles_path = /*#__PURE__*/react.createElement("path", {
    fillRule: "evenodd",
    d: "M5 2a1 1 0 0 1 1 1v1h1a1 1 0 0 1 0 2H6v1a1 1 0 0 1-2 0V6H3a1 1 0 0 1 0-2h1V3a1 1 0 0 1 1-1m0 10a1 1 0 0 1 1 1v1h1a1 1 0 1 1 0 2H6v1a1 1 0 1 1-2 0v-1H3a1 1 0 1 1 0-2h1v-1a1 1 0 0 1 1-1m7-10a1 1 0 0 1 .967.744L14.146 7.2 17.5 9.134a1 1 0 0 1 0 1.732l-3.354 1.935-1.18 4.455a1 1 0 0 1-1.933 0L9.854 12.8 6.5 10.866a1 1 0 0 1 0-1.732l3.354-1.935 1.18-4.455A1 1 0 0 1 12 2",
    clipRule: "evenodd"
  })));
};
/* harmony default export */ const solid_sparkles = (sparkles_SvgSparkles);
;// ./react/ui/icon/icons/solid/speakerphone.svg
var solid_speakerphone_path;
function solid_speakerphone_extends() { solid_speakerphone_extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return solid_speakerphone_extends.apply(this, arguments); }

var speakerphone_SvgSpeakerphone = function SvgSpeakerphone(props) {
  return /*#__PURE__*/react.createElement("svg", solid_speakerphone_extends({
    xmlns: "http://www.w3.org/2000/svg",
    fill: "currentColor",
    viewBox: "0 0 20 20"
  }, props), solid_speakerphone_path || (solid_speakerphone_path = /*#__PURE__*/react.createElement("path", {
    fillRule: "evenodd",
    d: "M18 3a1 1 0 0 0-1.447-.894L8.763 6H5a3 3 0 0 0 0 6h.28l1.771 5.316A1 1 0 0 0 8 18h1a1 1 0 0 0 1-1v-4.382l6.553 3.276A1 1 0 0 0 18 15z",
    clipRule: "evenodd"
  })));
};
/* harmony default export */ const solid_speakerphone = (speakerphone_SvgSpeakerphone);
;// ./react/ui/icon/icons/solid/star.svg
var solid_star_path;
function solid_star_extends() { solid_star_extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return solid_star_extends.apply(this, arguments); }

var star_SvgStar = function SvgStar(props) {
  return /*#__PURE__*/react.createElement("svg", solid_star_extends({
    xmlns: "http://www.w3.org/2000/svg",
    fill: "currentColor",
    viewBox: "0 0 20 20"
  }, props), solid_star_path || (solid_star_path = /*#__PURE__*/react.createElement("path", {
    d: "M9.049 2.927c.3-.921 1.603-.921 1.902 0l1.07 3.292a1 1 0 0 0 .95.69h3.462c.969 0 1.371 1.24.588 1.81l-2.8 2.034a1 1 0 0 0-.364 1.118l1.07 3.292c.3.921-.755 1.688-1.54 1.118l-2.8-2.034a1 1 0 0 0-1.175 0l-2.8 2.034c-.784.57-1.838-.197-1.539-1.118l1.07-3.292a1 1 0 0 0-.364-1.118L2.98 8.72c-.783-.57-.38-1.81.588-1.81h3.461a1 1 0 0 0 .951-.69l1.07-3.292z"
  })));
};
/* harmony default export */ const solid_star = (star_SvgStar);
;// ./react/ui/icon/icons/solid/status-offline.svg
var solid_status_offline_path;
function solid_status_offline_extends() { solid_status_offline_extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return solid_status_offline_extends.apply(this, arguments); }

var status_offline_SvgStatusOffline = function SvgStatusOffline(props) {
  return /*#__PURE__*/react.createElement("svg", solid_status_offline_extends({
    xmlns: "http://www.w3.org/2000/svg",
    fill: "currentColor",
    viewBox: "0 0 20 20"
  }, props), solid_status_offline_path || (solid_status_offline_path = /*#__PURE__*/react.createElement("path", {
    d: "M3.707 2.293a1 1 0 0 0-1.414 1.414l6.921 6.922q.074.093.168.167l6.91 6.911a1 1 0 0 0 1.415-1.414l-.675-.675a9 9 0 0 0-.668-11.982A1 1 0 1 0 14.95 5.05a7 7 0 0 1 .657 9.143l-1.435-1.435a5 5 0 0 0-.636-6.294A1 1 0 0 0 12.12 7.88a3 3 0 0 1 .587 3.415l-1.992-1.992-.018-.018-6.99-6.991zm-.469 5.894a1 1 0 0 0-1.933-.516 9 9 0 0 0 2.331 8.693 1 1 0 0 0 1.414-1.415 7 7 0 0 1-1.812-6.762M7.4 11.5a1 1 0 1 0-1.73 1c.214.371.48.72.795 1.035a1 1 0 0 0 1.414-1.414q-.286-.288-.478-.622z"
  })));
};
/* harmony default export */ const solid_status_offline = (status_offline_SvgStatusOffline);
;// ./react/ui/icon/icons/solid/status-online.svg
var solid_status_online_path;
function solid_status_online_extends() { solid_status_online_extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return solid_status_online_extends.apply(this, arguments); }

var status_online_SvgStatusOnline = function SvgStatusOnline(props) {
  return /*#__PURE__*/react.createElement("svg", solid_status_online_extends({
    xmlns: "http://www.w3.org/2000/svg",
    fill: "currentColor",
    viewBox: "0 0 20 20"
  }, props), solid_status_online_path || (solid_status_online_path = /*#__PURE__*/react.createElement("path", {
    fillRule: "evenodd",
    d: "M5.05 3.636a1 1 0 0 1 0 1.414 7 7 0 0 0 0 9.9 1 1 0 1 1-1.414 1.414 9 9 0 0 1 0-12.728 1 1 0 0 1 1.414 0m9.9 0a1 1 0 0 1 1.414 0 9 9 0 0 1 0 12.728 1 1 0 1 1-1.414-1.414 7 7 0 0 0 0-9.9 1 1 0 0 1 0-1.414M7.879 6.464a1 1 0 0 1 0 1.414 3 3 0 0 0 0 4.243 1 1 0 1 1-1.415 1.414 5 5 0 0 1 0-7.07 1 1 0 0 1 1.415 0zm4.242 0a1 1 0 0 1 1.415 0 5 5 0 0 1 0 7.072 1 1 0 0 1-1.415-1.415 3 3 0 0 0 0-4.242 1 1 0 0 1 0-1.415M10 9a1 1 0 0 1 1 1v.01a1 1 0 1 1-2 0V10a1 1 0 0 1 1-1",
    clipRule: "evenodd"
  })));
};
/* harmony default export */ const solid_status_online = (status_online_SvgStatusOnline);
;// ./react/ui/icon/icons/solid/stop.svg
var solid_stop_path;
function solid_stop_extends() { solid_stop_extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return solid_stop_extends.apply(this, arguments); }

var stop_SvgStop = function SvgStop(props) {
  return /*#__PURE__*/react.createElement("svg", solid_stop_extends({
    xmlns: "http://www.w3.org/2000/svg",
    fill: "currentColor",
    viewBox: "0 0 20 20"
  }, props), solid_stop_path || (solid_stop_path = /*#__PURE__*/react.createElement("path", {
    fillRule: "evenodd",
    d: "M10 18a8 8 0 1 0 0-16 8 8 0 0 0 0 16M8 7a1 1 0 0 0-1 1v4a1 1 0 0 0 1 1h4a1 1 0 0 0 1-1V8a1 1 0 0 0-1-1z",
    clipRule: "evenodd"
  })));
};
/* harmony default export */ const solid_stop = (stop_SvgStop);
;// ./react/ui/icon/icons/solid/sun.svg
var solid_sun_path;
function solid_sun_extends() { solid_sun_extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return solid_sun_extends.apply(this, arguments); }

var sun_SvgSun = function SvgSun(props) {
  return /*#__PURE__*/react.createElement("svg", solid_sun_extends({
    xmlns: "http://www.w3.org/2000/svg",
    fill: "currentColor",
    viewBox: "0 0 20 20"
  }, props), solid_sun_path || (solid_sun_path = /*#__PURE__*/react.createElement("path", {
    fillRule: "evenodd",
    d: "M10 2a1 1 0 0 1 1 1v1a1 1 0 1 1-2 0V3a1 1 0 0 1 1-1m4 8a4 4 0 1 1-8 0 4 4 0 0 1 8 0m-.464 4.95.707.707a1 1 0 0 0 1.414-1.414l-.707-.707a1 1 0 0 0-1.414 1.414m2.12-10.607a1 1 0 0 1 0 1.414l-.706.707a1 1 0 1 1-1.414-1.414l.707-.707a1 1 0 0 1 1.414 0zM17 11a1 1 0 1 0 0-2h-1a1 1 0 1 0 0 2zm-7 4a1 1 0 0 1 1 1v1a1 1 0 1 1-2 0v-1a1 1 0 0 1 1-1M5.05 6.464A1 1 0 1 0 6.465 5.05l-.708-.707a1 1 0 0 0-1.414 1.414zm1.414 8.486-.707.707a1 1 0 0 1-1.414-1.414l.707-.707a1 1 0 0 1 1.414 1.414M4 11a1 1 0 1 0 0-2H3a1 1 0 0 0 0 2z",
    clipRule: "evenodd"
  })));
};
/* harmony default export */ const solid_sun = (sun_SvgSun);
;// ./react/ui/icon/icons/solid/support.svg
var solid_support_path;
function solid_support_extends() { solid_support_extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return solid_support_extends.apply(this, arguments); }

var support_SvgSupport = function SvgSupport(props) {
  return /*#__PURE__*/react.createElement("svg", solid_support_extends({
    xmlns: "http://www.w3.org/2000/svg",
    fill: "currentColor",
    viewBox: "0 0 20 20"
  }, props), solid_support_path || (solid_support_path = /*#__PURE__*/react.createElement("path", {
    fillRule: "evenodd",
    d: "M18 10a8 8 0 1 1-16 0 8 8 0 0 1 16 0m-2 0c0 .993-.241 1.929-.668 2.754l-1.524-1.525a4 4 0 0 0 .078-2.183l1.562-1.562C15.802 8.249 16 9.1 16 10m-5.165 3.913 1.58 1.58A6 6 0 0 1 10 16a6 6 0 0 1-2.516-.552l1.562-1.562a4 4 0 0 0 1.789.027m-4.677-2.796a4 4 0 0 1-.041-2.08l-.08.08-1.53-1.533A6 6 0 0 0 4 10c0 .954.223 1.856.619 2.657zm1.088-6.45A6 6 0 0 1 10 4c.954 0 1.856.223 2.657.619l-1.54 1.54a4 4 0 0 0-2.346.033L7.246 4.668zM12 10a2 2 0 1 1-4 0 2 2 0 0 1 4 0",
    clipRule: "evenodd"
  })));
};
/* harmony default export */ const solid_support = (support_SvgSupport);
;// ./react/ui/icon/icons/solid/switch-horizontal.svg
var solid_switch_horizontal_path;
function solid_switch_horizontal_extends() { solid_switch_horizontal_extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return solid_switch_horizontal_extends.apply(this, arguments); }

var switch_horizontal_SvgSwitchHorizontal = function SvgSwitchHorizontal(props) {
  return /*#__PURE__*/react.createElement("svg", solid_switch_horizontal_extends({
    xmlns: "http://www.w3.org/2000/svg",
    fill: "currentColor",
    viewBox: "0 0 20 20"
  }, props), solid_switch_horizontal_path || (solid_switch_horizontal_path = /*#__PURE__*/react.createElement("path", {
    d: "M8 5a1 1 0 1 0 0 2h5.586l-1.293 1.293a1 1 0 0 0 1.414 1.414l3-3a1 1 0 0 0 0-1.414l-3-3a1 1 0 1 0-1.414 1.414L13.586 5zm4 10a1 1 0 1 0 0-2H6.414l1.293-1.293a1 1 0 1 0-1.414-1.414l-3 3a1 1 0 0 0 0 1.414l3 3a1 1 0 0 0 1.414-1.414L6.414 15z"
  })));
};
/* harmony default export */ const solid_switch_horizontal = (switch_horizontal_SvgSwitchHorizontal);
;// ./react/ui/icon/icons/solid/switch-vertical.svg
var solid_switch_vertical_path;
function solid_switch_vertical_extends() { solid_switch_vertical_extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return solid_switch_vertical_extends.apply(this, arguments); }

var switch_vertical_SvgSwitchVertical = function SvgSwitchVertical(props) {
  return /*#__PURE__*/react.createElement("svg", solid_switch_vertical_extends({
    xmlns: "http://www.w3.org/2000/svg",
    fill: "currentColor",
    viewBox: "0 0 20 20"
  }, props), solid_switch_vertical_path || (solid_switch_vertical_path = /*#__PURE__*/react.createElement("path", {
    d: "M5 12a1 1 0 1 0 2 0V6.414l1.293 1.293a1 1 0 0 0 1.414-1.414l-3-3a1 1 0 0 0-1.414 0l-3 3a1 1 0 0 0 1.414 1.414L5 6.414zm10-4a1 1 0 1 0-2 0v5.586l-1.293-1.293a1 1 0 0 0-1.414 1.414l3 3a1 1 0 0 0 1.414 0l3-3a1 1 0 0 0-1.414-1.414L15 13.586z"
  })));
};
/* harmony default export */ const solid_switch_vertical = (switch_vertical_SvgSwitchVertical);
;// ./react/ui/icon/icons/solid/table.svg
var solid_table_path;
function solid_table_extends() { solid_table_extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return solid_table_extends.apply(this, arguments); }

var table_SvgTable = function SvgTable(props) {
  return /*#__PURE__*/react.createElement("svg", solid_table_extends({
    xmlns: "http://www.w3.org/2000/svg",
    fill: "currentColor",
    viewBox: "0 0 20 20"
  }, props), solid_table_path || (solid_table_path = /*#__PURE__*/react.createElement("path", {
    fillRule: "evenodd",
    d: "M5 4a3 3 0 0 0-3 3v6a3 3 0 0 0 3 3h10a3 3 0 0 0 3-3V7a3 3 0 0 0-3-3zm-1 9v-1h5v2H5a1 1 0 0 1-1-1m7 1h4a1 1 0 0 0 1-1v-1h-5zm0-4h5V8h-5zM9 8H4v2h5z",
    clipRule: "evenodd"
  })));
};
/* harmony default export */ const solid_table = (table_SvgTable);
;// ./react/ui/icon/icons/solid/tag.svg
var solid_tag_path;
function solid_tag_extends() { solid_tag_extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return solid_tag_extends.apply(this, arguments); }

var tag_SvgTag = function SvgTag(props) {
  return /*#__PURE__*/react.createElement("svg", solid_tag_extends({
    xmlns: "http://www.w3.org/2000/svg",
    fill: "currentColor",
    viewBox: "0 0 20 20"
  }, props), solid_tag_path || (solid_tag_path = /*#__PURE__*/react.createElement("path", {
    fillRule: "evenodd",
    d: "M17.707 9.293a1 1 0 0 1 0 1.414l-7 7a1 1 0 0 1-1.414 0l-7-7A1 1 0 0 1 2 10V5a3 3 0 0 1 3-3h5c.256 0 .512.098.707.293zM5 6a1 1 0 1 0 0-2 1 1 0 0 0 0 2",
    clipRule: "evenodd"
  })));
};
/* harmony default export */ const solid_tag = (tag_SvgTag);
;// ./react/ui/icon/icons/solid/template.svg
var solid_template_path;
function solid_template_extends() { solid_template_extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return solid_template_extends.apply(this, arguments); }

var template_SvgTemplate = function SvgTemplate(props) {
  return /*#__PURE__*/react.createElement("svg", solid_template_extends({
    xmlns: "http://www.w3.org/2000/svg",
    fill: "currentColor",
    viewBox: "0 0 20 20"
  }, props), solid_template_path || (solid_template_path = /*#__PURE__*/react.createElement("path", {
    d: "M3 4a1 1 0 0 1 1-1h12a1 1 0 0 1 1 1v2a1 1 0 0 1-1 1H4a1 1 0 0 1-1-1zm0 6a1 1 0 0 1 1-1h6a1 1 0 0 1 1 1v6a1 1 0 0 1-1 1H4a1 1 0 0 1-1-1zm11-1a1 1 0 0 0-1 1v6a1 1 0 0 0 1 1h2a1 1 0 0 0 1-1v-6a1 1 0 0 0-1-1z"
  })));
};
/* harmony default export */ const solid_template = (template_SvgTemplate);
;// ./react/ui/icon/icons/solid/terminal.svg
var solid_terminal_path;
function solid_terminal_extends() { solid_terminal_extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return solid_terminal_extends.apply(this, arguments); }

var terminal_SvgTerminal = function SvgTerminal(props) {
  return /*#__PURE__*/react.createElement("svg", solid_terminal_extends({
    xmlns: "http://www.w3.org/2000/svg",
    fill: "currentColor",
    viewBox: "0 0 20 20"
  }, props), solid_terminal_path || (solid_terminal_path = /*#__PURE__*/react.createElement("path", {
    fillRule: "evenodd",
    d: "M2 5a2 2 0 0 1 2-2h12a2 2 0 0 1 2 2v10a2 2 0 0 1-2 2H4a2 2 0 0 1-2-2zm3.293 1.293a1 1 0 0 1 1.414 0l3 3a1 1 0 0 1 0 1.414l-3 3a1 1 0 0 1-1.414-1.414L7.586 10 5.293 7.707a1 1 0 0 1 0-1.414M11 12a1 1 0 1 0 0 2h3a1 1 0 1 0 0-2z",
    clipRule: "evenodd"
  })));
};
/* harmony default export */ const solid_terminal = (terminal_SvgTerminal);
;// ./react/ui/icon/icons/solid/thumb-down.svg
var solid_thumb_down_path;
function solid_thumb_down_extends() { solid_thumb_down_extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return solid_thumb_down_extends.apply(this, arguments); }

var thumb_down_SvgThumbDown = function SvgThumbDown(props) {
  return /*#__PURE__*/react.createElement("svg", solid_thumb_down_extends({
    xmlns: "http://www.w3.org/2000/svg",
    fill: "currentColor",
    viewBox: "0 0 20 20"
  }, props), solid_thumb_down_path || (solid_thumb_down_path = /*#__PURE__*/react.createElement("path", {
    d: "M18 9.5a1.5 1.5 0 1 1-3 0v-6a1.5 1.5 0 0 1 3 0zm-4 .167v-5.43a2 2 0 0 0-1.105-1.79l-.05-.025A4 4 0 0 0 11.055 2H5.64a2 2 0 0 0-1.962 1.608l-1.2 6A2 2 0 0 0 4.44 12H8v4a2 2 0 0 0 2 2 1 1 0 0 0 1-1v-.667a4 4 0 0 1 .8-2.4l1.4-1.866a4 4 0 0 0 .8-2.4"
  })));
};
/* harmony default export */ const solid_thumb_down = (thumb_down_SvgThumbDown);
;// ./react/ui/icon/icons/solid/thumb-up.svg
var solid_thumb_up_path;
function solid_thumb_up_extends() { solid_thumb_up_extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return solid_thumb_up_extends.apply(this, arguments); }

var thumb_up_SvgThumbUp = function SvgThumbUp(props) {
  return /*#__PURE__*/react.createElement("svg", solid_thumb_up_extends({
    xmlns: "http://www.w3.org/2000/svg",
    fill: "currentColor",
    viewBox: "0 0 20 20"
  }, props), solid_thumb_up_path || (solid_thumb_up_path = /*#__PURE__*/react.createElement("path", {
    d: "M2 10.5a1.5 1.5 0 1 1 3 0v6a1.5 1.5 0 0 1-3 0zm4-.167v5.43a2 2 0 0 0 1.106 1.79l.05.025A4 4 0 0 0 8.943 18h5.416a2 2 0 0 0 1.962-1.608l1.2-6A2 2 0 0 0 15.56 8H12V4a2 2 0 0 0-2-2 1 1 0 0 0-1 1v.667a4 4 0 0 1-.8 2.4L6.8 7.933a4 4 0 0 0-.8 2.4"
  })));
};
/* harmony default export */ const solid_thumb_up = (thumb_up_SvgThumbUp);
;// ./react/ui/icon/icons/solid/ticket.svg
var solid_ticket_path;
function solid_ticket_extends() { solid_ticket_extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return solid_ticket_extends.apply(this, arguments); }

var ticket_SvgTicket = function SvgTicket(props) {
  return /*#__PURE__*/react.createElement("svg", solid_ticket_extends({
    xmlns: "http://www.w3.org/2000/svg",
    fill: "currentColor",
    viewBox: "0 0 20 20"
  }, props), solid_ticket_path || (solid_ticket_path = /*#__PURE__*/react.createElement("path", {
    d: "M2 6a2 2 0 0 1 2-2h12a2 2 0 0 1 2 2v2a2 2 0 1 0 0 4v2a2 2 0 0 1-2 2H4a2 2 0 0 1-2-2v-2a2 2 0 1 0 0-4z"
  })));
};
/* harmony default export */ const solid_ticket = (ticket_SvgTicket);
;// ./react/ui/icon/icons/solid/translate.svg
var solid_translate_path;
function solid_translate_extends() { solid_translate_extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return solid_translate_extends.apply(this, arguments); }

var translate_SvgTranslate = function SvgTranslate(props) {
  return /*#__PURE__*/react.createElement("svg", solid_translate_extends({
    xmlns: "http://www.w3.org/2000/svg",
    fill: "currentColor",
    viewBox: "0 0 20 20"
  }, props), solid_translate_path || (solid_translate_path = /*#__PURE__*/react.createElement("path", {
    fillRule: "evenodd",
    d: "M7 2a1 1 0 0 1 1 1v1h3a1 1 0 1 1 0 2H9.578a18.9 18.9 0 0 1-1.724 4.78q.436.531.914 1.026a1 1 0 1 1-1.44 1.389 21 21 0 0 1-.554-.6 19 19 0 0 1-3.107 3.567 1 1 0 0 1-1.334-1.49 17 17 0 0 0 3.13-3.733 19 19 0 0 1-1.487-2.494 1 1 0 1 1 1.79-.89q.351.705.764 1.372c.417-.934.752-1.913.997-2.927H3a1 1 0 1 1 0-2h3V3a1 1 0 0 1 1-1m6 6a1 1 0 0 1 .894.553l2.991 5.982.02.037.99 1.98a1 1 0 1 1-1.79.895L15.383 16h-4.764l-.724 1.447a1 1 0 1 1-1.788-.894l.99-1.98.019-.038 2.99-5.982A1 1 0 0 1 13 8m-1.382 6h2.764L13 11.236z",
    clipRule: "evenodd"
  })));
};
/* harmony default export */ const solid_translate = (translate_SvgTranslate);
;// ./react/ui/icon/icons/solid/trash.svg
var solid_trash_path;
function solid_trash_extends() { solid_trash_extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return solid_trash_extends.apply(this, arguments); }

var trash_SvgTrash = function SvgTrash(props) {
  return /*#__PURE__*/react.createElement("svg", solid_trash_extends({
    xmlns: "http://www.w3.org/2000/svg",
    fill: "currentColor",
    viewBox: "0 0 20 20"
  }, props), solid_trash_path || (solid_trash_path = /*#__PURE__*/react.createElement("path", {
    fillRule: "evenodd",
    d: "M9 2a1 1 0 0 0-.894.553L7.382 4H4a1 1 0 0 0 0 2v10a2 2 0 0 0 2 2h8a2 2 0 0 0 2-2V6a1 1 0 1 0 0-2h-3.382l-.724-1.447A1 1 0 0 0 11 2zM7 8a1 1 0 0 1 2 0v6a1 1 0 1 1-2 0zm5-1a1 1 0 0 0-1 1v6a1 1 0 1 0 2 0V8a1 1 0 0 0-1-1",
    clipRule: "evenodd"
  })));
};
/* harmony default export */ const solid_trash = (trash_SvgTrash);
;// ./react/ui/icon/icons/solid/trending-down.svg
var solid_trending_down_path;
function solid_trending_down_extends() { solid_trending_down_extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return solid_trending_down_extends.apply(this, arguments); }

var trending_down_SvgTrendingDown = function SvgTrendingDown(props) {
  return /*#__PURE__*/react.createElement("svg", solid_trending_down_extends({
    xmlns: "http://www.w3.org/2000/svg",
    fill: "currentColor",
    viewBox: "0 0 20 20"
  }, props), solid_trending_down_path || (solid_trending_down_path = /*#__PURE__*/react.createElement("path", {
    fillRule: "evenodd",
    d: "M12 13a1 1 0 1 0 0 2h5a1 1 0 0 0 1-1V9a1 1 0 1 0-2 0v2.586l-4.293-4.293a1 1 0 0 0-1.414 0L8 9.586 3.707 5.293a1 1 0 0 0-1.414 1.414l5 5a1 1 0 0 0 1.414 0L11 9.414 14.586 13z",
    clipRule: "evenodd"
  })));
};
/* harmony default export */ const solid_trending_down = (trending_down_SvgTrendingDown);
;// ./react/ui/icon/icons/solid/trending-up.svg
var solid_trending_up_path;
function solid_trending_up_extends() { solid_trending_up_extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return solid_trending_up_extends.apply(this, arguments); }

var trending_up_SvgTrendingUp = function SvgTrendingUp(props) {
  return /*#__PURE__*/react.createElement("svg", solid_trending_up_extends({
    xmlns: "http://www.w3.org/2000/svg",
    fill: "currentColor",
    viewBox: "0 0 20 20"
  }, props), solid_trending_up_path || (solid_trending_up_path = /*#__PURE__*/react.createElement("path", {
    fillRule: "evenodd",
    d: "M12 7a1 1 0 1 1 0-2h5a1 1 0 0 1 1 1v5a1 1 0 1 1-2 0V8.414l-4.293 4.293a1 1 0 0 1-1.414 0L8 10.414l-4.293 4.293a1 1 0 0 1-1.414-1.414l5-5a1 1 0 0 1 1.414 0L11 10.586 14.586 7z",
    clipRule: "evenodd"
  })));
};
/* harmony default export */ const solid_trending_up = (trending_up_SvgTrendingUp);
;// ./react/ui/icon/icons/solid/truck.svg
var solid_truck_path, truck_path2;
function solid_truck_extends() { solid_truck_extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return solid_truck_extends.apply(this, arguments); }

var truck_SvgTruck = function SvgTruck(props) {
  return /*#__PURE__*/react.createElement("svg", solid_truck_extends({
    xmlns: "http://www.w3.org/2000/svg",
    fill: "currentColor",
    viewBox: "0 0 20 20"
  }, props), solid_truck_path || (solid_truck_path = /*#__PURE__*/react.createElement("path", {
    d: "M8 16.5a1.5 1.5 0 1 1-3 0 1.5 1.5 0 0 1 3 0m7 0a1.5 1.5 0 1 1-3 0 1.5 1.5 0 0 1 3 0"
  })), truck_path2 || (truck_path2 = /*#__PURE__*/react.createElement("path", {
    d: "M3 4a1 1 0 0 0-1 1v10a1 1 0 0 0 1 1h1.05a2.5 2.5 0 0 1 4.9 0H10a1 1 0 0 0 1-1V5a1 1 0 0 0-1-1zm11 3a1 1 0 0 0-1 1v6.05A2.5 2.5 0 0 1 15.95 16H17a1 1 0 0 0 1-1v-5a1 1 0 0 0-.293-.707l-2-2A1 1 0 0 0 15 7z"
  })));
};
/* harmony default export */ const solid_truck = (truck_SvgTruck);
;// ./react/ui/icon/icons/solid/upload.svg
var solid_upload_path;
function solid_upload_extends() { solid_upload_extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return solid_upload_extends.apply(this, arguments); }

var upload_SvgUpload = function SvgUpload(props) {
  return /*#__PURE__*/react.createElement("svg", solid_upload_extends({
    xmlns: "http://www.w3.org/2000/svg",
    fill: "currentColor",
    viewBox: "0 0 20 20"
  }, props), solid_upload_path || (solid_upload_path = /*#__PURE__*/react.createElement("path", {
    fillRule: "evenodd",
    d: "M3 17a1 1 0 0 1 1-1h12a1 1 0 1 1 0 2H4a1 1 0 0 1-1-1M6.293 6.707a1 1 0 0 1 0-1.414l3-3a1 1 0 0 1 1.414 0l3 3a1 1 0 0 1-1.414 1.414L11 5.414V13a1 1 0 1 1-2 0V5.414L7.707 6.707a1 1 0 0 1-1.414 0",
    clipRule: "evenodd"
  })));
};
/* harmony default export */ const solid_upload = (upload_SvgUpload);
;// ./react/ui/icon/icons/solid/user-add.svg
var solid_user_add_path;
function solid_user_add_extends() { solid_user_add_extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return solid_user_add_extends.apply(this, arguments); }

var user_add_SvgUserAdd = function SvgUserAdd(props) {
  return /*#__PURE__*/react.createElement("svg", solid_user_add_extends({
    xmlns: "http://www.w3.org/2000/svg",
    fill: "currentColor",
    viewBox: "0 0 20 20"
  }, props), solid_user_add_path || (solid_user_add_path = /*#__PURE__*/react.createElement("path", {
    d: "M8 9a3 3 0 1 0 0-6 3 3 0 0 0 0 6m0 2a6 6 0 0 1 6 6H2a6 6 0 0 1 6-6m8-4a1 1 0 1 0-2 0v1h-1a1 1 0 1 0 0 2h1v1a1 1 0 1 0 2 0v-1h1a1 1 0 1 0 0-2h-1z"
  })));
};
/* harmony default export */ const solid_user_add = (user_add_SvgUserAdd);
;// ./react/ui/icon/icons/solid/user-circle.svg
var solid_user_circle_path;
function solid_user_circle_extends() { solid_user_circle_extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return solid_user_circle_extends.apply(this, arguments); }

var user_circle_SvgUserCircle = function SvgUserCircle(props) {
  return /*#__PURE__*/react.createElement("svg", solid_user_circle_extends({
    xmlns: "http://www.w3.org/2000/svg",
    fill: "currentColor",
    viewBox: "0 0 20 20"
  }, props), solid_user_circle_path || (solid_user_circle_path = /*#__PURE__*/react.createElement("path", {
    fillRule: "evenodd",
    d: "M18 10a8 8 0 1 1-16 0 8 8 0 0 1 16 0m-6-3a2 2 0 1 1-4 0 2 2 0 0 1 4 0m-2 4a5 5 0 0 0-4.546 2.916A5.99 5.99 0 0 0 10 16a5.99 5.99 0 0 0 4.546-2.084A5 5 0 0 0 10 11",
    clipRule: "evenodd"
  })));
};
/* harmony default export */ const solid_user_circle = (user_circle_SvgUserCircle);
;// ./react/ui/icon/icons/solid/user-group.svg
var solid_user_group_path;
function solid_user_group_extends() { solid_user_group_extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return solid_user_group_extends.apply(this, arguments); }

var user_group_SvgUserGroup = function SvgUserGroup(props) {
  return /*#__PURE__*/react.createElement("svg", solid_user_group_extends({
    xmlns: "http://www.w3.org/2000/svg",
    fill: "currentColor",
    viewBox: "0 0 20 20"
  }, props), solid_user_group_path || (solid_user_group_path = /*#__PURE__*/react.createElement("path", {
    d: "M13 6a3 3 0 1 1-6 0 3 3 0 0 1 6 0m5 2a2 2 0 1 1-4 0 2 2 0 0 1 4 0m-4 7a4 4 0 0 0-8 0v3h8zM6 8a2 2 0 1 1-4 0 2 2 0 0 1 4 0m10 10v-3a6 6 0 0 0-.75-2.906A3.005 3.005 0 0 1 19 15v3zM4.75 12.094A6 6 0 0 0 4 15v3H1v-3a3 3 0 0 1 3.75-2.906"
  })));
};
/* harmony default export */ const solid_user_group = (user_group_SvgUserGroup);
;// ./react/ui/icon/icons/solid/user-remove.svg
var solid_user_remove_path;
function solid_user_remove_extends() { solid_user_remove_extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return solid_user_remove_extends.apply(this, arguments); }

var user_remove_SvgUserRemove = function SvgUserRemove(props) {
  return /*#__PURE__*/react.createElement("svg", solid_user_remove_extends({
    xmlns: "http://www.w3.org/2000/svg",
    fill: "currentColor",
    viewBox: "0 0 20 20"
  }, props), solid_user_remove_path || (solid_user_remove_path = /*#__PURE__*/react.createElement("path", {
    d: "M11 6a3 3 0 1 1-6 0 3 3 0 0 1 6 0m3 11a6 6 0 0 0-12 0zm-1-9a1 1 0 1 0 0 2h4a1 1 0 1 0 0-2z"
  })));
};
/* harmony default export */ const solid_user_remove = (user_remove_SvgUserRemove);
;// ./react/ui/icon/icons/solid/user.svg
var solid_user_path;
function solid_user_extends() { solid_user_extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return solid_user_extends.apply(this, arguments); }

var user_SvgUser = function SvgUser(props) {
  return /*#__PURE__*/react.createElement("svg", solid_user_extends({
    xmlns: "http://www.w3.org/2000/svg",
    fill: "currentColor",
    viewBox: "0 0 20 20"
  }, props), solid_user_path || (solid_user_path = /*#__PURE__*/react.createElement("path", {
    fillRule: "evenodd",
    d: "M10 9a3 3 0 1 0 0-6 3 3 0 0 0 0 6m-7 9a7 7 0 1 1 14 0z",
    clipRule: "evenodd"
  })));
};
/* harmony default export */ const solid_user = (user_SvgUser);
;// ./react/ui/icon/icons/solid/users.svg
var solid_users_path;
function solid_users_extends() { solid_users_extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return solid_users_extends.apply(this, arguments); }

var users_SvgUsers = function SvgUsers(props) {
  return /*#__PURE__*/react.createElement("svg", solid_users_extends({
    xmlns: "http://www.w3.org/2000/svg",
    fill: "currentColor",
    viewBox: "0 0 20 20"
  }, props), solid_users_path || (solid_users_path = /*#__PURE__*/react.createElement("path", {
    d: "M9 6a3 3 0 1 1-6 0 3 3 0 0 1 6 0m8 0a3 3 0 1 1-6 0 3 3 0 0 1 6 0m-4.07 11q.07-.49.07-1a6.97 6.97 0 0 0-1.5-4.33A5 5 0 0 1 19 16v1zM6 11a5 5 0 0 1 5 5v1H1v-1a5 5 0 0 1 5-5"
  })));
};
/* harmony default export */ const solid_users = (users_SvgUsers);
;// ./react/ui/icon/icons/solid/variable.svg
var solid_variable_path;
function solid_variable_extends() { solid_variable_extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return solid_variable_extends.apply(this, arguments); }

var variable_SvgVariable = function SvgVariable(props) {
  return /*#__PURE__*/react.createElement("svg", solid_variable_extends({
    xmlns: "http://www.w3.org/2000/svg",
    fill: "currentColor",
    viewBox: "0 0 20 20"
  }, props), solid_variable_path || (solid_variable_path = /*#__PURE__*/react.createElement("path", {
    fillRule: "evenodd",
    d: "M4.649 3.084A1 1 0 0 1 5.163 4.4 13.95 13.95 0 0 0 4 10c0 1.993.416 3.886 1.164 5.6a1 1 0 0 1-1.832.8A15.95 15.95 0 0 1 2 10c0-2.274.475-4.44 1.332-6.4a1 1 0 0 1 1.317-.516M12.96 7a3 3 0 0 0-2.342 1.126l-.328.41-.111-.279A2 2 0 0 0 8.323 7H8a1 1 0 0 0 0 2h.323l.532 1.33-1.035 1.295a1 1 0 0 1-.781.375H7a1 1 0 1 0 0 2h.039a3 3 0 0 0 2.342-1.126l.328-.41.111.279A2 2 0 0 0 11.677 14H12a1 1 0 1 0 0-2h-.323l-.532-1.33 1.035-1.295A1 1 0 0 1 12.961 9H13a1 1 0 1 0 0-2zm1.874-2.6a1 1 0 0 1 1.833-.8A15.95 15.95 0 0 1 18 10c0 2.274-.475 4.44-1.332 6.4a1 1 0 1 1-1.832-.8A13.95 13.95 0 0 0 16 10c0-1.993-.416-3.886-1.165-5.6z",
    clipRule: "evenodd"
  })));
};
/* harmony default export */ const solid_variable = (variable_SvgVariable);
;// ./react/ui/icon/icons/solid/video-camera.svg
var solid_video_camera_path;
function solid_video_camera_extends() { solid_video_camera_extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return solid_video_camera_extends.apply(this, arguments); }

var video_camera_SvgVideoCamera = function SvgVideoCamera(props) {
  return /*#__PURE__*/react.createElement("svg", solid_video_camera_extends({
    xmlns: "http://www.w3.org/2000/svg",
    fill: "currentColor",
    viewBox: "0 0 20 20"
  }, props), solid_video_camera_path || (solid_video_camera_path = /*#__PURE__*/react.createElement("path", {
    d: "M2 6a2 2 0 0 1 2-2h6a2 2 0 0 1 2 2v8a2 2 0 0 1-2 2H4a2 2 0 0 1-2-2zm12.553 1.106A1 1 0 0 0 14 8v4a1 1 0 0 0 .553.894l2 1A1 1 0 0 0 18 13V7a1 1 0 0 0-1.447-.894z"
  })));
};
/* harmony default export */ const solid_video_camera = (video_camera_SvgVideoCamera);
;// ./react/ui/icon/icons/solid/view-boards.svg
var solid_view_boards_path;
function solid_view_boards_extends() { solid_view_boards_extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return solid_view_boards_extends.apply(this, arguments); }

var view_boards_SvgViewBoards = function SvgViewBoards(props) {
  return /*#__PURE__*/react.createElement("svg", solid_view_boards_extends({
    xmlns: "http://www.w3.org/2000/svg",
    fill: "currentColor",
    viewBox: "0 0 20 20"
  }, props), solid_view_boards_path || (solid_view_boards_path = /*#__PURE__*/react.createElement("path", {
    d: "M2 4a1 1 0 0 1 1-1h2a1 1 0 0 1 1 1v12a1 1 0 0 1-1 1H3a1 1 0 0 1-1-1zm6 0a1 1 0 0 1 1-1h2a1 1 0 0 1 1 1v12a1 1 0 0 1-1 1H9a1 1 0 0 1-1-1zm7-1a1 1 0 0 0-1 1v12a1 1 0 0 0 1 1h2a1 1 0 0 0 1-1V4a1 1 0 0 0-1-1z"
  })));
};
/* harmony default export */ const solid_view_boards = (view_boards_SvgViewBoards);
;// ./react/ui/icon/icons/solid/view-grid-add.svg
var solid_view_grid_add_path;
function solid_view_grid_add_extends() { solid_view_grid_add_extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return solid_view_grid_add_extends.apply(this, arguments); }

var view_grid_add_SvgViewGridAdd = function SvgViewGridAdd(props) {
  return /*#__PURE__*/react.createElement("svg", solid_view_grid_add_extends({
    xmlns: "http://www.w3.org/2000/svg",
    fill: "currentColor",
    viewBox: "0 0 20 20"
  }, props), solid_view_grid_add_path || (solid_view_grid_add_path = /*#__PURE__*/react.createElement("path", {
    d: "M5 3a2 2 0 0 0-2 2v2a2 2 0 0 0 2 2h2a2 2 0 0 0 2-2V5a2 2 0 0 0-2-2zm0 8a2 2 0 0 0-2 2v2a2 2 0 0 0 2 2h2a2 2 0 0 0 2-2v-2a2 2 0 0 0-2-2zm6-6a2 2 0 0 1 2-2h2a2 2 0 0 1 2 2v2a2 2 0 0 1-2 2h-2a2 2 0 0 1-2-2zm3 6a1 1 0 0 1 1 1v1h1a1 1 0 1 1 0 2h-1v1a1 1 0 1 1-2 0v-1h-1a1 1 0 1 1 0-2h1v-1a1 1 0 0 1 1-1"
  })));
};
/* harmony default export */ const solid_view_grid_add = (view_grid_add_SvgViewGridAdd);
;// ./react/ui/icon/icons/solid/view-grid.svg
var solid_view_grid_path;
function solid_view_grid_extends() { solid_view_grid_extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return solid_view_grid_extends.apply(this, arguments); }

var view_grid_SvgViewGrid = function SvgViewGrid(props) {
  return /*#__PURE__*/react.createElement("svg", solid_view_grid_extends({
    xmlns: "http://www.w3.org/2000/svg",
    fill: "currentColor",
    viewBox: "0 0 20 20"
  }, props), solid_view_grid_path || (solid_view_grid_path = /*#__PURE__*/react.createElement("path", {
    d: "M5 3a2 2 0 0 0-2 2v2a2 2 0 0 0 2 2h2a2 2 0 0 0 2-2V5a2 2 0 0 0-2-2zm0 8a2 2 0 0 0-2 2v2a2 2 0 0 0 2 2h2a2 2 0 0 0 2-2v-2a2 2 0 0 0-2-2zm6-6a2 2 0 0 1 2-2h2a2 2 0 0 1 2 2v2a2 2 0 0 1-2 2h-2a2 2 0 0 1-2-2zm0 8a2 2 0 0 1 2-2h2a2 2 0 0 1 2 2v2a2 2 0 0 1-2 2h-2a2 2 0 0 1-2-2z"
  })));
};
/* harmony default export */ const solid_view_grid = (view_grid_SvgViewGrid);
;// ./react/ui/icon/icons/solid/view-list.svg
var solid_view_list_path;
function solid_view_list_extends() { solid_view_list_extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return solid_view_list_extends.apply(this, arguments); }

var view_list_SvgViewList = function SvgViewList(props) {
  return /*#__PURE__*/react.createElement("svg", solid_view_list_extends({
    xmlns: "http://www.w3.org/2000/svg",
    fill: "currentColor",
    viewBox: "0 0 20 20"
  }, props), solid_view_list_path || (solid_view_list_path = /*#__PURE__*/react.createElement("path", {
    fillRule: "evenodd",
    d: "M3 4a1 1 0 0 1 1-1h12a1 1 0 1 1 0 2H4a1 1 0 0 1-1-1m0 4a1 1 0 0 1 1-1h12a1 1 0 1 1 0 2H4a1 1 0 0 1-1-1m0 4a1 1 0 0 1 1-1h12a1 1 0 1 1 0 2H4a1 1 0 0 1-1-1m0 4a1 1 0 0 1 1-1h12a1 1 0 1 1 0 2H4a1 1 0 0 1-1-1",
    clipRule: "evenodd"
  })));
};
/* harmony default export */ const solid_view_list = (view_list_SvgViewList);
;// ./react/ui/icon/icons/solid/volume-off.svg
var solid_volume_off_path;
function solid_volume_off_extends() { solid_volume_off_extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return solid_volume_off_extends.apply(this, arguments); }

var volume_off_SvgVolumeOff = function SvgVolumeOff(props) {
  return /*#__PURE__*/react.createElement("svg", solid_volume_off_extends({
    xmlns: "http://www.w3.org/2000/svg",
    fill: "currentColor",
    viewBox: "0 0 20 20"
  }, props), solid_volume_off_path || (solid_volume_off_path = /*#__PURE__*/react.createElement("path", {
    fillRule: "evenodd",
    d: "M9.383 3.076A1 1 0 0 1 10 4v12a1 1 0 0 1-1.707.707L4.586 13H2a1 1 0 0 1-1-1V8a1 1 0 0 1 1-1h2.586l3.707-3.707a1 1 0 0 1 1.09-.217m2.91 4.217a1 1 0 0 1 1.414 0L15 8.586l1.293-1.293a1 1 0 1 1 1.414 1.414L16.414 10l1.293 1.293a1 1 0 0 1-1.414 1.414L15 11.414l-1.293 1.293a1 1 0 0 1-1.414-1.414L13.586 10l-1.293-1.293a1 1 0 0 1 0-1.414",
    clipRule: "evenodd"
  })));
};
/* harmony default export */ const solid_volume_off = (volume_off_SvgVolumeOff);
;// ./react/ui/icon/icons/solid/volume-up.svg
var solid_volume_up_path;
function solid_volume_up_extends() { solid_volume_up_extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return solid_volume_up_extends.apply(this, arguments); }

var volume_up_SvgVolumeUp = function SvgVolumeUp(props) {
  return /*#__PURE__*/react.createElement("svg", solid_volume_up_extends({
    xmlns: "http://www.w3.org/2000/svg",
    fill: "currentColor",
    viewBox: "0 0 20 20"
  }, props), solid_volume_up_path || (solid_volume_up_path = /*#__PURE__*/react.createElement("path", {
    fillRule: "evenodd",
    d: "M9.383 3.076A1 1 0 0 1 10 4v12a1 1 0 0 1-1.707.707L4.586 13H2a1 1 0 0 1-1-1V8a1 1 0 0 1 1-1h2.586l3.707-3.707a1 1 0 0 1 1.09-.217m5.274-.147a1 1 0 0 1 1.414 0A9.97 9.97 0 0 1 19 10a9.97 9.97 0 0 1-2.929 7.071 1 1 0 0 1-1.414-1.414A7.97 7.97 0 0 0 17 10a7.97 7.97 0 0 0-2.343-5.657 1 1 0 0 1 0-1.414m-2.829 2.828a1 1 0 0 1 1.415 0A5.98 5.98 0 0 1 15 10a5.98 5.98 0 0 1-1.757 4.243 1 1 0 0 1-1.415-1.415A3.98 3.98 0 0 0 13 10a3.98 3.98 0 0 0-1.172-2.828 1 1 0 0 1 0-1.415",
    clipRule: "evenodd"
  })));
};
/* harmony default export */ const solid_volume_up = (volume_up_SvgVolumeUp);
;// ./react/ui/icon/icons/solid/wifi.svg
var solid_wifi_path;
function solid_wifi_extends() { solid_wifi_extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return solid_wifi_extends.apply(this, arguments); }

var wifi_SvgWifi = function SvgWifi(props) {
  return /*#__PURE__*/react.createElement("svg", solid_wifi_extends({
    xmlns: "http://www.w3.org/2000/svg",
    fill: "currentColor",
    viewBox: "0 0 20 20"
  }, props), solid_wifi_path || (solid_wifi_path = /*#__PURE__*/react.createElement("path", {
    fillRule: "evenodd",
    d: "M17.778 8.222c-4.296-4.296-11.26-4.296-15.556 0A1 1 0 0 1 .808 6.808c5.076-5.077 13.308-5.077 18.384 0a1 1 0 0 1-1.414 1.414M14.95 11.05a7 7 0 0 0-9.9 0 1 1 0 0 1-1.414-1.414 9 9 0 0 1 12.728 0 1 1 0 0 1-1.414 1.414m-2.83 2.83a3 3 0 0 0-4.242 0 1 1 0 0 1-1.415-1.415 5 5 0 0 1 7.072 0 1 1 0 0 1-1.415 1.415M9 16a1 1 0 0 1 1-1h.01a1 1 0 1 1 0 2H10a1 1 0 0 1-1-1",
    clipRule: "evenodd"
  })));
};
/* harmony default export */ const solid_wifi = (wifi_SvgWifi);
;// ./react/ui/icon/icons/solid/x-circle.svg
var solid_x_circle_path;
function solid_x_circle_extends() { solid_x_circle_extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return solid_x_circle_extends.apply(this, arguments); }

var x_circle_SvgXCircle = function SvgXCircle(props) {
  return /*#__PURE__*/react.createElement("svg", solid_x_circle_extends({
    xmlns: "http://www.w3.org/2000/svg",
    fill: "currentColor",
    viewBox: "0 0 20 20"
  }, props), solid_x_circle_path || (solid_x_circle_path = /*#__PURE__*/react.createElement("path", {
    fillRule: "evenodd",
    d: "M10 18a8 8 0 1 0 0-16 8 8 0 0 0 0 16M8.707 7.293a1 1 0 0 0-1.414 1.414L8.586 10l-1.293 1.293a1 1 0 1 0 1.414 1.414L10 11.414l1.293 1.293a1 1 0 0 0 1.414-1.414L11.414 10l1.293-1.293a1 1 0 0 0-1.414-1.414L10 8.586z",
    clipRule: "evenodd"
  })));
};
/* harmony default export */ const solid_x_circle = (x_circle_SvgXCircle);
;// ./react/ui/icon/icons/solid/x.svg
var solid_x_path;
function solid_x_extends() { solid_x_extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return solid_x_extends.apply(this, arguments); }

var x_SvgX = function SvgX(props) {
  return /*#__PURE__*/react.createElement("svg", solid_x_extends({
    xmlns: "http://www.w3.org/2000/svg",
    fill: "currentColor",
    viewBox: "0 0 20 20"
  }, props), solid_x_path || (solid_x_path = /*#__PURE__*/react.createElement("path", {
    fillRule: "evenodd",
    d: "M4.293 4.293a1 1 0 0 1 1.414 0L10 8.586l4.293-4.293a1 1 0 1 1 1.414 1.414L11.414 10l4.293 4.293a1 1 0 0 1-1.414 1.414L10 11.414l-4.293 4.293a1 1 0 0 1-1.414-1.414L8.586 10 4.293 5.707a1 1 0 0 1 0-1.414",
    clipRule: "evenodd"
  })));
};
/* harmony default export */ const solid_x = (x_SvgX);
;// ./react/ui/icon/icons/solid/zoom-in.svg
var solid_zoom_in_path, zoom_in_path2;
function solid_zoom_in_extends() { solid_zoom_in_extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return solid_zoom_in_extends.apply(this, arguments); }

var zoom_in_SvgZoomIn = function SvgZoomIn(props) {
  return /*#__PURE__*/react.createElement("svg", solid_zoom_in_extends({
    xmlns: "http://www.w3.org/2000/svg",
    fill: "currentColor",
    viewBox: "0 0 20 20"
  }, props), solid_zoom_in_path || (solid_zoom_in_path = /*#__PURE__*/react.createElement("path", {
    d: "M5 8a1 1 0 0 1 1-1h1V6a1 1 0 0 1 2 0v1h1a1 1 0 1 1 0 2H9v1a1 1 0 1 1-2 0V9H6a1 1 0 0 1-1-1"
  })), zoom_in_path2 || (zoom_in_path2 = /*#__PURE__*/react.createElement("path", {
    fillRule: "evenodd",
    d: "M2 8a6 6 0 1 1 10.89 3.476l4.817 4.817a1 1 0 0 1-1.414 1.414l-4.816-4.816A6 6 0 0 1 2 8m6-4a4 4 0 1 0 0 8 4 4 0 0 0 0-8",
    clipRule: "evenodd"
  })));
};
/* harmony default export */ const solid_zoom_in = (zoom_in_SvgZoomIn);
;// ./react/ui/icon/icons/solid/zoom-out.svg
var solid_zoom_out_path, zoom_out_path2;
function solid_zoom_out_extends() { solid_zoom_out_extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return solid_zoom_out_extends.apply(this, arguments); }

var zoom_out_SvgZoomOut = function SvgZoomOut(props) {
  return /*#__PURE__*/react.createElement("svg", solid_zoom_out_extends({
    xmlns: "http://www.w3.org/2000/svg",
    fill: "currentColor",
    viewBox: "0 0 20 20"
  }, props), solid_zoom_out_path || (solid_zoom_out_path = /*#__PURE__*/react.createElement("path", {
    fillRule: "evenodd",
    d: "M8 4a4 4 0 1 0 0 8 4 4 0 0 0 0-8M2 8a6 6 0 1 1 10.89 3.476l4.817 4.817a1 1 0 0 1-1.414 1.414l-4.816-4.816A6 6 0 0 1 2 8",
    clipRule: "evenodd"
  })), zoom_out_path2 || (zoom_out_path2 = /*#__PURE__*/react.createElement("path", {
    fillRule: "evenodd",
    d: "M5 8a1 1 0 0 1 1-1h4a1 1 0 1 1 0 2H6a1 1 0 0 1-1-1",
    clipRule: "evenodd"
  })));
};
/* harmony default export */ const solid_zoom_out = (zoom_out_SvgZoomOut);
;// ./react/ui/icon/Icon.tsx







































































































































































































































































































































































































































































const getIcon = function (iconName) {
  let solid = arguments.length > 1 && arguments[1] !== undefined ? arguments[1] : false;
  if (solid) {
    switch (iconName) {
      case 'academic-cap':
        return solid_academic_cap;
      case 'adjustments':
        return solid_adjustments;
      case 'annotation':
        return solid_annotation;
      case 'archive':
        return solid_archive;
      case 'arrow-circle-down':
        return solid_arrow_circle_down;
      case 'arrow-circle-left':
        return solid_arrow_circle_left;
      case 'arrow-circle-right':
        return solid_arrow_circle_right;
      case 'arrow-circle-up':
        return solid_arrow_circle_up;
      case 'arrow-down':
        return solid_arrow_down;
      case 'arrow-left':
        return solid_arrow_left;
      case 'arrow-narrow-down':
        return solid_arrow_narrow_down;
      case 'arrow-narrow-left':
        return solid_arrow_narrow_left;
      case 'arrow-narrow-right':
        return solid_arrow_narrow_right;
      case 'arrow-narrow-up':
        return solid_arrow_narrow_up;
      case 'arrow-right':
        return solid_arrow_right;
      case 'arrow-up':
        return solid_arrow_up;
      case 'arrows-expand':
        return solid_arrows_expand;
      case 'at-symbol':
        return solid_at_symbol;
      case 'backspace':
        return solid_backspace;
      case 'badge-check':
        return solid_badge_check;
      case 'ban':
        return solid_ban;
      case 'beaker':
        return solid_beaker;
      case 'bell':
        return solid_bell;
      case 'book-open':
        return solid_book_open;
      case 'bookmark-alt':
        return solid_bookmark_alt;
      case 'bookmark':
        return solid_bookmark;
      case 'briefcase':
        return solid_briefcase;
      case 'cake':
        return solid_cake;
      case 'calculator':
        return solid_calculator;
      case 'calendar':
        return solid_calendar;
      case 'camera':
        return solid_camera;
      case 'cash':
        return solid_cash;
      case 'chart-bar':
        return solid_chart_bar;
      case 'chart-pie':
        return solid_chart_pie;
      case 'chart-square-bar':
        return solid_chart_square_bar;
      case 'chat-alt-2':
        return solid_chat_alt_2;
      case 'chat-alt':
        return solid_chat_alt;
      case 'chat':
        return solid_chat;
      case 'check-circle':
        return solid_check_circle;
      case 'check':
        return solid_check;
      case 'chevron-double-down':
        return solid_chevron_double_down;
      case 'chevron-double-left':
        return solid_chevron_double_left;
      case 'chevron-double-right':
        return solid_chevron_double_right;
      case 'chevron-double-up':
        return solid_chevron_double_up;
      case 'chevron-down':
        return solid_chevron_down;
      case 'chevron-left':
        return solid_chevron_left;
      case 'chevron-right':
        return solid_chevron_right;
      case 'chevron-up':
        return solid_chevron_up;
      case 'chip':
        return solid_chip;
      case 'clipboard-check':
        return solid_clipboard_check;
      case 'clipboard-copy':
        return solid_clipboard_copy;
      case 'clipboard-list':
        return solid_clipboard_list;
      case 'clipboard':
        return solid_clipboard;
      case 'clock':
        return solid_clock;
      case 'cloud-download':
        return solid_cloud_download;
      case 'cloud-upload':
        return solid_cloud_upload;
      case 'cloud':
        return solid_cloud;
      case 'code':
        return solid_code;
      case 'cog':
        return solid_cog;
      case 'collection':
        return solid_collection;
      case 'color-swatch':
        return solid_color_swatch;
      case 'credit-card':
        return solid_credit_card;
      case 'cube-transparent':
        return solid_cube_transparent;
      case 'cube':
        return solid_cube;
      case 'currency-bangladeshi':
        return solid_currency_bangladeshi;
      case 'currency-dollar':
        return solid_currency_dollar;
      case 'currency-euro':
        return solid_currency_euro;
      case 'currency-pound':
        return solid_currency_pound;
      case 'currency-rupee':
        return solid_currency_rupee;
      case 'currency-yen':
        return solid_currency_yen;
      case 'cursor-click':
        return solid_cursor_click;
      case 'database':
        return solid_database;
      case 'desktop-computer':
        return solid_desktop_computer;
      case 'device-mobile':
        return solid_device_mobile;
      case 'device-tablet':
        return solid_device_tablet;
      case 'document-add':
        return solid_document_add;
      case 'document-download':
        return solid_document_download;
      case 'document-duplicate':
        return solid_document_duplicate;
      case 'document-remove':
        return solid_document_remove;
      case 'document-report':
        return solid_document_report;
      case 'document-search':
        return solid_document_search;
      case 'document-text':
        return solid_document_text;
      case 'document':
        return solid_document;
      case 'dots-circle-horizontal':
        return solid_dots_circle_horizontal;
      case 'dots-horizontal':
        return solid_dots_horizontal;
      case 'dots-vertical':
        return solid_dots_vertical;
      case 'download':
        return solid_download;
      case 'duplicate':
        return solid_duplicate;
      case 'emoji-happy':
        return solid_emoji_happy;
      case 'emoji-sad':
        return solid_emoji_sad;
      case 'exclamation-circle':
        return solid_exclamation_circle;
      case 'exclamation':
        return solid_exclamation;
      case 'external-link':
        return solid_external_link;
      case 'eye-off':
        return solid_eye_off;
      case 'eye':
        return solid_eye;
      case 'fast-forward':
        return solid_fast_forward;
      case 'film':
        return solid_film;
      case 'filter':
        return solid_filter;
      case 'finger-print':
        return solid_finger_print;
      case 'fire':
        return solid_fire;
      case 'flag':
        return solid_flag;
      case 'folder-add':
        return solid_folder_add;
      case 'folder-download':
        return solid_folder_download;
      case 'folder-open':
        return solid_folder_open;
      case 'folder-remove':
        return solid_folder_remove;
      case 'folder':
        return solid_folder;
      case 'gift':
        return solid_gift;
      case 'globe-alt':
        return solid_globe_alt;
      case 'globe':
        return solid_globe;
      case 'hand':
        return solid_hand;
      case 'hashtag':
        return solid_hashtag;
      case 'heart':
        return solid_heart;
      case 'home':
        return solid_home;
      case 'identification':
        return solid_identification;
      case 'inbox-in':
        return solid_inbox_in;
      case 'inbox':
        return solid_inbox;
      case 'information-circle':
        return solid_information_circle;
      case 'key':
        return solid_key;
      case 'library':
        return solid_library;
      case 'light-bulb':
        return solid_light_bulb;
      case 'lightning-bolt':
        return solid_lightning_bolt;
      case 'link':
        return solid_link;
      case 'location-marker':
        return solid_location_marker;
      case 'lock-closed':
        return solid_lock_closed;
      case 'lock-open':
        return solid_lock_open;
      case 'login':
        return solid_login;
      case 'logout':
        return solid_logout;
      case 'mail-open':
        return solid_mail_open;
      case 'mail':
        return solid_mail;
      case 'map':
        return solid_map;
      case 'menu-alt-1':
        return solid_menu_alt_1;
      case 'menu-alt-2':
        return solid_menu_alt_2;
      case 'menu-alt-3':
        return solid_menu_alt_3;
      case 'menu-alt-4':
        return solid_menu_alt_4;
      case 'menu':
        return solid_menu;
      case 'microphone':
        return solid_microphone;
      case 'minus-circle':
        return solid_minus_circle;
      case 'minus-sm':
        return solid_minus_sm;
      case 'minus':
        return solid_minus;
      case 'moon':
        return solid_moon;
      case 'music-note':
        return solid_music_note;
      case 'newspaper':
        return solid_newspaper;
      case 'no-symbol':
        return solid_no_symbol;
      case 'office-building':
        return solid_office_building;
      case 'paper-airplane':
        return solid_paper_airplane;
      case 'paper-clip':
        return solid_paper_clip;
      case 'pause':
        return solid_pause;
      case 'pencil-alt':
        return solid_pencil_alt;
      case 'pencil':
        return solid_pencil;
      case 'phone-incoming':
        return solid_phone_incoming;
      case 'phone-missed-call':
        return solid_phone_missed_call;
      case 'phone-outgoing':
        return solid_phone_outgoing;
      case 'phone':
        return solid_phone;
      case 'photograph':
        return solid_photograph;
      case 'play':
        return solid_play;
      case 'plus-circle':
        return solid_plus_circle;
      case 'plus-sm':
        return solid_plus_sm;
      case 'plus':
        return solid_plus;
      case 'presentation-chart-bar':
        return solid_presentation_chart_bar;
      case 'presentation-chart-line':
        return solid_presentation_chart_line;
      case 'printer':
        return solid_printer;
      case 'puzzle':
        return solid_puzzle;
      case 'qrcode':
        return solid_qrcode;
      case 'question-mark-circle':
        return solid_question_mark_circle;
      case 'receipt-refund':
        return solid_receipt_refund;
      case 'receipt-tax':
        return solid_receipt_tax;
      case 'refresh':
        return solid_refresh;
      case 'reply':
        return solid_reply;
      case 'rewind':
        return solid_rewind;
      case 'rss':
        return solid_rss;
      case 'save-as':
        return solid_save_as;
      case 'save':
        return solid_save;
      case 'scale':
        return solid_scale;
      case 'scissors':
        return solid_scissors;
      case 'search-circle':
        return solid_search_circle;
      case 'search':
        return solid_search;
      case 'selector':
        return solid_selector;
      case 'server':
        return solid_server;
      case 'share':
        return solid_share;
      case 'shield-check':
        return solid_shield_check;
      case 'shield-exclamation':
        return solid_shield_exclamation;
      case 'shopping-bag':
        return solid_shopping_bag;
      case 'shopping-cart':
        return solid_shopping_cart;
      case 'sort-ascending':
        return solid_sort_ascending;
      case 'sort-descending':
        return solid_sort_descending;
      case 'sparkles':
        return solid_sparkles;
      case 'speakerphone':
        return solid_speakerphone;
      case 'star':
        return solid_star;
      case 'status-offline':
        return solid_status_offline;
      case 'status-online':
        return solid_status_online;
      case 'stop':
        return solid_stop;
      case 'sun':
        return solid_sun;
      case 'support':
        return solid_support;
      case 'switch-horizontal':
        return solid_switch_horizontal;
      case 'switch-vertical':
        return solid_switch_vertical;
      case 'table':
        return solid_table;
      case 'tag':
        return solid_tag;
      case 'template':
        return solid_template;
      case 'terminal':
        return solid_terminal;
      case 'thumb-down':
        return solid_thumb_down;
      case 'thumb-up':
        return solid_thumb_up;
      case 'ticket':
        return solid_ticket;
      case 'translate':
        return solid_translate;
      case 'trash':
        return solid_trash;
      case 'trending-down':
        return solid_trending_down;
      case 'trending-up':
        return solid_trending_up;
      case 'truck':
        return solid_truck;
      case 'upload':
        return solid_upload;
      case 'user-add':
        return solid_user_add;
      case 'user-circle':
        return solid_user_circle;
      case 'user-group':
        return solid_user_group;
      case 'user-remove':
        return solid_user_remove;
      case 'user':
        return solid_user;
      case 'users':
        return solid_users;
      case 'variable':
        return solid_variable;
      case 'video-camera':
        return solid_video_camera;
      case 'view-boards':
        return solid_view_boards;
      case 'view-grid-add':
        return solid_view_grid_add;
      case 'view-grid':
        return solid_view_grid;
      case 'view-list':
        return solid_view_list;
      case 'volume-off':
        return solid_volume_off;
      case 'volume-up':
        return solid_volume_up;
      case 'wifi':
        return solid_wifi;
      case 'x-circle':
        return solid_x_circle;
      case 'x':
        return solid_x;
      case 'zoom-in':
        return solid_zoom_in;
      case 'zoom-out':
        return solid_zoom_out;
      default:
        return solid_document;
    }
  } else {
    switch (iconName) {
      case 'academic-cap':
        return academic_cap;
      case 'adjustments':
        return adjustments;
      case 'annotation':
        return annotation;
      case 'archive':
        return archive;
      case 'arrow-circle-down':
        return arrow_circle_down;
      case 'arrow-circle-left':
        return arrow_circle_left;
      case 'arrow-circle-right':
        return arrow_circle_right;
      case 'arrow-circle-up':
        return arrow_circle_up;
      case 'arrow-down':
        return arrow_down;
      case 'arrow-left':
        return arrow_left;
      case 'arrow-narrow-down':
        return arrow_narrow_down;
      case 'arrow-narrow-left':
        return arrow_narrow_left;
      case 'arrow-narrow-right':
        return arrow_narrow_right;
      case 'arrow-narrow-up':
        return arrow_narrow_up;
      case 'arrow-right':
        return arrow_right;
      case 'arrow-up':
        return arrow_up;
      case 'arrows-expand':
        return arrows_expand;
      case 'at-symbol':
        return at_symbol;
      case 'backspace':
        return backspace;
      case 'badge-check':
        return badge_check;
      case 'ban':
        return ban;
      case 'beaker':
        return beaker;
      case 'bell':
        return bell;
      case 'book-open':
        return book_open;
      case 'bookmark-alt':
        return bookmark_alt;
      case 'bookmark':
        return bookmark;
      case 'briefcase':
        return briefcase;
      case 'cake':
        return cake;
      case 'calculator':
        return calculator;
      case 'calendar':
        return calendar;
      case 'camera':
        return camera;
      case 'cash':
        return cash;
      case 'chart-bar':
        return chart_bar;
      case 'chart-pie':
        return chart_pie;
      case 'chart-square-bar':
        return chart_square_bar;
      case 'chat-alt-2':
        return chat_alt_2;
      case 'chat-alt':
        return chat_alt;
      case 'chat':
        return chat;
      case 'check-circle':
        return check_circle;
      case 'check':
        return check;
      case 'chevron-double-down':
        return chevron_double_down;
      case 'chevron-double-left':
        return chevron_double_left;
      case 'chevron-double-right':
        return chevron_double_right;
      case 'chevron-double-up':
        return chevron_double_up;
      case 'chevron-down':
        return chevron_down;
      case 'chevron-left':
        return chevron_left;
      case 'chevron-right':
        return chevron_right;
      case 'chevron-up':
        return chevron_up;
      case 'chip':
        return chip;
      case 'clipboard-check':
        return clipboard_check;
      case 'clipboard-copy':
        return clipboard_copy;
      case 'clipboard-list':
        return clipboard_list;
      case 'clipboard':
        return clipboard;
      case 'clock':
        return clock;
      case 'cloud-download':
        return cloud_download;
      case 'cloud-upload':
        return cloud_upload;
      case 'cloud':
        return cloud;
      case 'code':
        return code;
      case 'cog':
        return cog;
      case 'collection':
        return collection;
      case 'color-swatch':
        return color_swatch;
      case 'credit-card':
        return credit_card;
      case 'cube-transparent':
        return cube_transparent;
      case 'cube':
        return cube;
      case 'currency-bangladeshi':
        return currency_bangladeshi;
      case 'currency-dollar':
        return currency_dollar;
      case 'currency-euro':
        return currency_euro;
      case 'currency-pound':
        return currency_pound;
      case 'currency-rupee':
        return currency_rupee;
      case 'currency-yen':
        return currency_yen;
      case 'cursor-click':
        return cursor_click;
      case 'database':
        return database;
      case 'desktop-computer':
        return desktop_computer;
      case 'device-mobile':
        return device_mobile;
      case 'device-tablet':
        return device_tablet;
      case 'document-add':
        return document_add;
      case 'document-download':
        return document_download;
      case 'document-duplicate':
        return document_duplicate;
      case 'document-remove':
        return document_remove;
      case 'document-report':
        return document_report;
      case 'document-search':
        return document_search;
      case 'document-text':
        return document_text;
      case 'document':
        return outline_document;
      case 'dots-circle-horizontal':
        return dots_circle_horizontal;
      case 'dots-horizontal':
        return dots_horizontal;
      case 'dots-vertical':
        return dots_vertical;
      case 'download':
        return download;
      case 'duplicate':
        return duplicate;
      case 'emoji-happy':
        return emoji_happy;
      case 'emoji-sad':
        return emoji_sad;
      case 'exclamation-circle':
        return exclamation_circle;
      case 'exclamation':
        return exclamation;
      case 'external-link':
        return external_link;
      case 'eye-off':
        return eye_off;
      case 'eye':
        return eye;
      case 'fast-forward':
        return fast_forward;
      case 'film':
        return film;
      case 'filter':
        return filter;
      case 'finger-print':
        return finger_print;
      case 'fire':
        return fire;
      case 'flag':
        return flag;
      case 'folder-add':
        return folder_add;
      case 'folder-download':
        return folder_download;
      case 'folder-open':
        return folder_open;
      case 'folder-remove':
        return folder_remove;
      case 'folder':
        return folder;
      case 'gift':
        return gift;
      case 'globe-alt':
        return globe_alt;
      case 'globe':
        return globe;
      case 'hand':
        return hand;
      case 'hashtag':
        return hashtag;
      case 'heart':
        return heart;
      case 'home':
        return home;
      case 'identification':
        return identification;
      case 'inbox-in':
        return inbox_in;
      case 'inbox':
        return inbox;
      case 'information-circle':
        return information_circle;
      case 'key':
        return key;
      case 'library':
        return library;
      case 'light-bulb':
        return light_bulb;
      case 'lightning-bolt':
        return lightning_bolt;
      case 'link':
        return outline_link;
      case 'location-marker':
        return location_marker;
      case 'lock-closed':
        return lock_closed;
      case 'lock-open':
        return lock_open;
      case 'login':
        return login;
      case 'logout':
        return logout;
      case 'mail-open':
        return mail_open;
      case 'mail':
        return mail;
      case 'map':
        return map;
      case 'menu-alt-1':
        return menu_alt_1;
      case 'menu-alt-2':
        return menu_alt_2;
      case 'menu-alt-3':
        return menu_alt_3;
      case 'menu-alt-4':
        return menu_alt_4;
      case 'menu':
        return menu;
      case 'microphone':
        return microphone;
      case 'minus-circle':
        return minus_circle;
      case 'minus-sm':
        return minus_sm;
      case 'minus':
        return minus;
      case 'moon':
        return moon;
      case 'music-note':
        return music_note;
      case 'newspaper':
        return newspaper;
      case 'no-symbol':
        return no_symbol;
      case 'office-building':
        return office_building;
      case 'paper-airplane':
        return paper_airplane;
      case 'paper-clip':
        return paper_clip;
      case 'pause':
        return pause;
      case 'pencil-alt':
        return pencil_alt;
      case 'pencil':
        return pencil;
      case 'phone-incoming':
        return phone_incoming;
      case 'phone-missed-call':
        return phone_missed_call;
      case 'phone-outgoing':
        return phone_outgoing;
      case 'phone':
        return phone;
      case 'photograph':
        return photograph;
      case 'play':
        return play;
      case 'plus-circle':
        return plus_circle;
      case 'plus-sm':
        return plus_sm;
      case 'plus':
        return plus;
      case 'presentation-chart-bar':
        return presentation_chart_bar;
      case 'presentation-chart-line':
        return presentation_chart_line;
      case 'printer':
        return printer;
      case 'puzzle':
        return puzzle;
      case 'qrcode':
        return qrcode;
      case 'question-mark-circle':
        return question_mark_circle;
      case 'receipt-refund':
        return receipt_refund;
      case 'receipt-tax':
        return receipt_tax;
      case 'refresh':
        return refresh;
      case 'reply':
        return reply;
      case 'rewind':
        return rewind;
      case 'rss':
        return rss;
      case 'save-as':
        return save_as;
      case 'save':
        return save;
      case 'scale':
        return scale;
      case 'scissors':
        return scissors;
      case 'search-circle':
        return search_circle;
      case 'search':
        return search;
      case 'selector':
        return selector;
      case 'server':
        return server;
      case 'share':
        return share;
      case 'shield-check':
        return shield_check;
      case 'shield-exclamation':
        return shield_exclamation;
      case 'shopping-bag':
        return shopping_bag;
      case 'shopping-cart':
        return shopping_cart;
      case 'sort-ascending':
        return sort_ascending;
      case 'sort-descending':
        return sort_descending;
      case 'sparkles':
        return sparkles;
      case 'speakerphone':
        return speakerphone;
      case 'star':
        return star;
      case 'status-offline':
        return status_offline;
      case 'status-online':
        return status_online;
      case 'stop':
        return stop;
      case 'sun':
        return sun;
      case 'support':
        return support;
      case 'switch-horizontal':
        return switch_horizontal;
      case 'switch-vertical':
        return switch_vertical;
      case 'table':
        return table;
      case 'tag':
        return tag;
      case 'template':
        return template;
      case 'terminal':
        return terminal;
      case 'thumb-down':
        return thumb_down;
      case 'thumb-up':
        return thumb_up;
      case 'ticket':
        return ticket;
      case 'translate':
        return translate;
      case 'trash':
        return trash;
      case 'trending-down':
        return trending_down;
      case 'trending-up':
        return trending_up;
      case 'truck':
        return truck;
      case 'upload':
        return upload;
      case 'user-add':
        return user_add;
      case 'user-circle':
        return user_circle;
      case 'user-group':
        return user_group;
      case 'user-remove':
        return user_remove;
      case 'user':
        return user;
      case 'users':
        return users;
      case 'variable':
        return variable;
      case 'video-camera':
        return video_camera;
      case 'view-boards':
        return view_boards;
      case 'view-grid-add':
        return view_grid_add;
      case 'view-grid':
        return view_grid;
      case 'view-list':
        return view_list;
      case 'volume-off':
        return volume_off;
      case 'volume-up':
        return volume_up;
      case 'wifi':
        return wifi;
      case 'x-circle':
        return x_circle;
      case 'x':
        return x;
      case 'zoom-in':
        return zoom_in;
      case 'zoom-out':
        return zoom_out;
      default:
        return outline_document;
    }
  }
};
function Icon(_ref) {
  let {
    name,
    size,
    color,
    colorIntensity = 700,
    fitted,
    solid,
    className
  } = _ref;
  const classArray = ['inline-block'];
  switch (size) {
    case 'tiny':
      classArray.push('h-4 w-4');
      break;
    case 'small':
      classArray.push('h-5 w-5');
      break;
    case 'large':
      classArray.push('h-6 w-6');
      break;
    case 'huge':
      classArray.push('h-7 w-7');
      break;
    default:
      classArray.push('h-5 w-5');
      break;
  }
  switch (color) {
    case 'gray':
      classArray.push("text-gray-".concat(colorIntensity));
      break;
    case 'red':
      classArray.push("text-red-".concat(colorIntensity));
      break;
    case 'yellow':
      classArray.push("text-yellow-".concat(colorIntensity));
      break;
    case 'green':
      classArray.push("text-green-".concat(colorIntensity));
      break;
    case 'blue':
      classArray.push("text-blue-".concat(colorIntensity));
      break;
    case 'indigo':
      classArray.push("text-indigo-".concat(colorIntensity));
      break;
    case 'purple':
      classArray.push("text-purple-".concat(colorIntensity));
      break;
    case 'pink':
      classArray.push("text-pink-".concat(colorIntensity));
      break;
    case 'white':
      classArray.push('text-white');
      break;
    default:
      break;
  }
  if (!fitted) {
    classArray.push('mr-0.5');
  }
  const TagName = getIcon(name, solid);
  return /*#__PURE__*/react.createElement(TagName, {
    className: className || classArray.join(' ')
  });
}
/* harmony default export */ const icon_Icon = (Icon);


/***/ }),

/***/ 31820:
/***/ ((__unused_webpack_module, __webpack_exports__, __webpack_require__) => {

/* harmony export */ __webpack_require__.d(__webpack_exports__, {
/* harmony export */   A: () => (__WEBPACK_DEFAULT_EXPORT__)
/* harmony export */ });
/* harmony import */ var react__WEBPACK_IMPORTED_MODULE_0__ = __webpack_require__(96540);

function getLabelBgColor(color) {
  switch (color) {
    case 'gray':
      return 'bg-gray-100';
    case 'indigo':
      return 'bg-indigo-100';
    case 'red':
      return 'bg-red-100';
    case 'yellow':
      return 'bg-yellow-100';
    case 'fuchsia':
      return 'bg-fuchsia-100';
    case 'violet':
      return 'bg-violet-100';
    case 'green':
      return 'bg-green-100';
    case 'blue':
      return 'bg-blue-100';
    case 'orange':
      return 'bg-orange-100';
    case 'pink':
      return 'bg-pink-100';
    case 'purple':
      return 'bg-purple-100';
    default:
      return 'bg-gray-100';
  }
}
function getLabelTextColor(color) {
  switch (color) {
    case 'gray':
      return 'text-gray-800';
    case 'indigo':
      return 'text-indigo-800';
    case 'red':
      return 'text-red-800';
    case 'yellow':
      return 'text-yellow-800';
    case 'fuchsia':
      return 'text-fuchsia-800';
    case 'violet':
      return 'text-violet-800';
    case 'green':
      return 'text-green-800';
    case 'blue':
      return 'text-blue-800';
    case 'orange':
      return 'text-orange-800';
    case 'pink':
      return 'text-pink-800';
    case 'purple':
      return 'text-purple-800';
    default:
      return 'text-gray-800';
  }
}
function getLabelBorderColor(color) {
  switch (color) {
    case 'gray':
      return 'border-gray-800';
    case 'indigo':
      return 'border-indigo-800';
    case 'red':
      return 'border-red-800';
    case 'yellow':
      return 'border-yellow-800';
    case 'fuchsia':
      return 'border-fuchsia-800';
    case 'violet':
      return 'border-violet-800';
    case 'green':
      return 'border-green-800';
    case 'blue':
      return 'border-blue-800';
    case 'orange':
      return 'border-orange-800';
    case 'pink':
      return 'border-pink-800';
    case 'purple':
      return 'border-purple-800';
    default:
      return 'border-gray-800';
  }
}
function getLabelDotColor(color) {
  switch (color) {
    case 'gray':
      return 'text-gray-400';
    case 'indigo':
      return 'text-indigo-400';
    case 'red':
      return 'text-red-400';
    case 'yellow':
      return 'text-yellow-400';
    case 'fuchsia':
      return 'text-fuchsia-400';
    case 'violet':
      return 'text-violet-400';
    case 'green':
      return 'text-green-400';
    case 'blue':
      return 'text-blue-400';
    case 'orange':
      return 'text-orange-400';
    case 'pink':
      return 'text-pink-400';
    case 'purple':
      return 'text-purple-400';
    default:
      return 'text-gray-400';
  }
}
function getLabelHoverFocusColors(color) {
  switch (color) {
    case 'gray':
      return 'hover:bg-gray-200 hover:text-gray-500 focus:gray-500';
    case 'indigo':
      return 'hover:bg-indigo-200 hover:text-indigo-500 focus:indigo-500';
    case 'red':
      return 'hover:bg-red-200 hover:text-red-500 focus:red-500';
    case 'yellow':
      return 'hover:bg-yellow-200 hover:text-yellow-500 focus:yellow-500';
    case 'fuchsia':
      return 'hover:bg-fuchsia-200 hover:text-fuchsia-500 focus:fuchsia-500';
    case 'violet':
      return 'hover:bg-violet-200 hover:text-violet-500 focus:violet-500';
    case 'green':
      return 'hover:bg-green-200 hover:text-green-500 focus:green-500';
    case 'blue':
      return 'hover:bg-blue-200 hover:text-blue-500 focus:blue-500';
    case 'orange':
      return 'hover:bg-orange-200 hover:text-orange-500 focus:orange-500';
    case 'pink':
      return 'hover:bg-pink-200 hover:text-pink-500 focus:pink-500';
    case 'purple':
      return 'hover:bg-purple-200 hover:text-purple-500 focus:purple-500';
    default:
      return 'hover:bg-gray-200 hover:text-gray-500 focus:gray-500';
  }
}
function Label(_ref) {
  let {
    color,
    size = 'basic',
    dot = false,
    rounded = false,
    border,
    onRemove,
    children
  } = _ref;
  const classNames = ["inline-flex items-center py-0.5 font-medium whitespace-nowrap cursor-default", getLabelBgColor(color), getLabelTextColor(color)];
  let dotComponent;
  if (size === 'basic') {
    classNames.push('px-2.5 text-xs');
    if (dot) {
      dotComponent = /*#__PURE__*/react__WEBPACK_IMPORTED_MODULE_0__.createElement("svg", {
        className: "-ml-0.5 mr-1.5 h-2 w-2 ".concat(getLabelTextColor(color)),
        fill: "currentColor",
        viewBox: "0 0 8 8"
      }, /*#__PURE__*/react__WEBPACK_IMPORTED_MODULE_0__.createElement("circle", {
        cx: "4",
        cy: "4",
        r: "3"
      }));
    }
    if (rounded) {
      classNames.push('rounded');
    } else {
      classNames.push('rounded-full');
    }
  } else {
    classNames.push('px-3 text-sm');
    if (dot) {
      dotComponent = /*#__PURE__*/react__WEBPACK_IMPORTED_MODULE_0__.createElement("svg", {
        className: "-ml-1 mr-1.5 h-2 w-2 ".concat(getLabelDotColor(color)),
        fill: "currentColor",
        viewBox: "0 0 8 8"
      }, /*#__PURE__*/react__WEBPACK_IMPORTED_MODULE_0__.createElement("circle", {
        cx: "4",
        cy: "4",
        r: "3"
      }));
    }
    if (rounded) {
      classNames.push('rounded-md');
    } else {
      classNames.push('rounded-full');
    }
  }
  if (border) {
    classNames.push('border');
    classNames.push(getLabelBorderColor(color));
  }
  return /*#__PURE__*/react__WEBPACK_IMPORTED_MODULE_0__.createElement("span", {
    className: classNames.join(' ')
  }, dotComponent, /*#__PURE__*/react__WEBPACK_IMPORTED_MODULE_0__.createElement("div", {
    className: "contents"
  }, children), onRemove && /*#__PURE__*/react__WEBPACK_IMPORTED_MODULE_0__.createElement("button", {
    onClick: onRemove,
    type: "button",
    className: "ml-0.5 inline-flex h-4 w-4 flex-shrink-0 items-center justify-center rounded-full ".concat(getLabelDotColor(color), " ").concat(getLabelHoverFocusColors(color), " focus:text-white focus:outline-none")
  }, /*#__PURE__*/react__WEBPACK_IMPORTED_MODULE_0__.createElement("span", {
    className: "sr-only"
  }, "Remove small option"), /*#__PURE__*/react__WEBPACK_IMPORTED_MODULE_0__.createElement("svg", {
    className: "h-2 w-2",
    stroke: "currentColor",
    fill: "none",
    viewBox: "0 0 8 8"
  }, /*#__PURE__*/react__WEBPACK_IMPORTED_MODULE_0__.createElement("path", {
    strokeLinecap: "round",
    strokeWidth: "1.5",
    d: "M1 1l6 6m0-6L1 7"
  }))));
}
/* harmony default export */ const __WEBPACK_DEFAULT_EXPORT__ = (Label);

/***/ }),

/***/ 19320:
/***/ ((__unused_webpack_module, __webpack_exports__, __webpack_require__) => {

/* harmony export */ __webpack_require__.d(__webpack_exports__, {
/* harmony export */   A: () => (__WEBPACK_DEFAULT_EXPORT__)
/* harmony export */ });
/* harmony import */ var react__WEBPACK_IMPORTED_MODULE_0__ = __webpack_require__(96540);

function Loader(_ref) {
  let {
    size = 'medium'
  } = _ref;
  const classArray = ['animate-spin'];
  switch (size) {
    case 'tiny':
      classArray.push('-ml-0.5 mr-1 h-4 w-4');
      break;
    case 'small':
      classArray.push('-ml-0.5 mr-1.5 h-4 w-4');
      break;
    default:
    case 'medium':
      classArray.push('-ml-1 mr-2 h-5 w-5');
      break;
    case 'large':
      classArray.push('-ml-1 mr-2 h-5 w-5');
      break;
    case 'huge':
      classArray.push('-ml-1 mr-3 h-6 w-6');
      break;
  }
  return /*#__PURE__*/react__WEBPACK_IMPORTED_MODULE_0__.createElement("svg", {
    className: classArray.join(' '),
    xmlns: "http://www.w3.org/2000/svg",
    fill: "none",
    viewBox: "0 0 24 24"
  }, /*#__PURE__*/react__WEBPACK_IMPORTED_MODULE_0__.createElement("circle", {
    className: "opacity-25",
    cx: "12",
    cy: "12",
    r: "10",
    stroke: "currentColor",
    strokeWidth: "4"
  }), /*#__PURE__*/react__WEBPACK_IMPORTED_MODULE_0__.createElement("path", {
    className: "opacity-75",
    fill: "currentColor",
    d: "M4 12a8 8 0 018-8V0C5.373 0 0 5.373 0 12h4zm2 5.291A7.962 7.962 0 014 12H0c0 3.042 1.135 5.824 3 7.938l3-2.647z"
  }));
}
/* harmony default export */ const __WEBPACK_DEFAULT_EXPORT__ = (Loader);

/***/ }),

/***/ 8764:
/***/ ((__unused_webpack_module, __webpack_exports__, __webpack_require__) => {

/* harmony export */ __webpack_require__.d(__webpack_exports__, {
/* harmony export */   A: () => (__WEBPACK_DEFAULT_EXPORT__)
/* harmony export */ });
/* harmony import */ var react__WEBPACK_IMPORTED_MODULE_0__ = __webpack_require__(96540);
/* harmony import */ var _headlessui_react__WEBPACK_IMPORTED_MODULE_2__ = __webpack_require__(95626);
/* harmony import */ var ui__WEBPACK_IMPORTED_MODULE_1__ = __webpack_require__(61715);



function Overlay(_ref) {
  let {
    open,
    onOverlayClick,
    children,
    inverted = false,
    transparent = false
  } = _ref;
  const handleOverlayClick = e => {
    e.stopPropagation();
    if (onOverlayClick) onOverlayClick();
  };
  let bgColor = 'bg-gray-500';
  if (transparent) {
    bgColor = 'transparent';
  } else if (inverted) {
    bgColor = 'bg-gray-100';
  }
  return /*#__PURE__*/react__WEBPACK_IMPORTED_MODULE_0__.createElement(ui__WEBPACK_IMPORTED_MODULE_1__/* .Portal */ .ZL, null, /*#__PURE__*/react__WEBPACK_IMPORTED_MODULE_0__.createElement(_headlessui_react__WEBPACK_IMPORTED_MODULE_2__/* .Transition */ .e, {
    show: open,
    enter: "ease-out duration-300",
    enterFrom: "opacity-0",
    enterTo: "opacity-100",
    leave: "ease-in duration-200",
    leaveFrom: "opacity-100",
    leaveTo: "opacity-0"
  }, /*#__PURE__*/react__WEBPACK_IMPORTED_MODULE_0__.createElement("div", {
    className: "fixed inset-0 z-40 overflow-y-auto"
  }, /*#__PURE__*/react__WEBPACK_IMPORTED_MODULE_0__.createElement("div", {
    className: "flex min-h-screen items-end justify-center px-4 pt-4 pb-20 text-center sm:block sm:p-0"
  }, /*#__PURE__*/react__WEBPACK_IMPORTED_MODULE_0__.createElement("div", {
    className: "fixed inset-0 transition-opacity",
    "aria-hidden": "true",
    onClick: handleOverlayClick
  }, /*#__PURE__*/react__WEBPACK_IMPORTED_MODULE_0__.createElement("div", {
    className: "absolute inset-0 opacity-75 ".concat(bgColor)
  })), /*#__PURE__*/react__WEBPACK_IMPORTED_MODULE_0__.createElement("span", {
    className: "hidden sm:inline-block sm:h-screen sm:align-middle",
    "aria-hidden": "true"
  }, "\u200B"), /*#__PURE__*/react__WEBPACK_IMPORTED_MODULE_0__.createElement("div", {
    className: "contents"
  }, children)))));
}
/* harmony default export */ const __WEBPACK_DEFAULT_EXPORT__ = (Overlay);

/***/ }),

/***/ 43470:
/***/ ((__unused_webpack_module, __unused_webpack___webpack_exports__, __webpack_require__) => {

/* harmony import */ var react__WEBPACK_IMPORTED_MODULE_0__ = __webpack_require__(96540);
/* harmony import */ var ui__WEBPACK_IMPORTED_MODULE_1__ = __webpack_require__(61715);


const LEFT_PAGE = 'LEFT';
const RIGHT_PAGE = 'RIGHT';
const SPILL_BLOCK = 'SPILL';
const NUM_PAGE_NEIGHBOURS = 2;
const range = (start, end) => Array.from({
  length: end + 1 - start
}, (v, k) => k + start);
function Pagination(props) {
  const fetchPageNumbers = () => {
    const totalPages = props.totalPagesCount;
    const currentPage = props.page;
    const pageNeighbours = NUM_PAGE_NEIGHBOURS;
    const totalNumbers = pageNeighbours * 2 + 3;
    const totalBlocks = totalNumbers + 2;
    if (totalPages > totalBlocks) {
      const startPage = Math.max(2, currentPage - pageNeighbours);
      const endPage = Math.min(totalPages - 1, currentPage + pageNeighbours);
      let pages = range(startPage, endPage);
      const hasLeftSpill = startPage > 2;
      const hasRightSpill = totalPages - endPage > 1;
      if (hasLeftSpill) pages = [SPILL_BLOCK, ...pages];
      if (hasRightSpill) pages = [...pages, SPILL_BLOCK];
      return [LEFT_PAGE, 1, ...pages, totalPages, RIGHT_PAGE];
    }
    return range(1, totalPages);
  };
  const pages = fetchPageNumbers();
  return /*#__PURE__*/React.createElement("div", null, /*#__PURE__*/React.createElement("div", {
    className: "flex flex-1 justify-between sm:hidden"
  }, /*#__PURE__*/React.createElement("button", {
    type: "button",
    className: "relative ml-3 inline-flex items-center rounded-md border border-gray-300 bg-white px-4 py-2 text-sm font-medium text-gray-700 ".concat(props.page === 1 ? 'cursor-not-allowed text-gray-300' : 'text-gray-500 hover:bg-gray-50'),
    disabled: props.page === 1,
    onClick: () => props.handleSetPage(props.page - 1)
  }, gettext('Previous')), /*#__PURE__*/React.createElement("button", {
    type: "button",
    className: "relative ml-3 inline-flex items-center rounded-md border border-gray-300 bg-white px-4 py-2 text-sm font-medium text-gray-700 ".concat(props.page === props.totalPagesCount ? 'cursor-not-allowed text-gray-300' : 'text-gray-500 hover:bg-gray-50'),
    disabled: props.page === props.totalPagesCount,
    onClick: () => props.handleSetPage(props.page + 1)
  }, gettext('Next'))), /*#__PURE__*/React.createElement("div", {
    className: "hidden sm:flex sm:flex-1 sm:items-center sm:justify-between"
  }, /*#__PURE__*/React.createElement("nav", {
    className: "relative z-0 inline-flex -space-x-px divide-x divide-gray-300 overflow-hidden rounded-md border border-gray-300 shadow-sm",
    "aria-label": "Pagination"
  }, pages.map(number => /*#__PURE__*/React.createElement(React.Fragment, {
    key: number
  }, number === LEFT_PAGE && /*#__PURE__*/React.createElement("button", {
    type: "button",
    disabled: props.page === 1,
    onClick: () => props.handleSetPage(props.page - 1),
    className: "relative inline-flex items-center rounded-l-md bg-white px-2 py-2 text-sm font-medium focus:outline-none ".concat(props.page === 1 ? 'cursor-not-allowed bg-white text-gray-300' : 'text-gray-500 hover:bg-gray-50')
  }, /*#__PURE__*/React.createElement("span", {
    className: "sr-only"
  }, gettext('Previous')), /*#__PURE__*/React.createElement(Icon, {
    name: "chevron-left",
    size: "tiny"
  })), number === RIGHT_PAGE && /*#__PURE__*/React.createElement("button", {
    type: "button",
    disabled: props.page === props.totalPagesCount,
    onClick: () => props.handleSetPage(props.page + 1),
    className: "relative inline-flex items-center rounded-r-md bg-white px-2 py-2 text-sm font-medium focus:outline-none ".concat(props.page === props.totalPagesCount ? 'cursor-not-allowed bg-white text-gray-300' : 'text-gray-500 hover:bg-gray-50')
  }, /*#__PURE__*/React.createElement("span", {
    className: "sr-only"
  }, gettext('Next')), /*#__PURE__*/React.createElement(Icon, {
    name: "chevron-right",
    size: "tiny"
  })), number === SPILL_BLOCK && /*#__PURE__*/React.createElement("span", {
    className: "relative inline-flex items-center bg-white px-4 py-2 text-sm font-medium text-gray-700"
  }, "..."), ![LEFT_PAGE, RIGHT_PAGE, SPILL_BLOCK].includes(number) && /*#__PURE__*/React.createElement("button", {
    type: "button",
    onClick: () => props.handleSetPage(number),
    className: "relative inline-flex items-center bg-white px-4 py-2 text-sm hover:bg-gray-50 focus:outline-none disabled:bg-white disabled:text-gray-300 ".concat(number === props.page ? 'font-bold text-indigo-700' : 'font-medium text-gray-700')
  }, number))))));
}
/* unused harmony default export */ var __WEBPACK_DEFAULT_EXPORT__ = ((/* unused pure expression or super */ null && (Pagination)));

/***/ }),

/***/ 77704:
/***/ ((__unused_webpack_module, __webpack_exports__, __webpack_require__) => {

/* harmony export */ __webpack_require__.d(__webpack_exports__, {
/* harmony export */   A: () => (__WEBPACK_DEFAULT_EXPORT__)
/* harmony export */ });
/* harmony import */ var react__WEBPACK_IMPORTED_MODULE_0__ = __webpack_require__(96540);
/* harmony import */ var _headlessui_react__WEBPACK_IMPORTED_MODULE_1__ = __webpack_require__(95626);


function Popup(_ref) {
  let {
    className = 'py-1 px-2 rounded-md shadow-lg bg-white ring-1 ring-black ring-opacity-5 outline-none',
    open,
    fluid = false,
    on = 'click',
    children,
    trigger,
    position = 'bottom center',
    disabled = false,
    unmount = false,
    onOpen,
    onClose
  } = _ref;
  const floaterRef = (0,react__WEBPACK_IMPORTED_MODULE_0__.useRef)();
  const closeTimeout = (0,react__WEBPACK_IMPORTED_MODULE_0__.useRef)(null);
  const [internalOpen, setInternalOpen] = (0,react__WEBPACK_IMPORTED_MODULE_0__.useState)(false);
  const isOpen = open === undefined ? internalOpen : open;
  const popupClasses = ['absolute', 'z-10'];
  const popupStyles = {};
  const innerPopupClasses = [];
  switch (position) {
    case 'bottom center':
      popupClasses.push('mt-1', 'left-1/2');
      innerPopupClasses.push('relative', '-left-1/2');
      break;
    case 'bottom left':
      popupClasses.push('mt-1', 'left-0');
      break;
    case 'bottom right':
      popupClasses.push('mt-1', 'right-0');
      break;
    case 'top center':
      popupClasses.push('mb-1', 'bottom-full', 'left-1/2');
      innerPopupClasses.push('relative', '-left-1/2');
      break;
    case 'top left':
      popupClasses.push('mb-1', 'bottom-full', 'left-0');
      break;
    case 'top right':
      popupClasses.push('mb-1', 'bottom-full', 'right-0');
      break;
    case 'left center':
      popupClasses.push('mr-1', 'right-full', 'top-0');
      popupStyles.top = '50%';
      popupStyles.transform = 'translateY(-50%)';
      break;
    case 'left top':
      popupClasses.push('mr-1', 'right-full', 'top-0');
      break;
    case 'left bottom':
      popupClasses.push('mr-1', 'right-full', 'bottom-0');
      break;
    case 'right center':
      popupClasses.push('ml-1', 'left-full', 'top-0');
      popupStyles.top = '50%';
      popupStyles.transform = 'translateY(-50%)';
      break;
    case 'right top':
      popupClasses.push('ml-1', 'left-full', 'top-0');
      break;
    case 'right bottom':
      popupClasses.push('ml-1', 'left-full', 'bottom-0');
      break;
    default:
      // bottom left
      popupClasses.push('mt-1', 'left-0');
      break;
  }
  if (fluid) {
    popupClasses.push('min-w-full');
  }
  const listener = (0,react__WEBPACK_IMPORTED_MODULE_0__.useRef)();
  const setListener = func => {
    document.addEventListener('click', func, false);
    listener.current = func;
  };
  (0,react__WEBPACK_IMPORTED_MODULE_0__.useEffect)(() => {
    if (listener.current && !isOpen) {
      document.removeEventListener('click', listener.current, false);
      listener.current = null;
    }
    if (!listener.current && isOpen) {
      const hide = e => {
        if (!e.composedPath().includes(floaterRef === null || floaterRef === void 0 ? void 0 : floaterRef.current)) {
          setInternalOpen(false);
          if (onClose) {
            onClose();
          }
        }
      };
      setListener(hide);
    }
  }, [open, internalOpen]);
  const triggerOnClick = e => {
    e.stopPropagation();
    if (on === 'click') {
      setInternalOpen(true);
      const hide = e => {
        if (!e.composedPath().includes(floaterRef === null || floaterRef === void 0 ? void 0 : floaterRef.current)) {
          setInternalOpen(false);
          if (onClose) {
            onClose();
          }
        }
      };
      if (!isOpen && onOpen) {
        onOpen();
      } else if (isOpen && onClose) {
        onClose();
      }
      if (!isOpen) {
        setListener(hide);
      }
    }
  };
  const triggerOnMouseEnter = () => {
    if (on === 'hover') {
      if (closeTimeout.current) {
        clearTimeout(closeTimeout.current);
        closeTimeout.current = null;
      }
      setInternalOpen(true);
      if (!isOpen && onOpen) onOpen();
    }
  };
  const triggerOnMouseLeave = () => {
    if (on === 'hover') {
      if (!closeTimeout.current) closeTimeout.current = setTimeout(() => {
        setInternalOpen(false);
        if (isOpen && onClose) onClose();
      }, 350);
    }
  };
  return /*#__PURE__*/react__WEBPACK_IMPORTED_MODULE_0__.createElement("div", {
    className: "relative inline-block ".concat(fluid && 'w-full')
  }, /*#__PURE__*/react__WEBPACK_IMPORTED_MODULE_0__.createElement("div", {
    className: "contents",
    role: "presentation",
    tabIndex: -1,
    onClick: triggerOnClick,
    onMouseOver: triggerOnMouseEnter,
    onFocus: triggerOnMouseEnter,
    onMouseOut: triggerOnMouseLeave,
    onBlur: triggerOnMouseLeave
  }, trigger), /*#__PURE__*/react__WEBPACK_IMPORTED_MODULE_0__.createElement(_headlessui_react__WEBPACK_IMPORTED_MODULE_1__/* .Transition */ .e, {
    unmount: unmount,
    show: !disabled && isOpen,
    className: popupClasses.join(' '),
    style: popupStyles,
    enter: "transition ease-out duration-100",
    enterFrom: "transform opacity-0 scale-95",
    enterTo: "transform opacity-100 scale-100",
    leave: "transition ease-in duration-75",
    leaveFrom: "transform opacity-100 scale-100",
    leaveTo: "transform opacity-0 scale-95"
  }, /*#__PURE__*/react__WEBPACK_IMPORTED_MODULE_0__.createElement("div", {
    className: "".concat(innerPopupClasses.join(' '), " ").concat(className),
    ref: floaterRef,
    onMouseOver: triggerOnMouseEnter,
    onFocus: triggerOnMouseEnter,
    onMouseOut: triggerOnMouseLeave,
    onBlur: triggerOnMouseLeave
  }, children)));
}
/* harmony default export */ const __WEBPACK_DEFAULT_EXPORT__ = (Popup);

/***/ }),

/***/ 58284:
/***/ ((__unused_webpack_module, __webpack_exports__, __webpack_require__) => {

/* harmony export */ __webpack_require__.d(__webpack_exports__, {
/* harmony export */   A: () => (__WEBPACK_DEFAULT_EXPORT__)
/* harmony export */ });
/* harmony import */ var react__WEBPACK_IMPORTED_MODULE_0__ = __webpack_require__(96540);
/* harmony import */ var _headlessui_react__WEBPACK_IMPORTED_MODULE_2__ = __webpack_require__(95626);
/* harmony import */ var ui__WEBPACK_IMPORTED_MODULE_1__ = __webpack_require__(61715);



function Segment(_ref) {
  let {
    fluid = false,
    basic = false,
    well = false,
    padded = false,
    secondary = false,
    primary = false,
    color,
    attached,
    loading = false,
    onClick,
    classNames = classNames => classNames,
    children
  } = _ref;
  const classes = ['relative'];
  const innerClassNames = [];

  // Bgcolor
  if (color) {
    classes.push(color);
  } else if (well) {
    classes.push('bg-gray-200');
  } else if (secondary) {
    classes.push('bg-gray-50');
  } else if (primary) {
    classes.push('bg-primary-50');
  } else {
    classes.push('bg-white');
  }

  // Shadow
  if (well) {
    classes.push('shadow-inner');
  } else {
    classes.push('shadow');
  }
  if (onClick) {
    classes.push('hover:bg-gray-50', 'cursor-pointer');
  }
  if (basic) {
    // no padding
  } else if (padded) {
    innerClassNames.push('px-4', 'py-8', 'sm:px-10');
  } else {
    innerClassNames.push('px-4', 'py-5', 'sm:p-6');
  }
  switch (attached) {
    case 'top':
      classes.push('rounded-b-lg');
      break;
    case 'bottom':
      classes.push('rounded-t-lg');
      break;
    default:
      classes.push('rounded-lg');
      break;
  }
  if (fluid) {
    classes.push('w-full');
  }
  return /*#__PURE__*/react__WEBPACK_IMPORTED_MODULE_0__.createElement("div", {
    role: "presentation",
    className: classNames(classes).join(' '),
    onClick: onClick
  }, /*#__PURE__*/react__WEBPACK_IMPORTED_MODULE_0__.createElement(_headlessui_react__WEBPACK_IMPORTED_MODULE_2__/* .Transition */ .e, {
    className: "absolute inset-0 z-20",
    show: loading,
    enter: "transition ease-in duration-50",
    enterFrom: "opacity-0",
    enterTo: "opacity-100",
    leave: "transition ease-out duration-50",
    leaveFrom: "opacity-100",
    leaveTo: "opacity-0"
  }, /*#__PURE__*/react__WEBPACK_IMPORTED_MODULE_0__.createElement("div", {
    className: "absolute inset-0 z-20 flex items-center justify-center rounded-lg bg-white opacity-70"
  }, /*#__PURE__*/react__WEBPACK_IMPORTED_MODULE_0__.createElement(ui__WEBPACK_IMPORTED_MODULE_1__/* .Loader */ .aH, {
    size: "huge"
  }))), /*#__PURE__*/react__WEBPACK_IMPORTED_MODULE_0__.createElement("div", {
    className: innerClassNames.join(' ')
  }, children));
}
/* harmony default export */ const __WEBPACK_DEFAULT_EXPORT__ = (Segment);

/***/ }),

/***/ 79059:
/***/ ((__unused_webpack_module, __unused_webpack___webpack_exports__, __webpack_require__) => {

/* harmony import */ var react__WEBPACK_IMPORTED_MODULE_0__ = __webpack_require__(96540);
/* harmony import */ var ui__WEBPACK_IMPORTED_MODULE_1__ = __webpack_require__(61715);



function SlideOver(_ref) {
  let {
    open,
    onClose,
    title,
    subtitle,
    children
  } = _ref;
  return /*#__PURE__*/React.createElement(Transition.Root, {
    show: open,
    as: React.Fragment
  }, /*#__PURE__*/React.createElement(Dialog, {
    as: "div",
    className: "relative z-10",
    onClose: onClose
  }, /*#__PURE__*/React.createElement(Transition.Child, {
    as: React.Fragment,
    enter: "ease-in-out duration-500",
    enterFrom: "opacity-0",
    enterTo: "opacity-100",
    leave: "ease-in-out duration-500",
    leaveFrom: "opacity-100",
    leaveTo: "opacity-0"
  }, /*#__PURE__*/React.createElement("div", {
    className: "fixed inset-0 bg-gray-500 bg-opacity-75 transition-opacity"
  })), /*#__PURE__*/React.createElement("div", {
    className: "fixed inset-0 overflow-hidden"
  }, /*#__PURE__*/React.createElement("div", {
    className: "absolute inset-0 overflow-hidden"
  }, /*#__PURE__*/React.createElement("div", {
    className: "pointer-events-none fixed inset-y-0 right-0 flex max-w-full pl-10"
  }, /*#__PURE__*/React.createElement(Transition.Child, {
    as: React.Fragment,
    enter: "transform transition ease-in-out duration-500 sm:duration-700",
    enterFrom: "translate-x-full",
    enterTo: "translate-x-0",
    leave: "transform transition ease-in-out duration-500 sm:duration-700",
    leaveFrom: "translate-x-0",
    leaveTo: "translate-x-full"
  }, /*#__PURE__*/React.createElement(Dialog.Panel, {
    className: "pointer-events-auto relative w-screen max-w-md"
  }, /*#__PURE__*/React.createElement(Transition.Child, {
    as: React.Fragment,
    enter: "ease-in-out duration-500",
    enterFrom: "opacity-0",
    enterTo: "opacity-100",
    leave: "ease-in-out duration-500",
    leaveFrom: "opacity-100",
    leaveTo: "opacity-0"
  }, /*#__PURE__*/React.createElement("div", {
    className: "absolute top-0 left-0 -ml-8 flex pt-4 pr-2 sm:-ml-10 sm:pr-4"
  }, /*#__PURE__*/React.createElement("button", {
    type: "button",
    className: "rounded-md text-gray-300 hover:text-white focus:outline-none focus:ring-2 focus:ring-white",
    onClick: onClose
  }, /*#__PURE__*/React.createElement("span", {
    className: "sr-only"
  }, "Close panel"), /*#__PURE__*/React.createElement(Icon, {
    name: "x"
  })))), /*#__PURE__*/React.createElement("div", {
    className: "flex h-full flex-col overflow-y-scroll bg-white py-6 shadow-xl"
  }, /*#__PURE__*/React.createElement("div", {
    className: "px-4 sm:px-6"
  }, /*#__PURE__*/React.createElement(Dialog.Title, {
    className: "text-lg font-medium leading-7 text-gray-900"
  }, title), subtitle && /*#__PURE__*/React.createElement("div", {
    className: "mt-1 text-sm text-gray-500"
  }, subtitle)), /*#__PURE__*/React.createElement("div", {
    className: "relative mt-6 flex-1 px-4 sm:px-6"
  }, children)))))))));
}
/* unused harmony default export */ var __WEBPACK_DEFAULT_EXPORT__ = ((/* unused pure expression or super */ null && (SlideOver)));

/***/ }),

/***/ 67136:
/***/ ((__unused_webpack_module, __unused_webpack___webpack_exports__, __webpack_require__) => {

/* harmony import */ var react__WEBPACK_IMPORTED_MODULE_0__ = __webpack_require__(96540);
/* harmony import */ var ui_icon_Icon__WEBPACK_IMPORTED_MODULE_1__ = __webpack_require__(89918);



function Statistic(props) {
  return /*#__PURE__*/React.createElement("div", {
    className: "flex flex-col overflow-hidden rounded-lg bg-white shadow"
  }, /*#__PURE__*/React.createElement("div", {
    className: "flex-grow p-2 sm:p-6"
  }, /*#__PURE__*/React.createElement("dt", {
    className: "truncate text-sm font-medium text-gray-500"
  }, props.label), /*#__PURE__*/React.createElement("dd", {
    className: "flex flex-wrap items-baseline"
  }, /*#__PURE__*/React.createElement("div", {
    className: "".concat(props.changePositive || props.changeNegative ? 'mr-2' : '', " text-2xl font-semibold text-gray-900")
  }, props.value), props.changePositive && /*#__PURE__*/React.createElement("div", {
    className: "text-medium flex items-baseline truncate whitespace-nowrap font-semibold text-green-600"
  }, props.changeUp && /*#__PURE__*/React.createElement(OutlineArrowNarrowUp, {
    className: "h-3.5 w-3.5 flex-shrink-0 self-center text-green-600"
  }), props.changeDown && /*#__PURE__*/React.createElement(OutlineArrowNarrowDown, {
    className: "h-3.5 w-3.5 flex-shrink-0 self-center text-green-600"
  }), props.changeValue), props.changeNegative && /*#__PURE__*/React.createElement("div", {
    className: "text-medium flex items-baseline truncate font-semibold text-red-600"
  }, props.changeUp && /*#__PURE__*/React.createElement(OutlineArrowNarrowUp, {
    className: "h-3.5 w-3.5 flex-shrink-0 self-center text-red-600"
  }), props.changeDown && /*#__PURE__*/React.createElement(OutlineArrowNarrowDown, {
    className: "h-3.5 w-3.5 flex-shrink-0 self-center text-red-600"
  }), props.changeValue))), props.link && /*#__PURE__*/React.createElement("div", {
    className: "bg-gray-50 p-2 sm:px-6"
  }, /*#__PURE__*/React.createElement("div", {
    className: "text-sm"
  }, /*#__PURE__*/React.createElement(Link, {
    to: props.link,
    className: "font-medium text-indigo-600 hover:text-indigo-500"
  }, props.linkLabel))));
}
/* unused harmony default export */ var __WEBPACK_DEFAULT_EXPORT__ = ((/* unused pure expression or super */ null && (Statistic)));

/***/ }),

/***/ 38762:
/***/ ((__unused_webpack_module, __unused_webpack___webpack_exports__, __webpack_require__) => {

/* harmony import */ var react__WEBPACK_IMPORTED_MODULE_0__ = __webpack_require__(96540);

function Step(props) {
  return /*#__PURE__*/React.createElement("span", {
    className: "ml-4 text-sm font-medium"
  }, props.children);
}
/* unused harmony default export */ var __WEBPACK_DEFAULT_EXPORT__ = ((/* unused pure expression or super */ null && (Step)));

/***/ }),

/***/ 77957:
/***/ ((__unused_webpack_module, __unused_webpack___webpack_exports__, __webpack_require__) => {

/* harmony import */ var react__WEBPACK_IMPORTED_MODULE_0__ = __webpack_require__(96540);

function StepGroup(props) {
  const activeIndex = React.Children.toArray(props.children).findIndex(child => child.props.active === true);
  useEffect(() => {
    // Scroll to the last active step
    const elements = document.querySelectorAll('.active-step');
    if (elements.length > 0) {
      const lastElement = elements[elements.length - 1];
      if (lastElement.nextElementSibling) {
        lastElement.nextElementSibling.scrollIntoView({
          behavior: 'smooth',
          block: 'end'
        });
      } else {
        lastElement.scrollIntoView({
          behavior: 'smooth',
          block: 'end'
        });
      }
    }
  }, []);
  return /*#__PURE__*/React.createElement("ol", {
    className: "divide-y divide-gray-300 rounded-md border border-gray-300 md:flex md:divide-y-0 md:overflow-x-auto"
  }, React.Children.map(props.children, (child, index) => {
    const isActive = index <= activeIndex;
    const color = isActive ? 'text-blue-700' : 'text-gray-400';
    return /*#__PURE__*/React.createElement("li", {
      className: "relative md:flex md:flex-1 ".concat(color, " ").concat(isActive ? 'active-step' : '')
    }, /*#__PURE__*/React.createElement("span", {
      className: "group flex w-full items-center"
    }, /*#__PURE__*/React.createElement("span", {
      className: "flex items-center px-4 py-3 text-sm font-medium"
    }, isActive ? /*#__PURE__*/React.createElement("span", {
      className: "flex h-6 w-6 flex-shrink-0 items-center justify-center rounded-full bg-blue-600"
    }, /*#__PURE__*/React.createElement("svg", {
      className: "h-4 w-4 text-white",
      xmlns: "http://www.w3.org/2000/svg",
      viewBox: "0 0 20 20",
      fill: "currentColor",
      "aria-hidden": "true"
    }, /*#__PURE__*/React.createElement("path", {
      fillRule: "evenodd",
      d: "M16.707 5.293a1 1 0 010 1.414l-8 8a1 1 0 01-1.414 0l-4-4a1 1 0 011.414-1.414L8 12.586l7.293-7.293a1 1 0 011.414 0z",
      clipRule: "evenodd"
    }))) : /*#__PURE__*/React.createElement("span", {
      className: "flex h-6 w-6 flex-shrink-0 items-center justify-center rounded-full bg-gray-200 text-white"
    }, /*#__PURE__*/React.createElement("svg", {
      className: "h-4 w-4 text-white",
      xmlns: "http://www.w3.org/2000/svg",
      viewBox: "0 0 20 20",
      fill: "currentColor"
    }, /*#__PURE__*/React.createElement("path", {
      fillRule: "evenodd",
      d: "M7.293 14.707a1 1 0 010-1.414L10.586 10 7.293 6.707a1 1 0 011.414-1.414l4 4a1 1 0 010 1.414l-4 4a1 1 0 01-1.414 0z",
      clipRule: "evenodd"
    }))), /*#__PURE__*/React.createElement("div", {
      className: "contents"
    }, child))), index !== React.Children.count(props.children) - 1 && /*#__PURE__*/React.createElement("div", {
      className: "absolute top-0 right-0 hidden h-full w-5 md:block",
      "aria-hidden": "true"
    }, /*#__PURE__*/React.createElement("svg", {
      className: "h-full w-full text-gray-300",
      viewBox: "0 0 22 80",
      fill: "none",
      preserveAspectRatio: "none"
    }, /*#__PURE__*/React.createElement("path", {
      d: "M0 -2L20 40L0 82",
      vectorEffect: "non-scaling-stroke",
      stroke: "currentcolor",
      strokeLinejoin: "round"
    }))));
  }));
}
/* unused harmony default export */ var __WEBPACK_DEFAULT_EXPORT__ = ((/* unused pure expression or super */ null && (StepGroup)));

/***/ }),

/***/ 41532:
/***/ ((__unused_webpack_module, __unused_webpack___webpack_exports__, __webpack_require__) => {

/* harmony import */ var react__WEBPACK_IMPORTED_MODULE_0__ = __webpack_require__(96540);
/* harmony import */ var ui_dimmer_Dimmer__WEBPACK_IMPORTED_MODULE_1__ = __webpack_require__(21862);
/* harmony import */ var ui_loader_Loader__WEBPACK_IMPORTED_MODULE_2__ = __webpack_require__(19320);
/* harmony import */ var _TableBody__WEBPACK_IMPORTED_MODULE_3__ = __webpack_require__(60844);
/* harmony import */ var _TableCell__WEBPACK_IMPORTED_MODULE_4__ = __webpack_require__(57420);
/* harmony import */ var _TableFooter__WEBPACK_IMPORTED_MODULE_5__ = __webpack_require__(27769);
/* harmony import */ var _TableHead__WEBPACK_IMPORTED_MODULE_6__ = __webpack_require__(33110);
/* harmony import */ var _TableHeadCell__WEBPACK_IMPORTED_MODULE_7__ = __webpack_require__(26714);
/* harmony import */ var _TableRow__WEBPACK_IMPORTED_MODULE_8__ = __webpack_require__(1470);









function Table(_ref) {
  let {
    id,
    basic = false,
    fixed = false,
    loading = false,
    tableContainerClassNames = clss => clss,
    children
  } = _ref;
  const tableContainerClasses = ['mx-1', 'relative'];
  const tableClasses = ['min-w-full', 'divide-y', 'divide-gray-200', 'table-auto'];
  if (fixed) {
    tableClasses.push('table-fixed');
  } else {
    tableClasses.push('table-auto');
  }
  if (!basic) {
    tableContainerClasses.push('shadow', 'overflow-hidden', 'rounded-lg', 'bg-white');
  }
  return /*#__PURE__*/react__WEBPACK_IMPORTED_MODULE_0__.createElement("div", {
    id: id,
    className: "flex flex-col"
  }, /*#__PURE__*/react__WEBPACK_IMPORTED_MODULE_0__.createElement("div", {
    className: "-my-2 -mx-1 overflow-x-auto"
  }, /*#__PURE__*/react__WEBPACK_IMPORTED_MODULE_0__.createElement("div", {
    className: "inline-block min-w-full py-2 align-middle"
  }, /*#__PURE__*/react__WEBPACK_IMPORTED_MODULE_0__.createElement("div", {
    className: tableContainerClassNames(tableContainerClasses).join(' ')
  }, /*#__PURE__*/react__WEBPACK_IMPORTED_MODULE_0__.createElement(ui_dimmer_Dimmer__WEBPACK_IMPORTED_MODULE_1__/* ["default"] */ .A, {
    open: loading
  }, /*#__PURE__*/react__WEBPACK_IMPORTED_MODULE_0__.createElement(ui_loader_Loader__WEBPACK_IMPORTED_MODULE_2__/* ["default"] */ .A, null)), /*#__PURE__*/react__WEBPACK_IMPORTED_MODULE_0__.createElement("table", {
    className: tableClasses.join(' ')
  }, children)))));
}
/* unused harmony default export */ var __WEBPACK_DEFAULT_EXPORT__ = (Object.assign(Table, {
  Header: _TableHead__WEBPACK_IMPORTED_MODULE_6__/* ["default"] */ .A,
  HeaderCell: _TableHeadCell__WEBPACK_IMPORTED_MODULE_7__/* ["default"] */ .A,
  Cell: _TableCell__WEBPACK_IMPORTED_MODULE_4__/* ["default"] */ .A,
  Row: _TableRow__WEBPACK_IMPORTED_MODULE_8__/* ["default"] */ .A,
  Body: _TableBody__WEBPACK_IMPORTED_MODULE_3__/* ["default"] */ .A,
  Footer: _TableFooter__WEBPACK_IMPORTED_MODULE_5__/* ["default"] */ .A
}));

/***/ }),

/***/ 24178:
/***/ ((__unused_webpack_module, __unused_webpack___webpack_exports__, __webpack_require__) => {


// UNUSED EXPORTS: default

// EXTERNAL MODULE: ./node_modules/react/index.js
var react = __webpack_require__(96540);
// EXTERNAL MODULE: ./node_modules/resize-observer-polyfill/dist/ResizeObserver.es.js
var ResizeObserver_es = __webpack_require__(43591);
// EXTERNAL MODULE: ./react/ui/index.ts + 2 modules
var ui = __webpack_require__(61715);
;// ./react/ui/tabs/Tab.tsx


const Tab_Tab = /*#__PURE__*/(/* unused pure expression or super */ null && (forwardRef((_ref, ref) => {
  let {
    id,
    type,
    active,
    classNames = classes => classes,
    onClick,
    label,
    icon,
    iconSolid = false
  } = _ref;
  let activeColor = 'indigo';
  if (type === 'pills' || type === 'pills-dark') {
    activeColor = 'gray';
  }
  const classes = ['group', 'items-center', 'font-medium', 'text-sm', 'focus:outline-none'];
  switch (type) {
    case 'underline':
      classes.push('py-4', 'inline-flex', 'px-1', 'border-b-2', 'ring-none');
      if (active) {
        classes.push("border-".concat(activeColor, "-500"), "text-".concat(activeColor, "-600"));
      } else {
        classes.push('border-transparent', 'text-gray-500', 'hover:text-gray-700', 'hover:border-gray-300');
      }
      break;
    case 'pills':
      classes.push('px-3', 'inline-flex', 'py-2', 'font-medium', 'text-sm', 'rounded-md');
      if (active) {
        classes.push("bg-".concat(activeColor, "-100 text-").concat(activeColor, "-700"));
      } else {
        classes.push('text-gray-500 hover:text-gray-700');
      }
      break;
    case 'pills-dark':
      classes.push('px-3', 'inline-flex', 'py-2', 'font-medium', 'text-sm', 'rounded-md');
      if (active) {
        classes.push("bg-".concat(activeColor, "-200"), "text-".concat(activeColor, "-800"));
      } else {
        classes.push('text-gray-600 hover:text-gray-800');
      }
      break;
    case 'pills-primary':
      classes.push('px-3', 'inline-flex', 'py-2', 'font-medium', 'text-sm', 'rounded-md');
      if (active) {
        classes.push("bg-".concat(activeColor, "-100"), "text-".concat(activeColor, "-700"));
      } else {
        classes.push('text-gray-500', 'hover:text-gray-700');
      }
      break;
    case 'bar':
    case 'bar-flat':
      classes.push('relative', 'inline-flex', 'justify-center',
      // 'min-w-0',
      'flex-1',
      // 'overflow-hidden',
      'bg-white', 'py-4', 'px-4', 'text-center', 'hover:bg-gray-50', 'focus:z-10');
      if (active) {
        classes.push('text-gray-900');
      } else {
        classes.push('text-gray-500', 'hover:text-gray-700');
      }
      break;
    default:
      break;
  }
  const iconClasses = ['-ml-0.5', 'mr-2', 'h-5', 'w-5'];
  if (active) {
    iconClasses.push("text-".concat(activeColor, "-500"));
  } else {
    iconClasses.push('text-gray-400', 'group-hover:text-gray-500');
  }
  return /*#__PURE__*/React.createElement("button", {
    ref: ref,
    id: id,
    type: "button",
    onClick: onClick,
    className: classNames(classes).join(' ')
  }, icon && /*#__PURE__*/React.createElement(Icon, {
    name: icon,
    solid: iconSolid,
    className: iconClasses.join(' ')
  }), /*#__PURE__*/React.createElement("span", {
    className: "whitespace-nowrap"
  }, label), (type === 'bar' || type === 'bar-flat') && /*#__PURE__*/React.createElement("span", {
    "aria-hidden": "true",
    className: "bg-".concat(active ? activeColor : 'transparent', "-500 absolute inset-x-0 bottom-0 h-0.5")
  }));
})));
/* harmony default export */ const tabs_Tab = ((/* unused pure expression or super */ null && (Tab_Tab)));
;// ./react/ui/tabs/Tabs.tsx
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }




function Tabs(_ref) {
  let {
    type = 'underline',
    value,
    onChange,
    tabs,
    compare = (a, b) => a === b
  } = _ref;
  const containerClasses = ['relative', 'w-full'];
  const rootContainerRef = useRef(null);
  const measuredTabs = useRef({});
  const measuredEllipsis = useRef(null);
  const [collapsedTabs, setCollapsedTabs] = useState([]);
  useEffect(() => {
    const onSizeChange = () => {
      setCollapsedTabs(() => Object.entries(measuredTabs.current).map(_ref2 => {
        var _rootContainerRef$cur;
        let [tab, ref] = _ref2;
        if (!ref || !measuredEllipsis.current) return null;
        return ref.offsetLeft + ref.scrollWidth + measuredEllipsis.current.scrollWidth >= (((_rootContainerRef$cur = rootContainerRef.current) === null || _rootContainerRef$cur === void 0 ? void 0 : _rootContainerRef$cur.clientWidth) || Infinity) ? tab : null;
      }).filter(item => item !== null));
    };
    let resizeObserver;
    if (rootContainerRef.current) {
      resizeObserver = new ResizeObserver(() => requestAnimationFrame(onSizeChange));
      resizeObserver.observe(rootContainerRef.current);
    }
    return () => {
      if (resizeObserver) {
        resizeObserver.disconnect();
      }
    };
  }, []);
  if (type === 'underline') {
    containerClasses.push('border-b', 'border-gray-200', 'px-4', 'sm:px-6');
  }
  const navClasses = ['flex'];
  if (type === 'bar') {
    navClasses.push('relative', 'rounded-lg', 'shadow', 'flex', 'divide-x', 'divide-gray-200', 'bg-white');
  } else if (type === 'bar-flat') {
    navClasses.push('relative', 'rounded-lg', 'shadow-sm', 'flex', 'divide-x', 'divide-gray-200', 'border', 'border-gray-300', 'bg-white');
  } else if (['pills', 'pills-dark', 'pills-primary'].includes(type)) {
    navClasses.push('gap-x-4');
  } else {
    navClasses.push('-mb-px', 'gap-x-8');
  }
  return /*#__PURE__*/React.createElement("div", {
    className: containerClasses.join(' ')
  }, /*#__PURE__*/React.createElement("div", {
    className: "relative w-full",
    ref: rootContainerRef
  }, /*#__PURE__*/React.createElement("div", {
    className: [...navClasses, 'invisible', 'h-0'].join(' ')
  }, tabs.map((item, index) => /*#__PURE__*/React.createElement(Tab, _extends({
    key: index
  }, item, {
    ref: ref => {
      measuredTabs.current[JSON.stringify(item.value)] = ref;
    },
    active: compare(value, item.value),
    onClick: () => onChange(item.value),
    type: type,
    classNames: classes => {
      if (type === 'bar' || type === 'bar-flat') {
        if (index === 0) {
          classes.push('rounded-l-lg');
        }
        if (index === tabs.length - 1) {
          classes.push('rounded-r-lg');
        }
      }
      return classes;
    }
  }))), /*#__PURE__*/React.createElement(Tab, {
    ref: measuredEllipsis,
    type: type,
    label: /*#__PURE__*/React.createElement("div", {
      className: "px-1"
    }, /*#__PURE__*/React.createElement(Icon, {
      name: "dots-horizontal",
      fitted: true
    }))
  })), /*#__PURE__*/React.createElement("nav", {
    className: navClasses.join(' '),
    "aria-label": "Tabs"
  }, tabs.filter(item => !collapsedTabs.includes(JSON.stringify(item.value))).map((item, index) => /*#__PURE__*/React.createElement(Tab, _extends({
    key: index
  }, item, {
    active: compare(value, item.value),
    onClick: () => onChange(item.value),
    type: type,
    classNames: classes => {
      if (type === 'bar' || type === 'bar-flat') {
        if (index === 0) {
          classes.push('rounded-l-lg');
        }
        if (index === tabs.length - 1 && collapsedTabs.length === 0) {
          classes.push('rounded-r-lg');
        }
      }
      return classes;
    }
  }))), collapsedTabs.length > 0 && /*#__PURE__*/React.createElement(Dropdown, {
    position: "bottom right",
    trigger: /*#__PURE__*/React.createElement(Tab, {
      type: type,
      value: {},
      label: /*#__PURE__*/React.createElement("div", {
        className: "px-1"
      }, /*#__PURE__*/React.createElement(Icon, {
        name: "dots-horizontal",
        fitted: true
      })),
      active: collapsedTabs.some(item => compare(value, JSON.parse(item))),
      onClick: () => null,
      classNames: classes => {
        if (type === 'bar' || type === 'bar-flat') {
          classes.push('rounded-r-lg');
        }
        return classes;
      }
    })
  }, /*#__PURE__*/React.createElement(Dropdown.Group, null, tabs.filter(item => collapsedTabs.includes(JSON.stringify(item.value))).map((item, index) => /*#__PURE__*/React.createElement(Dropdown.Item, {
    key: index,
    active: compare(value, item.value),
    onClick: () => onChange(item.value)
  }, /*#__PURE__*/React.createElement("span", {
    className: "whitespace-nowrap"
  }, item.label))))))));
}
/* harmony default export */ const tabs_Tabs = ((/* unused pure expression or super */ null && (Tabs)));

/***/ }),

/***/ 52227:
/***/ ((__unused_webpack_module, __webpack_exports__, __webpack_require__) => {

/* harmony export */ __webpack_require__.d(__webpack_exports__, {
/* harmony export */   A: () => (__WEBPACK_DEFAULT_EXPORT__)
/* harmony export */ });
function toast(item) {
  window.appState.toastStore.addToast(item);
}
const success = function (message) {
  let options = arguments.length > 1 && arguments[1] !== undefined ? arguments[1] : {};
  toast({
    type: 'success',
    title: options.title || gettext('Success'),
    description: message
  });
};
const error = function (message) {
  let options = arguments.length > 1 && arguments[1] !== undefined ? arguments[1] : {};
  toast({
    type: 'error',
    title: options.title || gettext('Error'),
    description: message || gettext('Oops. Something went wrong.')
  });
};
const errorBadRequest = function (message) {
  let options = arguments.length > 1 && arguments[1] !== undefined ? arguments[1] : {};
  toast({
    type: 'error',
    title: options.title || gettext('Error'),
    description: message || gettext('Please correct the highlighted fields.')
  });
};
const info = function (message) {
  let options = arguments.length > 1 && arguments[1] !== undefined ? arguments[1] : {};
  toast({
    type: 'info',
    title: options.title || gettext('Info'),
    description: message
  });
};
const warning = function (message) {
  let options = arguments.length > 1 && arguments[1] !== undefined ? arguments[1] : {};
  toast({
    type: 'warning',
    title: options.title || gettext('Warning'),
    description: message
  });
};
const itemSaved = message => {
  toast({
    type: 'success',
    title: gettext('Success'),
    description: message || gettext('Item was saved successfuly.')
  });
};
const itemDeleted = message => {
  toast({
    type: 'success',
    title: gettext('Success'),
    description: message || gettext('Item was deleted successfuly.')
  });
};
const settingsSaved = message => {
  toast({
    type: 'success',
    title: gettext('Success'),
    description: message || gettext('Settings were saved successfuly.')
  });
};
/* harmony default export */ const __WEBPACK_DEFAULT_EXPORT__ = ({
  success,
  error,
  errorBadRequest,
  info,
  warning,
  itemSaved,
  itemDeleted,
  settingsSaved
});

/***/ })

}]);